/******/ (() => {
  // webpackBootstrap
  /******/ var __webpack_modules__ = {
    /***/ "./node_modules/alpinejs/dist/module.esm.js":
      /*!**************************************************!*\
  !*** ./node_modules/alpinejs/dist/module.esm.js ***!
  \**************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ module_default,
          /* harmony export */
        });
        // packages/alpinejs/src/scheduler.js
        var flushPending = false;
        var flushing = false;
        var queue = [];
        function scheduler(callback) {
          queueJob(callback);
        }
        function queueJob(job) {
          if (!queue.includes(job)) queue.push(job);
          queueFlush();
        }
        function dequeueJob(job) {
          let index = queue.indexOf(job);
          if (index !== -1) queue.splice(index, 1);
        }
        function queueFlush() {
          if (!flushing && !flushPending) {
            flushPending = true;
            queueMicrotask(flushJobs);
          }
        }
        function flushJobs() {
          flushPending = false;
          flushing = true;
          for (let i = 0; i < queue.length; i++) {
            queue[i]();
          }
          queue.length = 0;
          flushing = false;
        }

        // packages/alpinejs/src/reactivity.js
        var reactive;
        var effect;
        var release;
        var raw;
        var shouldSchedule = true;
        function disableEffectScheduling(callback) {
          shouldSchedule = false;
          callback();
          shouldSchedule = true;
        }
        function setReactivityEngine(engine) {
          reactive = engine.reactive;
          release = engine.release;
          effect = (callback) =>
            engine.effect(callback, {
              scheduler: (task) => {
                if (shouldSchedule) {
                  scheduler(task);
                } else {
                  task();
                }
              },
            });
          raw = engine.raw;
        }
        function overrideEffect(override) {
          effect = override;
        }
        function elementBoundEffect(el) {
          let cleanup2 = () => {};
          let wrappedEffect = (callback) => {
            let effectReference = effect(callback);
            if (!el._x_effects) {
              el._x_effects = new Set();
              el._x_runEffects = () => {
                el._x_effects.forEach((i) => i());
              };
            }
            el._x_effects.add(effectReference);
            cleanup2 = () => {
              if (effectReference === void 0) return;
              el._x_effects.delete(effectReference);
              release(effectReference);
            };
            return effectReference;
          };
          return [
            wrappedEffect,
            () => {
              cleanup2();
            },
          ];
        }

        // packages/alpinejs/src/mutation.js
        var onAttributeAddeds = [];
        var onElRemoveds = [];
        var onElAddeds = [];
        function onElAdded(callback) {
          onElAddeds.push(callback);
        }
        function onElRemoved(el, callback) {
          if (typeof callback === "function") {
            if (!el._x_cleanups) el._x_cleanups = [];
            el._x_cleanups.push(callback);
          } else {
            callback = el;
            onElRemoveds.push(callback);
          }
        }
        function onAttributesAdded(callback) {
          onAttributeAddeds.push(callback);
        }
        function onAttributeRemoved(el, name, callback) {
          if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
          if (!el._x_attributeCleanups[name])
            el._x_attributeCleanups[name] = [];
          el._x_attributeCleanups[name].push(callback);
        }
        function cleanupAttributes(el, names) {
          if (!el._x_attributeCleanups) return;
          Object.entries(el._x_attributeCleanups).forEach(([name, value]) => {
            if (names === void 0 || names.includes(name)) {
              value.forEach((i) => i());
              delete el._x_attributeCleanups[name];
            }
          });
        }
        var observer = new MutationObserver(onMutate);
        var currentlyObserving = false;
        function startObservingMutations() {
          observer.observe(document, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeOldValue: true,
          });
          currentlyObserving = true;
        }
        function stopObservingMutations() {
          flushObserver();
          observer.disconnect();
          currentlyObserving = false;
        }
        var recordQueue = [];
        var willProcessRecordQueue = false;
        function flushObserver() {
          recordQueue = recordQueue.concat(observer.takeRecords());
          if (recordQueue.length && !willProcessRecordQueue) {
            willProcessRecordQueue = true;
            queueMicrotask(() => {
              processRecordQueue();
              willProcessRecordQueue = false;
            });
          }
        }
        function processRecordQueue() {
          onMutate(recordQueue);
          recordQueue.length = 0;
        }
        function mutateDom(callback) {
          if (!currentlyObserving) return callback();
          stopObservingMutations();
          let result = callback();
          startObservingMutations();
          return result;
        }
        var isCollecting = false;
        var deferredMutations = [];
        function deferMutations() {
          isCollecting = true;
        }
        function flushAndStopDeferringMutations() {
          isCollecting = false;
          onMutate(deferredMutations);
          deferredMutations = [];
        }
        function onMutate(mutations) {
          if (isCollecting) {
            deferredMutations = deferredMutations.concat(mutations);
            return;
          }
          let addedNodes = [];
          let removedNodes = [];
          let addedAttributes = new Map();
          let removedAttributes = new Map();
          for (let i = 0; i < mutations.length; i++) {
            if (mutations[i].target._x_ignoreMutationObserver) continue;
            if (mutations[i].type === "childList") {
              mutations[i].addedNodes.forEach(
                (node) => node.nodeType === 1 && addedNodes.push(node)
              );
              mutations[i].removedNodes.forEach(
                (node) => node.nodeType === 1 && removedNodes.push(node)
              );
            }
            if (mutations[i].type === "attributes") {
              let el = mutations[i].target;
              let name = mutations[i].attributeName;
              let oldValue = mutations[i].oldValue;
              let add2 = () => {
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes
                  .get(el)
                  .push({ name, value: el.getAttribute(name) });
              };
              let remove = () => {
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
              };
              if (el.hasAttribute(name) && oldValue === null) {
                add2();
              } else if (el.hasAttribute(name)) {
                remove();
                add2();
              } else {
                remove();
              }
            }
          }
          removedAttributes.forEach((attrs, el) => {
            cleanupAttributes(el, attrs);
          });
          addedAttributes.forEach((attrs, el) => {
            onAttributeAddeds.forEach((i) => i(el, attrs));
          });
          for (let node of removedNodes) {
            if (addedNodes.includes(node)) continue;
            onElRemoveds.forEach((i) => i(node));
            if (node._x_cleanups) {
              while (node._x_cleanups.length) node._x_cleanups.pop()();
            }
          }
          addedNodes.forEach((node) => {
            node._x_ignoreSelf = true;
            node._x_ignore = true;
          });
          for (let node of addedNodes) {
            if (removedNodes.includes(node)) continue;
            if (!node.isConnected) continue;
            delete node._x_ignoreSelf;
            delete node._x_ignore;
            onElAddeds.forEach((i) => i(node));
            node._x_ignore = true;
            node._x_ignoreSelf = true;
          }
          addedNodes.forEach((node) => {
            delete node._x_ignoreSelf;
            delete node._x_ignore;
          });
          addedNodes = null;
          removedNodes = null;
          addedAttributes = null;
          removedAttributes = null;
        }

        // packages/alpinejs/src/scope.js
        function scope(node) {
          return mergeProxies(closestDataStack(node));
        }
        function addScopeToNode(node, data2, referenceNode) {
          node._x_dataStack = [
            data2,
            ...closestDataStack(referenceNode || node),
          ];
          return () => {
            node._x_dataStack = node._x_dataStack.filter((i) => i !== data2);
          };
        }
        function refreshScope(element, scope2) {
          let existingScope = element._x_dataStack[0];
          Object.entries(scope2).forEach(([key, value]) => {
            existingScope[key] = value;
          });
        }
        function closestDataStack(node) {
          if (node._x_dataStack) return node._x_dataStack;
          if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) {
            return closestDataStack(node.host);
          }
          if (!node.parentNode) {
            return [];
          }
          return closestDataStack(node.parentNode);
        }
        function mergeProxies(objects) {
          let thisProxy = new Proxy(
            {},
            {
              ownKeys: () => {
                return Array.from(
                  new Set(objects.flatMap((i) => Object.keys(i)))
                );
              },
              has: (target, name) => {
                return objects.some((obj) => obj.hasOwnProperty(name));
              },
              get: (target, name) => {
                return (objects.find((obj) => {
                  if (obj.hasOwnProperty(name)) {
                    let descriptor = Object.getOwnPropertyDescriptor(obj, name);
                    if (
                      (descriptor.get && descriptor.get._x_alreadyBound) ||
                      (descriptor.set && descriptor.set._x_alreadyBound)
                    ) {
                      return true;
                    }
                    if (
                      (descriptor.get || descriptor.set) &&
                      descriptor.enumerable
                    ) {
                      let getter = descriptor.get;
                      let setter = descriptor.set;
                      let property = descriptor;
                      getter = getter && getter.bind(thisProxy);
                      setter = setter && setter.bind(thisProxy);
                      if (getter) getter._x_alreadyBound = true;
                      if (setter) setter._x_alreadyBound = true;
                      Object.defineProperty(obj, name, {
                        ...property,
                        get: getter,
                        set: setter,
                      });
                    }
                    return true;
                  }
                  return false;
                }) || {})[name];
              },
              set: (target, name, value) => {
                let closestObjectWithKey = objects.find((obj) =>
                  obj.hasOwnProperty(name)
                );
                if (closestObjectWithKey) {
                  closestObjectWithKey[name] = value;
                } else {
                  objects[objects.length - 1][name] = value;
                }
                return true;
              },
            }
          );
          return thisProxy;
        }

        // packages/alpinejs/src/interceptor.js
        function initInterceptors(data2) {
          let isObject2 = (val) =>
            typeof val === "object" && !Array.isArray(val) && val !== null;
          let recurse = (obj, basePath = "") => {
            Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(
              ([key, { value, enumerable }]) => {
                if (enumerable === false || value === void 0) return;
                let path = basePath === "" ? key : `${basePath}.${key}`;
                if (
                  typeof value === "object" &&
                  value !== null &&
                  value._x_interceptor
                ) {
                  obj[key] = value.initialize(data2, path, key);
                } else {
                  if (
                    isObject2(value) &&
                    value !== obj &&
                    !(value instanceof Element)
                  ) {
                    recurse(value, path);
                  }
                }
              }
            );
          };
          return recurse(data2);
        }
        function interceptor(callback, mutateObj = () => {}) {
          let obj = {
            initialValue: void 0,
            _x_interceptor: true,
            initialize(data2, path, key) {
              return callback(
                this.initialValue,
                () => get(data2, path),
                (value) => set(data2, path, value),
                path,
                key
              );
            },
          };
          mutateObj(obj);
          return (initialValue) => {
            if (
              typeof initialValue === "object" &&
              initialValue !== null &&
              initialValue._x_interceptor
            ) {
              let initialize = obj.initialize.bind(obj);
              obj.initialize = (data2, path, key) => {
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
              };
            } else {
              obj.initialValue = initialValue;
            }
            return obj;
          };
        }
        function get(obj, path) {
          return path
            .split(".")
            .reduce((carry, segment) => carry[segment], obj);
        }
        function set(obj, path, value) {
          if (typeof path === "string") path = path.split(".");
          if (path.length === 1) obj[path[0]] = value;
          else if (path.length === 0) throw error;
          else {
            if (obj[path[0]]) return set(obj[path[0]], path.slice(1), value);
            else {
              obj[path[0]] = {};
              return set(obj[path[0]], path.slice(1), value);
            }
          }
        }

        // packages/alpinejs/src/magics.js
        var magics = {};
        function magic(name, callback) {
          magics[name] = callback;
        }
        function injectMagics(obj, el) {
          Object.entries(magics).forEach(([name, callback]) => {
            Object.defineProperty(obj, `$${name}`, {
              get() {
                let [utilities, cleanup2] = getElementBoundUtilities(el);
                utilities = { interceptor, ...utilities };
                onElRemoved(el, cleanup2);
                return callback(el, utilities);
              },
              enumerable: false,
            });
          });
          return obj;
        }

        // packages/alpinejs/src/utils/error.js
        function tryCatch(el, expression, callback, ...args) {
          try {
            return callback(...args);
          } catch (e) {
            handleError(e, el, expression);
          }
        }
        function handleError(error2, el, expression = void 0) {
          Object.assign(error2, { el, expression });
          console.warn(
            `Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`,
            el
          );
          setTimeout(() => {
            throw error2;
          }, 0);
        }

        // packages/alpinejs/src/evaluator.js
        var shouldAutoEvaluateFunctions = true;
        function dontAutoEvaluateFunctions(callback) {
          let cache = shouldAutoEvaluateFunctions;
          shouldAutoEvaluateFunctions = false;
          callback();
          shouldAutoEvaluateFunctions = cache;
        }
        function evaluate(el, expression, extras = {}) {
          let result;
          evaluateLater(el, expression)((value) => (result = value), extras);
          return result;
        }
        function evaluateLater(...args) {
          return theEvaluatorFunction(...args);
        }
        var theEvaluatorFunction = normalEvaluator;
        function setEvaluator(newEvaluator) {
          theEvaluatorFunction = newEvaluator;
        }
        function normalEvaluator(el, expression) {
          let overriddenMagics = {};
          injectMagics(overriddenMagics, el);
          let dataStack = [overriddenMagics, ...closestDataStack(el)];
          if (typeof expression === "function") {
            return generateEvaluatorFromFunction(dataStack, expression);
          }
          let evaluator = generateEvaluatorFromString(
            dataStack,
            expression,
            el
          );
          return tryCatch.bind(null, el, expression, evaluator);
        }
        function generateEvaluatorFromFunction(dataStack, func) {
          return (
            receiver = () => {},
            { scope: scope2 = {}, params = [] } = {}
          ) => {
            let result = func.apply(
              mergeProxies([scope2, ...dataStack]),
              params
            );
            runIfTypeOfFunction(receiver, result);
          };
        }
        var evaluatorMemo = {};
        function generateFunctionFromString(expression, el) {
          if (evaluatorMemo[expression]) {
            return evaluatorMemo[expression];
          }
          let AsyncFunction = Object.getPrototypeOf(
            async function () {}
          ).constructor;
          let rightSideSafeExpression =
            /^[\n\s]*if.*\(.*\)/.test(expression) ||
            /^(let|const)\s/.test(expression)
              ? `(() => { ${expression} })()`
              : expression;
          const safeAsyncFunction = () => {
            try {
              return new AsyncFunction(
                ["__self", "scope"],
                `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`
              );
            } catch (error2) {
              handleError(error2, el, expression);
              return Promise.resolve();
            }
          };
          let func = safeAsyncFunction();
          evaluatorMemo[expression] = func;
          return func;
        }
        function generateEvaluatorFromString(dataStack, expression, el) {
          let func = generateFunctionFromString(expression, el);
          return (
            receiver = () => {},
            { scope: scope2 = {}, params = [] } = {}
          ) => {
            func.result = void 0;
            func.finished = false;
            let completeScope = mergeProxies([scope2, ...dataStack]);
            if (typeof func === "function") {
              let promise = func(func, completeScope).catch((error2) =>
                handleError(error2, el, expression)
              );
              if (func.finished) {
                runIfTypeOfFunction(
                  receiver,
                  func.result,
                  completeScope,
                  params,
                  el
                );
                func.result = void 0;
              } else {
                promise
                  .then((result) => {
                    runIfTypeOfFunction(
                      receiver,
                      result,
                      completeScope,
                      params,
                      el
                    );
                  })
                  .catch((error2) => handleError(error2, el, expression))
                  .finally(() => (func.result = void 0));
              }
            }
          };
        }
        function runIfTypeOfFunction(receiver, value, scope2, params, el) {
          if (shouldAutoEvaluateFunctions && typeof value === "function") {
            let result = value.apply(scope2, params);
            if (result instanceof Promise) {
              result
                .then((i) => runIfTypeOfFunction(receiver, i, scope2, params))
                .catch((error2) => handleError(error2, el, value));
            } else {
              receiver(result);
            }
          } else {
            receiver(value);
          }
        }

        // packages/alpinejs/src/directives.js
        var prefixAsString = "x-";
        function prefix(subject = "") {
          return prefixAsString + subject;
        }
        function setPrefix(newPrefix) {
          prefixAsString = newPrefix;
        }
        var directiveHandlers = {};
        function directive(name, callback) {
          directiveHandlers[name] = callback;
        }
        function directives(el, attributes, originalAttributeOverride) {
          let transformedAttributeMap = {};
          let directives2 = Array.from(attributes)
            .map(
              toTransformedAttributes(
                (newName, oldName) =>
                  (transformedAttributeMap[newName] = oldName)
              )
            )
            .filter(outNonAlpineAttributes)
            .map(
              toParsedDirectives(
                transformedAttributeMap,
                originalAttributeOverride
              )
            )
            .sort(byPriority);
          return directives2.map((directive2) => {
            return getDirectiveHandler(el, directive2);
          });
        }
        function attributesOnly(attributes) {
          return Array.from(attributes)
            .map(toTransformedAttributes())
            .filter((attr) => !outNonAlpineAttributes(attr));
        }
        var isDeferringHandlers = false;
        var directiveHandlerStacks = new Map();
        var currentHandlerStackKey = Symbol();
        function deferHandlingDirectives(callback) {
          isDeferringHandlers = true;
          let key = Symbol();
          currentHandlerStackKey = key;
          directiveHandlerStacks.set(key, []);
          let flushHandlers = () => {
            while (directiveHandlerStacks.get(key).length)
              directiveHandlerStacks.get(key).shift()();
            directiveHandlerStacks.delete(key);
          };
          let stopDeferring = () => {
            isDeferringHandlers = false;
            flushHandlers();
          };
          callback(flushHandlers);
          stopDeferring();
        }
        function getElementBoundUtilities(el) {
          let cleanups = [];
          let cleanup2 = (callback) => cleanups.push(callback);
          let [effect3, cleanupEffect] = elementBoundEffect(el);
          cleanups.push(cleanupEffect);
          let utilities = {
            Alpine: alpine_default,
            effect: effect3,
            cleanup: cleanup2,
            evaluateLater: evaluateLater.bind(evaluateLater, el),
            evaluate: evaluate.bind(evaluate, el),
          };
          let doCleanup = () => cleanups.forEach((i) => i());
          return [utilities, doCleanup];
        }
        function getDirectiveHandler(el, directive2) {
          let noop = () => {};
          let handler3 = directiveHandlers[directive2.type] || noop;
          let [utilities, cleanup2] = getElementBoundUtilities(el);
          onAttributeRemoved(el, directive2.original, cleanup2);
          let fullHandler = () => {
            if (el._x_ignore || el._x_ignoreSelf) return;
            handler3.inline && handler3.inline(el, directive2, utilities);
            handler3 = handler3.bind(handler3, el, directive2, utilities);
            isDeferringHandlers
              ? directiveHandlerStacks
                  .get(currentHandlerStackKey)
                  .push(handler3)
              : handler3();
          };
          fullHandler.runCleanups = cleanup2;
          return fullHandler;
        }
        var startingWith =
          (subject, replacement) =>
          ({ name, value }) => {
            if (name.startsWith(subject))
              name = name.replace(subject, replacement);
            return { name, value };
          };
        var into = (i) => i;
        function toTransformedAttributes(callback = () => {}) {
          return ({ name, value }) => {
            let { name: newName, value: newValue } =
              attributeTransformers.reduce(
                (carry, transform) => {
                  return transform(carry);
                },
                { name, value }
              );
            if (newName !== name) callback(newName, name);
            return { name: newName, value: newValue };
          };
        }
        var attributeTransformers = [];
        function mapAttributes(callback) {
          attributeTransformers.push(callback);
        }
        function outNonAlpineAttributes({ name }) {
          return alpineAttributeRegex().test(name);
        }
        var alpineAttributeRegex = () =>
          new RegExp(`^${prefixAsString}([^:^.]+)\\b`);
        function toParsedDirectives(
          transformedAttributeMap,
          originalAttributeOverride
        ) {
          return ({ name, value }) => {
            let typeMatch = name.match(alpineAttributeRegex());
            let valueMatch = name.match(/:([a-zA-Z0-9\-:]+)/);
            let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
            let original =
              originalAttributeOverride ||
              transformedAttributeMap[name] ||
              name;
            return {
              type: typeMatch ? typeMatch[1] : null,
              value: valueMatch ? valueMatch[1] : null,
              modifiers: modifiers.map((i) => i.replace(".", "")),
              expression: value,
              original,
            };
          };
        }
        var DEFAULT = "DEFAULT";
        var directiveOrder = [
          "ignore",
          "ref",
          "data",
          "id",
          "bind",
          "init",
          "for",
          "mask",
          "model",
          "modelable",
          "transition",
          "show",
          "if",
          DEFAULT,
          "teleport",
          "element",
        ];
        function byPriority(a, b) {
          let typeA = directiveOrder.indexOf(a.type) === -1 ? DEFAULT : a.type;
          let typeB = directiveOrder.indexOf(b.type) === -1 ? DEFAULT : b.type;
          return directiveOrder.indexOf(typeA) - directiveOrder.indexOf(typeB);
        }

        // packages/alpinejs/src/utils/dispatch.js
        function dispatch(el, name, detail = {}) {
          el.dispatchEvent(
            new CustomEvent(name, {
              detail,
              bubbles: true,
              composed: true,
              cancelable: true,
            })
          );
        }

        // packages/alpinejs/src/nextTick.js
        var tickStack = [];
        var isHolding = false;
        function nextTick(callback = () => {}) {
          queueMicrotask(() => {
            isHolding ||
              setTimeout(() => {
                releaseNextTicks();
              });
          });
          return new Promise((res) => {
            tickStack.push(() => {
              callback();
              res();
            });
          });
        }
        function releaseNextTicks() {
          isHolding = false;
          while (tickStack.length) tickStack.shift()();
        }
        function holdNextTicks() {
          isHolding = true;
        }

        // packages/alpinejs/src/utils/walk.js
        function walk(el, callback) {
          if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
            Array.from(el.children).forEach((el2) => walk(el2, callback));
            return;
          }
          let skip = false;
          callback(el, () => (skip = true));
          if (skip) return;
          let node = el.firstElementChild;
          while (node) {
            walk(node, callback, false);
            node = node.nextElementSibling;
          }
        }

        // packages/alpinejs/src/utils/warn.js
        function warn(message, ...args) {
          console.warn(`Alpine Warning: ${message}`, ...args);
        }

        // packages/alpinejs/src/lifecycle.js
        function start() {
          if (!document.body)
            warn(
              "Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?"
            );
          dispatch(document, "alpine:init");
          dispatch(document, "alpine:initializing");
          startObservingMutations();
          onElAdded((el) => initTree(el, walk));
          onElRemoved((el) => destroyTree(el));
          onAttributesAdded((el, attrs) => {
            directives(el, attrs).forEach((handle) => handle());
          });
          let outNestedComponents = (el) =>
            !closestRoot(el.parentElement, true);
          Array.from(document.querySelectorAll(allSelectors()))
            .filter(outNestedComponents)
            .forEach((el) => {
              initTree(el);
            });
          dispatch(document, "alpine:initialized");
        }
        var rootSelectorCallbacks = [];
        var initSelectorCallbacks = [];
        function rootSelectors() {
          return rootSelectorCallbacks.map((fn) => fn());
        }
        function allSelectors() {
          return rootSelectorCallbacks
            .concat(initSelectorCallbacks)
            .map((fn) => fn());
        }
        function addRootSelector(selectorCallback) {
          rootSelectorCallbacks.push(selectorCallback);
        }
        function addInitSelector(selectorCallback) {
          initSelectorCallbacks.push(selectorCallback);
        }
        function closestRoot(el, includeInitSelectors = false) {
          return findClosest(el, (element) => {
            const selectors = includeInitSelectors
              ? allSelectors()
              : rootSelectors();
            if (selectors.some((selector) => element.matches(selector)))
              return true;
          });
        }
        function findClosest(el, callback) {
          if (!el) return;
          if (callback(el)) return el;
          if (el._x_teleportBack) el = el._x_teleportBack;
          if (!el.parentElement) return;
          return findClosest(el.parentElement, callback);
        }
        function isRoot(el) {
          return rootSelectors().some((selector) => el.matches(selector));
        }
        function initTree(el, walker = walk) {
          deferHandlingDirectives(() => {
            walker(el, (el2, skip) => {
              directives(el2, el2.attributes).forEach((handle) => handle());
              el2._x_ignore && skip();
            });
          });
        }
        function destroyTree(root) {
          walk(root, (el) => cleanupAttributes(el));
        }

        // packages/alpinejs/src/utils/classes.js
        function setClasses(el, value) {
          if (Array.isArray(value)) {
            return setClassesFromString(el, value.join(" "));
          } else if (typeof value === "object" && value !== null) {
            return setClassesFromObject(el, value);
          } else if (typeof value === "function") {
            return setClasses(el, value());
          }
          return setClassesFromString(el, value);
        }
        function setClassesFromString(el, classString) {
          let split = (classString2) => classString2.split(" ").filter(Boolean);
          let missingClasses = (classString2) =>
            classString2
              .split(" ")
              .filter((i) => !el.classList.contains(i))
              .filter(Boolean);
          let addClassesAndReturnUndo = (classes) => {
            el.classList.add(...classes);
            return () => {
              el.classList.remove(...classes);
            };
          };
          classString =
            classString === true ? (classString = "") : classString || "";
          return addClassesAndReturnUndo(missingClasses(classString));
        }
        function setClassesFromObject(el, classObject) {
          let split = (classString) => classString.split(" ").filter(Boolean);
          let forAdd = Object.entries(classObject)
            .flatMap(([classString, bool]) =>
              bool ? split(classString) : false
            )
            .filter(Boolean);
          let forRemove = Object.entries(classObject)
            .flatMap(([classString, bool]) =>
              !bool ? split(classString) : false
            )
            .filter(Boolean);
          let added = [];
          let removed = [];
          forRemove.forEach((i) => {
            if (el.classList.contains(i)) {
              el.classList.remove(i);
              removed.push(i);
            }
          });
          forAdd.forEach((i) => {
            if (!el.classList.contains(i)) {
              el.classList.add(i);
              added.push(i);
            }
          });
          return () => {
            removed.forEach((i) => el.classList.add(i));
            added.forEach((i) => el.classList.remove(i));
          };
        }

        // packages/alpinejs/src/utils/styles.js
        function setStyles(el, value) {
          if (typeof value === "object" && value !== null) {
            return setStylesFromObject(el, value);
          }
          return setStylesFromString(el, value);
        }
        function setStylesFromObject(el, value) {
          let previousStyles = {};
          Object.entries(value).forEach(([key, value2]) => {
            previousStyles[key] = el.style[key];
            if (!key.startsWith("--")) {
              key = kebabCase(key);
            }
            el.style.setProperty(key, value2);
          });
          setTimeout(() => {
            if (el.style.length === 0) {
              el.removeAttribute("style");
            }
          });
          return () => {
            setStyles(el, previousStyles);
          };
        }
        function setStylesFromString(el, value) {
          let cache = el.getAttribute("style", value);
          el.setAttribute("style", value);
          return () => {
            el.setAttribute("style", cache || "");
          };
        }
        function kebabCase(subject) {
          return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
        }

        // packages/alpinejs/src/utils/once.js
        function once(callback, fallback = () => {}) {
          let called = false;
          return function () {
            if (!called) {
              called = true;
              callback.apply(this, arguments);
            } else {
              fallback.apply(this, arguments);
            }
          };
        }

        // packages/alpinejs/src/directives/x-transition.js
        directive(
          "transition",
          (el, { value, modifiers, expression }, { evaluate: evaluate2 }) => {
            if (typeof expression === "function")
              expression = evaluate2(expression);
            if (!expression) {
              registerTransitionsFromHelper(el, modifiers, value);
            } else {
              registerTransitionsFromClassString(el, expression, value);
            }
          }
        );
        function registerTransitionsFromClassString(el, classString, stage) {
          registerTransitionObject(el, setClasses, "");
          let directiveStorageMap = {
            enter: (classes) => {
              el._x_transition.enter.during = classes;
            },
            "enter-start": (classes) => {
              el._x_transition.enter.start = classes;
            },
            "enter-end": (classes) => {
              el._x_transition.enter.end = classes;
            },
            leave: (classes) => {
              el._x_transition.leave.during = classes;
            },
            "leave-start": (classes) => {
              el._x_transition.leave.start = classes;
            },
            "leave-end": (classes) => {
              el._x_transition.leave.end = classes;
            },
          };
          directiveStorageMap[stage](classString);
        }
        function registerTransitionsFromHelper(el, modifiers, stage) {
          registerTransitionObject(el, setStyles);
          let doesntSpecify =
            !modifiers.includes("in") && !modifiers.includes("out") && !stage;
          let transitioningIn =
            doesntSpecify ||
            modifiers.includes("in") ||
            ["enter"].includes(stage);
          let transitioningOut =
            doesntSpecify ||
            modifiers.includes("out") ||
            ["leave"].includes(stage);
          if (modifiers.includes("in") && !doesntSpecify) {
            modifiers = modifiers.filter(
              (i, index) => index < modifiers.indexOf("out")
            );
          }
          if (modifiers.includes("out") && !doesntSpecify) {
            modifiers = modifiers.filter(
              (i, index) => index > modifiers.indexOf("out")
            );
          }
          let wantsAll =
            !modifiers.includes("opacity") && !modifiers.includes("scale");
          let wantsOpacity = wantsAll || modifiers.includes("opacity");
          let wantsScale = wantsAll || modifiers.includes("scale");
          let opacityValue = wantsOpacity ? 0 : 1;
          let scaleValue = wantsScale
            ? modifierValue(modifiers, "scale", 95) / 100
            : 1;
          let delay = modifierValue(modifiers, "delay", 0);
          let origin = modifierValue(modifiers, "origin", "center");
          let property = "opacity, transform";
          let durationIn = modifierValue(modifiers, "duration", 150) / 1e3;
          let durationOut = modifierValue(modifiers, "duration", 75) / 1e3;
          let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
          if (transitioningIn) {
            el._x_transition.enter.during = {
              transformOrigin: origin,
              transitionDelay: delay,
              transitionProperty: property,
              transitionDuration: `${durationIn}s`,
              transitionTimingFunction: easing,
            };
            el._x_transition.enter.start = {
              opacity: opacityValue,
              transform: `scale(${scaleValue})`,
            };
            el._x_transition.enter.end = {
              opacity: 1,
              transform: `scale(1)`,
            };
          }
          if (transitioningOut) {
            el._x_transition.leave.during = {
              transformOrigin: origin,
              transitionDelay: delay,
              transitionProperty: property,
              transitionDuration: `${durationOut}s`,
              transitionTimingFunction: easing,
            };
            el._x_transition.leave.start = {
              opacity: 1,
              transform: `scale(1)`,
            };
            el._x_transition.leave.end = {
              opacity: opacityValue,
              transform: `scale(${scaleValue})`,
            };
          }
        }
        function registerTransitionObject(el, setFunction, defaultValue = {}) {
          if (!el._x_transition)
            el._x_transition = {
              enter: {
                during: defaultValue,
                start: defaultValue,
                end: defaultValue,
              },
              leave: {
                during: defaultValue,
                start: defaultValue,
                end: defaultValue,
              },
              in(before = () => {}, after = () => {}) {
                transition(
                  el,
                  setFunction,
                  {
                    during: this.enter.during,
                    start: this.enter.start,
                    end: this.enter.end,
                  },
                  before,
                  after
                );
              },
              out(before = () => {}, after = () => {}) {
                transition(
                  el,
                  setFunction,
                  {
                    during: this.leave.during,
                    start: this.leave.start,
                    end: this.leave.end,
                  },
                  before,
                  after
                );
              },
            };
        }
        window.Element.prototype._x_toggleAndCascadeWithTransitions = function (
          el,
          value,
          show,
          hide
        ) {
          let clickAwayCompatibleShow = () => {
            document.visibilityState === "visible"
              ? requestAnimationFrame(show)
              : setTimeout(show);
          };
          if (value) {
            if (
              el._x_transition &&
              (el._x_transition.enter || el._x_transition.leave)
            ) {
              el._x_transition.enter &&
              (Object.entries(el._x_transition.enter.during).length ||
                Object.entries(el._x_transition.enter.start).length ||
                Object.entries(el._x_transition.enter.end).length)
                ? el._x_transition.in(show)
                : clickAwayCompatibleShow();
            } else {
              el._x_transition
                ? el._x_transition.in(show)
                : clickAwayCompatibleShow();
            }
            return;
          }
          el._x_hidePromise = el._x_transition
            ? new Promise((resolve, reject) => {
                el._x_transition.out(
                  () => {},
                  () => resolve(hide)
                );
                el._x_transitioning.beforeCancel(() =>
                  reject({ isFromCancelledTransition: true })
                );
              })
            : Promise.resolve(hide);
          queueMicrotask(() => {
            let closest = closestHide(el);
            if (closest) {
              if (!closest._x_hideChildren) closest._x_hideChildren = [];
              closest._x_hideChildren.push(el);
            } else {
              queueMicrotask(() => {
                let hideAfterChildren = (el2) => {
                  let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren),
                  ]).then(([i]) => i());
                  delete el2._x_hidePromise;
                  delete el2._x_hideChildren;
                  return carry;
                };
                hideAfterChildren(el).catch((e) => {
                  if (!e.isFromCancelledTransition) throw e;
                });
              });
            }
          });
        };
        function closestHide(el) {
          let parent = el.parentNode;
          if (!parent) return;
          return parent._x_hidePromise ? parent : closestHide(parent);
        }
        function transition(
          el,
          setFunction,
          { during, start: start2, end } = {},
          before = () => {},
          after = () => {}
        ) {
          if (el._x_transitioning) el._x_transitioning.cancel();
          if (
            Object.keys(during).length === 0 &&
            Object.keys(start2).length === 0 &&
            Object.keys(end).length === 0
          ) {
            before();
            after();
            return;
          }
          let undoStart, undoDuring, undoEnd;
          performTransition(el, {
            start() {
              undoStart = setFunction(el, start2);
            },
            during() {
              undoDuring = setFunction(el, during);
            },
            before,
            end() {
              undoStart();
              undoEnd = setFunction(el, end);
            },
            after,
            cleanup() {
              undoDuring();
              undoEnd();
            },
          });
        }
        function performTransition(el, stages) {
          let interrupted, reachedBefore, reachedEnd;
          let finish = once(() => {
            mutateDom(() => {
              interrupted = true;
              if (!reachedBefore) stages.before();
              if (!reachedEnd) {
                stages.end();
                releaseNextTicks();
              }
              stages.after();
              if (el.isConnected) stages.cleanup();
              delete el._x_transitioning;
            });
          });
          el._x_transitioning = {
            beforeCancels: [],
            beforeCancel(callback) {
              this.beforeCancels.push(callback);
            },
            cancel: once(function () {
              while (this.beforeCancels.length) {
                this.beforeCancels.shift()();
              }
              finish();
            }),
            finish,
          };
          mutateDom(() => {
            stages.start();
            stages.during();
          });
          holdNextTicks();
          requestAnimationFrame(() => {
            if (interrupted) return;
            let duration =
              Number(
                getComputedStyle(el)
                  .transitionDuration.replace(/,.*/, "")
                  .replace("s", "")
              ) * 1e3;
            let delay =
              Number(
                getComputedStyle(el)
                  .transitionDelay.replace(/,.*/, "")
                  .replace("s", "")
              ) * 1e3;
            if (duration === 0)
              duration =
                Number(
                  getComputedStyle(el).animationDuration.replace("s", "")
                ) * 1e3;
            mutateDom(() => {
              stages.before();
            });
            reachedBefore = true;
            requestAnimationFrame(() => {
              if (interrupted) return;
              mutateDom(() => {
                stages.end();
              });
              releaseNextTicks();
              setTimeout(el._x_transitioning.finish, duration + delay);
              reachedEnd = true;
            });
          });
        }
        function modifierValue(modifiers, key, fallback) {
          if (modifiers.indexOf(key) === -1) return fallback;
          const rawValue = modifiers[modifiers.indexOf(key) + 1];
          if (!rawValue) return fallback;
          if (key === "scale") {
            if (isNaN(rawValue)) return fallback;
          }
          if (key === "duration") {
            let match = rawValue.match(/([0-9]+)ms/);
            if (match) return match[1];
          }
          if (key === "origin") {
            if (
              ["top", "right", "left", "center", "bottom"].includes(
                modifiers[modifiers.indexOf(key) + 2]
              )
            ) {
              return [rawValue, modifiers[modifiers.indexOf(key) + 2]].join(
                " "
              );
            }
          }
          return rawValue;
        }

        // packages/alpinejs/src/clone.js
        var isCloning = false;
        function skipDuringClone(callback, fallback = () => {}) {
          return (...args) =>
            isCloning ? fallback(...args) : callback(...args);
        }
        function clone(oldEl, newEl) {
          if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
          isCloning = true;
          dontRegisterReactiveSideEffects(() => {
            cloneTree(newEl);
          });
          isCloning = false;
        }
        function cloneTree(el) {
          let hasRunThroughFirstEl = false;
          let shallowWalker = (el2, callback) => {
            walk(el2, (el3, skip) => {
              if (hasRunThroughFirstEl && isRoot(el3)) return skip();
              hasRunThroughFirstEl = true;
              callback(el3, skip);
            });
          };
          initTree(el, shallowWalker);
        }
        function dontRegisterReactiveSideEffects(callback) {
          let cache = effect;
          overrideEffect((callback2, el) => {
            let storedEffect = cache(callback2);
            release(storedEffect);
            return () => {};
          });
          callback();
          overrideEffect(cache);
        }

        // packages/alpinejs/src/utils/bind.js
        function bind(el, name, value, modifiers = []) {
          if (!el._x_bindings) el._x_bindings = reactive({});
          el._x_bindings[name] = value;
          name = modifiers.includes("camel") ? camelCase(name) : name;
          switch (name) {
            case "value":
              bindInputValue(el, value);
              break;
            case "style":
              bindStyles(el, value);
              break;
            case "class":
              bindClasses(el, value);
              break;
            default:
              bindAttribute(el, name, value);
              break;
          }
        }
        function bindInputValue(el, value) {
          if (el.type === "radio") {
            if (el.attributes.value === void 0) {
              el.value = value;
            }
            if (window.fromModel) {
              el.checked = checkedAttrLooseCompare(el.value, value);
            }
          } else if (el.type === "checkbox") {
            if (Number.isInteger(value)) {
              el.value = value;
            } else if (
              !Number.isInteger(value) &&
              !Array.isArray(value) &&
              typeof value !== "boolean" &&
              ![null, void 0].includes(value)
            ) {
              el.value = String(value);
            } else {
              if (Array.isArray(value)) {
                el.checked = value.some((val) =>
                  checkedAttrLooseCompare(val, el.value)
                );
              } else {
                el.checked = !!value;
              }
            }
          } else if (el.tagName === "SELECT") {
            updateSelect(el, value);
          } else {
            if (el.value === value) return;
            el.value = value;
          }
        }
        function bindClasses(el, value) {
          if (el._x_undoAddedClasses) el._x_undoAddedClasses();
          el._x_undoAddedClasses = setClasses(el, value);
        }
        function bindStyles(el, value) {
          if (el._x_undoAddedStyles) el._x_undoAddedStyles();
          el._x_undoAddedStyles = setStyles(el, value);
        }
        function bindAttribute(el, name, value) {
          if (
            [null, void 0, false].includes(value) &&
            attributeShouldntBePreservedIfFalsy(name)
          ) {
            el.removeAttribute(name);
          } else {
            if (isBooleanAttr(name)) value = name;
            setIfChanged(el, name, value);
          }
        }
        function setIfChanged(el, attrName, value) {
          if (el.getAttribute(attrName) != value) {
            el.setAttribute(attrName, value);
          }
        }
        function updateSelect(el, value) {
          const arrayWrappedValue = [].concat(value).map((value2) => {
            return value2 + "";
          });
          Array.from(el.options).forEach((option) => {
            option.selected = arrayWrappedValue.includes(option.value);
          });
        }
        function camelCase(subject) {
          return subject
            .toLowerCase()
            .replace(/-(\w)/g, (match, char) => char.toUpperCase());
        }
        function checkedAttrLooseCompare(valueA, valueB) {
          return valueA == valueB;
        }
        function isBooleanAttr(attrName) {
          const booleanAttributes = [
            "disabled",
            "checked",
            "required",
            "readonly",
            "hidden",
            "open",
            "selected",
            "autofocus",
            "itemscope",
            "multiple",
            "novalidate",
            "allowfullscreen",
            "allowpaymentrequest",
            "formnovalidate",
            "autoplay",
            "controls",
            "loop",
            "muted",
            "playsinline",
            "default",
            "ismap",
            "reversed",
            "async",
            "defer",
            "nomodule",
          ];
          return booleanAttributes.includes(attrName);
        }
        function attributeShouldntBePreservedIfFalsy(name) {
          return ![
            "aria-pressed",
            "aria-checked",
            "aria-expanded",
            "aria-selected",
          ].includes(name);
        }
        function getBinding(el, name, fallback) {
          if (el._x_bindings && el._x_bindings[name] !== void 0)
            return el._x_bindings[name];
          let attr = el.getAttribute(name);
          if (attr === null)
            return typeof fallback === "function" ? fallback() : fallback;
          if (isBooleanAttr(name)) {
            return !![name, "true"].includes(attr);
          }
          if (attr === "") return true;
          return attr;
        }

        // packages/alpinejs/src/utils/debounce.js
        function debounce(func, wait) {
          var timeout;
          return function () {
            var context = this,
              args = arguments;
            var later = function () {
              timeout = null;
              func.apply(context, args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
          };
        }

        // packages/alpinejs/src/utils/throttle.js
        function throttle(func, limit) {
          let inThrottle;
          return function () {
            let context = this,
              args = arguments;
            if (!inThrottle) {
              func.apply(context, args);
              inThrottle = true;
              setTimeout(() => (inThrottle = false), limit);
            }
          };
        }

        // packages/alpinejs/src/plugin.js
        function plugin(callback) {
          callback(alpine_default);
        }

        // packages/alpinejs/src/store.js
        var stores = {};
        var isReactive = false;
        function store(name, value) {
          if (!isReactive) {
            stores = reactive(stores);
            isReactive = true;
          }
          if (value === void 0) {
            return stores[name];
          }
          stores[name] = value;
          if (
            typeof value === "object" &&
            value !== null &&
            value.hasOwnProperty("init") &&
            typeof value.init === "function"
          ) {
            stores[name].init();
          }
          initInterceptors(stores[name]);
        }
        function getStores() {
          return stores;
        }

        // packages/alpinejs/src/binds.js
        var binds = {};
        function bind2(name, object) {
          binds[name] = typeof object !== "function" ? () => object : object;
        }
        function injectBindingProviders(obj) {
          Object.entries(binds).forEach(([name, callback]) => {
            Object.defineProperty(obj, name, {
              get() {
                return (...args) => {
                  return callback(...args);
                };
              },
            });
          });
          return obj;
        }

        // packages/alpinejs/src/datas.js
        var datas = {};
        function data(name, callback) {
          datas[name] = callback;
        }
        function injectDataProviders(obj, context) {
          Object.entries(datas).forEach(([name, callback]) => {
            Object.defineProperty(obj, name, {
              get() {
                return (...args) => {
                  return callback.bind(context)(...args);
                };
              },
              enumerable: false,
            });
          });
          return obj;
        }

        // packages/alpinejs/src/alpine.js
        var Alpine = {
          get reactive() {
            return reactive;
          },
          get release() {
            return release;
          },
          get effect() {
            return effect;
          },
          get raw() {
            return raw;
          },
          version: "3.10.0",
          flushAndStopDeferringMutations,
          dontAutoEvaluateFunctions,
          disableEffectScheduling,
          setReactivityEngine,
          closestDataStack,
          skipDuringClone,
          addRootSelector,
          addInitSelector,
          addScopeToNode,
          deferMutations,
          mapAttributes,
          evaluateLater,
          setEvaluator,
          mergeProxies,
          findClosest,
          closestRoot,
          interceptor,
          transition,
          setStyles,
          mutateDom,
          directive,
          throttle,
          debounce,
          evaluate,
          initTree,
          nextTick,
          prefixed: prefix,
          prefix: setPrefix,
          plugin,
          magic,
          store,
          start,
          clone,
          bound: getBinding,
          $data: scope,
          data,
          bind: bind2,
        };
        var alpine_default = Alpine;

        // node_modules/@vue/shared/dist/shared.esm-bundler.js
        function makeMap(str, expectsLowerCase) {
          const map = Object.create(null);
          const list = str.split(",");
          for (let i = 0; i < list.length; i++) {
            map[list[i]] = true;
          }
          return expectsLowerCase
            ? (val) => !!map[val.toLowerCase()]
            : (val) => !!map[val];
        }
        var PatchFlagNames = {
          [1]: `TEXT`,
          [2]: `CLASS`,
          [4]: `STYLE`,
          [8]: `PROPS`,
          [16]: `FULL_PROPS`,
          [32]: `HYDRATE_EVENTS`,
          [64]: `STABLE_FRAGMENT`,
          [128]: `KEYED_FRAGMENT`,
          [256]: `UNKEYED_FRAGMENT`,
          [512]: `NEED_PATCH`,
          [1024]: `DYNAMIC_SLOTS`,
          [2048]: `DEV_ROOT_FRAGMENT`,
          [-1]: `HOISTED`,
          [-2]: `BAIL`,
        };
        var slotFlagsText = {
          [1]: "STABLE",
          [2]: "DYNAMIC",
          [3]: "FORWARDED",
        };
        var specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
        var isBooleanAttr2 = /* @__PURE__ */ makeMap(
          specialBooleanAttrs +
            `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`
        );
        var EMPTY_OBJ = false ? 0 : {};
        var EMPTY_ARR = false ? 0 : [];
        var extend = Object.assign;
        var hasOwnProperty = Object.prototype.hasOwnProperty;
        var hasOwn = (val, key) => hasOwnProperty.call(val, key);
        var isArray = Array.isArray;
        var isMap = (val) => toTypeString(val) === "[object Map]";
        var isString = (val) => typeof val === "string";
        var isSymbol = (val) => typeof val === "symbol";
        var isObject = (val) => val !== null && typeof val === "object";
        var objectToString = Object.prototype.toString;
        var toTypeString = (value) => objectToString.call(value);
        var toRawType = (value) => {
          return toTypeString(value).slice(8, -1);
        };
        var isIntegerKey = (key) =>
          isString(key) &&
          key !== "NaN" &&
          key[0] !== "-" &&
          "" + parseInt(key, 10) === key;
        var cacheStringFunction = (fn) => {
          const cache = Object.create(null);
          return (str) => {
            const hit = cache[str];
            return hit || (cache[str] = fn(str));
          };
        };
        var camelizeRE = /-(\w)/g;
        var camelize = cacheStringFunction((str) => {
          return str.replace(camelizeRE, (_, c) => (c ? c.toUpperCase() : ""));
        });
        var hyphenateRE = /\B([A-Z])/g;
        var hyphenate = cacheStringFunction((str) =>
          str.replace(hyphenateRE, "-$1").toLowerCase()
        );
        var capitalize = cacheStringFunction(
          (str) => str.charAt(0).toUpperCase() + str.slice(1)
        );
        var toHandlerKey = cacheStringFunction((str) =>
          str ? `on${capitalize(str)}` : ``
        );
        var hasChanged = (value, oldValue) =>
          value !== oldValue && (value === value || oldValue === oldValue);

        // node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
        var targetMap = new WeakMap();
        var effectStack = [];
        var activeEffect;
        var ITERATE_KEY = Symbol(false ? 0 : "");
        var MAP_KEY_ITERATE_KEY = Symbol(false ? 0 : "");
        function isEffect(fn) {
          return fn && fn._isEffect === true;
        }
        function effect2(fn, options = EMPTY_OBJ) {
          if (isEffect(fn)) {
            fn = fn.raw;
          }
          const effect3 = createReactiveEffect(fn, options);
          if (!options.lazy) {
            effect3();
          }
          return effect3;
        }
        function stop(effect3) {
          if (effect3.active) {
            cleanup(effect3);
            if (effect3.options.onStop) {
              effect3.options.onStop();
            }
            effect3.active = false;
          }
        }
        var uid = 0;
        function createReactiveEffect(fn, options) {
          const effect3 = function reactiveEffect() {
            if (!effect3.active) {
              return fn();
            }
            if (!effectStack.includes(effect3)) {
              cleanup(effect3);
              try {
                enableTracking();
                effectStack.push(effect3);
                activeEffect = effect3;
                return fn();
              } finally {
                effectStack.pop();
                resetTracking();
                activeEffect = effectStack[effectStack.length - 1];
              }
            }
          };
          effect3.id = uid++;
          effect3.allowRecurse = !!options.allowRecurse;
          effect3._isEffect = true;
          effect3.active = true;
          effect3.raw = fn;
          effect3.deps = [];
          effect3.options = options;
          return effect3;
        }
        function cleanup(effect3) {
          const { deps } = effect3;
          if (deps.length) {
            for (let i = 0; i < deps.length; i++) {
              deps[i].delete(effect3);
            }
            deps.length = 0;
          }
        }
        var shouldTrack = true;
        var trackStack = [];
        function pauseTracking() {
          trackStack.push(shouldTrack);
          shouldTrack = false;
        }
        function enableTracking() {
          trackStack.push(shouldTrack);
          shouldTrack = true;
        }
        function resetTracking() {
          const last = trackStack.pop();
          shouldTrack = last === void 0 ? true : last;
        }
        function track(target, type, key) {
          if (!shouldTrack || activeEffect === void 0) {
            return;
          }
          let depsMap = targetMap.get(target);
          if (!depsMap) {
            targetMap.set(target, (depsMap = new Map()));
          }
          let dep = depsMap.get(key);
          if (!dep) {
            depsMap.set(key, (dep = new Set()));
          }
          if (!dep.has(activeEffect)) {
            dep.add(activeEffect);
            activeEffect.deps.push(dep);
            if (false) {
            }
          }
        }
        function trigger(target, type, key, newValue, oldValue, oldTarget) {
          const depsMap = targetMap.get(target);
          if (!depsMap) {
            return;
          }
          const effects = new Set();
          const add2 = (effectsToAdd) => {
            if (effectsToAdd) {
              effectsToAdd.forEach((effect3) => {
                if (effect3 !== activeEffect || effect3.allowRecurse) {
                  effects.add(effect3);
                }
              });
            }
          };
          if (type === "clear") {
            depsMap.forEach(add2);
          } else if (key === "length" && isArray(target)) {
            depsMap.forEach((dep, key2) => {
              if (key2 === "length" || key2 >= newValue) {
                add2(dep);
              }
            });
          } else {
            if (key !== void 0) {
              add2(depsMap.get(key));
            }
            switch (type) {
              case "add":
                if (!isArray(target)) {
                  add2(depsMap.get(ITERATE_KEY));
                  if (isMap(target)) {
                    add2(depsMap.get(MAP_KEY_ITERATE_KEY));
                  }
                } else if (isIntegerKey(key)) {
                  add2(depsMap.get("length"));
                }
                break;
              case "delete":
                if (!isArray(target)) {
                  add2(depsMap.get(ITERATE_KEY));
                  if (isMap(target)) {
                    add2(depsMap.get(MAP_KEY_ITERATE_KEY));
                  }
                }
                break;
              case "set":
                if (isMap(target)) {
                  add2(depsMap.get(ITERATE_KEY));
                }
                break;
            }
          }
          const run = (effect3) => {
            if (false) {
            }
            if (effect3.options.scheduler) {
              effect3.options.scheduler(effect3);
            } else {
              effect3();
            }
          };
          effects.forEach(run);
        }
        var isNonTrackableKeys = /* @__PURE__ */ makeMap(
          `__proto__,__v_isRef,__isVue`
        );
        var builtInSymbols = new Set(
          Object.getOwnPropertyNames(Symbol)
            .map((key) => Symbol[key])
            .filter(isSymbol)
        );
        var get2 = /* @__PURE__ */ createGetter();
        var shallowGet = /* @__PURE__ */ createGetter(false, true);
        var readonlyGet = /* @__PURE__ */ createGetter(true);
        var shallowReadonlyGet = /* @__PURE__ */ createGetter(true, true);
        var arrayInstrumentations = {};
        ["includes", "indexOf", "lastIndexOf"].forEach((key) => {
          const method = Array.prototype[key];
          arrayInstrumentations[key] = function (...args) {
            const arr = toRaw(this);
            for (let i = 0, l = this.length; i < l; i++) {
              track(arr, "get", i + "");
            }
            const res = method.apply(arr, args);
            if (res === -1 || res === false) {
              return method.apply(arr, args.map(toRaw));
            } else {
              return res;
            }
          };
        });
        ["push", "pop", "shift", "unshift", "splice"].forEach((key) => {
          const method = Array.prototype[key];
          arrayInstrumentations[key] = function (...args) {
            pauseTracking();
            const res = method.apply(this, args);
            resetTracking();
            return res;
          };
        });
        function createGetter(isReadonly = false, shallow = false) {
          return function get3(target, key, receiver) {
            if (key === "__v_isReactive") {
              return !isReadonly;
            } else if (key === "__v_isReadonly") {
              return isReadonly;
            } else if (
              key === "__v_raw" &&
              receiver ===
                (isReadonly
                  ? shallow
                    ? shallowReadonlyMap
                    : readonlyMap
                  : shallow
                  ? shallowReactiveMap
                  : reactiveMap
                ).get(target)
            ) {
              return target;
            }
            const targetIsArray = isArray(target);
            if (
              !isReadonly &&
              targetIsArray &&
              hasOwn(arrayInstrumentations, key)
            ) {
              return Reflect.get(arrayInstrumentations, key, receiver);
            }
            const res = Reflect.get(target, key, receiver);
            if (
              isSymbol(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)
            ) {
              return res;
            }
            if (!isReadonly) {
              track(target, "get", key);
            }
            if (shallow) {
              return res;
            }
            if (isRef(res)) {
              const shouldUnwrap = !targetIsArray || !isIntegerKey(key);
              return shouldUnwrap ? res.value : res;
            }
            if (isObject(res)) {
              return isReadonly ? readonly(res) : reactive2(res);
            }
            return res;
          };
        }
        var set2 = /* @__PURE__ */ createSetter();
        var shallowSet = /* @__PURE__ */ createSetter(true);
        function createSetter(shallow = false) {
          return function set3(target, key, value, receiver) {
            let oldValue = target[key];
            if (!shallow) {
              value = toRaw(value);
              oldValue = toRaw(oldValue);
              if (!isArray(target) && isRef(oldValue) && !isRef(value)) {
                oldValue.value = value;
                return true;
              }
            }
            const hadKey =
              isArray(target) && isIntegerKey(key)
                ? Number(key) < target.length
                : hasOwn(target, key);
            const result = Reflect.set(target, key, value, receiver);
            if (target === toRaw(receiver)) {
              if (!hadKey) {
                trigger(target, "add", key, value);
              } else if (hasChanged(value, oldValue)) {
                trigger(target, "set", key, value, oldValue);
              }
            }
            return result;
          };
        }
        function deleteProperty(target, key) {
          const hadKey = hasOwn(target, key);
          const oldValue = target[key];
          const result = Reflect.deleteProperty(target, key);
          if (result && hadKey) {
            trigger(target, "delete", key, void 0, oldValue);
          }
          return result;
        }
        function has(target, key) {
          const result = Reflect.has(target, key);
          if (!isSymbol(key) || !builtInSymbols.has(key)) {
            track(target, "has", key);
          }
          return result;
        }
        function ownKeys(target) {
          track(target, "iterate", isArray(target) ? "length" : ITERATE_KEY);
          return Reflect.ownKeys(target);
        }
        var mutableHandlers = {
          get: get2,
          set: set2,
          deleteProperty,
          has,
          ownKeys,
        };
        var readonlyHandlers = {
          get: readonlyGet,
          set(target, key) {
            if (false) {
            }
            return true;
          },
          deleteProperty(target, key) {
            if (false) {
            }
            return true;
          },
        };
        var shallowReactiveHandlers = extend({}, mutableHandlers, {
          get: shallowGet,
          set: shallowSet,
        });
        var shallowReadonlyHandlers = extend({}, readonlyHandlers, {
          get: shallowReadonlyGet,
        });
        var toReactive = (value) =>
          isObject(value) ? reactive2(value) : value;
        var toReadonly = (value) => (isObject(value) ? readonly(value) : value);
        var toShallow = (value) => value;
        var getProto = (v) => Reflect.getPrototypeOf(v);
        function get$1(target, key, isReadonly = false, isShallow = false) {
          target = target["__v_raw"];
          const rawTarget = toRaw(target);
          const rawKey = toRaw(key);
          if (key !== rawKey) {
            !isReadonly && track(rawTarget, "get", key);
          }
          !isReadonly && track(rawTarget, "get", rawKey);
          const { has: has2 } = getProto(rawTarget);
          const wrap = isShallow
            ? toShallow
            : isReadonly
            ? toReadonly
            : toReactive;
          if (has2.call(rawTarget, key)) {
            return wrap(target.get(key));
          } else if (has2.call(rawTarget, rawKey)) {
            return wrap(target.get(rawKey));
          } else if (target !== rawTarget) {
            target.get(key);
          }
        }
        function has$1(key, isReadonly = false) {
          const target = this["__v_raw"];
          const rawTarget = toRaw(target);
          const rawKey = toRaw(key);
          if (key !== rawKey) {
            !isReadonly && track(rawTarget, "has", key);
          }
          !isReadonly && track(rawTarget, "has", rawKey);
          return key === rawKey
            ? target.has(key)
            : target.has(key) || target.has(rawKey);
        }
        function size(target, isReadonly = false) {
          target = target["__v_raw"];
          !isReadonly && track(toRaw(target), "iterate", ITERATE_KEY);
          return Reflect.get(target, "size", target);
        }
        function add(value) {
          value = toRaw(value);
          const target = toRaw(this);
          const proto = getProto(target);
          const hadKey = proto.has.call(target, value);
          if (!hadKey) {
            target.add(value);
            trigger(target, "add", value, value);
          }
          return this;
        }
        function set$1(key, value) {
          value = toRaw(value);
          const target = toRaw(this);
          const { has: has2, get: get3 } = getProto(target);
          let hadKey = has2.call(target, key);
          if (!hadKey) {
            key = toRaw(key);
            hadKey = has2.call(target, key);
          } else if (false) {
          }
          const oldValue = get3.call(target, key);
          target.set(key, value);
          if (!hadKey) {
            trigger(target, "add", key, value);
          } else if (hasChanged(value, oldValue)) {
            trigger(target, "set", key, value, oldValue);
          }
          return this;
        }
        function deleteEntry(key) {
          const target = toRaw(this);
          const { has: has2, get: get3 } = getProto(target);
          let hadKey = has2.call(target, key);
          if (!hadKey) {
            key = toRaw(key);
            hadKey = has2.call(target, key);
          } else if (false) {
          }
          const oldValue = get3 ? get3.call(target, key) : void 0;
          const result = target.delete(key);
          if (hadKey) {
            trigger(target, "delete", key, void 0, oldValue);
          }
          return result;
        }
        function clear() {
          const target = toRaw(this);
          const hadItems = target.size !== 0;
          const oldTarget = false ? 0 : void 0;
          const result = target.clear();
          if (hadItems) {
            trigger(target, "clear", void 0, void 0, oldTarget);
          }
          return result;
        }
        function createForEach(isReadonly, isShallow) {
          return function forEach(callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = toRaw(target);
            const wrap = isShallow
              ? toShallow
              : isReadonly
              ? toReadonly
              : toReactive;
            !isReadonly && track(rawTarget, "iterate", ITERATE_KEY);
            return target.forEach((value, key) => {
              return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
          };
        }
        function createIterableMethod(method, isReadonly, isShallow) {
          return function (...args) {
            const target = this["__v_raw"];
            const rawTarget = toRaw(target);
            const targetIsMap = isMap(rawTarget);
            const isPair =
              method === "entries" ||
              (method === Symbol.iterator && targetIsMap);
            const isKeyOnly = method === "keys" && targetIsMap;
            const innerIterator = target[method](...args);
            const wrap = isShallow
              ? toShallow
              : isReadonly
              ? toReadonly
              : toReactive;
            !isReadonly &&
              track(
                rawTarget,
                "iterate",
                isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY
              );
            return {
              next() {
                const { value, done } = innerIterator.next();
                return done
                  ? { value, done }
                  : {
                      value: isPair
                        ? [wrap(value[0]), wrap(value[1])]
                        : wrap(value),
                      done,
                    };
              },
              [Symbol.iterator]() {
                return this;
              },
            };
          };
        }
        function createReadonlyMethod(type) {
          return function (...args) {
            if (false) {
            }
            return type === "delete" ? false : this;
          };
        }
        var mutableInstrumentations = {
          get(key) {
            return get$1(this, key);
          },
          get size() {
            return size(this);
          },
          has: has$1,
          add,
          set: set$1,
          delete: deleteEntry,
          clear,
          forEach: createForEach(false, false),
        };
        var shallowInstrumentations = {
          get(key) {
            return get$1(this, key, false, true);
          },
          get size() {
            return size(this);
          },
          has: has$1,
          add,
          set: set$1,
          delete: deleteEntry,
          clear,
          forEach: createForEach(false, true),
        };
        var readonlyInstrumentations = {
          get(key) {
            return get$1(this, key, true);
          },
          get size() {
            return size(this, true);
          },
          has(key) {
            return has$1.call(this, key, true);
          },
          add: createReadonlyMethod("add"),
          set: createReadonlyMethod("set"),
          delete: createReadonlyMethod("delete"),
          clear: createReadonlyMethod("clear"),
          forEach: createForEach(true, false),
        };
        var shallowReadonlyInstrumentations = {
          get(key) {
            return get$1(this, key, true, true);
          },
          get size() {
            return size(this, true);
          },
          has(key) {
            return has$1.call(this, key, true);
          },
          add: createReadonlyMethod("add"),
          set: createReadonlyMethod("set"),
          delete: createReadonlyMethod("delete"),
          clear: createReadonlyMethod("clear"),
          forEach: createForEach(true, true),
        };
        var iteratorMethods = ["keys", "values", "entries", Symbol.iterator];
        iteratorMethods.forEach((method) => {
          mutableInstrumentations[method] = createIterableMethod(
            method,
            false,
            false
          );
          readonlyInstrumentations[method] = createIterableMethod(
            method,
            true,
            false
          );
          shallowInstrumentations[method] = createIterableMethod(
            method,
            false,
            true
          );
          shallowReadonlyInstrumentations[method] = createIterableMethod(
            method,
            true,
            true
          );
        });
        function createInstrumentationGetter(isReadonly, shallow) {
          const instrumentations = shallow
            ? isReadonly
              ? shallowReadonlyInstrumentations
              : shallowInstrumentations
            : isReadonly
            ? readonlyInstrumentations
            : mutableInstrumentations;
          return (target, key, receiver) => {
            if (key === "__v_isReactive") {
              return !isReadonly;
            } else if (key === "__v_isReadonly") {
              return isReadonly;
            } else if (key === "__v_raw") {
              return target;
            }
            return Reflect.get(
              hasOwn(instrumentations, key) && key in target
                ? instrumentations
                : target,
              key,
              receiver
            );
          };
        }
        var mutableCollectionHandlers = {
          get: createInstrumentationGetter(false, false),
        };
        var shallowCollectionHandlers = {
          get: createInstrumentationGetter(false, true),
        };
        var readonlyCollectionHandlers = {
          get: createInstrumentationGetter(true, false),
        };
        var shallowReadonlyCollectionHandlers = {
          get: createInstrumentationGetter(true, true),
        };
        var reactiveMap = new WeakMap();
        var shallowReactiveMap = new WeakMap();
        var readonlyMap = new WeakMap();
        var shallowReadonlyMap = new WeakMap();
        function targetTypeMap(rawType) {
          switch (rawType) {
            case "Object":
            case "Array":
              return 1;
            case "Map":
            case "Set":
            case "WeakMap":
            case "WeakSet":
              return 2;
            default:
              return 0;
          }
        }
        function getTargetType(value) {
          return value["__v_skip"] || !Object.isExtensible(value)
            ? 0
            : targetTypeMap(toRawType(value));
        }
        function reactive2(target) {
          if (target && target["__v_isReadonly"]) {
            return target;
          }
          return createReactiveObject(
            target,
            false,
            mutableHandlers,
            mutableCollectionHandlers,
            reactiveMap
          );
        }
        function readonly(target) {
          return createReactiveObject(
            target,
            true,
            readonlyHandlers,
            readonlyCollectionHandlers,
            readonlyMap
          );
        }
        function createReactiveObject(
          target,
          isReadonly,
          baseHandlers,
          collectionHandlers,
          proxyMap
        ) {
          if (!isObject(target)) {
            if (false) {
            }
            return target;
          }
          if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) {
            return target;
          }
          const existingProxy = proxyMap.get(target);
          if (existingProxy) {
            return existingProxy;
          }
          const targetType = getTargetType(target);
          if (targetType === 0) {
            return target;
          }
          const proxy = new Proxy(
            target,
            targetType === 2 ? collectionHandlers : baseHandlers
          );
          proxyMap.set(target, proxy);
          return proxy;
        }
        function toRaw(observed) {
          return (observed && toRaw(observed["__v_raw"])) || observed;
        }
        function isRef(r) {
          return Boolean(r && r.__v_isRef === true);
        }

        // packages/alpinejs/src/magics/$nextTick.js
        magic("nextTick", () => nextTick);

        // packages/alpinejs/src/magics/$dispatch.js
        magic("dispatch", (el) => dispatch.bind(dispatch, el));

        // packages/alpinejs/src/magics/$watch.js
        magic(
          "watch",
          (el, { evaluateLater: evaluateLater2, effect: effect3 }) =>
            (key, callback) => {
              let evaluate2 = evaluateLater2(key);
              let firstTime = true;
              let oldValue;
              let effectReference = effect3(() =>
                evaluate2((value) => {
                  JSON.stringify(value);
                  if (!firstTime) {
                    queueMicrotask(() => {
                      callback(value, oldValue);
                      oldValue = value;
                    });
                  } else {
                    oldValue = value;
                  }
                  firstTime = false;
                })
              );
              el._x_effects.delete(effectReference);
            }
        );

        // packages/alpinejs/src/magics/$store.js
        magic("store", getStores);

        // packages/alpinejs/src/magics/$data.js
        magic("data", (el) => scope(el));

        // packages/alpinejs/src/magics/$root.js
        magic("root", (el) => closestRoot(el));

        // packages/alpinejs/src/magics/$refs.js
        magic("refs", (el) => {
          if (el._x_refs_proxy) return el._x_refs_proxy;
          el._x_refs_proxy = mergeProxies(getArrayOfRefObject(el));
          return el._x_refs_proxy;
        });
        function getArrayOfRefObject(el) {
          let refObjects = [];
          let currentEl = el;
          while (currentEl) {
            if (currentEl._x_refs) refObjects.push(currentEl._x_refs);
            currentEl = currentEl.parentNode;
          }
          return refObjects;
        }

        // packages/alpinejs/src/ids.js
        var globalIdMemo = {};
        function findAndIncrementId(name) {
          if (!globalIdMemo[name]) globalIdMemo[name] = 0;
          return ++globalIdMemo[name];
        }
        function closestIdRoot(el, name) {
          return findClosest(el, (element) => {
            if (element._x_ids && element._x_ids[name]) return true;
          });
        }
        function setIdRoot(el, name) {
          if (!el._x_ids) el._x_ids = {};
          if (!el._x_ids[name]) el._x_ids[name] = findAndIncrementId(name);
        }

        // packages/alpinejs/src/magics/$id.js
        magic("id", (el) => (name, key = null) => {
          let root = closestIdRoot(el, name);
          let id = root ? root._x_ids[name] : findAndIncrementId(name);
          return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });

        // packages/alpinejs/src/magics/$el.js
        magic("el", (el) => el);

        // packages/alpinejs/src/magics/index.js
        warnMissingPluginMagic("Focus", "focus", "focus");
        warnMissingPluginMagic("Persist", "persist", "persist");
        function warnMissingPluginMagic(name, magicName, slug) {
          magic(magicName, (el) =>
            warn(
              `You can't use [$${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`,
              el
            )
          );
        }

        // packages/alpinejs/src/directives/x-modelable.js
        directive(
          "modelable",
          (
            el,
            { expression },
            { effect: effect3, evaluateLater: evaluateLater2 }
          ) => {
            let func = evaluateLater2(expression);
            let innerGet = () => {
              let result;
              func((i) => (result = i));
              return result;
            };
            let evaluateInnerSet = evaluateLater2(
              `${expression} = __placeholder`
            );
            let innerSet = (val) =>
              evaluateInnerSet(() => {}, { scope: { __placeholder: val } });
            let initialValue = innerGet();
            innerSet(initialValue);
            queueMicrotask(() => {
              if (!el._x_model) return;
              el._x_removeModelListeners["default"]();
              let outerGet = el._x_model.get;
              let outerSet = el._x_model.set;
              effect3(() => innerSet(outerGet()));
              effect3(() => outerSet(innerGet()));
            });
          }
        );

        // packages/alpinejs/src/directives/x-teleport.js
        directive("teleport", (el, { expression }, { cleanup: cleanup2 }) => {
          if (el.tagName.toLowerCase() !== "template")
            warn("x-teleport can only be used on a <template> tag", el);
          let target = document.querySelector(expression);
          if (!target)
            warn(
              `Cannot find x-teleport element for selector: "${expression}"`
            );
          let clone2 = el.content.cloneNode(true).firstElementChild;
          el._x_teleport = clone2;
          clone2._x_teleportBack = el;
          if (el._x_forwardEvents) {
            el._x_forwardEvents.forEach((eventName) => {
              clone2.addEventListener(eventName, (e) => {
                e.stopPropagation();
                el.dispatchEvent(new e.constructor(e.type, e));
              });
            });
          }
          addScopeToNode(clone2, {}, el);
          mutateDom(() => {
            target.appendChild(clone2);
            initTree(clone2);
            clone2._x_ignore = true;
          });
          cleanup2(() => clone2.remove());
        });

        // packages/alpinejs/src/directives/x-ignore.js
        var handler = () => {};
        handler.inline = (el, { modifiers }, { cleanup: cleanup2 }) => {
          modifiers.includes("self")
            ? (el._x_ignoreSelf = true)
            : (el._x_ignore = true);
          cleanup2(() => {
            modifiers.includes("self")
              ? delete el._x_ignoreSelf
              : delete el._x_ignore;
          });
        };
        directive("ignore", handler);

        // packages/alpinejs/src/directives/x-effect.js
        directive("effect", (el, { expression }, { effect: effect3 }) =>
          effect3(evaluateLater(el, expression))
        );

        // packages/alpinejs/src/utils/on.js
        function on(el, event, modifiers, callback) {
          let listenerTarget = el;
          let handler3 = (e) => callback(e);
          let options = {};
          let wrapHandler = (callback2, wrapper) => (e) =>
            wrapper(callback2, e);
          if (modifiers.includes("dot")) event = dotSyntax(event);
          if (modifiers.includes("camel")) event = camelCase2(event);
          if (modifiers.includes("passive")) options.passive = true;
          if (modifiers.includes("capture")) options.capture = true;
          if (modifiers.includes("window")) listenerTarget = window;
          if (modifiers.includes("document")) listenerTarget = document;
          if (modifiers.includes("prevent"))
            handler3 = wrapHandler(handler3, (next, e) => {
              e.preventDefault();
              next(e);
            });
          if (modifiers.includes("stop"))
            handler3 = wrapHandler(handler3, (next, e) => {
              e.stopPropagation();
              next(e);
            });
          if (modifiers.includes("self"))
            handler3 = wrapHandler(handler3, (next, e) => {
              e.target === el && next(e);
            });
          if (modifiers.includes("away") || modifiers.includes("outside")) {
            listenerTarget = document;
            handler3 = wrapHandler(handler3, (next, e) => {
              if (el.contains(e.target)) return;
              if (e.target.isConnected === false) return;
              if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
              if (el._x_isShown === false) return;
              next(e);
            });
          }
          if (modifiers.includes("once")) {
            handler3 = wrapHandler(handler3, (next, e) => {
              next(e);
              listenerTarget.removeEventListener(event, handler3, options);
            });
          }
          handler3 = wrapHandler(handler3, (next, e) => {
            if (isKeyEvent(event)) {
              if (
                isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)
              ) {
                return;
              }
            }
            next(e);
          });
          if (modifiers.includes("debounce")) {
            let nextModifier =
              modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
            let wait = isNumeric(nextModifier.split("ms")[0])
              ? Number(nextModifier.split("ms")[0])
              : 250;
            handler3 = debounce(handler3, wait);
          }
          if (modifiers.includes("throttle")) {
            let nextModifier =
              modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
            let wait = isNumeric(nextModifier.split("ms")[0])
              ? Number(nextModifier.split("ms")[0])
              : 250;
            handler3 = throttle(handler3, wait);
          }
          listenerTarget.addEventListener(event, handler3, options);
          return () => {
            listenerTarget.removeEventListener(event, handler3, options);
          };
        }
        function dotSyntax(subject) {
          return subject.replace(/-/g, ".");
        }
        function camelCase2(subject) {
          return subject
            .toLowerCase()
            .replace(/-(\w)/g, (match, char) => char.toUpperCase());
        }
        function isNumeric(subject) {
          return !Array.isArray(subject) && !isNaN(subject);
        }
        function kebabCase2(subject) {
          return subject
            .replace(/([a-z])([A-Z])/g, "$1-$2")
            .replace(/[_\s]/, "-")
            .toLowerCase();
        }
        function isKeyEvent(event) {
          return ["keydown", "keyup"].includes(event);
        }
        function isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
          let keyModifiers = modifiers.filter((i) => {
            return !["window", "document", "prevent", "stop", "once"].includes(
              i
            );
          });
          if (keyModifiers.includes("debounce")) {
            let debounceIndex = keyModifiers.indexOf("debounce");
            keyModifiers.splice(
              debounceIndex,
              isNumeric(
                (keyModifiers[debounceIndex + 1] || "invalid-wait").split(
                  "ms"
                )[0]
              )
                ? 2
                : 1
            );
          }
          if (keyModifiers.length === 0) return false;
          if (
            keyModifiers.length === 1 &&
            keyToModifiers(e.key).includes(keyModifiers[0])
          )
            return false;
          const systemKeyModifiers = [
            "ctrl",
            "shift",
            "alt",
            "meta",
            "cmd",
            "super",
          ];
          const selectedSystemKeyModifiers = systemKeyModifiers.filter(
            (modifier) => keyModifiers.includes(modifier)
          );
          keyModifiers = keyModifiers.filter(
            (i) => !selectedSystemKeyModifiers.includes(i)
          );
          if (selectedSystemKeyModifiers.length > 0) {
            const activelyPressedKeyModifiers =
              selectedSystemKeyModifiers.filter((modifier) => {
                if (modifier === "cmd" || modifier === "super")
                  modifier = "meta";
                return e[`${modifier}Key`];
              });
            if (
              activelyPressedKeyModifiers.length ===
              selectedSystemKeyModifiers.length
            ) {
              if (keyToModifiers(e.key).includes(keyModifiers[0])) return false;
            }
          }
          return true;
        }
        function keyToModifiers(key) {
          if (!key) return [];
          key = kebabCase2(key);
          let modifierToKeyMap = {
            ctrl: "control",
            slash: "/",
            space: "-",
            spacebar: "-",
            cmd: "meta",
            esc: "escape",
            up: "arrow-up",
            down: "arrow-down",
            left: "arrow-left",
            right: "arrow-right",
            period: ".",
            equal: "=",
          };
          modifierToKeyMap[key] = key;
          return Object.keys(modifierToKeyMap)
            .map((modifier) => {
              if (modifierToKeyMap[modifier] === key) return modifier;
            })
            .filter((modifier) => modifier);
        }

        // packages/alpinejs/src/directives/x-model.js
        directive(
          "model",
          (
            el,
            { modifiers, expression },
            { effect: effect3, cleanup: cleanup2 }
          ) => {
            let evaluate2 = evaluateLater(el, expression);
            let assignmentExpression = `${expression} = rightSideOfExpression($event, ${expression})`;
            let evaluateAssignment = evaluateLater(el, assignmentExpression);
            var event =
              el.tagName.toLowerCase() === "select" ||
              ["checkbox", "radio"].includes(el.type) ||
              modifiers.includes("lazy")
                ? "change"
                : "input";
            let assigmentFunction = generateAssignmentFunction(
              el,
              modifiers,
              expression
            );
            let removeListener = on(el, event, modifiers, (e) => {
              evaluateAssignment(() => {}, {
                scope: {
                  $event: e,
                  rightSideOfExpression: assigmentFunction,
                },
              });
            });
            if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
            el._x_removeModelListeners["default"] = removeListener;
            cleanup2(() => el._x_removeModelListeners["default"]());
            let evaluateSetModel = evaluateLater(
              el,
              `${expression} = __placeholder`
            );
            el._x_model = {
              get() {
                let result;
                evaluate2((value) => (result = value));
                return result;
              },
              set(value) {
                evaluateSetModel(() => {}, { scope: { __placeholder: value } });
              },
            };
            el._x_forceModelUpdate = () => {
              evaluate2((value) => {
                if (value === void 0 && expression.match(/\./)) value = "";
                window.fromModel = true;
                mutateDom(() => bind(el, "value", value));
                delete window.fromModel;
              });
            };
            effect3(() => {
              if (
                modifiers.includes("unintrusive") &&
                document.activeElement.isSameNode(el)
              )
                return;
              el._x_forceModelUpdate();
            });
          }
        );
        function generateAssignmentFunction(el, modifiers, expression) {
          if (el.type === "radio") {
            mutateDom(() => {
              if (!el.hasAttribute("name")) el.setAttribute("name", expression);
            });
          }
          return (event, currentValue) => {
            return mutateDom(() => {
              if (event instanceof CustomEvent && event.detail !== void 0) {
                return event.detail || event.target.value;
              } else if (el.type === "checkbox") {
                if (Array.isArray(currentValue)) {
                  let newValue = modifiers.includes("number")
                    ? safeParseNumber(event.target.value)
                    : event.target.value;
                  return event.target.checked
                    ? currentValue.concat([newValue])
                    : currentValue.filter(
                        (el2) => !checkedAttrLooseCompare2(el2, newValue)
                      );
                } else {
                  return event.target.checked;
                }
              } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
                return modifiers.includes("number")
                  ? Array.from(event.target.selectedOptions).map((option) => {
                      let rawValue = option.value || option.text;
                      return safeParseNumber(rawValue);
                    })
                  : Array.from(event.target.selectedOptions).map((option) => {
                      return option.value || option.text;
                    });
              } else {
                let rawValue = event.target.value;
                return modifiers.includes("number")
                  ? safeParseNumber(rawValue)
                  : modifiers.includes("trim")
                  ? rawValue.trim()
                  : rawValue;
              }
            });
          };
        }
        function safeParseNumber(rawValue) {
          let number = rawValue ? parseFloat(rawValue) : null;
          return isNumeric2(number) ? number : rawValue;
        }
        function checkedAttrLooseCompare2(valueA, valueB) {
          return valueA == valueB;
        }
        function isNumeric2(subject) {
          return !Array.isArray(subject) && !isNaN(subject);
        }

        // packages/alpinejs/src/directives/x-cloak.js
        directive("cloak", (el) =>
          queueMicrotask(() =>
            mutateDom(() => el.removeAttribute(prefix("cloak")))
          )
        );

        // packages/alpinejs/src/directives/x-init.js
        addInitSelector(() => `[${prefix("init")}]`);
        directive(
          "init",
          skipDuringClone((el, { expression }, { evaluate: evaluate2 }) => {
            if (typeof expression === "string") {
              return !!expression.trim() && evaluate2(expression, {}, false);
            }
            return evaluate2(expression, {}, false);
          })
        );

        // packages/alpinejs/src/directives/x-text.js
        directive(
          "text",
          (
            el,
            { expression },
            { effect: effect3, evaluateLater: evaluateLater2 }
          ) => {
            let evaluate2 = evaluateLater2(expression);
            effect3(() => {
              evaluate2((value) => {
                mutateDom(() => {
                  el.textContent = value;
                });
              });
            });
          }
        );

        // packages/alpinejs/src/directives/x-html.js
        directive(
          "html",
          (
            el,
            { expression },
            { effect: effect3, evaluateLater: evaluateLater2 }
          ) => {
            let evaluate2 = evaluateLater2(expression);
            effect3(() => {
              evaluate2((value) => {
                mutateDom(() => {
                  el.innerHTML = value;
                  el._x_ignoreSelf = true;
                  initTree(el);
                  delete el._x_ignoreSelf;
                });
              });
            });
          }
        );

        // packages/alpinejs/src/directives/x-bind.js
        mapAttributes(startingWith(":", into(prefix("bind:"))));
        directive(
          "bind",
          (
            el,
            { value, modifiers, expression, original },
            { effect: effect3 }
          ) => {
            if (!value) {
              return applyBindingsObject(el, expression, original, effect3);
            }
            if (value === "key") return storeKeyForXFor(el, expression);
            let evaluate2 = evaluateLater(el, expression);
            effect3(() =>
              evaluate2((result) => {
                if (result === void 0 && expression.match(/\./)) result = "";
                mutateDom(() => bind(el, value, result, modifiers));
              })
            );
          }
        );
        function applyBindingsObject(el, expression, original, effect3) {
          let bindingProviders = {};
          injectBindingProviders(bindingProviders);
          let getBindings = evaluateLater(el, expression);
          let cleanupRunners = [];
          while (cleanupRunners.length) cleanupRunners.pop()();
          getBindings(
            (bindings) => {
              let attributes = Object.entries(bindings).map(
                ([name, value]) => ({ name, value })
              );
              let staticAttributes = attributesOnly(attributes);
              attributes = attributes.map((attribute) => {
                if (
                  staticAttributes.find((attr) => attr.name === attribute.name)
                ) {
                  return {
                    name: `x-bind:${attribute.name}`,
                    value: `"${attribute.value}"`,
                  };
                }
                return attribute;
              });
              directives(el, attributes, original).map((handle) => {
                cleanupRunners.push(handle.runCleanups);
                handle();
              });
            },
            { scope: bindingProviders }
          );
        }
        function storeKeyForXFor(el, expression) {
          el._x_keyExpression = expression;
        }

        // packages/alpinejs/src/directives/x-data.js
        addRootSelector(() => `[${prefix("data")}]`);
        directive(
          "data",
          skipDuringClone((el, { expression }, { cleanup: cleanup2 }) => {
            expression = expression === "" ? "{}" : expression;
            let magicContext = {};
            injectMagics(magicContext, el);
            let dataProviderContext = {};
            injectDataProviders(dataProviderContext, magicContext);
            let data2 = evaluate(el, expression, {
              scope: dataProviderContext,
            });
            if (data2 === void 0) data2 = {};
            injectMagics(data2, el);
            let reactiveData = reactive(data2);
            initInterceptors(reactiveData);
            let undo = addScopeToNode(el, reactiveData);
            reactiveData["init"] && evaluate(el, reactiveData["init"]);
            cleanup2(() => {
              reactiveData["destroy"] && evaluate(el, reactiveData["destroy"]);
              undo();
            });
          })
        );

        // packages/alpinejs/src/directives/x-show.js
        directive(
          "show",
          (el, { modifiers, expression }, { effect: effect3 }) => {
            let evaluate2 = evaluateLater(el, expression);
            if (!el._x_doHide)
              el._x_doHide = () => {
                mutateDom(() => (el.style.display = "none"));
              };
            if (!el._x_doShow)
              el._x_doShow = () => {
                mutateDom(() => {
                  if (el.style.length === 1 && el.style.display === "none") {
                    el.removeAttribute("style");
                  } else {
                    el.style.removeProperty("display");
                  }
                });
              };
            let hide = () => {
              el._x_doHide();
              el._x_isShown = false;
            };
            let show = () => {
              el._x_doShow();
              el._x_isShown = true;
            };
            let clickAwayCompatibleShow = () => setTimeout(show);
            let toggle = once(
              (value) => (value ? show() : hide()),
              (value) => {
                if (
                  typeof el._x_toggleAndCascadeWithTransitions === "function"
                ) {
                  el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
                } else {
                  value ? clickAwayCompatibleShow() : hide();
                }
              }
            );
            let oldValue;
            let firstTime = true;
            effect3(() =>
              evaluate2((value) => {
                if (!firstTime && value === oldValue) return;
                if (modifiers.includes("immediate"))
                  value ? clickAwayCompatibleShow() : hide();
                toggle(value);
                oldValue = value;
                firstTime = false;
              })
            );
          }
        );

        // packages/alpinejs/src/directives/x-for.js
        directive(
          "for",
          (el, { expression }, { effect: effect3, cleanup: cleanup2 }) => {
            let iteratorNames = parseForExpression(expression);
            let evaluateItems = evaluateLater(el, iteratorNames.items);
            let evaluateKey = evaluateLater(el, el._x_keyExpression || "index");
            el._x_prevKeys = [];
            el._x_lookup = {};
            effect3(() => loop(el, iteratorNames, evaluateItems, evaluateKey));
            cleanup2(() => {
              Object.values(el._x_lookup).forEach((el2) => el2.remove());
              delete el._x_prevKeys;
              delete el._x_lookup;
            });
          }
        );
        function loop(el, iteratorNames, evaluateItems, evaluateKey) {
          let isObject2 = (i) => typeof i === "object" && !Array.isArray(i);
          let templateEl = el;
          evaluateItems((items) => {
            if (isNumeric3(items) && items >= 0) {
              items = Array.from(Array(items).keys(), (i) => i + 1);
            }
            if (items === void 0) items = [];
            let lookup = el._x_lookup;
            let prevKeys = el._x_prevKeys;
            let scopes = [];
            let keys = [];
            if (isObject2(items)) {
              items = Object.entries(items).map(([key, value]) => {
                let scope2 = getIterationScopeVariables(
                  iteratorNames,
                  value,
                  key,
                  items
                );
                evaluateKey((value2) => keys.push(value2), {
                  scope: { index: key, ...scope2 },
                });
                scopes.push(scope2);
              });
            } else {
              for (let i = 0; i < items.length; i++) {
                let scope2 = getIterationScopeVariables(
                  iteratorNames,
                  items[i],
                  i,
                  items
                );
                evaluateKey((value) => keys.push(value), {
                  scope: { index: i, ...scope2 },
                });
                scopes.push(scope2);
              }
            }
            let adds = [];
            let moves = [];
            let removes = [];
            let sames = [];
            for (let i = 0; i < prevKeys.length; i++) {
              let key = prevKeys[i];
              if (keys.indexOf(key) === -1) removes.push(key);
            }
            prevKeys = prevKeys.filter((key) => !removes.includes(key));
            let lastKey = "template";
            for (let i = 0; i < keys.length; i++) {
              let key = keys[i];
              let prevIndex = prevKeys.indexOf(key);
              if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([lastKey, i]);
              } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([keyInSpot, keyForSpot]);
              } else {
                sames.push(key);
              }
              lastKey = key;
            }
            for (let i = 0; i < removes.length; i++) {
              let key = removes[i];
              if (!!lookup[key]._x_effects) {
                lookup[key]._x_effects.forEach(dequeueJob);
              }
              lookup[key].remove();
              lookup[key] = null;
              delete lookup[key];
            }
            for (let i = 0; i < moves.length; i++) {
              let [keyInSpot, keyForSpot] = moves[i];
              let elInSpot = lookup[keyInSpot];
              let elForSpot = lookup[keyForSpot];
              let marker = document.createElement("div");
              mutateDom(() => {
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl &&
                  elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl &&
                  elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
              });
              refreshScope(elForSpot, scopes[keys.indexOf(keyForSpot)]);
            }
            for (let i = 0; i < adds.length; i++) {
              let [lastKey2, index] = adds[i];
              let lastEl =
                lastKey2 === "template" ? templateEl : lookup[lastKey2];
              if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
              let scope2 = scopes[index];
              let key = keys[index];
              let clone2 = document.importNode(
                templateEl.content,
                true
              ).firstElementChild;
              addScopeToNode(clone2, reactive(scope2), templateEl);
              mutateDom(() => {
                lastEl.after(clone2);
                initTree(clone2);
              });
              if (typeof key === "object") {
                warn(
                  "x-for key cannot be an object, it must be a string or an integer",
                  templateEl
                );
              }
              lookup[key] = clone2;
            }
            for (let i = 0; i < sames.length; i++) {
              refreshScope(lookup[sames[i]], scopes[keys.indexOf(sames[i])]);
            }
            templateEl._x_prevKeys = keys;
          });
        }
        function parseForExpression(expression) {
          let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
          let stripParensRE = /^\s*\(|\)\s*$/g;
          let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
          let inMatch = expression.match(forAliasRE);
          if (!inMatch) return;
          let res = {};
          res.items = inMatch[2].trim();
          let item = inMatch[1].replace(stripParensRE, "").trim();
          let iteratorMatch = item.match(forIteratorRE);
          if (iteratorMatch) {
            res.item = item.replace(forIteratorRE, "").trim();
            res.index = iteratorMatch[1].trim();
            if (iteratorMatch[2]) {
              res.collection = iteratorMatch[2].trim();
            }
          } else {
            res.item = item;
          }
          return res;
        }
        function getIterationScopeVariables(iteratorNames, item, index, items) {
          let scopeVariables = {};
          if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
            let names = iteratorNames.item
              .replace("[", "")
              .replace("]", "")
              .split(",")
              .map((i) => i.trim());
            names.forEach((name, i) => {
              scopeVariables[name] = item[i];
            });
          } else if (
            /^\{.*\}$/.test(iteratorNames.item) &&
            !Array.isArray(item) &&
            typeof item === "object"
          ) {
            let names = iteratorNames.item
              .replace("{", "")
              .replace("}", "")
              .split(",")
              .map((i) => i.trim());
            names.forEach((name) => {
              scopeVariables[name] = item[name];
            });
          } else {
            scopeVariables[iteratorNames.item] = item;
          }
          if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
          if (iteratorNames.collection)
            scopeVariables[iteratorNames.collection] = items;
          return scopeVariables;
        }
        function isNumeric3(subject) {
          return !Array.isArray(subject) && !isNaN(subject);
        }

        // packages/alpinejs/src/directives/x-ref.js
        function handler2() {}
        handler2.inline = (el, { expression }, { cleanup: cleanup2 }) => {
          let root = closestRoot(el);
          if (!root._x_refs) root._x_refs = {};
          root._x_refs[expression] = el;
          cleanup2(() => delete root._x_refs[expression]);
        };
        directive("ref", handler2);

        // packages/alpinejs/src/directives/x-if.js
        directive(
          "if",
          (el, { expression }, { effect: effect3, cleanup: cleanup2 }) => {
            let evaluate2 = evaluateLater(el, expression);
            let show = () => {
              if (el._x_currentIfEl) return el._x_currentIfEl;
              let clone2 = el.content.cloneNode(true).firstElementChild;
              addScopeToNode(clone2, {}, el);
              mutateDom(() => {
                el.after(clone2);
                initTree(clone2);
              });
              el._x_currentIfEl = clone2;
              el._x_undoIf = () => {
                walk(clone2, (node) => {
                  if (!!node._x_effects) {
                    node._x_effects.forEach(dequeueJob);
                  }
                });
                clone2.remove();
                delete el._x_currentIfEl;
              };
              return clone2;
            };
            let hide = () => {
              if (!el._x_undoIf) return;
              el._x_undoIf();
              delete el._x_undoIf;
            };
            effect3(() =>
              evaluate2((value) => {
                value ? show() : hide();
              })
            );
            cleanup2(() => el._x_undoIf && el._x_undoIf());
          }
        );

        // packages/alpinejs/src/directives/x-id.js
        directive("id", (el, { expression }, { evaluate: evaluate2 }) => {
          let names = evaluate2(expression);
          names.forEach((name) => setIdRoot(el, name));
        });

        // packages/alpinejs/src/directives/x-on.js
        mapAttributes(startingWith("@", into(prefix("on:"))));
        directive(
          "on",
          skipDuringClone(
            (el, { value, modifiers, expression }, { cleanup: cleanup2 }) => {
              let evaluate2 = expression
                ? evaluateLater(el, expression)
                : () => {};
              if (el.tagName.toLowerCase() === "template") {
                if (!el._x_forwardEvents) el._x_forwardEvents = [];
                if (!el._x_forwardEvents.includes(value))
                  el._x_forwardEvents.push(value);
              }
              let removeListener = on(el, value, modifiers, (e) => {
                evaluate2(() => {}, { scope: { $event: e }, params: [e] });
              });
              cleanup2(() => removeListener());
            }
          )
        );

        // packages/alpinejs/src/directives/index.js
        warnMissingPluginDirective("Collapse", "collapse", "collapse");
        warnMissingPluginDirective("Intersect", "intersect", "intersect");
        warnMissingPluginDirective("Focus", "trap", "focus");
        warnMissingPluginDirective("Mask", "mask", "mask");
        function warnMissingPluginDirective(name, directiveName2, slug) {
          directive(directiveName2, (el) =>
            warn(
              `You can't use [x-${directiveName2}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`,
              el
            )
          );
        }

        // packages/alpinejs/src/index.js
        alpine_default.setEvaluator(normalEvaluator);
        alpine_default.setReactivityEngine({
          reactive: reactive2,
          effect: effect2,
          release: stop,
          raw: toRaw,
        });
        var src_default = alpine_default;

        // packages/alpinejs/builds/module.js
        var module_default = src_default;

        /***/
      },

    /***/ "./node_modules/axios/index.js":
      /*!*************************************!*\
  !*** ./node_modules/axios/index.js ***!
  \*************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        module.exports = __webpack_require__(
          /*! ./lib/axios */ "./node_modules/axios/lib/axios.js"
        );

        /***/
      },

    /***/ "./node_modules/axios/lib/adapters/xhr.js":
      /*!************************************************!*\
  !*** ./node_modules/axios/lib/adapters/xhr.js ***!
  \************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var utils = __webpack_require__(
          /*! ./../utils */ "./node_modules/axios/lib/utils.js"
        );
        var settle = __webpack_require__(
          /*! ./../core/settle */ "./node_modules/axios/lib/core/settle.js"
        );
        var cookies = __webpack_require__(
          /*! ./../helpers/cookies */ "./node_modules/axios/lib/helpers/cookies.js"
        );
        var buildURL = __webpack_require__(
          /*! ./../helpers/buildURL */ "./node_modules/axios/lib/helpers/buildURL.js"
        );
        var buildFullPath = __webpack_require__(
          /*! ../core/buildFullPath */ "./node_modules/axios/lib/core/buildFullPath.js"
        );
        var parseHeaders = __webpack_require__(
          /*! ./../helpers/parseHeaders */ "./node_modules/axios/lib/helpers/parseHeaders.js"
        );
        var isURLSameOrigin = __webpack_require__(
          /*! ./../helpers/isURLSameOrigin */ "./node_modules/axios/lib/helpers/isURLSameOrigin.js"
        );
        var createError = __webpack_require__(
          /*! ../core/createError */ "./node_modules/axios/lib/core/createError.js"
        );

        module.exports = function xhrAdapter(config) {
          return new Promise(function dispatchXhrRequest(resolve, reject) {
            var requestData = config.data;
            var requestHeaders = config.headers;
            var responseType = config.responseType;

            if (utils.isFormData(requestData)) {
              delete requestHeaders["Content-Type"]; // Let the browser set it
            }

            var request = new XMLHttpRequest();

            // HTTP basic authentication
            if (config.auth) {
              var username = config.auth.username || "";
              var password = config.auth.password
                ? unescape(encodeURIComponent(config.auth.password))
                : "";
              requestHeaders.Authorization =
                "Basic " + btoa(username + ":" + password);
            }

            var fullPath = buildFullPath(config.baseURL, config.url);
            request.open(
              config.method.toUpperCase(),
              buildURL(fullPath, config.params, config.paramsSerializer),
              true
            );

            // Set the request timeout in MS
            request.timeout = config.timeout;

            function onloadend() {
              if (!request) {
                return;
              }
              // Prepare the response
              var responseHeaders =
                "getAllResponseHeaders" in request
                  ? parseHeaders(request.getAllResponseHeaders())
                  : null;
              var responseData =
                !responseType ||
                responseType === "text" ||
                responseType === "json"
                  ? request.responseText
                  : request.response;
              var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request,
              };

              settle(resolve, reject, response);

              // Clean up request
              request = null;
            }

            if ("onloadend" in request) {
              // Use onloadend if available
              request.onloadend = onloadend;
            } else {
              // Listen for ready state to emulate onloadend
              request.onreadystatechange = function handleLoad() {
                if (!request || request.readyState !== 4) {
                  return;
                }

                // The request errored out and we didn't get a response, this will be
                // handled by onerror instead
                // With one exception: request that using file: protocol, most browsers
                // will return status as 0 even though it's a successful request
                if (
                  request.status === 0 &&
                  !(
                    request.responseURL &&
                    request.responseURL.indexOf("file:") === 0
                  )
                ) {
                  return;
                }
                // readystate handler is calling before onerror or ontimeout handlers,
                // so we should call onloadend on the next 'tick'
                setTimeout(onloadend);
              };
            }

            // Handle browser request cancellation (as opposed to a manual cancellation)
            request.onabort = function handleAbort() {
              if (!request) {
                return;
              }

              reject(
                createError("Request aborted", config, "ECONNABORTED", request)
              );

              // Clean up request
              request = null;
            };

            // Handle low level network errors
            request.onerror = function handleError() {
              // Real errors are hidden from us by the browser
              // onerror should only fire if it's a network error
              reject(createError("Network Error", config, null, request));

              // Clean up request
              request = null;
            };

            // Handle timeout
            request.ontimeout = function handleTimeout() {
              var timeoutErrorMessage =
                "timeout of " + config.timeout + "ms exceeded";
              if (config.timeoutErrorMessage) {
                timeoutErrorMessage = config.timeoutErrorMessage;
              }
              reject(
                createError(
                  timeoutErrorMessage,
                  config,
                  config.transitional && config.transitional.clarifyTimeoutError
                    ? "ETIMEDOUT"
                    : "ECONNABORTED",
                  request
                )
              );

              // Clean up request
              request = null;
            };

            // Add xsrf header
            // This is only done if running in a standard browser environment.
            // Specifically not if we're in a web worker, or react-native.
            if (utils.isStandardBrowserEnv()) {
              // Add xsrf header
              var xsrfValue =
                (config.withCredentials || isURLSameOrigin(fullPath)) &&
                config.xsrfCookieName
                  ? cookies.read(config.xsrfCookieName)
                  : undefined;

              if (xsrfValue) {
                requestHeaders[config.xsrfHeaderName] = xsrfValue;
              }
            }

            // Add headers to the request
            if ("setRequestHeader" in request) {
              utils.forEach(
                requestHeaders,
                function setRequestHeader(val, key) {
                  if (
                    typeof requestData === "undefined" &&
                    key.toLowerCase() === "content-type"
                  ) {
                    // Remove Content-Type if data is undefined
                    delete requestHeaders[key];
                  } else {
                    // Otherwise add header to the request
                    request.setRequestHeader(key, val);
                  }
                }
              );
            }

            // Add withCredentials to request if needed
            if (!utils.isUndefined(config.withCredentials)) {
              request.withCredentials = !!config.withCredentials;
            }

            // Add responseType to request if needed
            if (responseType && responseType !== "json") {
              request.responseType = config.responseType;
            }

            // Handle progress if needed
            if (typeof config.onDownloadProgress === "function") {
              request.addEventListener("progress", config.onDownloadProgress);
            }

            // Not all browsers support upload events
            if (
              typeof config.onUploadProgress === "function" &&
              request.upload
            ) {
              request.upload.addEventListener(
                "progress",
                config.onUploadProgress
              );
            }

            if (config.cancelToken) {
              // Handle cancellation
              config.cancelToken.promise.then(function onCanceled(cancel) {
                if (!request) {
                  return;
                }

                request.abort();
                reject(cancel);
                // Clean up request
                request = null;
              });
            }

            if (!requestData) {
              requestData = null;
            }

            // Send the request
            request.send(requestData);
          });
        };

        /***/
      },

    /***/ "./node_modules/axios/lib/axios.js":
      /*!*****************************************!*\
  !*** ./node_modules/axios/lib/axios.js ***!
  \*****************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var utils = __webpack_require__(
          /*! ./utils */ "./node_modules/axios/lib/utils.js"
        );
        var bind = __webpack_require__(
          /*! ./helpers/bind */ "./node_modules/axios/lib/helpers/bind.js"
        );
        var Axios = __webpack_require__(
          /*! ./core/Axios */ "./node_modules/axios/lib/core/Axios.js"
        );
        var mergeConfig = __webpack_require__(
          /*! ./core/mergeConfig */ "./node_modules/axios/lib/core/mergeConfig.js"
        );
        var defaults = __webpack_require__(
          /*! ./defaults */ "./node_modules/axios/lib/defaults.js"
        );

        /**
         * Create an instance of Axios
         *
         * @param {Object} defaultConfig The default config for the instance
         * @return {Axios} A new instance of Axios
         */
        function createInstance(defaultConfig) {
          var context = new Axios(defaultConfig);
          var instance = bind(Axios.prototype.request, context);

          // Copy axios.prototype to instance
          utils.extend(instance, Axios.prototype, context);

          // Copy context to instance
          utils.extend(instance, context);

          return instance;
        }

        // Create the default instance to be exported
        var axios = createInstance(defaults);

        // Expose Axios class to allow class inheritance
        axios.Axios = Axios;

        // Factory for creating new instances
        axios.create = function create(instanceConfig) {
          return createInstance(mergeConfig(axios.defaults, instanceConfig));
        };

        // Expose Cancel & CancelToken
        axios.Cancel = __webpack_require__(
          /*! ./cancel/Cancel */ "./node_modules/axios/lib/cancel/Cancel.js"
        );
        axios.CancelToken = __webpack_require__(
          /*! ./cancel/CancelToken */ "./node_modules/axios/lib/cancel/CancelToken.js"
        );
        axios.isCancel = __webpack_require__(
          /*! ./cancel/isCancel */ "./node_modules/axios/lib/cancel/isCancel.js"
        );

        // Expose all/spread
        axios.all = function all(promises) {
          return Promise.all(promises);
        };
        axios.spread = __webpack_require__(
          /*! ./helpers/spread */ "./node_modules/axios/lib/helpers/spread.js"
        );

        // Expose isAxiosError
        axios.isAxiosError = __webpack_require__(
          /*! ./helpers/isAxiosError */ "./node_modules/axios/lib/helpers/isAxiosError.js"
        );

        module.exports = axios;

        // Allow use of default import syntax in TypeScript
        module.exports["default"] = axios;

        /***/
      },

    /***/ "./node_modules/axios/lib/cancel/Cancel.js":
      /*!*************************************************!*\
  !*** ./node_modules/axios/lib/cancel/Cancel.js ***!
  \*************************************************/
      /***/ (module) => {
        "use strict";

        /**
         * A `Cancel` is an object that is thrown when an operation is canceled.
         *
         * @class
         * @param {string=} message The message.
         */
        function Cancel(message) {
          this.message = message;
        }

        Cancel.prototype.toString = function toString() {
          return "Cancel" + (this.message ? ": " + this.message : "");
        };

        Cancel.prototype.__CANCEL__ = true;

        module.exports = Cancel;

        /***/
      },

    /***/ "./node_modules/axios/lib/cancel/CancelToken.js":
      /*!******************************************************!*\
  !*** ./node_modules/axios/lib/cancel/CancelToken.js ***!
  \******************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var Cancel = __webpack_require__(
          /*! ./Cancel */ "./node_modules/axios/lib/cancel/Cancel.js"
        );

        /**
         * A `CancelToken` is an object that can be used to request cancellation of an operation.
         *
         * @class
         * @param {Function} executor The executor function.
         */
        function CancelToken(executor) {
          if (typeof executor !== "function") {
            throw new TypeError("executor must be a function.");
          }

          var resolvePromise;
          this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
          });

          var token = this;
          executor(function cancel(message) {
            if (token.reason) {
              // Cancellation has already been requested
              return;
            }

            token.reason = new Cancel(message);
            resolvePromise(token.reason);
          });
        }

        /**
         * Throws a `Cancel` if cancellation has been requested.
         */
        CancelToken.prototype.throwIfRequested = function throwIfRequested() {
          if (this.reason) {
            throw this.reason;
          }
        };

        /**
         * Returns an object that contains a new `CancelToken` and a function that, when called,
         * cancels the `CancelToken`.
         */
        CancelToken.source = function source() {
          var cancel;
          var token = new CancelToken(function executor(c) {
            cancel = c;
          });
          return {
            token: token,
            cancel: cancel,
          };
        };

        module.exports = CancelToken;

        /***/
      },

    /***/ "./node_modules/axios/lib/cancel/isCancel.js":
      /*!***************************************************!*\
  !*** ./node_modules/axios/lib/cancel/isCancel.js ***!
  \***************************************************/
      /***/ (module) => {
        "use strict";

        module.exports = function isCancel(value) {
          return !!(value && value.__CANCEL__);
        };

        /***/
      },

    /***/ "./node_modules/axios/lib/core/Axios.js":
      /*!**********************************************!*\
  !*** ./node_modules/axios/lib/core/Axios.js ***!
  \**********************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var utils = __webpack_require__(
          /*! ./../utils */ "./node_modules/axios/lib/utils.js"
        );
        var buildURL = __webpack_require__(
          /*! ../helpers/buildURL */ "./node_modules/axios/lib/helpers/buildURL.js"
        );
        var InterceptorManager = __webpack_require__(
          /*! ./InterceptorManager */ "./node_modules/axios/lib/core/InterceptorManager.js"
        );
        var dispatchRequest = __webpack_require__(
          /*! ./dispatchRequest */ "./node_modules/axios/lib/core/dispatchRequest.js"
        );
        var mergeConfig = __webpack_require__(
          /*! ./mergeConfig */ "./node_modules/axios/lib/core/mergeConfig.js"
        );
        var validator = __webpack_require__(
          /*! ../helpers/validator */ "./node_modules/axios/lib/helpers/validator.js"
        );

        var validators = validator.validators;
        /**
         * Create a new instance of Axios
         *
         * @param {Object} instanceConfig The default config for the instance
         */
        function Axios(instanceConfig) {
          this.defaults = instanceConfig;
          this.interceptors = {
            request: new InterceptorManager(),
            response: new InterceptorManager(),
          };
        }

        /**
         * Dispatch a request
         *
         * @param {Object} config The config specific for this request (merged with this.defaults)
         */
        Axios.prototype.request = function request(config) {
          /*eslint no-param-reassign:0*/
          // Allow for axios('example/url'[, config]) a la fetch API
          if (typeof config === "string") {
            config = arguments[1] || {};
            config.url = arguments[0];
          } else {
            config = config || {};
          }

          config = mergeConfig(this.defaults, config);

          // Set config.method
          if (config.method) {
            config.method = config.method.toLowerCase();
          } else if (this.defaults.method) {
            config.method = this.defaults.method.toLowerCase();
          } else {
            config.method = "get";
          }

          var transitional = config.transitional;

          if (transitional !== undefined) {
            validator.assertOptions(
              transitional,
              {
                silentJSONParsing: validators.transitional(
                  validators.boolean,
                  "1.0.0"
                ),
                forcedJSONParsing: validators.transitional(
                  validators.boolean,
                  "1.0.0"
                ),
                clarifyTimeoutError: validators.transitional(
                  validators.boolean,
                  "1.0.0"
                ),
              },
              false
            );
          }

          // filter out skipped interceptors
          var requestInterceptorChain = [];
          var synchronousRequestInterceptors = true;
          this.interceptors.request.forEach(function unshiftRequestInterceptors(
            interceptor
          ) {
            if (
              typeof interceptor.runWhen === "function" &&
              interceptor.runWhen(config) === false
            ) {
              return;
            }

            synchronousRequestInterceptors =
              synchronousRequestInterceptors && interceptor.synchronous;

            requestInterceptorChain.unshift(
              interceptor.fulfilled,
              interceptor.rejected
            );
          });

          var responseInterceptorChain = [];
          this.interceptors.response.forEach(function pushResponseInterceptors(
            interceptor
          ) {
            responseInterceptorChain.push(
              interceptor.fulfilled,
              interceptor.rejected
            );
          });

          var promise;

          if (!synchronousRequestInterceptors) {
            var chain = [dispatchRequest, undefined];

            Array.prototype.unshift.apply(chain, requestInterceptorChain);
            chain = chain.concat(responseInterceptorChain);

            promise = Promise.resolve(config);
            while (chain.length) {
              promise = promise.then(chain.shift(), chain.shift());
            }

            return promise;
          }

          var newConfig = config;
          while (requestInterceptorChain.length) {
            var onFulfilled = requestInterceptorChain.shift();
            var onRejected = requestInterceptorChain.shift();
            try {
              newConfig = onFulfilled(newConfig);
            } catch (error) {
              onRejected(error);
              break;
            }
          }

          try {
            promise = dispatchRequest(newConfig);
          } catch (error) {
            return Promise.reject(error);
          }

          while (responseInterceptorChain.length) {
            promise = promise.then(
              responseInterceptorChain.shift(),
              responseInterceptorChain.shift()
            );
          }

          return promise;
        };

        Axios.prototype.getUri = function getUri(config) {
          config = mergeConfig(this.defaults, config);
          return buildURL(
            config.url,
            config.params,
            config.paramsSerializer
          ).replace(/^\?/, "");
        };

        // Provide aliases for supported request methods
        utils.forEach(
          ["delete", "get", "head", "options"],
          function forEachMethodNoData(method) {
            /*eslint func-names:0*/
            Axios.prototype[method] = function (url, config) {
              return this.request(
                mergeConfig(config || {}, {
                  method: method,
                  url: url,
                  data: (config || {}).data,
                })
              );
            };
          }
        );

        utils.forEach(
          ["post", "put", "patch"],
          function forEachMethodWithData(method) {
            /*eslint func-names:0*/
            Axios.prototype[method] = function (url, data, config) {
              return this.request(
                mergeConfig(config || {}, {
                  method: method,
                  url: url,
                  data: data,
                })
              );
            };
          }
        );

        module.exports = Axios;

        /***/
      },

    /***/ "./node_modules/axios/lib/core/InterceptorManager.js":
      /*!***********************************************************!*\
  !*** ./node_modules/axios/lib/core/InterceptorManager.js ***!
  \***********************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var utils = __webpack_require__(
          /*! ./../utils */ "./node_modules/axios/lib/utils.js"
        );

        function InterceptorManager() {
          this.handlers = [];
        }

        /**
         * Add a new interceptor to the stack
         *
         * @param {Function} fulfilled The function to handle `then` for a `Promise`
         * @param {Function} rejected The function to handle `reject` for a `Promise`
         *
         * @return {Number} An ID used to remove interceptor later
         */
        InterceptorManager.prototype.use = function use(
          fulfilled,
          rejected,
          options
        ) {
          this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null,
          });
          return this.handlers.length - 1;
        };

        /**
         * Remove an interceptor from the stack
         *
         * @param {Number} id The ID that was returned by `use`
         */
        InterceptorManager.prototype.eject = function eject(id) {
          if (this.handlers[id]) {
            this.handlers[id] = null;
          }
        };

        /**
         * Iterate over all the registered interceptors
         *
         * This method is particularly useful for skipping over any
         * interceptors that may have become `null` calling `eject`.
         *
         * @param {Function} fn The function to call for each interceptor
         */
        InterceptorManager.prototype.forEach = function forEach(fn) {
          utils.forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) {
              fn(h);
            }
          });
        };

        module.exports = InterceptorManager;

        /***/
      },

    /***/ "./node_modules/axios/lib/core/buildFullPath.js":
      /*!******************************************************!*\
  !*** ./node_modules/axios/lib/core/buildFullPath.js ***!
  \******************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var isAbsoluteURL = __webpack_require__(
          /*! ../helpers/isAbsoluteURL */ "./node_modules/axios/lib/helpers/isAbsoluteURL.js"
        );
        var combineURLs = __webpack_require__(
          /*! ../helpers/combineURLs */ "./node_modules/axios/lib/helpers/combineURLs.js"
        );

        /**
         * Creates a new URL by combining the baseURL with the requestedURL,
         * only when the requestedURL is not already an absolute URL.
         * If the requestURL is absolute, this function returns the requestedURL untouched.
         *
         * @param {string} baseURL The base URL
         * @param {string} requestedURL Absolute or relative URL to combine
         * @returns {string} The combined full path
         */
        module.exports = function buildFullPath(baseURL, requestedURL) {
          if (baseURL && !isAbsoluteURL(requestedURL)) {
            return combineURLs(baseURL, requestedURL);
          }
          return requestedURL;
        };

        /***/
      },

    /***/ "./node_modules/axios/lib/core/createError.js":
      /*!****************************************************!*\
  !*** ./node_modules/axios/lib/core/createError.js ***!
  \****************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var enhanceError = __webpack_require__(
          /*! ./enhanceError */ "./node_modules/axios/lib/core/enhanceError.js"
        );

        /**
         * Create an Error with the specified message, config, error code, request and response.
         *
         * @param {string} message The error message.
         * @param {Object} config The config.
         * @param {string} [code] The error code (for example, 'ECONNABORTED').
         * @param {Object} [request] The request.
         * @param {Object} [response] The response.
         * @returns {Error} The created error.
         */
        module.exports = function createError(
          message,
          config,
          code,
          request,
          response
        ) {
          var error = new Error(message);
          return enhanceError(error, config, code, request, response);
        };

        /***/
      },

    /***/ "./node_modules/axios/lib/core/dispatchRequest.js":
      /*!********************************************************!*\
  !*** ./node_modules/axios/lib/core/dispatchRequest.js ***!
  \********************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var utils = __webpack_require__(
          /*! ./../utils */ "./node_modules/axios/lib/utils.js"
        );
        var transformData = __webpack_require__(
          /*! ./transformData */ "./node_modules/axios/lib/core/transformData.js"
        );
        var isCancel = __webpack_require__(
          /*! ../cancel/isCancel */ "./node_modules/axios/lib/cancel/isCancel.js"
        );
        var defaults = __webpack_require__(
          /*! ../defaults */ "./node_modules/axios/lib/defaults.js"
        );

        /**
         * Throws a `Cancel` if cancellation has been requested.
         */
        function throwIfCancellationRequested(config) {
          if (config.cancelToken) {
            config.cancelToken.throwIfRequested();
          }
        }

        /**
         * Dispatch a request to the server using the configured adapter.
         *
         * @param {object} config The config that is to be used for the request
         * @returns {Promise} The Promise to be fulfilled
         */
        module.exports = function dispatchRequest(config) {
          throwIfCancellationRequested(config);

          // Ensure headers exist
          config.headers = config.headers || {};

          // Transform request data
          config.data = transformData.call(
            config,
            config.data,
            config.headers,
            config.transformRequest
          );

          // Flatten headers
          config.headers = utils.merge(
            config.headers.common || {},
            config.headers[config.method] || {},
            config.headers
          );

          utils.forEach(
            ["delete", "get", "head", "post", "put", "patch", "common"],
            function cleanHeaderConfig(method) {
              delete config.headers[method];
            }
          );

          var adapter = config.adapter || defaults.adapter;

          return adapter(config).then(
            function onAdapterResolution(response) {
              throwIfCancellationRequested(config);

              // Transform response data
              response.data = transformData.call(
                config,
                response.data,
                response.headers,
                config.transformResponse
              );

              return response;
            },
            function onAdapterRejection(reason) {
              if (!isCancel(reason)) {
                throwIfCancellationRequested(config);

                // Transform response data
                if (reason && reason.response) {
                  reason.response.data = transformData.call(
                    config,
                    reason.response.data,
                    reason.response.headers,
                    config.transformResponse
                  );
                }
              }

              return Promise.reject(reason);
            }
          );
        };

        /***/
      },

    /***/ "./node_modules/axios/lib/core/enhanceError.js":
      /*!*****************************************************!*\
  !*** ./node_modules/axios/lib/core/enhanceError.js ***!
  \*****************************************************/
      /***/ (module) => {
        "use strict";

        /**
         * Update an Error with the specified config, error code, and response.
         *
         * @param {Error} error The error to update.
         * @param {Object} config The config.
         * @param {string} [code] The error code (for example, 'ECONNABORTED').
         * @param {Object} [request] The request.
         * @param {Object} [response] The response.
         * @returns {Error} The error.
         */
        module.exports = function enhanceError(
          error,
          config,
          code,
          request,
          response
        ) {
          error.config = config;
          if (code) {
            error.code = code;
          }

          error.request = request;
          error.response = response;
          error.isAxiosError = true;

          error.toJSON = function toJSON() {
            return {
              // Standard
              message: this.message,
              name: this.name,
              // Microsoft
              description: this.description,
              number: this.number,
              // Mozilla
              fileName: this.fileName,
              lineNumber: this.lineNumber,
              columnNumber: this.columnNumber,
              stack: this.stack,
              // Axios
              config: this.config,
              code: this.code,
            };
          };
          return error;
        };

        /***/
      },

    /***/ "./node_modules/axios/lib/core/mergeConfig.js":
      /*!****************************************************!*\
  !*** ./node_modules/axios/lib/core/mergeConfig.js ***!
  \****************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var utils = __webpack_require__(
          /*! ../utils */ "./node_modules/axios/lib/utils.js"
        );

        /**
         * Config-specific merge-function which creates a new config-object
         * by merging two configuration objects together.
         *
         * @param {Object} config1
         * @param {Object} config2
         * @returns {Object} New object resulting from merging config2 to config1
         */
        module.exports = function mergeConfig(config1, config2) {
          // eslint-disable-next-line no-param-reassign
          config2 = config2 || {};
          var config = {};

          var valueFromConfig2Keys = ["url", "method", "data"];
          var mergeDeepPropertiesKeys = ["headers", "auth", "proxy", "params"];
          var defaultToConfig2Keys = [
            "baseURL",
            "transformRequest",
            "transformResponse",
            "paramsSerializer",
            "timeout",
            "timeoutMessage",
            "withCredentials",
            "adapter",
            "responseType",
            "xsrfCookieName",
            "xsrfHeaderName",
            "onUploadProgress",
            "onDownloadProgress",
            "decompress",
            "maxContentLength",
            "maxBodyLength",
            "maxRedirects",
            "transport",
            "httpAgent",
            "httpsAgent",
            "cancelToken",
            "socketPath",
            "responseEncoding",
          ];
          var directMergeKeys = ["validateStatus"];

          function getMergedValue(target, source) {
            if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
              return utils.merge(target, source);
            } else if (utils.isPlainObject(source)) {
              return utils.merge({}, source);
            } else if (utils.isArray(source)) {
              return source.slice();
            }
            return source;
          }

          function mergeDeepProperties(prop) {
            if (!utils.isUndefined(config2[prop])) {
              config[prop] = getMergedValue(config1[prop], config2[prop]);
            } else if (!utils.isUndefined(config1[prop])) {
              config[prop] = getMergedValue(undefined, config1[prop]);
            }
          }

          utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
            if (!utils.isUndefined(config2[prop])) {
              config[prop] = getMergedValue(undefined, config2[prop]);
            }
          });

          utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

          utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
            if (!utils.isUndefined(config2[prop])) {
              config[prop] = getMergedValue(undefined, config2[prop]);
            } else if (!utils.isUndefined(config1[prop])) {
              config[prop] = getMergedValue(undefined, config1[prop]);
            }
          });

          utils.forEach(directMergeKeys, function merge(prop) {
            if (prop in config2) {
              config[prop] = getMergedValue(config1[prop], config2[prop]);
            } else if (prop in config1) {
              config[prop] = getMergedValue(undefined, config1[prop]);
            }
          });

          var axiosKeys = valueFromConfig2Keys
            .concat(mergeDeepPropertiesKeys)
            .concat(defaultToConfig2Keys)
            .concat(directMergeKeys);

          var otherKeys = Object.keys(config1)
            .concat(Object.keys(config2))
            .filter(function filterAxiosKeys(key) {
              return axiosKeys.indexOf(key) === -1;
            });

          utils.forEach(otherKeys, mergeDeepProperties);

          return config;
        };

        /***/
      },

    /***/ "./node_modules/axios/lib/core/settle.js":
      /*!***********************************************!*\
  !*** ./node_modules/axios/lib/core/settle.js ***!
  \***********************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var createError = __webpack_require__(
          /*! ./createError */ "./node_modules/axios/lib/core/createError.js"
        );

        /**
         * Resolve or reject a Promise based on response status.
         *
         * @param {Function} resolve A function that resolves the promise.
         * @param {Function} reject A function that rejects the promise.
         * @param {object} response The response.
         */
        module.exports = function settle(resolve, reject, response) {
          var validateStatus = response.config.validateStatus;
          if (
            !response.status ||
            !validateStatus ||
            validateStatus(response.status)
          ) {
            resolve(response);
          } else {
            reject(
              createError(
                "Request failed with status code " + response.status,
                response.config,
                null,
                response.request,
                response
              )
            );
          }
        };

        /***/
      },

    /***/ "./node_modules/axios/lib/core/transformData.js":
      /*!******************************************************!*\
  !*** ./node_modules/axios/lib/core/transformData.js ***!
  \******************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var utils = __webpack_require__(
          /*! ./../utils */ "./node_modules/axios/lib/utils.js"
        );
        var defaults = __webpack_require__(
          /*! ./../defaults */ "./node_modules/axios/lib/defaults.js"
        );

        /**
         * Transform the data for a request or a response
         *
         * @param {Object|String} data The data to be transformed
         * @param {Array} headers The headers for the request or response
         * @param {Array|Function} fns A single function or Array of functions
         * @returns {*} The resulting transformed data
         */
        module.exports = function transformData(data, headers, fns) {
          var context = this || defaults;
          /*eslint no-param-reassign:0*/
          utils.forEach(fns, function transform(fn) {
            data = fn.call(context, data, headers);
          });

          return data;
        };

        /***/
      },

    /***/ "./node_modules/axios/lib/defaults.js":
      /*!********************************************!*\
  !*** ./node_modules/axios/lib/defaults.js ***!
  \********************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";
        /* provided dependency */ var process = __webpack_require__(
          /*! process/browser.js */ "./node_modules/process/browser.js"
        );

        var utils = __webpack_require__(
          /*! ./utils */ "./node_modules/axios/lib/utils.js"
        );
        var normalizeHeaderName = __webpack_require__(
          /*! ./helpers/normalizeHeaderName */ "./node_modules/axios/lib/helpers/normalizeHeaderName.js"
        );
        var enhanceError = __webpack_require__(
          /*! ./core/enhanceError */ "./node_modules/axios/lib/core/enhanceError.js"
        );

        var DEFAULT_CONTENT_TYPE = {
          "Content-Type": "application/x-www-form-urlencoded",
        };

        function setContentTypeIfUnset(headers, value) {
          if (
            !utils.isUndefined(headers) &&
            utils.isUndefined(headers["Content-Type"])
          ) {
            headers["Content-Type"] = value;
          }
        }

        function getDefaultAdapter() {
          var adapter;
          if (typeof XMLHttpRequest !== "undefined") {
            // For browsers use XHR adapter
            adapter = __webpack_require__(
              /*! ./adapters/xhr */ "./node_modules/axios/lib/adapters/xhr.js"
            );
          } else if (
            typeof process !== "undefined" &&
            Object.prototype.toString.call(process) === "[object process]"
          ) {
            // For node use HTTP adapter
            adapter = __webpack_require__(
              /*! ./adapters/http */ "./node_modules/axios/lib/adapters/xhr.js"
            );
          }
          return adapter;
        }

        function stringifySafely(rawValue, parser, encoder) {
          if (utils.isString(rawValue)) {
            try {
              (parser || JSON.parse)(rawValue);
              return utils.trim(rawValue);
            } catch (e) {
              if (e.name !== "SyntaxError") {
                throw e;
              }
            }
          }

          return (encoder || JSON.stringify)(rawValue);
        }

        var defaults = {
          transitional: {
            silentJSONParsing: true,
            forcedJSONParsing: true,
            clarifyTimeoutError: false,
          },

          adapter: getDefaultAdapter(),

          transformRequest: [
            function transformRequest(data, headers) {
              normalizeHeaderName(headers, "Accept");
              normalizeHeaderName(headers, "Content-Type");

              if (
                utils.isFormData(data) ||
                utils.isArrayBuffer(data) ||
                utils.isBuffer(data) ||
                utils.isStream(data) ||
                utils.isFile(data) ||
                utils.isBlob(data)
              ) {
                return data;
              }
              if (utils.isArrayBufferView(data)) {
                return data.buffer;
              }
              if (utils.isURLSearchParams(data)) {
                setContentTypeIfUnset(
                  headers,
                  "application/x-www-form-urlencoded;charset=utf-8"
                );
                return data.toString();
              }
              if (
                utils.isObject(data) ||
                (headers && headers["Content-Type"] === "application/json")
              ) {
                setContentTypeIfUnset(headers, "application/json");
                return stringifySafely(data);
              }
              return data;
            },
          ],

          transformResponse: [
            function transformResponse(data) {
              var transitional = this.transitional;
              var silentJSONParsing =
                transitional && transitional.silentJSONParsing;
              var forcedJSONParsing =
                transitional && transitional.forcedJSONParsing;
              var strictJSONParsing =
                !silentJSONParsing && this.responseType === "json";

              if (
                strictJSONParsing ||
                (forcedJSONParsing && utils.isString(data) && data.length)
              ) {
                try {
                  return JSON.parse(data);
                } catch (e) {
                  if (strictJSONParsing) {
                    if (e.name === "SyntaxError") {
                      throw enhanceError(e, this, "E_JSON_PARSE");
                    }
                    throw e;
                  }
                }
              }

              return data;
            },
          ],

          /**
           * A timeout in milliseconds to abort a request. If set to 0 (default) a
           * timeout is not created.
           */
          timeout: 0,

          xsrfCookieName: "XSRF-TOKEN",
          xsrfHeaderName: "X-XSRF-TOKEN",

          maxContentLength: -1,
          maxBodyLength: -1,

          validateStatus: function validateStatus(status) {
            return status >= 200 && status < 300;
          },
        };

        defaults.headers = {
          common: {
            Accept: "application/json, text/plain, */*",
          },
        };

        utils.forEach(
          ["delete", "get", "head"],
          function forEachMethodNoData(method) {
            defaults.headers[method] = {};
          }
        );

        utils.forEach(
          ["post", "put", "patch"],
          function forEachMethodWithData(method) {
            defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
          }
        );

        module.exports = defaults;

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/bind.js":
      /*!************************************************!*\
  !*** ./node_modules/axios/lib/helpers/bind.js ***!
  \************************************************/
      /***/ (module) => {
        "use strict";

        module.exports = function bind(fn, thisArg) {
          return function wrap() {
            var args = new Array(arguments.length);
            for (var i = 0; i < args.length; i++) {
              args[i] = arguments[i];
            }
            return fn.apply(thisArg, args);
          };
        };

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/buildURL.js":
      /*!****************************************************!*\
  !*** ./node_modules/axios/lib/helpers/buildURL.js ***!
  \****************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var utils = __webpack_require__(
          /*! ./../utils */ "./node_modules/axios/lib/utils.js"
        );

        function encode(val) {
          return encodeURIComponent(val)
            .replace(/%3A/gi, ":")
            .replace(/%24/g, "$")
            .replace(/%2C/gi, ",")
            .replace(/%20/g, "+")
            .replace(/%5B/gi, "[")
            .replace(/%5D/gi, "]");
        }

        /**
         * Build a URL by appending params to the end
         *
         * @param {string} url The base of the url (e.g., http://www.google.com)
         * @param {object} [params] The params to be appended
         * @returns {string} The formatted url
         */
        module.exports = function buildURL(url, params, paramsSerializer) {
          /*eslint no-param-reassign:0*/
          if (!params) {
            return url;
          }

          var serializedParams;
          if (paramsSerializer) {
            serializedParams = paramsSerializer(params);
          } else if (utils.isURLSearchParams(params)) {
            serializedParams = params.toString();
          } else {
            var parts = [];

            utils.forEach(params, function serialize(val, key) {
              if (val === null || typeof val === "undefined") {
                return;
              }

              if (utils.isArray(val)) {
                key = key + "[]";
              } else {
                val = [val];
              }

              utils.forEach(val, function parseValue(v) {
                if (utils.isDate(v)) {
                  v = v.toISOString();
                } else if (utils.isObject(v)) {
                  v = JSON.stringify(v);
                }
                parts.push(encode(key) + "=" + encode(v));
              });
            });

            serializedParams = parts.join("&");
          }

          if (serializedParams) {
            var hashmarkIndex = url.indexOf("#");
            if (hashmarkIndex !== -1) {
              url = url.slice(0, hashmarkIndex);
            }

            url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
          }

          return url;
        };

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/combineURLs.js":
      /*!*******************************************************!*\
  !*** ./node_modules/axios/lib/helpers/combineURLs.js ***!
  \*******************************************************/
      /***/ (module) => {
        "use strict";

        /**
         * Creates a new URL by combining the specified URLs
         *
         * @param {string} baseURL The base URL
         * @param {string} relativeURL The relative URL
         * @returns {string} The combined URL
         */
        module.exports = function combineURLs(baseURL, relativeURL) {
          return relativeURL
            ? baseURL.replace(/\/+$/, "") +
                "/" +
                relativeURL.replace(/^\/+/, "")
            : baseURL;
        };

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/cookies.js":
      /*!***************************************************!*\
  !*** ./node_modules/axios/lib/helpers/cookies.js ***!
  \***************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var utils = __webpack_require__(
          /*! ./../utils */ "./node_modules/axios/lib/utils.js"
        );

        module.exports = utils.isStandardBrowserEnv()
          ? // Standard browser envs support document.cookie
            (function standardBrowserEnv() {
              return {
                write: function write(
                  name,
                  value,
                  expires,
                  path,
                  domain,
                  secure
                ) {
                  var cookie = [];
                  cookie.push(name + "=" + encodeURIComponent(value));

                  if (utils.isNumber(expires)) {
                    cookie.push("expires=" + new Date(expires).toGMTString());
                  }

                  if (utils.isString(path)) {
                    cookie.push("path=" + path);
                  }

                  if (utils.isString(domain)) {
                    cookie.push("domain=" + domain);
                  }

                  if (secure === true) {
                    cookie.push("secure");
                  }

                  document.cookie = cookie.join("; ");
                },

                read: function read(name) {
                  var match = document.cookie.match(
                    new RegExp("(^|;\\s*)(" + name + ")=([^;]*)")
                  );
                  return match ? decodeURIComponent(match[3]) : null;
                },

                remove: function remove(name) {
                  this.write(name, "", Date.now() - 86400000);
                },
              };
            })()
          : // Non standard browser env (web workers, react-native) lack needed support.
            (function nonStandardBrowserEnv() {
              return {
                write: function write() {},
                read: function read() {
                  return null;
                },
                remove: function remove() {},
              };
            })();

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/isAbsoluteURL.js":
      /*!*********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/isAbsoluteURL.js ***!
  \*********************************************************/
      /***/ (module) => {
        "use strict";

        /**
         * Determines whether the specified URL is absolute
         *
         * @param {string} url The URL to test
         * @returns {boolean} True if the specified URL is absolute, otherwise false
         */
        module.exports = function isAbsoluteURL(url) {
          // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
          // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
          // by any combination of letters, digits, plus, period, or hyphen.
          return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
        };

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/isAxiosError.js":
      /*!********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/isAxiosError.js ***!
  \********************************************************/
      /***/ (module) => {
        "use strict";

        /**
         * Determines whether the payload is an error thrown by Axios
         *
         * @param {*} payload The value to test
         * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
         */
        module.exports = function isAxiosError(payload) {
          return typeof payload === "object" && payload.isAxiosError === true;
        };

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/isURLSameOrigin.js":
      /*!***********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/isURLSameOrigin.js ***!
  \***********************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var utils = __webpack_require__(
          /*! ./../utils */ "./node_modules/axios/lib/utils.js"
        );

        module.exports = utils.isStandardBrowserEnv()
          ? // Standard browser envs have full support of the APIs needed to test
            // whether the request URL is of the same origin as current location.
            (function standardBrowserEnv() {
              var msie = /(msie|trident)/i.test(navigator.userAgent);
              var urlParsingNode = document.createElement("a");
              var originURL;

              /**
               * Parse a URL to discover it's components
               *
               * @param {String} url The URL to be parsed
               * @returns {Object}
               */
              function resolveURL(url) {
                var href = url;

                if (msie) {
                  // IE needs attribute set twice to normalize properties
                  urlParsingNode.setAttribute("href", href);
                  href = urlParsingNode.href;
                }

                urlParsingNode.setAttribute("href", href);

                // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
                return {
                  href: urlParsingNode.href,
                  protocol: urlParsingNode.protocol
                    ? urlParsingNode.protocol.replace(/:$/, "")
                    : "",
                  host: urlParsingNode.host,
                  search: urlParsingNode.search
                    ? urlParsingNode.search.replace(/^\?/, "")
                    : "",
                  hash: urlParsingNode.hash
                    ? urlParsingNode.hash.replace(/^#/, "")
                    : "",
                  hostname: urlParsingNode.hostname,
                  port: urlParsingNode.port,
                  pathname:
                    urlParsingNode.pathname.charAt(0) === "/"
                      ? urlParsingNode.pathname
                      : "/" + urlParsingNode.pathname,
                };
              }

              originURL = resolveURL(window.location.href);

              /**
               * Determine if a URL shares the same origin as the current location
               *
               * @param {String} requestURL The URL to test
               * @returns {boolean} True if URL shares the same origin, otherwise false
               */
              return function isURLSameOrigin(requestURL) {
                var parsed = utils.isString(requestURL)
                  ? resolveURL(requestURL)
                  : requestURL;
                return (
                  parsed.protocol === originURL.protocol &&
                  parsed.host === originURL.host
                );
              };
            })()
          : // Non standard browser envs (web workers, react-native) lack needed support.
            (function nonStandardBrowserEnv() {
              return function isURLSameOrigin() {
                return true;
              };
            })();

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/normalizeHeaderName.js":
      /*!***************************************************************!*\
  !*** ./node_modules/axios/lib/helpers/normalizeHeaderName.js ***!
  \***************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var utils = __webpack_require__(
          /*! ../utils */ "./node_modules/axios/lib/utils.js"
        );

        module.exports = function normalizeHeaderName(headers, normalizedName) {
          utils.forEach(headers, function processHeader(value, name) {
            if (
              name !== normalizedName &&
              name.toUpperCase() === normalizedName.toUpperCase()
            ) {
              headers[normalizedName] = value;
              delete headers[name];
            }
          });
        };

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/parseHeaders.js":
      /*!********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/parseHeaders.js ***!
  \********************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var utils = __webpack_require__(
          /*! ./../utils */ "./node_modules/axios/lib/utils.js"
        );

        // Headers whose duplicates are ignored by node
        // c.f. https://nodejs.org/api/http.html#http_message_headers
        var ignoreDuplicateOf = [
          "age",
          "authorization",
          "content-length",
          "content-type",
          "etag",
          "expires",
          "from",
          "host",
          "if-modified-since",
          "if-unmodified-since",
          "last-modified",
          "location",
          "max-forwards",
          "proxy-authorization",
          "referer",
          "retry-after",
          "user-agent",
        ];

        /**
         * Parse headers into an object
         *
         * ```
         * Date: Wed, 27 Aug 2014 08:58:49 GMT
         * Content-Type: application/json
         * Connection: keep-alive
         * Transfer-Encoding: chunked
         * ```
         *
         * @param {String} headers Headers needing to be parsed
         * @returns {Object} Headers parsed into an object
         */
        module.exports = function parseHeaders(headers) {
          var parsed = {};
          var key;
          var val;
          var i;

          if (!headers) {
            return parsed;
          }

          utils.forEach(headers.split("\n"), function parser(line) {
            i = line.indexOf(":");
            key = utils.trim(line.substr(0, i)).toLowerCase();
            val = utils.trim(line.substr(i + 1));

            if (key) {
              if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
                return;
              }
              if (key === "set-cookie") {
                parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
              } else {
                parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
              }
            }
          });

          return parsed;
        };

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/spread.js":
      /*!**************************************************!*\
  !*** ./node_modules/axios/lib/helpers/spread.js ***!
  \**************************************************/
      /***/ (module) => {
        "use strict";

        /**
         * Syntactic sugar for invoking a function and expanding an array for arguments.
         *
         * Common use case would be to use `Function.prototype.apply`.
         *
         *  ```js
         *  function f(x, y, z) {}
         *  var args = [1, 2, 3];
         *  f.apply(null, args);
         *  ```
         *
         * With `spread` this example can be re-written.
         *
         *  ```js
         *  spread(function(x, y, z) {})([1, 2, 3]);
         *  ```
         *
         * @param {Function} callback
         * @returns {Function}
         */
        module.exports = function spread(callback) {
          return function wrap(arr) {
            return callback.apply(null, arr);
          };
        };

        /***/
      },

    /***/ "./node_modules/axios/lib/helpers/validator.js":
      /*!*****************************************************!*\
  !*** ./node_modules/axios/lib/helpers/validator.js ***!
  \*****************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var pkg = __webpack_require__(
          /*! ./../../package.json */ "./node_modules/axios/package.json"
        );

        var validators = {};

        // eslint-disable-next-line func-names
        ["object", "boolean", "number", "function", "string", "symbol"].forEach(
          function (type, i) {
            validators[type] = function validator(thing) {
              return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
            };
          }
        );

        var deprecatedWarnings = {};
        var currentVerArr = pkg.version.split(".");

        /**
         * Compare package versions
         * @param {string} version
         * @param {string?} thanVersion
         * @returns {boolean}
         */
        function isOlderVersion(version, thanVersion) {
          var pkgVersionArr = thanVersion
            ? thanVersion.split(".")
            : currentVerArr;
          var destVer = version.split(".");
          for (var i = 0; i < 3; i++) {
            if (pkgVersionArr[i] > destVer[i]) {
              return true;
            } else if (pkgVersionArr[i] < destVer[i]) {
              return false;
            }
          }
          return false;
        }

        /**
         * Transitional option validator
         * @param {function|boolean?} validator
         * @param {string?} version
         * @param {string} message
         * @returns {function}
         */
        validators.transitional = function transitional(
          validator,
          version,
          message
        ) {
          var isDeprecated = version && isOlderVersion(version);

          function formatMessage(opt, desc) {
            return (
              "[Axios v" +
              pkg.version +
              "] Transitional option '" +
              opt +
              "'" +
              desc +
              (message ? ". " + message : "")
            );
          }

          // eslint-disable-next-line func-names
          return function (value, opt, opts) {
            if (validator === false) {
              throw new Error(
                formatMessage(opt, " has been removed in " + version)
              );
            }

            if (isDeprecated && !deprecatedWarnings[opt]) {
              deprecatedWarnings[opt] = true;
              // eslint-disable-next-line no-console
              console.warn(
                formatMessage(
                  opt,
                  " has been deprecated since v" +
                    version +
                    " and will be removed in the near future"
                )
              );
            }

            return validator ? validator(value, opt, opts) : true;
          };
        };

        /**
         * Assert object's properties type
         * @param {object} options
         * @param {object} schema
         * @param {boolean?} allowUnknown
         */

        function assertOptions(options, schema, allowUnknown) {
          if (typeof options !== "object") {
            throw new TypeError("options must be an object");
          }
          var keys = Object.keys(options);
          var i = keys.length;
          while (i-- > 0) {
            var opt = keys[i];
            var validator = schema[opt];
            if (validator) {
              var value = options[opt];
              var result =
                value === undefined || validator(value, opt, options);
              if (result !== true) {
                throw new TypeError("option " + opt + " must be " + result);
              }
              continue;
            }
            if (allowUnknown !== true) {
              throw Error("Unknown option " + opt);
            }
          }
        }

        module.exports = {
          isOlderVersion: isOlderVersion,
          assertOptions: assertOptions,
          validators: validators,
        };

        /***/
      },

    /***/ "./node_modules/axios/lib/utils.js":
      /*!*****************************************!*\
  !*** ./node_modules/axios/lib/utils.js ***!
  \*****************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var bind = __webpack_require__(
          /*! ./helpers/bind */ "./node_modules/axios/lib/helpers/bind.js"
        );

        // utils is a library of generic helper functions non-specific to axios

        var toString = Object.prototype.toString;

        /**
         * Determine if a value is an Array
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if value is an Array, otherwise false
         */
        function isArray(val) {
          return toString.call(val) === "[object Array]";
        }

        /**
         * Determine if a value is undefined
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if the value is undefined, otherwise false
         */
        function isUndefined(val) {
          return typeof val === "undefined";
        }

        /**
         * Determine if a value is a Buffer
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if value is a Buffer, otherwise false
         */
        function isBuffer(val) {
          return (
            val !== null &&
            !isUndefined(val) &&
            val.constructor !== null &&
            !isUndefined(val.constructor) &&
            typeof val.constructor.isBuffer === "function" &&
            val.constructor.isBuffer(val)
          );
        }

        /**
         * Determine if a value is an ArrayBuffer
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if value is an ArrayBuffer, otherwise false
         */
        function isArrayBuffer(val) {
          return toString.call(val) === "[object ArrayBuffer]";
        }

        /**
         * Determine if a value is a FormData
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if value is an FormData, otherwise false
         */
        function isFormData(val) {
          return typeof FormData !== "undefined" && val instanceof FormData;
        }

        /**
         * Determine if a value is a view on an ArrayBuffer
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
         */
        function isArrayBufferView(val) {
          var result;
          if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
            result = ArrayBuffer.isView(val);
          } else {
            result = val && val.buffer && val.buffer instanceof ArrayBuffer;
          }
          return result;
        }

        /**
         * Determine if a value is a String
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if value is a String, otherwise false
         */
        function isString(val) {
          return typeof val === "string";
        }

        /**
         * Determine if a value is a Number
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if value is a Number, otherwise false
         */
        function isNumber(val) {
          return typeof val === "number";
        }

        /**
         * Determine if a value is an Object
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if value is an Object, otherwise false
         */
        function isObject(val) {
          return val !== null && typeof val === "object";
        }

        /**
         * Determine if a value is a plain Object
         *
         * @param {Object} val The value to test
         * @return {boolean} True if value is a plain Object, otherwise false
         */
        function isPlainObject(val) {
          if (toString.call(val) !== "[object Object]") {
            return false;
          }

          var prototype = Object.getPrototypeOf(val);
          return prototype === null || prototype === Object.prototype;
        }

        /**
         * Determine if a value is a Date
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if value is a Date, otherwise false
         */
        function isDate(val) {
          return toString.call(val) === "[object Date]";
        }

        /**
         * Determine if a value is a File
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if value is a File, otherwise false
         */
        function isFile(val) {
          return toString.call(val) === "[object File]";
        }

        /**
         * Determine if a value is a Blob
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if value is a Blob, otherwise false
         */
        function isBlob(val) {
          return toString.call(val) === "[object Blob]";
        }

        /**
         * Determine if a value is a Function
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if value is a Function, otherwise false
         */
        function isFunction(val) {
          return toString.call(val) === "[object Function]";
        }

        /**
         * Determine if a value is a Stream
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if value is a Stream, otherwise false
         */
        function isStream(val) {
          return isObject(val) && isFunction(val.pipe);
        }

        /**
         * Determine if a value is a URLSearchParams object
         *
         * @param {Object} val The value to test
         * @returns {boolean} True if value is a URLSearchParams object, otherwise false
         */
        function isURLSearchParams(val) {
          return (
            typeof URLSearchParams !== "undefined" &&
            val instanceof URLSearchParams
          );
        }

        /**
         * Trim excess whitespace off the beginning and end of a string
         *
         * @param {String} str The String to trim
         * @returns {String} The String freed of excess whitespace
         */
        function trim(str) {
          return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
        }

        /**
         * Determine if we're running in a standard browser environment
         *
         * This allows axios to run in a web worker, and react-native.
         * Both environments support XMLHttpRequest, but not fully standard globals.
         *
         * web workers:
         *  typeof window -> undefined
         *  typeof document -> undefined
         *
         * react-native:
         *  navigator.product -> 'ReactNative'
         * nativescript
         *  navigator.product -> 'NativeScript' or 'NS'
         */
        function isStandardBrowserEnv() {
          if (
            typeof navigator !== "undefined" &&
            (navigator.product === "ReactNative" ||
              navigator.product === "NativeScript" ||
              navigator.product === "NS")
          ) {
            return false;
          }
          return (
            typeof window !== "undefined" && typeof document !== "undefined"
          );
        }

        /**
         * Iterate over an Array or an Object invoking a function for each item.
         *
         * If `obj` is an Array callback will be called passing
         * the value, index, and complete array for each item.
         *
         * If 'obj' is an Object callback will be called passing
         * the value, key, and complete object for each property.
         *
         * @param {Object|Array} obj The object to iterate
         * @param {Function} fn The callback to invoke for each item
         */
        function forEach(obj, fn) {
          // Don't bother if no value provided
          if (obj === null || typeof obj === "undefined") {
            return;
          }

          // Force an array if not already something iterable
          if (typeof obj !== "object") {
            /*eslint no-param-reassign:0*/
            obj = [obj];
          }

          if (isArray(obj)) {
            // Iterate over array values
            for (var i = 0, l = obj.length; i < l; i++) {
              fn.call(null, obj[i], i, obj);
            }
          } else {
            // Iterate over object keys
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) {
                fn.call(null, obj[key], key, obj);
              }
            }
          }
        }

        /**
         * Accepts varargs expecting each argument to be an object, then
         * immutably merges the properties of each object and returns result.
         *
         * When multiple objects contain the same key the later object in
         * the arguments list will take precedence.
         *
         * Example:
         *
         * ```js
         * var result = merge({foo: 123}, {foo: 456});
         * console.log(result.foo); // outputs 456
         * ```
         *
         * @param {Object} obj1 Object to merge
         * @returns {Object} Result of all merge properties
         */
        function merge(/* obj1, obj2, obj3, ... */) {
          var result = {};
          function assignValue(val, key) {
            if (isPlainObject(result[key]) && isPlainObject(val)) {
              result[key] = merge(result[key], val);
            } else if (isPlainObject(val)) {
              result[key] = merge({}, val);
            } else if (isArray(val)) {
              result[key] = val.slice();
            } else {
              result[key] = val;
            }
          }

          for (var i = 0, l = arguments.length; i < l; i++) {
            forEach(arguments[i], assignValue);
          }
          return result;
        }

        /**
         * Extends object a by mutably adding to it the properties of object b.
         *
         * @param {Object} a The object to be extended
         * @param {Object} b The object to copy properties from
         * @param {Object} thisArg The object to bind function to
         * @return {Object} The resulting value of object a
         */
        function extend(a, b, thisArg) {
          forEach(b, function assignValue(val, key) {
            if (thisArg && typeof val === "function") {
              a[key] = bind(val, thisArg);
            } else {
              a[key] = val;
            }
          });
          return a;
        }

        /**
         * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
         *
         * @param {string} content with BOM
         * @return {string} content value without BOM
         */
        function stripBOM(content) {
          if (content.charCodeAt(0) === 0xfeff) {
            content = content.slice(1);
          }
          return content;
        }

        module.exports = {
          isArray: isArray,
          isArrayBuffer: isArrayBuffer,
          isBuffer: isBuffer,
          isFormData: isFormData,
          isArrayBufferView: isArrayBufferView,
          isString: isString,
          isNumber: isNumber,
          isObject: isObject,
          isPlainObject: isPlainObject,
          isUndefined: isUndefined,
          isDate: isDate,
          isFile: isFile,
          isBlob: isBlob,
          isFunction: isFunction,
          isStream: isStream,
          isURLSearchParams: isURLSearchParams,
          isStandardBrowserEnv: isStandardBrowserEnv,
          forEach: forEach,
          merge: merge,
          extend: extend,
          trim: trim,
          stripBOM: stripBOM,
        };

        /***/
      },

    /***/ "./node_modules/ev-emitter/ev-emitter.js":
      /*!***********************************************!*\
  !*** ./node_modules/ev-emitter/ev-emitter.js ***!
  \***********************************************/
      /***/ function (module) {
        /**
         * EvEmitter v2.1.1
         * Lil' event emitter
         * MIT License
         */

        (function (global, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS - Browserify, Webpack
            module.exports = factory();
          } else {
            // Browser globals
            global.EvEmitter = factory();
          }
        })(typeof window != "undefined" ? window : this, function () {
          function EvEmitter() {}

          let proto = EvEmitter.prototype;

          proto.on = function (eventName, listener) {
            if (!eventName || !listener) return this;

            // set events hash
            let events = (this._events = this._events || {});
            // set listeners array
            let listeners = (events[eventName] = events[eventName] || []);
            // only add once
            if (!listeners.includes(listener)) {
              listeners.push(listener);
            }

            return this;
          };

          proto.once = function (eventName, listener) {
            if (!eventName || !listener) return this;

            // add event
            this.on(eventName, listener);
            // set once flag
            // set onceEvents hash
            let onceEvents = (this._onceEvents = this._onceEvents || {});
            // set onceListeners object
            let onceListeners = (onceEvents[eventName] =
              onceEvents[eventName] || {});
            // set flag
            onceListeners[listener] = true;

            return this;
          };

          proto.off = function (eventName, listener) {
            let listeners = this._events && this._events[eventName];
            if (!listeners || !listeners.length) return this;

            let index = listeners.indexOf(listener);
            if (index != -1) {
              listeners.splice(index, 1);
            }

            return this;
          };

          proto.emitEvent = function (eventName, args) {
            let listeners = this._events && this._events[eventName];
            if (!listeners || !listeners.length) return this;

            // copy over to avoid interference if .off() in listener
            listeners = listeners.slice(0);
            args = args || [];
            // once stuff
            let onceListeners = this._onceEvents && this._onceEvents[eventName];

            for (let listener of listeners) {
              let isOnce = onceListeners && onceListeners[listener];
              if (isOnce) {
                // remove listener
                // remove before trigger to prevent recursion
                this.off(eventName, listener);
                // unset once flag
                delete onceListeners[listener];
              }
              // trigger listener
              listener.apply(this, args);
            }

            return this;
          };

          proto.allOff = function () {
            delete this._events;
            delete this._onceEvents;
            return this;
          };

          return EvEmitter;
        });

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/config.js":
      /*!***************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/config.js ***!
  \***************************************************/
      /***/ (__unused_webpack_module, exports) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", { value: true });
        exports.API_ERROR_MSG =
          exports.POST_LOAD_WAIT_TIME =
          exports.MIN_RECENT_SERP_PRODUCTS =
          exports.MAX_RECENT_SERP_PRODUCT_LIFE =
          exports.MAX_RECENT_SERP_PRODUCTS_PRODUCTS =
          exports.MAX_RECENT_COLLECTION_PRODUCTS =
          exports.MAX_RECENT_PRODUCTS =
          exports.SESSION_TOKEN_LIFE =
          exports.KLAVIYO_ID_SS_KEY =
          exports.CART_TOKEN_COOKIE_NAME =
          exports.CART_TOKEN_LS_KEY =
          exports.SDK_NO_CACHING_LS_KEY =
          exports.SDK_DEBUG_LS_LEY =
          exports.POST_LOAD_EVENT_KEY =
          exports.RECENT_RESPONSE_SERP_PRODUCTS_KEY =
          exports.RECENT_SERP_PRODUCTS_KEY =
          exports.RECENT_COLLECTION_PRODUCTS_KEY =
          exports.RECENT_PRODUCT_LS_KEY =
          exports.USER_SESSION_TOKEN_LS_KEY =
          exports.SESSION_TOKEN_LS_KEY =
            void 0;
        //Local Storage Keys
        exports.SESSION_TOKEN_LS_KEY = "isp-session-token";
        exports.USER_SESSION_TOKEN_LS_KEY = "isp-user-session-token";
        exports.RECENT_PRODUCT_LS_KEY = "isp-recent-product";
        exports.RECENT_COLLECTION_PRODUCTS_KEY =
          "isp-recent-product-collection";
        exports.RECENT_SERP_PRODUCTS_KEY = "isp-recent-product-serp";
        exports.RECENT_RESPONSE_SERP_PRODUCTS_KEY =
          "isp-recent-response-product-serp";
        exports.POST_LOAD_EVENT_KEY = "post-load-event";
        exports.SDK_DEBUG_LS_LEY = "isp-sdk-version";
        exports.SDK_NO_CACHING_LS_KEY = "isp-sdk-caching";
        exports.CART_TOKEN_LS_KEY = "isp-cart-token";
        exports.CART_TOKEN_COOKIE_NAME = "cart";
        exports.KLAVIYO_ID_SS_KEY = "KLAVIYO_ID";
        //constants
        exports.SESSION_TOKEN_LIFE = 1800;
        exports.MAX_RECENT_PRODUCTS = 10;
        exports.MAX_RECENT_COLLECTION_PRODUCTS = 5;
        exports.MAX_RECENT_SERP_PRODUCTS_PRODUCTS = 50;
        exports.MAX_RECENT_SERP_PRODUCT_LIFE = 360;
        exports.MIN_RECENT_SERP_PRODUCTS = 3;
        exports.POST_LOAD_WAIT_TIME = 4500;
        exports.API_ERROR_MSG =
          '\u274C IS+ SDK Error | Please turn on the "Use REST API" switch in IS+ Dashboard > Sync tab or contact support';
        //# sourceMappingURL=config.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/index.js":
      /*!**************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/index.js ***!
  \**************************************************/
      /***/ function (__unused_webpack_module, exports, __webpack_require__) {
        "use strict";

        var __createBinding =
          (this && this.__createBinding) ||
          (Object.create
            ? function (o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                Object.defineProperty(o, k2, {
                  enumerable: true,
                  get: function () {
                    return m[k];
                  },
                });
              }
            : function (o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                o[k2] = m[k];
              });
        var __exportStar =
          (this && this.__exportStar) ||
          function (m, exports) {
            for (var p in m)
              if (
                p !== "default" &&
                !Object.prototype.hasOwnProperty.call(exports, p)
              )
                __createBinding(exports, m, p);
          };
        Object.defineProperty(exports, "__esModule", { value: true });
        exports.FastSimonSDK = void 0;
        var sections_1 = __webpack_require__(
          /*! ./sections */ "./node_modules/fast-simon-sdk/lib/sections/index.js"
        );
        Object.defineProperty(exports, "FastSimonSDK", {
          enumerable: true,
          get: function () {
            return sections_1.FastSDK;
          },
        });
        var enums_1 = __webpack_require__(
          /*! ./sections/enums */ "./node_modules/fast-simon-sdk/lib/sections/enums/index.js"
        );
        var debug_1 = __webpack_require__(
          /*! ./utils/debug */ "./node_modules/fast-simon-sdk/lib/utils/debug.js"
        );
        window.FastSimonSDK = sections_1.FastSDK;
        // (window as any).SDKUtils = sdkUtils;
        window.FastSimonAppType = enums_1.FastAppType;
        window.FastSimonEventName = enums_1.FastEventName;
        window.FastSimonSortBy = enums_1.FastSortBy;
        window.FastSimonRecommendationsSource =
          enums_1.FastRecommendationsSource;
        window.debugSDK = debug_1.debugSDK;
        window.clearDebugSDK = debug_1.clearDebugSDK;
        __exportStar(
          __webpack_require__(
            /*! ./models/exports */ "./node_modules/fast-simon-sdk/lib/models/exports.js"
          ),
          exports
        );
        // export {FastSDK as FastSimonSDK, sdkUtils as SDKUtils}
        //# sourceMappingURL=index.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/models/common.js":
      /*!**********************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/models/common.js ***!
  \**********************************************************/
      /***/ (__unused_webpack_module, exports) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", { value: true });
        exports.defaultSDKData =
          exports.defaultDashboardData =
          exports.defaultSDKTemp =
            void 0;
        exports.defaultSDKTemp = {
          autocomplete: {
            totalResults: 0,
            categories: [],
            popularSearches: [],
            products: [],
            turbolinks: [],
            query: "",
          },
          fullTextSearch: {
            query: "",
            products: [],
            facets: [],
            totalResults: 0,
          },
          smartCollections: {
            ancestors: [],
            categoryID: "",
            products: [],
            facets: [],
            totalResults: 0,
            name: "",
          },
          landingPage: {
            slug: "",
            products: [],
            facets: [],
            totalResults: 0,
          },
        };
        exports.defaultDashboardData = {
          site_url: "",
          disable_categories_suggestions: false,
          max_popular_categories_suggestions: 0,
          max_popular_searches_suggestions: 0,
          max_product_suggestions: 0,
          using_isp_api: true,
          isp_personalized_search_enabled: false,
          products_per_page: 20,
          categories_products_per_page: 20,
          show_popular_products_on_focus: false,
        };
        exports.defaultSDKData = {
          storeID: 0,
          uuid: "",
          cdnKey: Date.now(),
          sessionToken: {
            lastActive: Date.now(),
            start: Date.now(),
          },
          userToken: "",
          cartToken: "",
          dashboard: exports.defaultDashboardData,
          popularProducts: [],
          categories: [],
          turbolinks: [],
          contentData: { 0: "" },
        };
        //# sourceMappingURL=common.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/models/exports.js":
      /*!***********************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/models/exports.js ***!
  \***********************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", { value: true });
        exports.FeaturedRanking = void 0;
        var fullTextSearch_1 = __webpack_require__(
          /*! ./fullTextSearch */ "./node_modules/fast-simon-sdk/lib/models/fullTextSearch.js"
        );
        Object.defineProperty(exports, "FeaturedRanking", {
          enumerable: true,
          get: function () {
            return fullTextSearch_1.FeaturedRanking;
          },
        });
        //# sourceMappingURL=exports.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/models/fullTextSearch.js":
      /*!******************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/models/fullTextSearch.js ***!
  \******************************************************************/
      /***/ (__unused_webpack_module, exports) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", { value: true });
        exports.FeaturedRanking = exports.isSortBy = void 0;
        function isSortBy(sort) {
          if (!sort) {
            return false;
          }
          return [
            "creation_date",
            "a_to_z",
            "z_to_a",
            "creation_date_oldest",
            "reviews",
            "relevency",
            "price_min_to_max",
            "price_max_to_min",
            "popularity",
          ].includes(sort);
        }
        exports.isSortBy = isSortBy;
        var FeaturedRanking;
        (function (FeaturedRanking) {
          FeaturedRanking[(FeaturedRanking["FEATURED_RANK_NO"] = 0)] =
            "FEATURED_RANK_NO";
          FeaturedRanking[(FeaturedRanking["FEATURED_RANK_ON_MATCH"] = 1)] =
            "FEATURED_RANK_ON_MATCH";
          FeaturedRanking[(FeaturedRanking["FEATURED_RANK_ALWAYS"] = 2)] =
            "FEATURED_RANK_ALWAYS";
          FeaturedRanking[(FeaturedRanking["FEATURED_RANK_NEVER"] = 3)] =
            "FEATURED_RANK_NEVER";
        })(
          (FeaturedRanking =
            exports.FeaturedRanking || (exports.FeaturedRanking = {}))
        );
        //# sourceMappingURL=fullTextSearch.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/sections/contentSearch/index.js":
      /*!*************************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/sections/contentSearch/index.js ***!
  \*************************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", { value: true });
        exports.contentSearch = void 0;
        var content_1 = __webpack_require__(
          /*! ../../services/content */ "./node_modules/fast-simon-sdk/lib/services/content.js"
        );
        var contentSearch = function (_a) {
          var self = _a.self,
            _b = _a.page,
            page = _b === void 0 ? 1 : _b,
            query = _a.query,
            callback = _a.callback;
          var _c = self.data,
            uuid = _c.uuid,
            storeID = _c.storeID,
            cdnKey = _c.cdnKey,
            contentData = _c.contentData;
          var cursor = contentData[page - 1];
          if (!cursor && page !== 1) {
            console.error("Could not access this page at the moment");
          }
          content_1.Content.search({
            uuid: uuid,
            storeID: storeID,
            cdn: cdnKey,
            query: query,
            cursor: cursor !== null && cursor !== void 0 ? cursor : undefined,
          }).then(function (response) {
            contentData[page] = response.content_cursor;
            callback({
              action: "content-search",
              payload: {
                content: response.content_results
                  ? serializeContentData(response.content_results)
                  : [],
                page: page,
              },
            });
          });
        };
        exports.contentSearch = contentSearch;
        var serializeContentData = function (content) {
          return content.map(function (article) {
            var result = {
              title: article[0],
              url: article[1],
            };
            if (article[2]) {
              result["description"] = article[2];
            }
            if (article[4]) {
              result["image"] = article[4];
            }
            return result;
          });
        };
        //# sourceMappingURL=index.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/sections/enums/index.js":
      /*!*****************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/sections/enums/index.js ***!
  \*****************************************************************/
      /***/ (__unused_webpack_module, exports) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", { value: true });
        exports.FastRecommendationsSource =
          exports.FastSortBy =
          exports.FastEventName =
          exports.FastAppType =
            void 0;
        exports.FastAppType = {
          SinglePage: "SPA",
          MultiPage: "MPA",
        };
        exports.FastEventName = {
          AutocompleteProductClicked: "instantsearch-product",
          AutocompleteCategoryClicked: "instantsearch-category",
          AutocompletePopularClicked: "instantsearch-popular-search",
          SearchPerformed: "search",
          SmartCollectionPreformed: "collection",
          SerpProductClicked: "productFromSearch",
          CollectionProductClicked: "productFromCollection",
          RecommendationProductClicked: "productFromRecommendation",
          LookALikeClickedSerp: "lookALikeViewSerp",
          QuickViewClickedCollection: "quickViewCollection",
          LookALikeClickedCollection: "lookALikeViewCollection",
          QuickViewClickedSerp: "quickViewSerp",
          LookALikeProductClicked: "productFromLookALike",
          QuickViewProductClicked: "productFromQuickView",
          DirectProductClicked: "productDirect",
          CartVisited: "cartVisited",
          AddToCartPerformed: "cartPerformed",
        };
        exports.FastSortBy = {
          PriceHighToLow: "price_max_to_min",
          PriceLowToHigh: "price_min_to_max",
          NewFirst: "creation_date",
          OldFirst: "creation_date_oldest",
          Popularity: "popularity",
          Reviews: "reviews",
          AtoZ: "a_to_z",
          ZtoA: "z_to_a",
          relevancy: "relevency",
        };
        exports.FastRecommendationsSource = {
          relatedRecentProducts: "related_recent_products",
          relatedPurchase: "related_purchase",
          relatedViews: "related_views",
          relatedCart: "related_cart",
          similarProducts: "similar_products",
          relatedRecentlyViewed: "related_recently_viewed",
          similarProducts_byAttributes: "similar_products_by_attributes",
          similarProductsLookalike: "similar_products_lookalike",
          relatedTopProducts: "related_top_products",
        };
        //# sourceMappingURL=index.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/sections/eventReporter/index.js":
      /*!*************************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/sections/eventReporter/index.js ***!
  \*************************************************************************/
      /***/ function (__unused_webpack_module, exports, __webpack_require__) {
        "use strict";

        var __assign =
          (this && this.__assign) ||
          function () {
            __assign =
              Object.assign ||
              function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                  s = arguments[i];
                  for (var p in s)
                    if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
              };
            return __assign.apply(this, arguments);
          };
        Object.defineProperty(exports, "__esModule", { value: true });
        exports.reportEvent = exports.event = exports.SPAOnlyReports = void 0;
        var utils_1 = __webpack_require__(
          /*! ./utils */ "./node_modules/fast-simon-sdk/lib/sections/eventReporter/utils.js"
        );
        var utils_2 = __webpack_require__(
          /*! ../smartCollections/utils */ "./node_modules/fast-simon-sdk/lib/sections/smartCollections/utils.js"
        );
        var utils_3 = __webpack_require__(
          /*! ../fullTextSearch/utils */ "./node_modules/fast-simon-sdk/lib/sections/fullTextSearch/utils.js"
        );
        var config_1 = __webpack_require__(
          /*! ../../config */ "./node_modules/fast-simon-sdk/lib/config.js"
        );
        var reporting_1 = __webpack_require__(
          /*! ../../services/reporting */ "./node_modules/fast-simon-sdk/lib/services/reporting.js"
        );
        exports.SPAOnlyReports = new Set([
          "lookALikeViewSerp",
          "quickViewSerp",
          "lookALikeViewCollection",
          "quickViewCollection",
          "search",
          "collection",
        ]);
        var event = function (_a) {
          var report = _a.report,
            self = _a.self;
          var type = report.reportAppType ? report.reportAppType : self.type;
          var categoryName = self.temp.smartCollections.name;
          if (
            report.eventName === "productFromCollection" &&
            !report.data.query
          ) {
            report = __assign(__assign({}, report), {
              data: __assign(__assign({}, report.data), {
                query:
                  categoryName !== null && categoryName !== void 0
                    ? categoryName
                    : "",
              }),
            });
          }
          console.log("event-received", type, report);
          if (type === "MPA" && !exports.SPAOnlyReports.has(report.eventName)) {
            utils_1.saveEvent(report);
          } else {
            reportEvent({ report: report, self: self });
          }
        };
        exports.event = event;
        function reportEvent(_a) {
          var report = _a.report,
            self = _a.self;
          switch (report.eventName) {
            case "instantsearch-product": {
              reportAutocompleteProductSeen({ self: self, report: report });
              break;
            }
            case "instantsearch-category": {
              reportAutocompleteCategory({ self: self, report: report });
              break;
            }
            case "instantsearch-popular-search": {
              reportAutocompletePopularSearch({ self: self, report: report });
              break;
            }
            case "search": {
              reportSearchPreformed({ self: self, report: report });
              break;
            }
            case "productFromSearch": {
              reportSerpProductSeen({ self: self, report: report });
              break;
            }
            case "collection": {
              reportSmartCollectionPreformed({ self: self, report: report });
              break;
            }
            case "productFromCollection": {
              reportProductFromCollection({ self: self, report: report });
              break;
            }
            case "productFromRecommendation": {
              reportRecommendationsProductSeen({ self: self, report: report });
              break;
            }
            case "productFromLookALike": {
              reportProductFromLookALike({ self: self, report: report });
              break;
            }
            case "quickViewCollection": {
              reportQuickViewCollection({
                self: self,
                report: report,
                type: "Quick View",
              });
              break;
            }
            case "quickViewSerp": {
              reportQuickViewSerp({
                self: self,
                report: report,
                type: "Quick View",
              });
              break;
            }
            case "productFromQuickView": {
              reportProductFromQuickView({ self: self, report: report });
              break;
            }
            case "lookALikeViewCollection": {
              reportQuickViewCollection({
                self: self,
                report: report,
                type: "Look A Like",
              });
              break;
            }
            case "lookALikeViewSerp": {
              reportQuickViewSerp({
                self: self,
                report: report,
                type: "Look A Like",
              });
              break;
            }
            case "productDirect": {
              reportDirectProductViewData({ self: self, report: report });
              break;
            }
            case "cartPerformed": {
              reportCartVisited({ self: self, report: report });
              break;
            }
            case "cartVisited": {
              reportAddToCart({ self: self, report: report });
              break;
            }
          }
          localStorage.removeItem(config_1.POST_LOAD_EVENT_KEY);
        }
        exports.reportEvent = reportEvent;
        var reportAutocompleteProductSeen = function (_a) {
          var self = _a.self,
            report = _a.report;
          var _b = self.data,
            userToken = _b.userToken,
            sessionToken = _b.sessionToken,
            uuid = _b.uuid,
            storeID = _b.storeID,
            cartToken = _b.cartToken;
          var time = report.time,
            callback = report.callback,
            targetURL = report.targetURL;
          var _c = report.data,
            productID = _c.productID,
            query = _c.query,
            productQuery = _c.productQuery;
          var waitTime = time ? time : config_1.POST_LOAD_WAIT_TIME;
          function reportEvent() {
            utils_3.setRecentSearchProducts(self, productID);
            utils_1.postLoadCallback({
              eventName: report.eventName,
              promise: reporting_1.Reporting.productSeen({
                type: "autocomplete",
                query: productQuery,
                term: query,
                uuid: uuid,
                storeID: storeID,
                userToken: userToken,
                productId: productID,
                sessionStart: sessionToken.start,
                cartToken: cartToken,
              }),
              callback: callback,
            });
          }
          if (report.reportAppType && report.reportAppType === "SPA") {
            reportEvent();
          } else {
            setTimeout(function () {
              if (!targetURL || targetURL.includes(window.location.pathname)) {
                reportEvent();
              }
            }, waitTime);
          }
        };
        var reportAutocompleteCategory = function (_a) {
          var report = _a.report,
            self = _a.self;
          var _b = self.data,
            userToken = _b.userToken,
            sessionToken = _b.sessionToken,
            uuid = _b.uuid,
            storeID = _b.storeID,
            cartToken = _b.cartToken;
          var callback = report.callback;
          var _c = report.data,
            categoryID = _c.categoryID,
            query = _c.query;
          utils_1.postLoadCallback({
            eventName: report.eventName,
            promise: reporting_1.Reporting.categorySearchSeen({
              query: query,
              uuid: uuid,
              storeID: storeID,
              userToken: userToken,
              categoryID: categoryID,
              sessionStart: sessionToken.start,
              cartToken: cartToken,
            }),
            callback: callback,
          });
        };
        var reportDirectProductViewData = function (_a) {
          var report = _a.report,
            self = _a.self;
          var _b = self.data,
            userToken = _b.userToken,
            sessionToken = _b.sessionToken,
            uuid = _b.uuid,
            storeID = _b.storeID,
            cartToken = _b.cartToken;
          var time = report.time,
            callback = report.callback,
            targetURL = report.targetURL;
          var productID = report.data.productID;
          var waitTime = time ? time : config_1.POST_LOAD_WAIT_TIME;
          setTimeout(function () {
            if (!targetURL || targetURL.includes(window.location.pathname)) {
              utils_1.postLoadCallback({
                eventName: report.eventName,
                promise: reporting_1.Reporting.productSeen({
                  type: "direct",
                  uuid: uuid,
                  storeID: storeID,
                  userToken: userToken,
                  productId: productID,
                  sessionStart: sessionToken.start,
                  cartToken: cartToken,
                }),
                callback: callback,
              });
            }
          }, waitTime);
        };
        var reportAutocompletePopularSearch = function (_a) {
          var report = _a.report,
            self = _a.self;
          var _b = self.data,
            userToken = _b.userToken,
            sessionToken = _b.sessionToken,
            uuid = _b.uuid,
            storeID = _b.storeID,
            cartToken = _b.cartToken;
          var callback = report.callback;
          var _c = report.data,
            query = _c.query,
            term = _c.term;
          utils_1.postLoadCallback({
            eventName: report.eventName,
            promise: reporting_1.Reporting.popularSearchSeen({
              originId: query,
              uuid: uuid,
              storeID: storeID,
              userToken: userToken,
              term: term,
              sessionStart: sessionToken.start,
              cartToken: cartToken,
            }),
            callback: callback,
          });
        };
        var reportSearchPreformed = function (_a) {
          var self = _a.self,
            report = _a.report;
          var _b = self.data,
            userToken = _b.userToken,
            sessionToken = _b.sessionToken,
            uuid = _b.uuid,
            storeID = _b.storeID,
            cartToken = _b.cartToken;
          var _c = report.data,
            query = _c.query,
            narrowBy = _c.narrowBy,
            sortBy = _c.sortBy;
          var callback = report.callback;
          utils_1.postLoadCallback({
            eventName: report.eventName,
            promise: reporting_1.Reporting.searchPerformed({
              userToken: userToken,
              sessionStart: sessionToken.start,
              uuid: uuid,
              storeID: storeID,
              query: query,
              narrow: narrowBy,
              sortBy: sortBy,
              cartToken: cartToken,
            }),
            callback: callback,
          });
        };
        var reportSmartCollectionPreformed = function (_a) {
          var self = _a.self,
            report = _a.report;
          var _b = self.data,
            userToken = _b.userToken,
            sessionToken = _b.sessionToken,
            uuid = _b.uuid,
            storeID = _b.storeID,
            cartToken = _b.cartToken;
          var _c = report.data,
            query = _c.query,
            categoryID = _c.categoryID,
            narrowBy = _c.narrowBy,
            sortBy = _c.sortBy;
          var callback = report.callback;
          var categoryName = self.temp.smartCollections.name;
          /* check if categories were fetched, if not retry in 300ms */
          if (!categoryName && self.data.categories.length === 0) {
            setTimeout(function () {
              reportSmartCollectionPreformed({ self: self, report: report });
            }, 300);
            return;
          }
          utils_1.postLoadCallback({
            eventName: report.eventName,
            promise: reporting_1.Reporting.collectionPerformed({
              uuid: uuid,
              storeID: storeID,
              userToken: userToken,
              sessionStart: sessionToken.start,
              query:
                (query !== null && query !== void 0 ? query : categoryName) ||
                utils_2.getCollectionName(self, categoryID),
              collectionID: categoryID,
              narrow: narrowBy,
              sortBy: sortBy,
              cartToken: cartToken,
            }),
            callback: callback,
          });
        };
        var reportQuickViewSerp = function (_a) {
          var self = _a.self,
            report = _a.report,
            type = _a.type;
          var _b = self.data,
            userToken = _b.userToken,
            sessionToken = _b.sessionToken,
            uuid = _b.uuid,
            storeID = _b.storeID,
            cartToken = _b.cartToken;
          var _c = report.data,
            position = _c.position,
            productID = _c.productID,
            term = _c.term;
          var callback = report.callback;
          utils_1.postLoadCallback({
            eventName: report.eventName,
            promise: reporting_1.Reporting.popUpUsed({
              uuid: uuid,
              storeID: storeID,
              userToken: userToken,
              cartToken: cartToken,
              query: term,
              productId: productID,
              position: position,
              sessionStart: sessionToken.start,
              type: type,
            }),
            callback: callback,
          });
        };
        var reportQuickViewCollection = function (_a) {
          var self = _a.self,
            report = _a.report,
            type = _a.type;
          var _b = self.data,
            userToken = _b.userToken,
            sessionToken = _b.sessionToken,
            uuid = _b.uuid,
            storeID = _b.storeID,
            cartToken = _b.cartToken;
          var _c = report.data,
            position = _c.position,
            productID = _c.productID,
            collectionID = _c.collectionID;
          var callback = report.callback;
          var categoryName = self.temp.smartCollections.name;
          utils_1.postLoadCallback({
            eventName: report.eventName,
            promise: reporting_1.Reporting.popUpUsed({
              uuid: uuid,
              storeID: storeID,
              userToken: userToken,
              cartToken: cartToken,
              productId: productID,
              position: position,
              categoryID: collectionID,
              categoryName:
                categoryName || utils_2.getCollectionName(self, collectionID),
              sessionStart: sessionToken.start,
              type: type,
            }),
            callback: callback,
          });
        };
        var reportSerpProductSeen = function (_a) {
          var self = _a.self,
            report = _a.report;
          var _b = self.data,
            userToken = _b.userToken,
            sessionToken = _b.sessionToken,
            uuid = _b.uuid,
            storeID = _b.storeID,
            cartToken = _b.cartToken;
          var time = report.time,
            callback = report.callback,
            targetURL = report.targetURL;
          var _c = report.data,
            productID = _c.productID,
            query = _c.query,
            _d = _c.position,
            position = _d === void 0 ? 1 : _d,
            imageID = _c.imageID;
          var waitTime = time ? time : config_1.POST_LOAD_WAIT_TIME;
          setTimeout(function () {
            if (!targetURL || targetURL.includes(window.location.pathname)) {
              utils_3.setRecentSearchProducts(self, productID);
              utils_1.postLoadCallback({
                eventName: report.eventName,
                promise: reporting_1.Reporting.productSeen({
                  type: "search",
                  term: query,
                  originId: query,
                  uuid: uuid,
                  storeID: storeID,
                  userToken: userToken,
                  productId: productID,
                  sessionStart: sessionToken.start,
                  position: position,
                  cartToken: cartToken,
                  recommended: utils_3.isRecentSearchProduct(productID, self),
                  imageID: imageID,
                }),
                callback: callback,
              });
            }
          }, waitTime);
        };
        var reportRecommendationsProductSeen = function (_a) {
          var self = _a.self,
            report = _a.report;
          var _b = self.data,
            userToken = _b.userToken,
            sessionToken = _b.sessionToken,
            uuid = _b.uuid,
            storeID = _b.storeID,
            cartToken = _b.cartToken;
          var time = report.time,
            callback = report.callback,
            targetURL = report.targetURL;
          var _c = report.data,
            productID = _c.productID,
            _d = _c.position,
            position = _d === void 0 ? 1 : _d,
            sourceProductID = _c.sourceProductID;
          var waitTime = time ? time : config_1.POST_LOAD_WAIT_TIME;
          setTimeout(function () {
            if (!targetURL || targetURL.includes(window.location.pathname)) {
              utils_3.setRecentSearchProducts(self, productID);
              utils_1.postLoadCallback({
                eventName: report.eventName,
                promise: reporting_1.Reporting.productSeen({
                  type: "related",
                  sourceProduct: sourceProductID,
                  uuid: uuid,
                  storeID: storeID,
                  userToken: userToken,
                  productId: productID,
                  cartToken: cartToken,
                  sessionStart: sessionToken.start,
                  position: position,
                  reference: "isp_rel_prd",
                }),
                callback: callback,
              });
            }
          }, waitTime);
        };
        var reportProductFromCollection = function (_a) {
          var report = _a.report,
            self = _a.self;
          var _b = self.data,
            userToken = _b.userToken,
            sessionToken = _b.sessionToken,
            uuid = _b.uuid,
            storeID = _b.storeID,
            cartToken = _b.cartToken;
          var time = report.time,
            callback = report.callback,
            targetURL = report.targetURL;
          var _c = report.data,
            productID = _c.productID,
            collectionID = _c.collectionID,
            _d = _c.position,
            position = _d === void 0 ? 1 : _d,
            query = _c.query,
            imageID = _c.imageID;
          var waitTime = time ? time : config_1.POST_LOAD_WAIT_TIME;
          var isRecommended = utils_2.isRecommendedProduct(productID);
          /* check if categories were fetched, if not retry in 300ms */
          if (!query && self.data.categories.length === 0) {
            setTimeout(function () {
              reportProductFromCollection({ self: self, report: report });
            }, 300);
            return;
          }
          setTimeout(function () {
            if (!targetURL || targetURL.includes(window.location.pathname)) {
              utils_2.updateRecentCollectionProducts(productID, collectionID);
              utils_3.setRecentSearchProducts(self, productID);
              utils_1.postLoadCallback({
                eventName: report.eventName,
                promise: reporting_1.Reporting.productSeen({
                  type: "category",
                  categoryName:
                    query || utils_2.getCollectionName(self, collectionID),
                  uuid: uuid,
                  storeID: storeID,
                  userToken: userToken,
                  productId: productID,
                  categoryID: collectionID,
                  sessionStart: sessionToken.start,
                  position: position,
                  cartToken: cartToken,
                  recommended: isRecommended,
                  imageID: imageID,
                }),
                callback: callback,
              });
            }
          }, waitTime);
        };
        var reportProductFromLookALike = function (_a) {
          var report = _a.report,
            self = _a.self;
          var _b = self.data,
            userToken = _b.userToken,
            sessionToken = _b.sessionToken,
            uuid = _b.uuid,
            storeID = _b.storeID,
            cartToken = _b.cartToken;
          var time = report.time,
            callback = report.callback,
            targetURL = report.targetURL;
          var _c = report.data,
            productID = _c.productID,
            _d = _c.position,
            position = _d === void 0 ? 1 : _d,
            originalProduct = _c.originalProduct;
          var waitTime = time ? time : config_1.POST_LOAD_WAIT_TIME;
          setTimeout(function () {
            if (!targetURL || targetURL.includes(window.location.pathname)) {
              utils_1.postLoadCallback({
                eventName: report.eventName,
                promise: reporting_1.Reporting.productSeen({
                  type: "look a like",
                  uuid: uuid,
                  storeID: storeID,
                  userToken: userToken,
                  productId: productID,
                  originProduct: originalProduct,
                  sessionStart: sessionToken.start,
                  position: position,
                  cartToken: cartToken,
                  reference: "isp_look_a_like",
                }),
                callback: callback,
              });
            }
          }, waitTime);
        };
        var reportProductFromQuickView = function (_a) {
          var report = _a.report,
            self = _a.self;
          var _b = self.data,
            userToken = _b.userToken,
            sessionToken = _b.sessionToken,
            uuid = _b.uuid,
            storeID = _b.storeID,
            cartToken = _b.cartToken;
          var time = report.time,
            callback = report.callback,
            targetURL = report.targetURL;
          var _c = report.data,
            productID = _c.productID,
            _d = _c.position,
            position = _d === void 0 ? 1 : _d,
            originalProduct = _c.originalProduct;
          var waitTime = time ? time : config_1.POST_LOAD_WAIT_TIME;
          setTimeout(function () {
            if (!targetURL || targetURL.includes(window.location.pathname)) {
              utils_1.postLoadCallback({
                eventName: report.eventName,
                promise: reporting_1.Reporting.productSeen({
                  uuid: uuid,
                  storeID: storeID,
                  userToken: userToken,
                  productId: productID,
                  originProduct: originalProduct,
                  sessionStart: sessionToken.start,
                  position: position,
                  cartToken: cartToken,
                  type: "quick view",
                  reference: "isp_look_a_like",
                }),
                callback: callback,
              });
            }
          }, waitTime);
        };
        var reportAddToCart = function (_a) {
          var report = _a.report,
            self = _a.self;
          var _b = self.data,
            userToken = _b.userToken,
            sessionToken = _b.sessionToken,
            uuid = _b.uuid,
            storeID = _b.storeID,
            cartToken = _b.cartToken;
          var callback = report.callback;
          var productID = report.data.productID;
          utils_1.postLoadCallback({
            eventName: report.eventName,
            promise: reporting_1.Reporting.addToCart({
              userToken: userToken,
              sessionStart: sessionToken.start,
              uuid: uuid,
              storeID: storeID,
              cartToken: cartToken,
              productID: productID,
            }),
            callback: callback,
          });
        };
        var reportCartVisited = function (_a) {
          var report = _a.report,
            self = _a.self;
          var _b = self.data,
            userToken = _b.userToken,
            sessionToken = _b.sessionToken,
            uuid = _b.uuid,
            storeID = _b.storeID,
            cartToken = _b.cartToken;
          var callback = report.callback;
          utils_1.postLoadCallback({
            eventName: report.eventName,
            promise: reporting_1.Reporting.addToCart({
              userToken: userToken,
              sessionStart: sessionToken.start,
              uuid: uuid,
              storeID: storeID,
              cartToken: cartToken,
            }),
            callback: callback,
          });
        };
        //# sourceMappingURL=index.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/sections/eventReporter/utils.js":
      /*!*************************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/sections/eventReporter/utils.js ***!
  \*************************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", { value: true });
        exports.postLoadCallback =
          exports.postLoad =
          exports.saveEvent =
            void 0;
        var index_1 = __webpack_require__(
          /*! ./index */ "./node_modules/fast-simon-sdk/lib/sections/eventReporter/index.js"
        );
        var config_1 = __webpack_require__(
          /*! ../../config */ "./node_modules/fast-simon-sdk/lib/config.js"
        );
        function saveEvent(report) {
          localStorage.setItem(
            config_1.POST_LOAD_EVENT_KEY,
            JSON.stringify(report)
          );
        }
        exports.saveEvent = saveEvent;
        var postLoad = function (self) {
          if (config_1.POST_LOAD_EVENT_KEY in localStorage) {
            var report = JSON.parse(
              localStorage.getItem(config_1.POST_LOAD_EVENT_KEY)
            );
            index_1.reportEvent({ self: self, report: report });
          }
        };
        exports.postLoad = postLoad;
        var postLoadCallback = function (_a) {
          var eventName = _a.eventName,
            promise = _a.promise,
            callback = _a.callback;
          promise
            .then(function (r) {
              if (callback) {
                callback({ eventName: eventName, payload: { success: true } });
              }
            })
            .catch(function (e) {
              if (callback) {
                callback({ eventName: eventName, payload: { success: true } });
              }
            });
        };
        exports.postLoadCallback = postLoadCallback;
        //# sourceMappingURL=utils.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/sections/fullTextSearch/index.js":
      /*!**************************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/sections/fullTextSearch/index.js ***!
  \**************************************************************************/
      /***/ function (__unused_webpack_module, exports, __webpack_require__) {
        "use strict";

        var __assign =
          (this && this.__assign) ||
          function () {
            __assign =
              Object.assign ||
              function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                  s = arguments[i];
                  for (var p in s)
                    if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
              };
            return __assign.apply(this, arguments);
          };
        var __rest =
          (this && this.__rest) ||
          function (s, e) {
            var t = {};
            for (var p in s)
              if (
                Object.prototype.hasOwnProperty.call(s, p) &&
                e.indexOf(p) < 0
              )
                t[p] = s[p];
            if (s != null && typeof Object.getOwnPropertySymbols === "function")
              for (
                var i = 0, p = Object.getOwnPropertySymbols(s);
                i < p.length;
                i++
              ) {
                if (
                  e.indexOf(p[i]) < 0 &&
                  Object.prototype.propertyIsEnumerable.call(s, p[i])
                )
                  t[p[i]] = s[p[i]];
              }
            return t;
          };
        var __spreadArray =
          (this && this.__spreadArray) ||
          function (to, from) {
            for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
              to[j] = from[i];
            return to;
          };
        Object.defineProperty(exports, "__esModule", { value: true });
        exports.fullTextSearch = void 0;
        var fullTextSearch_1 = __webpack_require__(
          /*! ../../services/fullTextSearch */ "./node_modules/fast-simon-sdk/lib/services/fullTextSearch.js"
        );
        var utils_1 = __webpack_require__(
          /*! ./utils */ "./node_modules/fast-simon-sdk/lib/sections/fullTextSearch/utils.js"
        );
        var fullTextSearch_2 = __webpack_require__(
          /*! ../../models/fullTextSearch */ "./node_modules/fast-simon-sdk/lib/models/fullTextSearch.js"
        );
        var fullTextSearch = function (_a) {
          var props = __rest(_a, []);
          var _b = props.self.data,
            uuid = _b.uuid,
            storeID = _b.storeID,
            cdnKey = _b.cdnKey,
            sessionToken = _b.sessionToken,
            userToken = _b.userToken;
          var term = props.term,
            narrowBy = props.narrowBy,
            _c = props.page,
            page = _c === void 0 ? 1 : _c,
            productsPerPage = props.productsPerPage,
            _d = props.facets,
            facets = _d === void 0 ? true : _d,
            _e = props.withAttributes,
            withAttributes = _e === void 0 ? false : _e,
            searchWithinSearch = props.searchWithinSearch;
          var sortBy = fullTextSearch_2.isSortBy(props.sortBy)
            ? props.sortBy
            : undefined;
          var isFacetNeeded = utils_1.facetNeeded({
            self: props.self,
            newQuery: term,
            newNarrow: narrowBy,
            newPage: page,
          });
          var filterData =
            facets &&
            props.self.temp.fullTextSearch.facets &&
            __spreadArray([], props.self.temp.fullTextSearch.facets);
          utils_1.emptyResults(props.self, term);
          var params = {
            cdn: cdnKey,
            uuid: uuid,
            storeID: storeID,
            term: term,
            sortBy: sortBy,
            productsPerPage: productsPerPage,
            searchWithinSearch: searchWithinSearch,
            page: page,
            narrowBy: narrowBy,
            withAttributes: withAttributes,
            recent: utils_1.getRecentSearchProducts(props.self),
          };
          if (!facets || !isFacetNeeded) {
            fullTextSearch_1.FullTextSearch.getFullTextSearch(
              __assign(__assign({}, params), {
                facetRequired: 0,
                sessionStart: sessionToken.start,
                userToken: userToken,
              })
            ).then(function (data) {
              var result = utils_1.getData(props.self, data);
              result.query = term;
              if (props.infiniteScrollPage && props.productsPerPage) {
                result.pageCount = Math.ceil(
                  result.totalResults /
                    (props.productsPerPage / props.infiniteScrollPage)
                );
              }
              if (filterData) {
                result.facets = filterData;
              }
              props.callback({
                action: filterData ? "facets and products" : "products",
                payload: result,
              });
            });
          } else {
            fullTextSearch_1.FullTextSearch.getFullTextSearch(
              __assign(__assign({}, params), {
                facetRequired: 1,
                sessionStart: sessionToken.start,
                userToken: userToken,
              })
            ).then(function (data) {
              var result = utils_1.getData(props.self, data);
              result.query = term;
              if (props.infiniteScrollPage && props.productsPerPage) {
                result.pageCount = Math.ceil(
                  result.totalResults /
                    (props.productsPerPage / props.infiniteScrollPage)
                );
              }
              if (data.facets_completed || data.pop_products_no_results) {
                result.facets = data.facets;
                props.callback({
                  action: "facets and products",
                  payload: result,
                });
                return;
              }
              props.callback({ action: "products", payload: result });
              fullTextSearch_1.FullTextSearch.getFullTextSearch(
                __assign(__assign({}, params), {
                  facetRequired: 2,
                  sessionStart: sessionToken.start,
                  userToken: userToken,
                })
              ).then(function (data) {
                result.facets = data.facets;
                props.callback({
                  action: "facets and products",
                  payload: result,
                });
              });
            });
          }
        };
        exports.fullTextSearch = fullTextSearch;
        //# sourceMappingURL=index.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/sections/fullTextSearch/utils.js":
      /*!**************************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/sections/fullTextSearch/utils.js ***!
  \**************************************************************************/
      /***/ function (__unused_webpack_module, exports, __webpack_require__) {
        "use strict";

        var __spreadArray =
          (this && this.__spreadArray) ||
          function (to, from) {
            for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
              to[j] = from[i];
            return to;
          };
        Object.defineProperty(exports, "__esModule", { value: true });
        exports.getFacets =
          exports.savePersonalizedProductsFromResponse =
          exports.setInfiniteScroll =
          exports.getData =
          exports.reformatNarrow =
          exports.facetNeeded =
          exports.isRecentSearchProduct =
          exports.setRecentSearchProducts =
          exports.getRecentSearchProducts =
          exports.emptyResults =
            void 0;
        var config_1 = __webpack_require__(
          /*! ../../config */ "./node_modules/fast-simon-sdk/lib/config.js"
        );
        var emptyResults = function (self, query) {
          self.temp.fullTextSearch = {
            totalResults: 0,
            products: [],
            query: query,
          };
        };
        exports.emptyResults = emptyResults;
        var getRecentSearchProducts = function (self) {
          if (self.data.dashboard.isp_personalized_search_enabled) {
            var products = localStorage.getItem(
              config_1.RECENT_SERP_PRODUCTS_KEY
            );
            if (products) {
              var current = JSON.parse(products);
              return current.length >= config_1.MIN_RECENT_SERP_PRODUCTS
                ? getRecentSearchProductsIds(current)
                : undefined;
            }
            return undefined;
          }
          return undefined;
        };
        exports.getRecentSearchProducts = getRecentSearchProducts;
        var getRecentSearchProductsIds = function (current) {
          return current
            .map(function (c) {
              return c.id;
            })
            .join(",");
        };
        var setRecentSearchProducts = function (self, id) {
          if (self.data.dashboard.isp_personalized_search_enabled) {
            var products = localStorage.getItem(
              config_1.RECENT_SERP_PRODUCTS_KEY
            );
            if (products) {
              localStorage.setItem(
                config_1.RECENT_SERP_PRODUCTS_KEY,
                getUpdatedRecentProducts(JSON.parse(products), id)
              );
            } else {
              localStorage.setItem(
                config_1.RECENT_SERP_PRODUCTS_KEY,
                JSON.stringify([
                  { id: id, time: Math.round(Date.now() / 1000) },
                ])
              );
            }
          }
        };
        exports.setRecentSearchProducts = setRecentSearchProducts;
        var isRecentSearchProduct = function (id, self) {
          var recent = localStorage.getItem(
            config_1.RECENT_RESPONSE_SERP_PRODUCTS_KEY
          );
          return Boolean(
            recent &&
              JSON.parse(recent).find(function (p) {
                return p === id;
              })
          );
        };
        exports.isRecentSearchProduct = isRecentSearchProduct;
        var getUpdatedRecentProducts = function (current, id) {
          var now = Math.round(Date.now() / 1000);
          var products = current.filter(function (c) {
            return (
              now - c.time < config_1.MAX_RECENT_SERP_PRODUCT_LIFE ||
              c.id !== id
            );
          });
          return JSON.stringify(
            __spreadArray(__spreadArray([], products), [
              { id: id, time: now },
            ]).splice(0, config_1.MAX_RECENT_SERP_PRODUCTS_PRODUCTS)
          );
        };
        var facetNeeded = function (_a) {
          var self = _a.self,
            newNarrow = _a.newNarrow,
            newQuery = _a.newQuery,
            newPage = _a.newPage;
          var _b = self.temp.fullTextSearch,
            query = _b.query,
            narrow = _b.narrow,
            page = _b.page;
          return !(
            query === newQuery &&
            JSON.stringify(narrow) === JSON.stringify(newNarrow) &&
            newPage === page
          );
        };
        exports.facetNeeded = facetNeeded;
        var reformatNarrow = function (narrow) {
          return narrow.map(function (term) {
            return [term[2], term[1]];
          });
        };
        exports.reformatNarrow = reformatNarrow;
        var getData = function (self, response) {
          var results = {};
          results.products = response.items;
          results.totalResults = response.total_results;
          if (response.narrow) {
            results.narrow = exports.reformatNarrow(response.narrow);
          }
          if (response.sort_by) {
            results.sortBy = response.sort_by;
          }
          if (response.pop_products_no_results) {
            results.isNoResults = true;
          }
          if (response.total_p) {
            results.pageCount = response.total_p;
          }
          if (response.personalized_products) {
            exports.savePersonalizedProductsFromResponse(
              response.personalized_products
            );
          }
          if (response.ancestor_categories) {
            results.ancestors = response.ancestor_categories;
          }
          if (response.avoid_tag_prefixes) {
            results.avoidPrefixList = response.avoid_tag_prefixes.split(",");
          }
          if (response.merch) {
            results.merch = response.merch;
          }
          results.page = response.p || 1;
          return results;
        };
        exports.getData = getData;
        var setInfiniteScroll = function (
          self,
          infiniteCount,
          productsPerPage
        ) {
          if (infiniteCount && productsPerPage) {
            self.temp.fullTextSearch.pageCount = Math.ceil(
              self.temp.fullTextSearch.totalResults /
                (productsPerPage / infiniteCount)
            );
          }
        };
        exports.setInfiniteScroll = setInfiniteScroll;
        var savePersonalizedProductsFromResponse = function (data) {
          localStorage.setItem(
            config_1.RECENT_RESPONSE_SERP_PRODUCTS_KEY,
            JSON.stringify(
              data.map(function (id) {
                return String(id);
              })
            )
          );
        };
        exports.savePersonalizedProductsFromResponse =
          savePersonalizedProductsFromResponse;
        var getFacets = function (self, facets) {
          var avoids =
            self.temp.fullTextSearch.avoidPrefixList ||
            self.temp.smartCollections.avoidPrefixList;
          if (avoids) {
            return facets.map(function (_a) {
              var facetName = _a[0],
                values = _a[1],
                rest = _a.slice(2);
              return __spreadArray(
                [facetName, fixFacetValues(values, avoids)],
                rest
              );
            });
          }
          return facets;
        };
        exports.getFacets = getFacets;
        var fixFacetValue = function (name, avoids) {
          return avoids.reduce(function (previousValue, currentValue) {
            return name.replace(currentValue, "");
          }, name);
        };
        var fixFacetValues = function (values, avoids) {
          return values.map(function (value) {
            var name, rest;
            if (value.length === 2) {
              (name = value[0]), (rest = value.slice(1));
              return __spreadArray([fixFacetValue(name, avoids)], rest);
            }
            return value;
          });
        };
        //# sourceMappingURL=utils.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/sections/index.js":
      /*!***********************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/sections/index.js ***!
  \***********************************************************/
      /***/ function (__unused_webpack_module, exports, __webpack_require__) {
        "use strict";

        var __assign =
          (this && this.__assign) ||
          function () {
            __assign =
              Object.assign ||
              function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                  s = arguments[i];
                  for (var p in s)
                    if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
              };
            return __assign.apply(this, arguments);
          };
        var __awaiter =
          (this && this.__awaiter) ||
          function (thisArg, _arguments, P, generator) {
            function adopt(value) {
              return value instanceof P
                ? value
                : new P(function (resolve) {
                    resolve(value);
                  });
            }
            return new (P || (P = Promise))(function (resolve, reject) {
              function fulfilled(value) {
                try {
                  step(generator.next(value));
                } catch (e) {
                  reject(e);
                }
              }
              function rejected(value) {
                try {
                  step(generator["throw"](value));
                } catch (e) {
                  reject(e);
                }
              }
              function step(result) {
                result.done
                  ? resolve(result.value)
                  : adopt(result.value).then(fulfilled, rejected);
              }
              step(
                (generator = generator.apply(thisArg, _arguments || [])).next()
              );
            });
          };
        var __generator =
          (this && this.__generator) ||
          function (thisArg, body) {
            var _ = {
                label: 0,
                sent: function () {
                  if (t[0] & 1) throw t[1];
                  return t[1];
                },
                trys: [],
                ops: [],
              },
              f,
              y,
              t,
              g;
            return (
              (g = { next: verb(0), throw: verb(1), return: verb(2) }),
              typeof Symbol === "function" &&
                (g[Symbol.iterator] = function () {
                  return this;
                }),
              g
            );
            function verb(n) {
              return function (v) {
                return step([n, v]);
              };
            }
            function step(op) {
              if (f) throw new TypeError("Generator is already executing.");
              while (_)
                try {
                  if (
                    ((f = 1),
                    y &&
                      (t =
                        op[0] & 2
                          ? y["return"]
                          : op[0]
                          ? y["throw"] || ((t = y["return"]) && t.call(y), 0)
                          : y.next) &&
                      !(t = t.call(y, op[1])).done)
                  )
                    return t;
                  if (((y = 0), t)) op = [op[0] & 2, t.value];
                  switch (op[0]) {
                    case 0:
                    case 1:
                      t = op;
                      break;
                    case 4:
                      _.label++;
                      return { value: op[1], done: false };
                    case 5:
                      _.label++;
                      y = op[1];
                      op = [0];
                      continue;
                    case 7:
                      op = _.ops.pop();
                      _.trys.pop();
                      continue;
                    default:
                      if (
                        !((t = _.trys),
                        (t = t.length > 0 && t[t.length - 1])) &&
                        (op[0] === 6 || op[0] === 2)
                      ) {
                        _ = 0;
                        continue;
                      }
                      if (
                        op[0] === 3 &&
                        (!t || (op[1] > t[0] && op[1] < t[3]))
                      ) {
                        _.label = op[1];
                        break;
                      }
                      if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                      }
                      if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                      }
                      if (t[2]) _.ops.pop();
                      _.trys.pop();
                      continue;
                  }
                  op = body.call(thisArg, _);
                } catch (e) {
                  op = [6, e];
                  y = 0;
                } finally {
                  f = t = 0;
                }
              if (op[0] & 5) throw op[1];
              return { value: op[0] ? op[1] : void 0, done: true };
            }
          };
        var __rest =
          (this && this.__rest) ||
          function (s, e) {
            var t = {};
            for (var p in s)
              if (
                Object.prototype.hasOwnProperty.call(s, p) &&
                e.indexOf(p) < 0
              )
                t[p] = s[p];
            if (s != null && typeof Object.getOwnPropertySymbols === "function")
              for (
                var i = 0, p = Object.getOwnPropertySymbols(s);
                i < p.length;
                i++
              ) {
                if (
                  e.indexOf(p[i]) < 0 &&
                  Object.prototype.propertyIsEnumerable.call(s, p[i])
                )
                  t[p[i]] = s[p[i]];
              }
            return t;
          };
        Object.defineProperty(exports, "__esModule", { value: true });
        exports.FastSDK = exports.sdkUtils = void 0;
        var initialization_1 = __webpack_require__(
          /*! ./initialization */ "./node_modules/fast-simon-sdk/lib/sections/initialization/index.js"
        );
        var instantSearch_1 = __webpack_require__(
          /*! ./instantSearch */ "./node_modules/fast-simon-sdk/lib/sections/instantSearch/index.js"
        );
        var common_1 = __webpack_require__(
          /*! ../models/common */ "./node_modules/fast-simon-sdk/lib/models/common.js"
        );
        var fullTextSearch_1 = __webpack_require__(
          /*! ./fullTextSearch */ "./node_modules/fast-simon-sdk/lib/sections/fullTextSearch/index.js"
        );
        var smartCollections_1 = __webpack_require__(
          /*! ./smartCollections */ "./node_modules/fast-simon-sdk/lib/sections/smartCollections/index.js"
        );
        var lookAlikeProductRecommendation_1 = __webpack_require__(
          /*! ./lookAlikeProductRecommendation */ "./node_modules/fast-simon-sdk/lib/sections/lookAlikeProductRecommendation/index.js"
        );
        var eventReporter_1 = __webpack_require__(
          /*! ./eventReporter */ "./node_modules/fast-simon-sdk/lib/sections/eventReporter/index.js"
        );
        var recommendations_1 = __webpack_require__(
          /*! ./recommendations */ "./node_modules/fast-simon-sdk/lib/sections/recommendations/index.js"
        );
        var validation_1 = __webpack_require__(
          /*! ../utils/validation */ "./node_modules/fast-simon-sdk/lib/utils/validation.js"
        );
        var utils_1 = __webpack_require__(
          /*! ./initialization/utils */ "./node_modules/fast-simon-sdk/lib/sections/initialization/utils.js"
        );
        var contentSearch_1 = __webpack_require__(
          /*! ./contentSearch */ "./node_modules/fast-simon-sdk/lib/sections/contentSearch/index.js"
        );
        var common_2 = __webpack_require__(
          /*! ../services/common */ "./node_modules/fast-simon-sdk/lib/services/common.js"
        );
        var related_1 = __webpack_require__(
          /*! ../services/related */ "./node_modules/fast-simon-sdk/lib/services/related.js"
        );
        var landingPage_1 = __webpack_require__(
          /*! ./landingPage */ "./node_modules/fast-simon-sdk/lib/sections/landingPage/index.js"
        );
        exports.sdkUtils = {
          status: "loading",
          type: "MPA",
          temp: common_1.defaultSDKTemp,
          data: common_1.defaultSDKData,
        };
        // @ts-ignore
        exports.FastSDK = {
          initialization: function (_a) {
            var props = __rest(_a, []);
            if (
              !validation_1.validateParams(
                ["uuid", "storeID", "type"],
                props
              ) ||
              !validation_1.validateUUID(props.uuid)
            ) {
              return;
            }
            initialization_1.initialization(
              __assign({ self: exports.sdkUtils }, props)
            );
          },
          instantSearch: function (_a) {
            var props = __rest(_a, []);
            if (!validation_1.validateParams(["query", "callback"], props)) {
              return;
            }
            if (!validation_1.isValidAPIUser(exports.sdkUtils)) {
              return;
            }
            var func = function () {
              instantSearch_1.InstantSearch(
                __assign({ self: exports.sdkUtils }, props)
              );
            };
            if (!utils_1.registerCallback(exports.sdkUtils, func)) {
              func();
            }
          },
          fullTextSearch: function (_a) {
            var props = __rest(_a, []);
            if (!validation_1.validateParams(["term", "callback"], props)) {
              return;
            }
            if (!validation_1.isValidAPIUser(exports.sdkUtils)) {
              return;
            }
            var func = function () {
              fullTextSearch_1.fullTextSearch(
                __assign({ self: exports.sdkUtils }, props)
              );
            };
            if (!utils_1.registerCallback(exports.sdkUtils, func)) {
              func();
            }
          },
          landingPage: function (_a) {
            var props = __rest(_a, []);
            if (!validation_1.validateParams(["slug", "callback"], props)) {
              return;
            }
            if (!validation_1.isValidAPIUser(exports.sdkUtils)) {
              return;
            }
            var func = function () {
              landingPage_1.landingPage(
                __assign({ self: exports.sdkUtils }, props)
              );
            };
            if (!utils_1.registerCallback(exports.sdkUtils, func)) {
              func();
            }
          },
          smartCollections: function (_a) {
            var props = __rest(_a, []);
            if (
              !validation_1.validateParams(["categoryID", "callback"], props)
            ) {
              return;
            }
            if (!validation_1.isValidAPIUser(exports.sdkUtils)) {
              return;
            }
            var func = function () {
              smartCollections_1.smartCollections(
                __assign({ self: exports.sdkUtils }, props)
              );
            };
            if (!utils_1.registerCallback(exports.sdkUtils, func)) {
              func();
            }
          },
          lookAlikeProductRecommendation: function (_a) {
            var props = __rest(_a, []);
            if (
              !validation_1.validateParams(
                ["viewedProductId", "callback"],
                props
              )
            ) {
              return;
            }
            if (!validation_1.isValidAPIUser(exports.sdkUtils)) {
              return;
            }
            var func = function () {
              lookAlikeProductRecommendation_1.lookAlikeProductRecommendation(
                __assign({ self: exports.sdkUtils }, props)
              );
            };
            if (!utils_1.registerCallback(exports.sdkUtils, func)) {
              func();
            }
          },
          productRecommendation: function (_a) {
            var props = __rest(_a, []);
            if (
              !validation_1.validateParams(
                ["productID", "specs", "callback"],
                props
              )
            ) {
              return;
            }
            if (!validation_1.isValidAPIUser(exports.sdkUtils)) {
              return;
            }
            var func = function () {
              recommendations_1.recommendations(
                __assign({ self: exports.sdkUtils }, props)
              );
            };
            if (!utils_1.registerCallback(exports.sdkUtils, func)) {
              func();
            }
          },
          contentSearch: function (_a) {
            var props = __rest(_a, []);
            if (!validation_1.validateParams(["query", "callback"], props)) {
              return;
            }
            if (!validation_1.isValidAPIUser(exports.sdkUtils)) {
              return;
            }
            var func = function () {
              contentSearch_1.contentSearch(
                __assign({ self: exports.sdkUtils }, props)
              );
            };
            if (!utils_1.registerCallback(exports.sdkUtils, func)) {
              func();
            }
          },
          event: function (_a) {
            var report = __rest(_a, []);
            if (!validation_1.validateParams(["eventName", "data"], report)) {
              return;
            }
            if (!validation_1.isValidAPIUser(exports.sdkUtils)) {
              return;
            }
            eventReporter_1.event({
              self: exports.sdkUtils,
              report: report,
            });
          },
          getAllCategories: function (callback) {
            return __awaiter(void 0, void 0, void 0, function () {
              var categories;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    if (exports.sdkUtils.status !== "ready") {
                      console.warn("SDK wasn't initialized!!!");
                      if (callback) callback(null);
                      return [
                        2 /*return*/,
                        new Promise(function (resolve) {
                          return resolve(null);
                        }),
                      ];
                    }
                    if (exports.sdkUtils.data.categories.length > 0) {
                      if (callback) callback(exports.sdkUtils.data.categories);
                      return [
                        2 /*return*/,
                        new Promise(function (resolve) {
                          resolve(exports.sdkUtils.data.categories);
                        }),
                      ];
                    }
                    return [
                      4 /*yield*/,
                      common_2.Common.getCategories({
                        cdn: exports.sdkUtils.data.cdnKey,
                        uuid: exports.sdkUtils.data.uuid,
                        storeID: exports.sdkUtils.data.storeID,
                      }),
                    ];
                  case 1:
                    categories = _a.sent();
                    if (callback) callback(categories);
                    return [2 /*return*/, categories];
                }
              });
            });
          },
          getAllPopularProducts: function (callback, withAttributes) {
            return __awaiter(void 0, void 0, void 0, function () {
              var popularProducts;
              var _a, _b;
              return __generator(this, function (_c) {
                switch (_c.label) {
                  case 0:
                    if (exports.sdkUtils.status !== "ready") {
                      console.warn("SDK wasn't initialized!!!");
                      if (callback) callback(null);
                      return [
                        2 /*return*/,
                        new Promise(function (resolve) {
                          return resolve(null);
                        }),
                      ];
                    }
                    if (exports.sdkUtils.data.popularProducts.length > 0) {
                      if (
                        (withAttributes &&
                          ((_b =
                            (_a = exports.sdkUtils.data.popularProducts) ===
                              null || _a === void 0
                              ? void 0
                              : _a[0]) === null || _b === void 0
                            ? void 0
                            : _b.att)) ||
                        !withAttributes
                      ) {
                        if (callback)
                          callback(exports.sdkUtils.data.popularProducts);
                        return [
                          2 /*return*/,
                          new Promise(function (resolve) {
                            resolve(exports.sdkUtils.data.popularProducts);
                          }),
                        ];
                      }
                    }
                    return [
                      4 /*yield*/,
                      common_2.Common.getPopularProducts({
                        cdn: exports.sdkUtils.data.cdnKey,
                        uuid: exports.sdkUtils.data.uuid,
                        storeID: exports.sdkUtils.data.storeID,
                        withAttributes: withAttributes,
                      }),
                    ];
                  case 1:
                    popularProducts = _c.sent();
                    if (callback) callback(popularProducts.products);
                    return [2 /*return*/, popularProducts.products];
                }
              });
            });
          },
          getProducts: function (_a) {
            var productIds = _a.productIds,
              callback = _a.callback;
            return __awaiter(void 0, void 0, void 0, function () {
              var response;
              return __generator(this, function (_b) {
                switch (_b.label) {
                  case 0:
                    if (productIds.length === 0) {
                      if (callback) callback([]);
                      return [
                        2 /*return*/,
                        new Promise(function (resolve) {
                          return resolve([]);
                        }),
                      ];
                    }
                    return [
                      4 /*yield*/,
                      related_1.Related.getRecentlyViewed({
                        uuid: exports.sdkUtils.data.uuid,
                        storeID: exports.sdkUtils.data.storeID,
                        categoryID: "",
                        cartToken: exports.sdkUtils.data.cartToken,
                        recent: productIds,
                      }),
                    ];
                  case 1:
                    response = _b.sent();
                    if (callback) {
                      callback(response.widget_responses[0].products);
                    }
                    return [
                      2 /*return*/,
                      response.widget_responses[0].products,
                    ];
                }
              });
            });
          },
          getSetup: function (props) {
            var keys = props.keys,
              callback = props.callback;
            if (!validation_1.validateParams(["keys", "callback"], props)) {
              return;
            }
            var func = function () {
              var response = {};
              for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                var key = keys_1[_i];
                // @ts-ignore
                response[key] = exports.sdkUtils.data.dashboard[key];
              }
              callback(response);
            };
            if (!utils_1.registerCallback(exports.sdkUtils, func)) {
              func();
            }
          },
        };
        //# sourceMappingURL=index.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/sections/initialization/index.js":
      /*!**************************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/sections/initialization/index.js ***!
  \**************************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", { value: true });
        exports.initialization = void 0;
        var common_1 = __webpack_require__(
          /*! ../../services/common */ "./node_modules/fast-simon-sdk/lib/services/common.js"
        );
        var utils_1 = __webpack_require__(
          /*! ./utils */ "./node_modules/fast-simon-sdk/lib/sections/initialization/utils.js"
        );
        var utils_2 = __webpack_require__(
          /*! ../eventReporter/utils */ "./node_modules/fast-simon-sdk/lib/sections/eventReporter/utils.js"
        );
        var initialization = function (_a) {
          var self = _a.self,
            storeID = _a.storeID,
            uuid = _a.uuid,
            onReady = _a.onReady,
            type = _a.type,
            cartToken = _a.cartToken;
          common_1.Common.getLoad({ uuid: uuid, storeID: storeID }).then(
            function (response) {
              utils_1.setLoadData(self, response);
              if (!self.data.dashboard.using_isp_api) {
                utils_1.printSDKError(self);
                return;
              }
              self.type = type;
              utils_1.setSessionToken(self);
              self.data.uuid = uuid;
              self.data.storeID = storeID;
              utils_1.printSDKReady(self, onReady);
              utils_1.executeCallbacks(self);
              if (cartToken) {
                self.data.cartToken = cartToken;
              } else {
                utils_1.setCartToken(self);
              }
              common_1.Common.getPopularProducts({
                cdn: self.data.cdnKey,
                uuid: uuid,
                storeID: storeID,
              })
                .then(function (popularProducts) {
                  var _a;
                  self.data.popularProducts =
                    (_a = popularProducts.products) !== null && _a !== void 0
                      ? _a
                      : [];
                })
                .catch(function (e) {
                  console.warn("Failed to fetch Popular Products");
                  console.warn(e);
                });
              common_1.Common.getCategories({
                cdn: self.data.cdnKey,
                uuid: uuid,
                storeID: storeID,
              })
                .then(function (categories) {
                  self.data.categories =
                    categories !== null && categories !== void 0
                      ? categories
                      : [];
                })
                .catch(function (e) {
                  console.warn("Failed to fetch Categories");
                  console.warn(e);
                });
              common_1.Common.getTurbolinks({
                cdn: self.data.cdnKey,
                uuid: uuid,
                storeID: storeID,
              })
                .then(function (turbolinks) {
                  self.data.turbolinks =
                    turbolinks !== null && turbolinks !== void 0
                      ? turbolinks
                      : [];
                })
                .catch(function (e) {
                  console.warn("Failed to fetch Turbolinks");
                  console.warn(e);
                });
              utils_1
                .getUserSessionToken(self)
                .then(function (token) {
                  self.data.userToken = token;
                  utils_2.postLoad(self);
                })
                .catch(function (e) {
                  console.warn("Failed to fetch User Session Token");
                  console.warn(e);
                });
            }
          );
        };
        exports.initialization = initialization;
        //# sourceMappingURL=index.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/sections/initialization/utils.js":
      /*!**************************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/sections/initialization/utils.js ***!
  \**************************************************************************/
      /***/ function (__unused_webpack_module, exports, __webpack_require__) {
        "use strict";

        var __assign =
          (this && this.__assign) ||
          function () {
            __assign =
              Object.assign ||
              function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                  s = arguments[i];
                  for (var p in s)
                    if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
              };
            return __assign.apply(this, arguments);
          };
        var __awaiter =
          (this && this.__awaiter) ||
          function (thisArg, _arguments, P, generator) {
            function adopt(value) {
              return value instanceof P
                ? value
                : new P(function (resolve) {
                    resolve(value);
                  });
            }
            return new (P || (P = Promise))(function (resolve, reject) {
              function fulfilled(value) {
                try {
                  step(generator.next(value));
                } catch (e) {
                  reject(e);
                }
              }
              function rejected(value) {
                try {
                  step(generator["throw"](value));
                } catch (e) {
                  reject(e);
                }
              }
              function step(result) {
                result.done
                  ? resolve(result.value)
                  : adopt(result.value).then(fulfilled, rejected);
              }
              step(
                (generator = generator.apply(thisArg, _arguments || [])).next()
              );
            });
          };
        var __generator =
          (this && this.__generator) ||
          function (thisArg, body) {
            var _ = {
                label: 0,
                sent: function () {
                  if (t[0] & 1) throw t[1];
                  return t[1];
                },
                trys: [],
                ops: [],
              },
              f,
              y,
              t,
              g;
            return (
              (g = { next: verb(0), throw: verb(1), return: verb(2) }),
              typeof Symbol === "function" &&
                (g[Symbol.iterator] = function () {
                  return this;
                }),
              g
            );
            function verb(n) {
              return function (v) {
                return step([n, v]);
              };
            }
            function step(op) {
              if (f) throw new TypeError("Generator is already executing.");
              while (_)
                try {
                  if (
                    ((f = 1),
                    y &&
                      (t =
                        op[0] & 2
                          ? y["return"]
                          : op[0]
                          ? y["throw"] || ((t = y["return"]) && t.call(y), 0)
                          : y.next) &&
                      !(t = t.call(y, op[1])).done)
                  )
                    return t;
                  if (((y = 0), t)) op = [op[0] & 2, t.value];
                  switch (op[0]) {
                    case 0:
                    case 1:
                      t = op;
                      break;
                    case 4:
                      _.label++;
                      return { value: op[1], done: false };
                    case 5:
                      _.label++;
                      y = op[1];
                      op = [0];
                      continue;
                    case 7:
                      op = _.ops.pop();
                      _.trys.pop();
                      continue;
                    default:
                      if (
                        !((t = _.trys),
                        (t = t.length > 0 && t[t.length - 1])) &&
                        (op[0] === 6 || op[0] === 2)
                      ) {
                        _ = 0;
                        continue;
                      }
                      if (
                        op[0] === 3 &&
                        (!t || (op[1] > t[0] && op[1] < t[3]))
                      ) {
                        _.label = op[1];
                        break;
                      }
                      if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                      }
                      if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                      }
                      if (t[2]) _.ops.pop();
                      _.trys.pop();
                      continue;
                  }
                  op = body.call(thisArg, _);
                } catch (e) {
                  op = [6, e];
                  y = 0;
                } finally {
                  f = t = 0;
                }
              if (op[0] & 5) throw op[1];
              return { value: op[0] ? op[1] : void 0, done: true };
            }
          };
        Object.defineProperty(exports, "__esModule", { value: true });
        exports.executeCallbacks =
          exports.registerCallback =
          exports.getPlatform =
          exports.setCartToken =
          exports.getUserSessionToken =
          exports.setSessionToken =
          exports.printSDKError =
          exports.printSDKReady =
          exports.setLoadData =
            void 0;
        var common_1 = __webpack_require__(
          /*! ../../services/common */ "./node_modules/fast-simon-sdk/lib/services/common.js"
        );
        var config_1 = __webpack_require__(
          /*! ../../config */ "./node_modules/fast-simon-sdk/lib/config.js"
        );
        var debug_1 = __webpack_require__(
          /*! ../../utils/debug */ "./node_modules/fast-simon-sdk/lib/utils/debug.js"
        );
        var options_1 = __webpack_require__(
          /*! ../../utils/options */ "./node_modules/fast-simon-sdk/lib/utils/options.js"
        );
        var cookies_1 = __webpack_require__(
          /*! ../../utils/cookies */ "./node_modules/fast-simon-sdk/lib/utils/cookies.js"
        );
        var segments_1 = __webpack_require__(
          /*! ../../utils/segments */ "./node_modules/fast-simon-sdk/lib/utils/segments.js"
        );
        var setLoadData = function (self, load) {
          self.data.cdnKey = load.cdn_cache_key || Date.now();
          self.data.dashboard = {
            site_url: load.site_url,
            site_domain: load.site_domain,
            disable_categories_suggestions: load.disable_categories_suggestions,
            max_popular_categories_suggestions:
              load.max_popular_searches_suggestions,
            max_popular_searches_suggestions:
              load.max_popular_searches_suggestions,
            max_product_suggestions: load.max_product_suggestions,
            using_isp_api: true,
            isp_personalized_search_enabled:
              load.isp_personalized_search_enabled,
            products_per_page: load.products_per_page,
            categories_products_per_page: load.categories_products_per_page,
            show_popular_products_on_focus: load.show_popular_products_on_focus,
          };
          if (options_1.getSDKABTestingOptionExist("autocomplete_preview")) {
            self.data.dashboard = __assign(__assign({}, self.data.dashboard), {
              disable_categories_suggestions: false,
              max_popular_categories_suggestions: 20,
              max_popular_searches_suggestions: 20,
              max_product_suggestions: 20,
            });
          }
          localStorage.setItem("sdk-cdn-key", String(self.data.cdnKey));
        };
        exports.setLoadData = setLoadData;
        var printSDKReady = function (self, callback) {
          self.status = "ready";
          console.log(
            "%c\u2705 Fast SDK Ready | uuid : " +
              self.data.uuid +
              " | storeID: " +
              self.data.storeID +
              " | url: " +
              self.data.dashboard.site_url,
            "font-weight: bold; font-size: 12px;"
          );
          if (callback) {
            callback();
          }
          var debugEndpoint = debug_1.getDebugEndpoint();
          var isNotCaching = debug_1.isDebugCaching();
          if (debugEndpoint || isNotCaching) {
            console.log(
              "%c\uD83D\uDEE0\uFE0F Debug ON | Endpoint: " +
                debugEndpoint +
                " " +
                (isNotCaching ? "| Caching OFF " : "") +
                " ",
              "font-weight: bold; font-size: 12px; color: red"
            );
          }
        };
        exports.printSDKReady = printSDKReady;
        var printSDKError = function (self) {
          self.status = "error";
          console.log(
            "%c" + config_1.API_ERROR_MSG,
            "font-weight: bold; font-size: 12px; color: red"
          );
        };
        exports.printSDKError = printSDKError;
        var setSessionToken = function (self) {
          self.data.sessionToken = getSessionToken();
          localStorage.setItem(
            config_1.SESSION_TOKEN_LS_KEY,
            JSON.stringify(self.data.sessionToken)
          );
        };
        exports.setSessionToken = setSessionToken;
        var getSessionToken = function () {
          var sessionLC = localStorage.getItem(config_1.SESSION_TOKEN_LS_KEY);
          var now = Math.round(Date.now() / 1000);
          if (sessionLC) {
            var currentSession = JSON.parse(sessionLC);
            if (
              now - currentSession.lastActive >=
              config_1.SESSION_TOKEN_LIFE
            ) {
              return {
                lastActive: now,
                start: now,
              };
            } else {
              return {
                lastActive: now,
                start: currentSession.start,
              };
            }
          } else {
            return {
              lastActive: now,
              start: now,
            };
          }
        };
        var getUserSessionToken = function (self) {
          return __awaiter(void 0, void 0, void 0, function () {
            var userSessionLC, _a, storeID, uuid, newSession;
            return __generator(this, function (_b) {
              switch (_b.label) {
                case 0:
                  userSessionLC = localStorage.getItem(
                    config_1.USER_SESSION_TOKEN_LS_KEY
                  );
                  (_a = self.data), (storeID = _a.storeID), (uuid = _a.uuid);
                  if (!userSessionLC) return [3 /*break*/, 1];
                  return [
                    2 /*return*/,
                    new Promise(function (resolve) {
                      return resolve(userSessionLC);
                    }),
                  ];
                case 1:
                  return [
                    4 /*yield*/,
                    common_1.Common.getPostLoad({
                      storeID: storeID,
                      uuid: uuid,
                    }),
                  ];
                case 2:
                  newSession = _b.sent();
                  localStorage.setItem(
                    config_1.USER_SESSION_TOKEN_LS_KEY,
                    newSession.isp_token
                  );
                  segments_1.setServingSegments(
                    newSession === null || newSession === void 0
                      ? void 0
                      : newSession.isp_segments_serving
                  );
                  return [2 /*return*/, newSession.isp_token];
              }
            });
          });
        };
        exports.getUserSessionToken = getUserSessionToken;
        var setCartToken = function (self) {
          var platform = exports.getPlatform();
          var cookies = new cookies_1.default();
          if (
            platform == "Shopify" &&
            cookies.has(config_1.CART_TOKEN_COOKIE_NAME)
          ) {
            self.data.cartToken = cookies.get(config_1.CART_TOKEN_COOKIE_NAME);
            return;
          }
          if (config_1.CART_TOKEN_LS_KEY in localStorage) {
            self.data.cartToken = localStorage.getItem(
              config_1.CART_TOKEN_LS_KEY
            );
            return;
          }
          if (platform == "Shopify") {
            common_1.Common.getShopifyCartToken().then(function (resp) {
              if (resp.token) {
                self.data.cartToken = resp.token;
                localStorage.setItem(config_1.CART_TOKEN_LS_KEY, resp.token);
              }
            });
          } else if (platform === "Bigcommerce") {
            common_1.Common.getBigcommerceCartToken().then(function (resp) {
              if (resp.length > 0 && resp[0].id) {
                self.data.cartToken = resp[0].id;
                localStorage.setItem(config_1.CART_TOKEN_LS_KEY, resp[0].id);
              }
            });
          }
        };
        exports.setCartToken = setCartToken;
        var getPlatform = function () {
          if ("Shopify" in window) {
            return "Shopify";
          }
          if ("BCData" in window) {
            return "Bigcommerce";
          }
          return "";
        };
        exports.getPlatform = getPlatform;
        var registerCallback = function (self, callback) {
          if (self.status !== "ready") {
            if (self.callbacks) {
              self.callbacks.push(callback);
            } else {
              self.callbacks = [callback];
            }
            return true;
          }
          return false;
        };
        exports.registerCallback = registerCallback;
        var executeCallbacks = function (self) {
          if (self.callbacks) {
            self.callbacks.forEach(function (callback) {
              return callback();
            });
          }
        };
        exports.executeCallbacks = executeCallbacks;
        //# sourceMappingURL=utils.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/sections/instantSearch/index.js":
      /*!*************************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/sections/instantSearch/index.js ***!
  \*************************************************************************/
      /***/ function (__unused_webpack_module, exports, __webpack_require__) {
        "use strict";

        var __assign =
          (this && this.__assign) ||
          function () {
            __assign =
              Object.assign ||
              function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                  s = arguments[i];
                  for (var p in s)
                    if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
              };
            return __assign.apply(this, arguments);
          };
        var __spreadArray =
          (this && this.__spreadArray) ||
          function (to, from) {
            for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
              to[j] = from[i];
            return to;
          };
        Object.defineProperty(exports, "__esModule", { value: true });
        exports.InstantSearch = void 0;
        var utils_1 = __webpack_require__(
          /*! ./utils */ "./node_modules/fast-simon-sdk/lib/sections/instantSearch/utils.js"
        );
        var autocomplete_1 = __webpack_require__(
          /*! ../../services/autocomplete */ "./node_modules/fast-simon-sdk/lib/services/autocomplete.js"
        );
        var options_1 = __webpack_require__(
          /*! ../../utils/options */ "./node_modules/fast-simon-sdk/lib/utils/options.js"
        );
        var InstantSearch = function (_a) {
          var _b, _c;
          var self = _a.self,
            query = _a.query,
            callback = _a.callback,
            withAttributes = _a.withAttributes;
          var _d = self.data,
            cdnKey = _d.cdnKey,
            uuid = _d.uuid,
            storeID = _d.storeID,
            dashboard = _d.dashboard;
          utils_1.emptyResults(self, query);
          if (
            !query &&
            (dashboard.show_popular_products_on_focus ||
              options_1.getSDKABTestingOptionExist("show_popular_on_hover"))
          ) {
            callback({
              action: "instantSearch",
              payload: {
                categories: [],
                products: __spreadArray([], self.data.popularProducts).splice(
                  0,
                  dashboard.max_product_suggestions
                ),
                turbolinks: [],
                totalResults: 0,
                query: query,
                popularSearches: [],
              },
            });
            return;
          }
          var _e = utils_1.clientSuggestion({ self: self, query: query }),
            turbolinks = _e.turbolinks,
            categories = _e.categories;
          var data = {
            totalResults: 0,
            popularSearches: [],
            query: query,
            products: [],
            categories: categories
              ? categories.splice(
                  0,
                  (_b = dashboard.max_popular_categories_suggestions) !==
                    null && _b !== void 0
                    ? _b
                    : 10
                )
              : [],
            turbolinks:
              turbolinks !== null && turbolinks !== void 0 ? turbolinks : [],
          };
          autocomplete_1.Autocomplete.getPopularSearches({
            query: query,
            cdn: cdnKey,
            uuid: uuid,
            storeID: storeID,
            site: utils_1.parseUrl(
              (_c = dashboard.site_domain) !== null && _c !== void 0
                ? _c
                : dashboard.site_url
            ),
          })
            .then(function (result) {
              var _a;
              var popularSearches = result.items.splice(
                0,
                (_a = dashboard.max_popular_searches_suggestions) !== null &&
                  _a !== void 0
                  ? _a
                  : 5
              );
              utils_1.handleProducts({
                self: self,
                query: query,
                callback: callback,
                data: __assign(__assign({}, data), {
                  popularSearches: popularSearches,
                }),
                withAttributes: withAttributes,
              });
            })
            .catch(function (e) {
              console.warn("Could not fetch popular searches");
              console.warn(e);
              utils_1.handleProducts({
                self: self,
                query: query,
                callback: callback,
                data: data,
                withAttributes: withAttributes,
              });
            });
        };
        exports.InstantSearch = InstantSearch;
        //# sourceMappingURL=index.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/sections/instantSearch/utils.js":
      /*!*************************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/sections/instantSearch/utils.js ***!
  \*************************************************************************/
      /***/ function (__unused_webpack_module, exports, __webpack_require__) {
        "use strict";

        var __assign =
          (this && this.__assign) ||
          function () {
            __assign =
              Object.assign ||
              function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                  s = arguments[i];
                  for (var p in s)
                    if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
              };
            return __assign.apply(this, arguments);
          };
        var __spreadArray =
          (this && this.__spreadArray) ||
          function (to, from) {
            for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
              to[j] = from[i];
            return to;
          };
        Object.defineProperty(exports, "__esModule", { value: true });
        exports.parseUrl =
          exports.handleProducts =
          exports.clientSuggestion =
          exports.emptyResults =
            void 0;
        var autocomplete_1 = __webpack_require__(
          /*! ../../services/autocomplete */ "./node_modules/fast-simon-sdk/lib/services/autocomplete.js"
        );
        var emptyResults = function (self, query) {
          self.temp.autocomplete = {
            totalResults: 0,
            popularSearches: [],
            products: [],
            turbolinks: [],
            query: query,
          };
        };
        exports.emptyResults = emptyResults;
        var clientSuggestion = function (_a) {
          var self = _a.self,
            query = _a.query;
          var _b = self.data.dashboard,
            max_popular_categories_suggestions =
              _b.max_popular_categories_suggestions,
            disable_categories_suggestions = _b.disable_categories_suggestions;
          return {
            categories: getCategories({
              query: query,
              isCategories: !disable_categories_suggestions,
              count: max_popular_categories_suggestions,
              categories: self.data.categories,
            }),
            turbolinks: getTrubolinks({
              searchTerm: query,
              turbolinks: self.data.turbolinks,
            }),
          };
        };
        exports.clientSuggestion = clientSuggestion;
        var getCategories = function (_a) {
          var query = _a.query,
            isCategories = _a.isCategories,
            count = _a.count,
            categories = _a.categories;
          if (!isCategories) {
            return undefined;
          }
          if (!query || count === 0) return [];
          // score categories
          var scoredCategories = __spreadArray([], categories).map(function (
            category
          ) {
            return [category, scoreCategory(category, query)];
          });
          // sort scored categories by score
          var newCategories = scoredCategories
            .filter(function (category) {
              return category[1];
            })
            .sort(function (category1, category2) {
              if (category1[1] > category2[1]) return -1;
              if (category1[1] < category2[1]) return 1;
              return 0;
            });
          // filter to show max results
          var result = newCategories
            .map(function (category) {
              return category[0];
            })
            .filter(function (category, index) {
              return index < count;
            });
          // check if you need to show parent category
          var needParentCategory = (function () {
            var names = new Set();
            for (var _i = 0, result_1 = result; _i < result_1.length; _i++) {
              var category = result_1[_i];
              names.add(category.l.toLowerCase());
            }
            return names.size !== newCategories.length;
          })();
          if (needParentCategory) {
            return result.map(function (category) {
              var _a;
              if (!category.parent_name) {
                return __assign(__assign({}, category), {
                  parent_name:
                    ((_a = categories.find(function (c) {
                      return c.id === category.p_id;
                    })) === null || _a === void 0
                      ? void 0
                      : _a.l) || "",
                });
              }
              return category;
            });
          } else {
            return result.map(function (category) {
              return __assign(__assign({}, category), { parent_name: "" });
            });
          }
        };
        var scoreCategory = function (category, searchTerm) {
          var score = 0;
          var categoryName = category.l.toLowerCase();
          var search = searchTerm.toLowerCase().trim();
          //exact match
          if (categoryName === search) {
            return 10;
          }
          //begins with query
          if (
            categoryName.split(" ").find(function (w) {
              return w && w.indexOf(search) === 0;
            })
          ) {
            score += 5;
          }
          // half match
          if (categoryName.includes(search)) {
            score += 1;
          }
          return score;
        };
        var getTrubolinks = function (_a) {
          var turbolinks = _a.turbolinks,
            searchTerm = _a.searchTerm;
          if (!searchTerm) return [];
          var search = searchTerm.toLowerCase().trim();
          return turbolinks.filter(function (turbolinks) {
            return (
              turbolinks.l.toLowerCase().includes(search) ||
              turbolinks.u.toLowerCase().includes(search)
            );
          });
        };
        var handleProducts = function (_a) {
          var callback = _a.callback,
            data = _a.data,
            query = _a.query,
            self = _a.self,
            withAttributes = _a.withAttributes;
          var _b = self.data,
            cdnKey = _b.cdnKey,
            storeID = _b.storeID,
            uuid = _b.uuid,
            popularProducts = _b.popularProducts;
          var max_product_suggestions =
            self.data.dashboard.max_product_suggestions;
          var clientProducts = getClientProducts({
            products: popularProducts,
            searchTerm: query,
            count: max_product_suggestions,
          });
          var ids = new Set(
            clientProducts.map(function (p) {
              return p.id;
            })
          );
          if (clientProducts.length < max_product_suggestions) {
            autocomplete_1.Autocomplete.getProducts({
              query: query,
              storeID: storeID,
              uuid: uuid,
              cdn: cdnKey,
              withAttributes: withAttributes,
            })
              .then(function (server) {
                var products = __spreadArray(
                  __spreadArray([], clientProducts),
                  server.items.filter(function (p, i) {
                    return (
                      i < max_product_suggestions - clientProducts.length &&
                      !ids.has(p.id)
                    );
                  })
                );
                var totalResults = products.length;
                callback({
                  action: "instantSearch",
                  payload: __assign(__assign({}, data), {
                    products: products,
                    totalResults: totalResults,
                  }),
                });
              })
              .catch(function (e) {
                console.warn("Could not fetch products");
                console.warn(e);
              });
          } else {
            callback({
              action: "instantSearch",
              payload: __assign(__assign({}, data), {
                products: clientProducts,
                totalResults: clientProducts.length,
              }),
            });
          }
        };
        exports.handleProducts = handleProducts;
        var getClientProducts = function (_a) {
          var products = _a.products,
            count = _a.count,
            searchTerm = _a.searchTerm;
          if (!searchTerm) {
            return [];
          }
          if (!searchTerm) return [];
          var scored = products.map(function (p) {
            return getProductMatching(p, searchTerm);
          });
          var filtered = scored.filter(function (p) {
            return p[1];
          });
          var sorted = filtered.sort(function (p1, p2) {
            if (p1[1] > p2[1]) return -1;
            if (p2[1] > p1[1]) return 1;
            return 0;
          });
          var spliced = sorted.filter(function (product, index) {
            return index < count;
          });
          return spliced.map(function (p) {
            return p[0];
          });
        };
        var getProductMatching = function (product, searchTerm) {
          var title = product.l
            .toLowerCase()
            .replace(/\s{2,}/g, " ")
            .replace(/[^\w\s]/gi, " ");
          var search = searchTerm
            .toLowerCase()
            .replace(/\s{2,}/g, " ")
            .replace(/[^\w\s]/gi, " ");
          var description = product.d
            .toLowerCase()
            .replace(/\s{2,}/g, " ")
            .replace(/[^\w\s]/gi, " ");
          //sku match
          if (
            product.real_sku &&
            product.real_sku === search &&
            product.skus &&
            product.skus.length > 1
          ) {
            return [product, 3];
          }
          //title exact match
          if (title === search) {
            return [product, 3];
          }
          // title semi match
          for (var _i = 0, _a = title.split(" "); _i < _a.length; _i++) {
            var word = _a[_i];
            if (word === search) {
              return [product, 2];
            }
            if (word.indexOf(search) === 0) {
              return description.match(searchTerm)
                ? [product, 2]
                : [product, 1];
            }
          }
          return [product, 0];
        };
        var parseUrl = function (url) {
          var fixed = url.replace("https://", "").replace("http://", "");
          if (fixed[fixed.length - 1] === "/") {
            return fixed.slice(0, fixed.length - 1);
          }
          return fixed;
        };
        exports.parseUrl = parseUrl;
        //# sourceMappingURL=utils.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/sections/landingPage/index.js":
      /*!***********************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/sections/landingPage/index.js ***!
  \***********************************************************************/
      /***/ function (__unused_webpack_module, exports, __webpack_require__) {
        "use strict";

        var __assign =
          (this && this.__assign) ||
          function () {
            __assign =
              Object.assign ||
              function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                  s = arguments[i];
                  for (var p in s)
                    if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
              };
            return __assign.apply(this, arguments);
          };
        var __rest =
          (this && this.__rest) ||
          function (s, e) {
            var t = {};
            for (var p in s)
              if (
                Object.prototype.hasOwnProperty.call(s, p) &&
                e.indexOf(p) < 0
              )
                t[p] = s[p];
            if (s != null && typeof Object.getOwnPropertySymbols === "function")
              for (
                var i = 0, p = Object.getOwnPropertySymbols(s);
                i < p.length;
                i++
              ) {
                if (
                  e.indexOf(p[i]) < 0 &&
                  Object.prototype.propertyIsEnumerable.call(s, p[i])
                )
                  t[p[i]] = s[p[i]];
              }
            return t;
          };
        var __spreadArray =
          (this && this.__spreadArray) ||
          function (to, from) {
            for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
              to[j] = from[i];
            return to;
          };
        Object.defineProperty(exports, "__esModule", { value: true });
        exports.landingPage = void 0;
        var utils_1 = __webpack_require__(
          /*! ./utils */ "./node_modules/fast-simon-sdk/lib/sections/landingPage/utils.js"
        );
        var fullTextSearch_1 = __webpack_require__(
          /*! ../../models/fullTextSearch */ "./node_modules/fast-simon-sdk/lib/models/fullTextSearch.js"
        );
        var landingPage_1 = __webpack_require__(
          /*! ../../services/landingPage */ "./node_modules/fast-simon-sdk/lib/services/landingPage.js"
        );
        var landingPage = function (_a) {
          var props = __rest(_a, []);
          var _b = props.self.data,
            uuid = _b.uuid,
            storeID = _b.storeID,
            cdnKey = _b.cdnKey,
            sessionToken = _b.sessionToken,
            userToken = _b.userToken;
          var slug = props.slug,
            narrowBy = props.narrowBy,
            _c = props.page,
            page = _c === void 0 ? 1 : _c,
            productsPerPage = props.productsPerPage,
            _d = props.facets,
            facets = _d === void 0 ? true : _d,
            _e = props.withAttributes,
            withAttributes = _e === void 0 ? false : _e;
          var sortBy = fullTextSearch_1.isSortBy(props.sortBy)
            ? props.sortBy
            : undefined;
          var isFacetNeeded = utils_1.facetNeeded({
            self: props.self,
            newQuery: slug,
            newNarrow: narrowBy,
            newPage: page,
          });
          var filterData =
            facets &&
            props.self.temp.fullTextSearch.facets &&
            __spreadArray([], props.self.temp.fullTextSearch.facets);
          utils_1.emptyResults(props.self, slug);
          var params = {
            cdn: cdnKey,
            uuid: uuid,
            storeID: storeID,
            slug: slug,
            sortBy: sortBy,
            productsPerPage: productsPerPage,
            page: page,
            narrowBy: narrowBy,
            withAttributes: withAttributes,
          };
          if (!facets || !isFacetNeeded) {
            landingPage_1.LandingPage.getLandingPage(
              __assign(__assign({}, params), {
                facetRequired: 0,
                sessionStart: sessionToken.start,
                userToken: userToken,
              })
            ).then(function (data) {
              utils_1.setData(props.self, data);
              if (filterData) {
                props.self.temp.landingPage.facets = filterData;
              }
              props.callback({
                action: filterData ? "facets and products" : "products",
                payload: props.self.temp.landingPage,
              });
            });
          } else {
            landingPage_1.LandingPage.getLandingPage(
              __assign(__assign({}, params), {
                facetRequired: 1,
                sessionStart: sessionToken.start,
                userToken: userToken,
              })
            ).then(function (data) {
              utils_1.setData(props.self, data);
              if (data.facets_completed || data.pop_products_no_results) {
                props.self.temp.landingPage.facets = data.facets;
                props.callback({
                  action: "facets and products",
                  payload: props.self.temp.landingPage,
                });
                return;
              }
              props.callback({
                action: "products",
                payload: props.self.temp.landingPage,
              });
              landingPage_1.LandingPage.getLandingPage(
                __assign(__assign({}, params), {
                  facetRequired: 2,
                  sessionStart: sessionToken.start,
                  userToken: userToken,
                })
              ).then(function (data) {
                props.self.temp.landingPage.facets = data.facets;
                props.callback({
                  action: "facets and products",
                  payload: props.self.temp.landingPage,
                });
              });
            });
          }
        };
        exports.landingPage = landingPage;
        //# sourceMappingURL=index.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/sections/landingPage/utils.js":
      /*!***********************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/sections/landingPage/utils.js ***!
  \***********************************************************************/
      /***/ function (__unused_webpack_module, exports, __webpack_require__) {
        "use strict";

        var __spreadArray =
          (this && this.__spreadArray) ||
          function (to, from) {
            for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
              to[j] = from[i];
            return to;
          };
        Object.defineProperty(exports, "__esModule", { value: true });
        exports.setData =
          exports.reformatNarrow =
          exports.facetNeeded =
          exports.isRecentSearchProduct =
          exports.setRecentSearchProducts =
          exports.getRecentSearchProducts =
          exports.emptyResults =
            void 0;
        var config_1 = __webpack_require__(
          /*! ../../config */ "./node_modules/fast-simon-sdk/lib/config.js"
        );
        var emptyResults = function (self, slug) {
          self.temp.landingPage = {
            totalResults: 0,
            products: [],
            slug: slug,
          };
        };
        exports.emptyResults = emptyResults;
        var getRecentSearchProducts = function (self) {
          if (self.data.dashboard.isp_personalized_search_enabled) {
            var products = localStorage.getItem(
              config_1.RECENT_SERP_PRODUCTS_KEY
            );
            if (products) {
              var current = JSON.parse(products);
              return current.length >= config_1.MIN_RECENT_SERP_PRODUCTS
                ? getRecentSearchProductsIds(current)
                : undefined;
            }
            return undefined;
          }
          return undefined;
        };
        exports.getRecentSearchProducts = getRecentSearchProducts;
        var getRecentSearchProductsIds = function (current) {
          return current
            .map(function (c) {
              return c.id;
            })
            .join(",");
        };
        var setRecentSearchProducts = function (self, id) {
          if (self.data.dashboard.isp_personalized_search_enabled) {
            var products = localStorage.getItem(
              config_1.RECENT_SERP_PRODUCTS_KEY
            );
            if (products) {
              localStorage.setItem(
                config_1.RECENT_SERP_PRODUCTS_KEY,
                getUpdatedRecentProducts(JSON.parse(products), id)
              );
            } else {
              localStorage.setItem(
                config_1.RECENT_SERP_PRODUCTS_KEY,
                JSON.stringify([
                  { id: id, time: Math.round(Date.now() / 1000) },
                ])
              );
            }
          }
        };
        exports.setRecentSearchProducts = setRecentSearchProducts;
        var isRecentSearchProduct = function (id, self) {
          var recent = localStorage.getItem(
            config_1.RECENT_RESPONSE_SERP_PRODUCTS_KEY
          );
          return Boolean(
            recent &&
              JSON.parse(recent).find(function (p) {
                return p === id;
              })
          );
        };
        exports.isRecentSearchProduct = isRecentSearchProduct;
        var getUpdatedRecentProducts = function (current, id) {
          var now = Math.round(Date.now() / 1000);
          var products = current.filter(function (c) {
            return (
              now - c.time < config_1.MAX_RECENT_SERP_PRODUCT_LIFE ||
              c.id !== id
            );
          });
          return JSON.stringify(
            __spreadArray(__spreadArray([], products), [
              { id: id, time: now },
            ]).splice(0, config_1.MAX_RECENT_SERP_PRODUCTS_PRODUCTS)
          );
        };
        var facetNeeded = function (_a) {
          var self = _a.self,
            newNarrow = _a.newNarrow,
            newQuery = _a.newQuery,
            newPage = _a.newPage;
          var _b = self.temp.fullTextSearch,
            query = _b.query,
            narrow = _b.narrow,
            page = _b.page;
          return !(
            query === newQuery &&
            JSON.stringify(narrow) === JSON.stringify(newNarrow) &&
            newPage === page
          );
        };
        exports.facetNeeded = facetNeeded;
        var reformatNarrow = function (narrow) {
          return narrow.map(function (term) {
            return [term[2], term[1]];
          });
        };
        exports.reformatNarrow = reformatNarrow;
        var setData = function (self, response) {
          self.temp.landingPage.products = response.items;
          self.temp.landingPage.totalResults = response.total_results;
          if (response.narrow) {
            self.temp.landingPage.narrow = exports.reformatNarrow(
              response.narrow
            );
          }
          if (response.sort_by) {
            self.temp.landingPage.sortBy = response.sort_by;
          }
          if (response.pop_products_no_results) {
            self.temp.landingPage.isNoResults = true;
          }
          if (response.total_p) {
            self.temp.landingPage.pageCount = response.total_p;
          }
          if (response.ancestor_categories) {
            self.temp.landingPage.ancestors = response.ancestor_categories;
          }
          if (response.avoid_tag_prefixes) {
            self.temp.landingPage.avoidPrefixList =
              response.avoid_tag_prefixes.split(",");
          }
          self.temp.landingPage.page = response.p || 1;
        };
        exports.setData = setData;
        //# sourceMappingURL=utils.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/sections/lookAlikeProductRecommendation/index.js":
      /*!******************************************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/sections/lookAlikeProductRecommendation/index.js ***!
  \******************************************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", { value: true });
        exports.lookAlikeProductRecommendation = void 0;
        var lookAlikeProductRecommendation_1 = __webpack_require__(
          /*! ../../services/lookAlikeProductRecommendation */ "./node_modules/fast-simon-sdk/lib/services/lookAlikeProductRecommendation.js"
        );
        var lookAlikeProductRecommendation = function (_a) {
          var self = _a.self,
            callback = _a.callback,
            viewedProductId = _a.viewedProductId;
          lookAlikeProductRecommendation_1.LookAlikeProductRecommendation.getLookALike(
            {
              viewedProductId: viewedProductId,
              uuid: self.data.uuid,
              storeID: self.data.storeID,
            }
          ).then(function (data) {
            callback({
              action: "look a like",
              payload: data,
            });
          });
        };
        exports.lookAlikeProductRecommendation = lookAlikeProductRecommendation;
        //# sourceMappingURL=index.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/sections/recommendations/index.js":
      /*!***************************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/sections/recommendations/index.js ***!
  \***************************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", { value: true });
        exports.recommendations = void 0;
        var utils_1 = __webpack_require__(
          /*! ./utils */ "./node_modules/fast-simon-sdk/lib/sections/recommendations/utils.js"
        );
        var related_1 = __webpack_require__(
          /*! ../../services/related */ "./node_modules/fast-simon-sdk/lib/services/related.js"
        );
        var config_1 = __webpack_require__(
          /*! ../../config */ "./node_modules/fast-simon-sdk/lib/config.js"
        );
        var recommendations = function (_a) {
          var specs = _a.specs,
            recent = _a.recent,
            productID = _a.productID,
            self = _a.self,
            callback = _a.callback,
            withAttributes = _a.withAttributes;
          var recentProducts = recent ? recent : utils_1.getRecent();
          var _b = self.data,
            uuid = _b.uuid,
            storeID = _b.storeID;
          var cartToken = localStorage.getItem(config_1.CART_TOKEN_LS_KEY);
          related_1.Related.getProducts({
            uuid: uuid,
            storeID: storeID,
            recent: recentProducts,
            productID: productID,
            specs: specs,
            cartToken: cartToken,
            withAttributes: withAttributes,
          })
            .then(function (widgets) {
              callback({
                action: "recommendations",
                payload: utils_1.serializeResponseWidgets(widgets),
              });
            })
            .catch(function (e) {
              console.error("Could not fetch widget data");
              callback({
                action: "recommendations",
                payload: [],
              });
            });
        };
        exports.recommendations = recommendations;
        //# sourceMappingURL=index.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/sections/recommendations/utils.js":
      /*!***************************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/sections/recommendations/utils.js ***!
  \***************************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", { value: true });
        exports.serializeResponseWidgets =
          exports.updateRecent =
          exports.getRecent =
            void 0;
        var config_1 = __webpack_require__(
          /*! ../../config */ "./node_modules/fast-simon-sdk/lib/config.js"
        );
        var getRecent = function () {
          if (config_1.RECENT_PRODUCT_LS_KEY in localStorage) {
            return JSON.parse(
              localStorage.getItem(config_1.RECENT_PRODUCT_LS_KEY)
            );
          }
          return [];
        };
        exports.getRecent = getRecent;
        var updateRecent = function (products) {
          if (config_1.RECENT_PRODUCT_LS_KEY in localStorage) {
            var ids = JSON.parse(
              localStorage.getItem(config_1.RECENT_PRODUCT_LS_KEY)
            );
            localStorage.setItem(
              config_1.RECENT_PRODUCT_LS_KEY,
              JSON.stringify(getRecentList(products, ids))
            );
          } else {
            localStorage.setItem(
              config_1.RECENT_PRODUCT_LS_KEY,
              JSON.stringify(products)
            );
          }
        };
        exports.updateRecent = updateRecent;
        var getRecentList = function (newIDS, products) {
          newIDS.forEach(function (id) {
            products.unshift(id);
          });
          return Array.from(new Set(products)).splice(
            0,
            config_1.MAX_RECENT_PRODUCTS
          );
        };
        var serializeResponseWidgets = function (response) {
          return response.widget_responses.map(function (widget) {
            var _a;
            return {
              categoriesIDs: ((_a = widget.categories) !== null && _a !== void 0
                ? _a
                : ""
              ).split(","),
              productID: String(widget.from_product),
              widgetID: widget.widget_id,
              payload: widget.products,
              sources: widget.sources,
            };
          });
        };
        exports.serializeResponseWidgets = serializeResponseWidgets;
        //# sourceMappingURL=utils.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/sections/smartCollections/index.js":
      /*!****************************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/sections/smartCollections/index.js ***!
  \****************************************************************************/
      /***/ function (__unused_webpack_module, exports, __webpack_require__) {
        "use strict";

        var __assign =
          (this && this.__assign) ||
          function () {
            __assign =
              Object.assign ||
              function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                  s = arguments[i];
                  for (var p in s)
                    if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
              };
            return __assign.apply(this, arguments);
          };
        var __rest =
          (this && this.__rest) ||
          function (s, e) {
            var t = {};
            for (var p in s)
              if (
                Object.prototype.hasOwnProperty.call(s, p) &&
                e.indexOf(p) < 0
              )
                t[p] = s[p];
            if (s != null && typeof Object.getOwnPropertySymbols === "function")
              for (
                var i = 0, p = Object.getOwnPropertySymbols(s);
                i < p.length;
                i++
              ) {
                if (
                  e.indexOf(p[i]) < 0 &&
                  Object.prototype.propertyIsEnumerable.call(s, p[i])
                )
                  t[p[i]] = s[p[i]];
              }
            return t;
          };
        var __spreadArray =
          (this && this.__spreadArray) ||
          function (to, from) {
            for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
              to[j] = from[i];
            return to;
          };
        Object.defineProperty(exports, "__esModule", { value: true });
        exports.smartCollections = void 0;
        var utils_1 = __webpack_require__(
          /*! ./utils */ "./node_modules/fast-simon-sdk/lib/sections/smartCollections/utils.js"
        );
        var smartCollections_1 = __webpack_require__(
          /*! ../../services/smartCollections */ "./node_modules/fast-simon-sdk/lib/services/smartCollections.js"
        );
        var utils_2 = __webpack_require__(
          /*! ../fullTextSearch/utils */ "./node_modules/fast-simon-sdk/lib/sections/fullTextSearch/utils.js"
        );
        var fullTextSearch_1 = __webpack_require__(
          /*! ../../models/fullTextSearch */ "./node_modules/fast-simon-sdk/lib/models/fullTextSearch.js"
        );
        var smartCollections = function (_a) {
          var props = __rest(_a, []);
          var _b = props.self.data,
            uuid = _b.uuid,
            storeID = _b.storeID,
            cdnKey = _b.cdnKey,
            sessionToken = _b.sessionToken,
            userToken = _b.userToken;
          var categoryID = props.categoryID,
            narrowBy = props.narrowBy,
            _c = props.page,
            page = _c === void 0 ? 1 : _c,
            productsPerPage = props.productsPerPage,
            _d = props.facets,
            facets = _d === void 0 ? true : _d,
            _e = props.withAttributes,
            withAttributes = _e === void 0 ? false : _e,
            searchWithinSearch = props.searchWithinSearch;
          var sortBy = fullTextSearch_1.isSortBy(props.sortBy)
            ? props.sortBy
            : undefined;
          var params = {
            cdn: cdnKey,
            uuid: uuid,
            storeID: storeID,
            categoryID: categoryID,
            sortBy: sortBy,
            productsPerPage: productsPerPage,
            searchWithinSearch: searchWithinSearch,
            page: page,
            narrowBy: narrowBy,
            withAttributes: withAttributes,
            recent: utils_2.getRecentSearchProducts(props.self),
          };
          var filterData =
            facets &&
            props.self.temp.smartCollections.facets &&
            __spreadArray([], props.self.temp.smartCollections.facets);
          var isFacetNeeded = utils_1.facetNeeded({
            self: props.self,
            newNarrow: narrowBy,
            newPage: page,
            newCategoryID: categoryID,
          });
          utils_1.emptyResults(props.self, categoryID);
          if (!isFacetNeeded || !facets) {
            smartCollections_1.SmartCollections.getSmartCollections(
              __assign(__assign({}, params), {
                facetRequired: 0,
                sessionStart: sessionToken.start,
                userToken: userToken,
              })
            ).then(function (data) {
              var result = utils_1.getData(props.self, data);
              if (props.infiniteScrollPage && props.productsPerPage) {
                result.pageCount = Math.ceil(
                  result.totalResults /
                    (props.productsPerPage / props.infiniteScrollPage)
                );
              }
              if (filterData) {
                result.facets = filterData;
              }
              utils_1.handleSmartCollection({
                event: filterData ? "facets and products" : "products",
                callback: props.callback,
                self: props.self,
                personalized: data.use_personalized_collection,
                time: data.personalization_recency_limit,
                isNoResults: data.pop_products_no_results,
                page: page,
                sortBy: sortBy,
                narrow: narrowBy,
                result: result,
              });
            });
          } else {
            smartCollections_1.SmartCollections.getSmartCollections(
              __assign(__assign({}, params), {
                facetRequired: 1,
                sessionStart: sessionToken.start,
                userToken: userToken,
              })
            ).then(function (data) {
              var result = utils_1.getData(props.self, data);
              if (props.infiniteScrollPage && props.productsPerPage) {
                result.pageCount = Math.ceil(
                  result.totalResults /
                    (props.productsPerPage / props.infiniteScrollPage)
                );
              }
              if (data.facets_completed || data.pop_products_no_results) {
                result.facets = data.facets;
                utils_1.handleSmartCollection({
                  event: "facets and products",
                  callback: props.callback,
                  self: props.self,
                  personalized: data.use_personalized_collection,
                  time: data.personalization_recency_limit,
                  isNoResults: data.pop_products_no_results,
                  page: page,
                  sortBy: sortBy,
                  narrow: narrowBy,
                  result: result,
                });
                return;
              }
              utils_1.handleSmartCollection({
                event: "products",
                callback: props.callback,
                self: props.self,
                personalized: data.use_personalized_collection,
                time: data.personalization_recency_limit,
                page: page,
                sortBy: sortBy,
                narrow: narrowBy,
                result: result,
              });
              smartCollections_1.SmartCollections.getSmartCollections(
                __assign(__assign({}, params), {
                  facetRequired: 2,
                  sessionStart: sessionToken.start,
                  userToken: userToken,
                })
              ).then(function (data) {
                result.facets = data.facets;
                utils_1.handleSmartCollection({
                  event: "facets and products",
                  callback: props.callback,
                  self: props.self,
                  personalized: data.use_personalized_collection,
                  page: page,
                  sortBy: sortBy,
                  narrow: narrowBy,
                  result: result,
                });
              });
            });
          }
        };
        exports.smartCollections = smartCollections;
        //# sourceMappingURL=index.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/sections/smartCollections/utils.js":
      /*!****************************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/sections/smartCollections/utils.js ***!
  \****************************************************************************/
      /***/ function (__unused_webpack_module, exports, __webpack_require__) {
        "use strict";

        var __assign =
          (this && this.__assign) ||
          function () {
            __assign =
              Object.assign ||
              function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                  s = arguments[i];
                  for (var p in s)
                    if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
              };
            return __assign.apply(this, arguments);
          };
        Object.defineProperty(exports, "__esModule", { value: true });
        exports.isRecommendedProduct =
          exports.facetNeeded =
          exports.updateRecentCollectionProducts =
          exports.getRecentCollectionProducts =
          exports.getCollectionName =
          exports.getPersonalizedProducts =
          exports.handleSmartCollection =
          exports.getData =
          exports.setInfiniteScroll =
          exports.emptyResults =
            void 0;
        var ArrayUtils_1 = __webpack_require__(
          /*! ../../utils/ArrayUtils */ "./node_modules/fast-simon-sdk/lib/utils/ArrayUtils.js"
        );
        var related_1 = __webpack_require__(
          /*! ../../services/related */ "./node_modules/fast-simon-sdk/lib/services/related.js"
        );
        var config_1 = __webpack_require__(
          /*! ../../config */ "./node_modules/fast-simon-sdk/lib/config.js"
        );
        var utils_1 = __webpack_require__(
          /*! ../fullTextSearch/utils */ "./node_modules/fast-simon-sdk/lib/sections/fullTextSearch/utils.js"
        );
        var emptyResults = function (self, categoryID) {
          self.temp.smartCollections = {
            ancestors: [],
            totalResults: 0,
            products: [],
            categoryID: categoryID,
            name: "",
          };
        };
        exports.emptyResults = emptyResults;
        var setInfiniteScroll = function (
          self,
          infiniteCount,
          productsPerPage
        ) {
          if (infiniteCount && productsPerPage) {
            self.temp.smartCollections.pageCount = Math.ceil(
              self.temp.smartCollections.totalResults /
                (productsPerPage / infiniteCount)
            );
          }
        };
        exports.setInfiniteScroll = setInfiniteScroll;
        var getData = function (self, response) {
          var result = {};
          result.products = response.items;
          result.totalResults = response.total_results;
          if (response.ancestor_categories) {
            result.ancestors = response.ancestor_categories;
          }
          if (response.narrow) {
            result.narrow = utils_1.reformatNarrow(response.narrow);
          }
          if (response.sort_by) {
            result.sortBy = response.sort_by;
          }
          if (response.pop_products_no_results) {
            result.isNoResults = true;
          }
          if (response.total_p) {
            result.pageCount = response.total_p;
          }
          if (response.avoid_tag_prefixes) {
            result.avoidPrefixList = response.avoid_tag_prefixes.split(",");
          }
          if (response.merch) {
            result.merch = response.merch;
          }
          if (response.banner_html) {
            result.bannerHTML = response.banner_html;
          }
          result.page = response.p || 1;
          result.categoryID = response.category_id;
          result.name = response.category_name;
          return result;
        };
        exports.getData = getData;
        var handleSmartCollection = function (_a) {
          var event = _a.event,
            callback = _a.callback,
            self = _a.self,
            personalized = _a.personalized,
            time = _a.time,
            isNoResults = _a.isNoResults,
            page = _a.page,
            sortBy = _a.sortBy,
            narrow = _a.narrow,
            result = _a.result;
          if (
            personalized &&
            !isNoResults &&
            page === 1 &&
            (!narrow || narrow.length === 0) &&
            (!sortBy || sortBy === "relevency")
          ) {
            handlePersonalisedProducts(
              self,
              result,
              callback,
              event,
              time !== null && time !== void 0 ? time : 356
            );
          } else {
            callback({
              action: event,
              payload: result,
            });
          }
        };
        exports.handleSmartCollection = handleSmartCollection;
        var handlePersonalisedProducts = function (
          self,
          payload,
          callback,
          event,
          time
        ) {
          var _a = self.data,
            storeID = _a.storeID,
            uuid = _a.uuid;
          var now = Math.round(Date.now() / 1000);
          var categoryID = payload.categoryID;
          var recent = exports
            .getRecentCollectionProducts()
            .filter(function (r) {
              return r.time + time * 360 > now;
            });
          localStorage.setItem(
            "" + config_1.RECENT_COLLECTION_PRODUCTS_KEY,
            JSON.stringify(recent)
          );
          var recentProducts = recent.map(function (r) {
            return r.id;
          });
          if (recent.length > 0) {
            related_1.Related.getRecentlyViewed({
              uuid: uuid,
              storeID: storeID,
              recent: recentProducts,
              categoryID: categoryID,
              cartToken: self.data.cartToken,
            }).then(function (response) {
              callback({
                action: event,
                payload: __assign(__assign({}, payload), {
                  products: exports.getPersonalizedProducts(
                    self,
                    response.widget_responses[0].products,
                    payload.products
                  ),
                }),
              });
            });
          } else {
            callback({
              action: event,
              payload: payload,
            });
          }
        };
        var getPersonalizedProducts = function (self, recent, products) {
          var recentProducts = recent.filter(function (r, i) {
            var newPosition = i * 2;
            var oldPosition = products.findIndex(function (p) {
              return p.id === r.id;
            });
            return oldPosition === -1 || newPosition < oldPosition;
          });
          var ids = new Set(
            recentProducts.map(function (p) {
              return p.id;
            })
          );
          var newProducts = products.filter(function (p) {
            return !ids.has(p.id);
          });
          for (var i = 0, pos = 1; i < recentProducts.length; i++, pos += 2) {
            ArrayUtils_1.insert(
              newProducts,
              pos,
              __assign({ rec: true }, recentProducts[i])
            );
          }
          return newProducts;
        };
        exports.getPersonalizedProducts = getPersonalizedProducts;
        var getCollectionName = function (self, id) {
          var category = self.data.categories.find(function (category) {
            return category.id === id;
          });
          if (!category) {
            console.warn(
              "can't find the collection / category name for id: " + id
            );
            return id;
          }
          return category.l;
        };
        exports.getCollectionName = getCollectionName;
        var getRecentCollectionProducts = function () {
          if (config_1.RECENT_COLLECTION_PRODUCTS_KEY in localStorage) {
            return JSON.parse(
              localStorage.getItem(config_1.RECENT_COLLECTION_PRODUCTS_KEY)
            );
          }
          return [];
        };
        exports.getRecentCollectionProducts = getRecentCollectionProducts;
        var updateRecentCollectionProducts = function (productID, categoryID) {
          var categories = exports.getRecentCollectionProducts();
          var index = categories.findIndex(function (c) {
            return c.id === productID;
          });
          if (index !== -1) {
            moveAndUpdate(categories, index);
          } else {
            categories.push({
              id: productID,
              time: Math.round(Date.now() / 1000),
            });
          }
          localStorage.setItem(
            config_1.RECENT_COLLECTION_PRODUCTS_KEY,
            JSON.stringify(
              categories.splice(0, config_1.MAX_RECENT_COLLECTION_PRODUCTS)
            )
          );
        };
        exports.updateRecentCollectionProducts = updateRecentCollectionProducts;
        var moveAndUpdate = function (categories, index) {
          ArrayUtils_1.arrayMove(categories, index, categories.length - 1);
          categories[categories.length - 1].time = Date.now();
        };
        var facetNeeded = function (_a) {
          var self = _a.self,
            newNarrow = _a.newNarrow,
            newPage = _a.newPage,
            newCategoryID = _a.newCategoryID;
          var _b = self.temp.smartCollections,
            narrow = _b.narrow,
            page = _b.page,
            categoryID = _b.categoryID;
          return !(
            JSON.stringify(narrow) === JSON.stringify(newNarrow) &&
            newPage === page &&
            categoryID === newCategoryID
          );
        };
        exports.facetNeeded = facetNeeded;
        var isRecommendedProduct = function (productId) {
          var recent = exports.getRecentCollectionProducts();
          return Boolean(
            recent.find(function (r) {
              return r.id === productId;
            })
          );
        };
        exports.isRecommendedProduct = isRecommendedProduct;
        //# sourceMappingURL=utils.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/services/autocomplete.js":
      /*!******************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/services/autocomplete.js ***!
  \******************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", { value: true });
        exports.Autocomplete = exports.debugVersion = void 0;
        var API_1 = __webpack_require__(
          /*! ../utils/API */ "./node_modules/fast-simon-sdk/lib/utils/API.js"
        );
        var debug_1 = __webpack_require__(
          /*! ../utils/debug */ "./node_modules/fast-simon-sdk/lib/utils/debug.js"
        );
        var segments_1 = __webpack_require__(
          /*! ../utils/segments */ "./node_modules/fast-simon-sdk/lib/utils/segments.js"
        );
        var REPORT_BASE = "https://ping-dot-acp-magento.appspot.com";
        var BASE_URL = "https://api.fastsimon.com";
        var BASE_SUGGESTOR_URL = "https://suggest.instantsearchplus.com";
        exports.debugVersion = debug_1.getDebugEndpoint();
        exports.Autocomplete = {
          getProducts: function (_a) {
            var cdn = _a.cdn,
              storeID = _a.storeID,
              uuid = _a.uuid,
              query = _a.query,
              withAttributes = _a.withAttributes;
            return API_1.API.get({
              url: exports.debugVersion || BASE_URL,
              params: {
                store_id: storeID,
                UUID: uuid,
                cdn_cache_key: cdn,
                q: query,
                m: debug_1.isDebugCaching() ? 1 : undefined,
                with_product_attributes: withAttributes,
                st: segments_1.getSegments(),
              },
            });
          },
          getPopularSearches: function (_a) {
            var cdn = _a.cdn,
              storeID = _a.storeID,
              uuid = _a.uuid,
              query = _a.query,
              site = _a.site;
            return API_1.API.get({
              url: BASE_SUGGESTOR_URL,
              params: {
                l: site,
                q: query,
                cdn_cache_key: cdn,
                store_id: storeID,
                uuid: uuid,
                m: debug_1.isDebugCaching() ? 1 : undefined,
                st: segments_1.getSegments(),
              },
            });
          },
        };
        //# sourceMappingURL=autocomplete.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/services/common.js":
      /*!************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/services/common.js ***!
  \************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", { value: true });
        exports.Common = exports.debugVersion = void 0;
        var API_1 = __webpack_require__(
          /*! ../utils/API */ "./node_modules/fast-simon-sdk/lib/utils/API.js"
        );
        var debug_1 = __webpack_require__(
          /*! ../utils/debug */ "./node_modules/fast-simon-sdk/lib/utils/debug.js"
        );
        var segments_1 = __webpack_require__(
          /*! ../utils/segments */ "./node_modules/fast-simon-sdk/lib/utils/segments.js"
        );
        var BASE_URL = "https://acp-magento.appspot.com";
        var REPORT_BASE = "https://ping-dot-acp-magento.appspot.com";
        var BASE_URL_API = "https://api.fastsimon.com";
        exports.debugVersion = debug_1.getDebugEndpoint();
        exports.Common = {
          getLoad: function (_a) {
            var uuid = _a.uuid,
              storeID = _a.storeID;
            return API_1.API.get({
              url: (exports.debugVersion || BASE_URL_API) + "/load",
              params: {
                UUID: uuid,
                store_id: storeID,
                m: debug_1.isDebugCaching() ? 1 : undefined,
              },
            });
          },
          getPopularProducts: function (_a) {
            var uuid = _a.uuid,
              storeID = _a.storeID,
              cdn = _a.cdn,
              withAttributes = _a.withAttributes;
            return API_1.API.get({
              url: (exports.debugVersion || BASE_URL_API) + "/pop",
              params: {
                store_id: storeID,
                UUID: uuid,
                cdn_cache_key: cdn,
                api_type: "json",
                m: debug_1.isDebugCaching() ? 1 : undefined,
                with_product_attributes: withAttributes,
                st: segments_1.getSegments(),
              },
            });
          },
          getCategories: function (_a) {
            var uuid = _a.uuid,
              storeID = _a.storeID,
              cdn = _a.cdn;
            return API_1.API.get({
              url: (exports.debugVersion || BASE_URL_API) + "/pop",
              params: {
                store_id: storeID,
                UUID: uuid,
                cdn_cache_key: cdn,
                c: 1,
                api_type: "json",
                m: debug_1.isDebugCaching() ? 1 : undefined,
                st: segments_1.getSegments(),
              },
            });
          },
          getTurbolinks: function (_a) {
            var uuid = _a.uuid,
              storeID = _a.storeID,
              cdn = _a.cdn;
            return API_1.API.get({
              url: (exports.debugVersion || BASE_URL_API) + "/pop",
              params: {
                store_id: storeID,
                UUID: uuid,
                cdn_cache_key: cdn,
                t: 1,
                api_type: "json",
                m: debug_1.isDebugCaching() ? 1 : undefined,
                st: segments_1.getSegments(),
              },
            });
          },
          getPostLoad: function (_a) {
            var uuid = _a.uuid,
              storeID = _a.storeID;
            return API_1.API.get({
              url: (exports.debugVersion || REPORT_BASE) + "/post_load",
              params: {
                store_id: storeID,
                UUID: uuid,
              },
            });
          },
          getBigcommerceCartToken: function () {
            return API_1.API.get({
              url: location.origin + "/api/storefront/cart",
            });
          },
          getShopifyCartToken: function () {
            return API_1.API.get({
              url: location.origin + "/cart.js",
            });
          },
        };
        //# sourceMappingURL=common.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/services/content.js":
      /*!*************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/services/content.js ***!
  \*************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", { value: true });
        exports.Content = void 0;
        var API_1 = __webpack_require__(
          /*! ../utils/API */ "./node_modules/fast-simon-sdk/lib/utils/API.js"
        );
        var debug_1 = __webpack_require__(
          /*! ../utils/debug */ "./node_modules/fast-simon-sdk/lib/utils/debug.js"
        );
        var BASE_URL = "https://api.fastsimon.com";
        var debugVersion = debug_1.getDebugEndpoint();
        exports.Content = {
          search: function (_a) {
            var storeID = _a.storeID,
              uuid = _a.uuid,
              query = _a.query,
              cursor = _a.cursor,
              cdn = _a.cdn;
            var params = {
              uuid: uuid,
              store_id: storeID,
              cdn_cache_key: cdn,
              cursor: cursor,
              q: query,
              source: "fast-simon-sdk",
              content_is_norm: true,
            };
            return API_1.API.get({
              url: (debugVersion || BASE_URL) + "/cms_content_get_next",
              params: params,
            });
          },
        };
        //# sourceMappingURL=content.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/services/fullTextSearch.js":
      /*!********************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/services/fullTextSearch.js ***!
  \********************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", { value: true });
        exports.FullTextSearch = void 0;
        var API_1 = __webpack_require__(
          /*! ../utils/API */ "./node_modules/fast-simon-sdk/lib/utils/API.js"
        );
        var debug_1 = __webpack_require__(
          /*! ../utils/debug */ "./node_modules/fast-simon-sdk/lib/utils/debug.js"
        );
        var options_1 = __webpack_require__(
          /*! ../utils/options */ "./node_modules/fast-simon-sdk/lib/utils/options.js"
        );
        var segments_1 = __webpack_require__(
          /*! ../utils/segments */ "./node_modules/fast-simon-sdk/lib/utils/segments.js"
        );
        var BASE_URL = "https://api.fastsimon.com";
        var debugVersion = debug_1.getDebugEndpoint();
        exports.FullTextSearch = {
          getFullTextSearch: function (_a) {
            var uuid = _a.uuid,
              storeID = _a.storeID,
              cdn = _a.cdn,
              facetRequired = _a.facetRequired,
              narrowBy = _a.narrowBy,
              page = _a.page,
              productsPerPage = _a.productsPerPage,
              term = _a.term,
              sortBy = _a.sortBy,
              withAttributes = _a.withAttributes,
              recent = _a.recent,
              searchWithinSearch = _a.searchWithinSearch;
            var params = {
              UUID: uuid,
              store_id: storeID,
              cdn_cache_key: cdn,
              facets_required: facetRequired,
              q: term,
              page_num: page,
              with_product_attributes: withAttributes,
              narrow: JSON.stringify(narrowBy),
              products_per_page: productsPerPage,
              sort_by: sortBy,
              sp: recent,
              search_within_search: searchWithinSearch,
              m: debug_1.isDebugCaching() ? 1 : undefined,
              // ab_testing
              disable_personalization: options_1.getSDKABTestingOptionExist(
                "ab_test_disable_search_personalization"
              ),
              disable_merchandising:
                options_1.getSDKABTestingOptionExist(
                  "ab_test_disable_merchandising"
                ) || options_1.getSDKABTestingOption("disable_merchandising"),
              disable_merchandising_rules:
                options_1.getSDKABTestingOptionExist(
                  "ab_test_disable_merchandising_rules"
                ) ||
                options_1.getSDKABTestingOption("disable_merchandising_rules"),
              disable_strategies:
                options_1.getSDKABTestingOptionExist(
                  "ab_test_disable_merchandising_strategies"
                ) || options_1.getSDKABTestingOption("disable_strategies"),
              disable_semantics: options_1.getSDKABTestingOptionExist(
                "ab_test_disable_semantics"
              ),
              //preview stuff
              merchandising_rules: options_1.getSDKABTestingOption(
                "merchandising_rules"
              ),
              strategy: options_1.getSDKABTestingOption("strategy"),
              request_serial_number: options_1.getSDKABTestingOption(
                "request_serial_number"
              ),
              related_search: options_1.getSDKABTestingOption("related_search"),
              st: segments_1.getSegments(),
            };
            if (options_1.getSDKABTestingOption("reasoning")) {
              return API_1.API.get({
                url: (debugVersion || BASE_URL) + "/full_text_search_reasoning",
                params: params,
                config: {
                  headers: {
                    sid: options_1
                      .getSDKABTestingOption("reasoning")
                      .split(":")[0],
                    site_key: options_1
                      .getSDKABTestingOption("reasoning")
                      .split(":")[1],
                  },
                },
              });
            }
            return API_1.API.get({
              url: (debugVersion || BASE_URL) + "/full_text_search",
              params: params,
            });
          },
        };
        //# sourceMappingURL=fullTextSearch.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/services/landingPage.js":
      /*!*****************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/services/landingPage.js ***!
  \*****************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", { value: true });
        exports.LandingPage = void 0;
        var API_1 = __webpack_require__(
          /*! ../utils/API */ "./node_modules/fast-simon-sdk/lib/utils/API.js"
        );
        var debug_1 = __webpack_require__(
          /*! ../utils/debug */ "./node_modules/fast-simon-sdk/lib/utils/debug.js"
        );
        var options_1 = __webpack_require__(
          /*! ../utils/options */ "./node_modules/fast-simon-sdk/lib/utils/options.js"
        );
        var BASE_URL = "https://api.fastsimon.com";
        var debugVersion = debug_1.getDebugEndpoint();
        exports.LandingPage = {
          getLandingPage: function (_a) {
            var uuid = _a.uuid,
              storeID = _a.storeID,
              cdn = _a.cdn,
              facetRequired = _a.facetRequired,
              narrowBy = _a.narrowBy,
              page = _a.page,
              productsPerPage = _a.productsPerPage,
              slug = _a.slug,
              sortBy = _a.sortBy,
              withAttributes = _a.withAttributes;
            var params = {
              UUID: uuid,
              store_id: storeID,
              cdn_cache_key: cdn,
              facets_required: facetRequired,
              lp: slug,
              page_num: page,
              with_product_attributes: withAttributes,
              narrow: JSON.stringify(narrowBy),
              products_per_page: productsPerPage,
              sort_by: sortBy,
              // ab_testing
              disable_personalization: options_1.getSDKABTestingOptionExist(
                "ab_test_disable_search_personalization"
              ),
              disable_merchandising: options_1.getSDKABTestingOptionExist(
                "ab_test_disable_merchandising"
              ),
              disable_merchandising_rules: options_1.getSDKABTestingOptionExist(
                "ab_test_disable_merchandising_rules"
              ),
              disable_strategies: options_1.getSDKABTestingOptionExist(
                "ab_test_disable_merchandising_strategies"
              ),
              disable_semantics: options_1.getSDKABTestingOptionExist(
                "ab_test_disable_semantics"
              ),
              // custom keys
              reasoning: options_1.getSDKABTestingOptionExist("reasoning"),
            };
            return API_1.API.get({
              url: (debugVersion || BASE_URL) + "/landing_page",
              params: params,
            });
          },
        };
        //# sourceMappingURL=landingPage.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/services/lookAlikeProductRecommendation.js":
      /*!************************************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/services/lookAlikeProductRecommendation.js ***!
  \************************************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", { value: true });
        exports.LookAlikeProductRecommendation = exports.debugVersion = void 0;
        var API_1 = __webpack_require__(
          /*! ../utils/API */ "./node_modules/fast-simon-sdk/lib/utils/API.js"
        );
        var debug_1 = __webpack_require__(
          /*! ../utils/debug */ "./node_modules/fast-simon-sdk/lib/utils/debug.js"
        );
        var BASE_URL = "https://api.fastsimon.com";
        exports.debugVersion = debug_1.getDebugEndpoint();
        exports.LookAlikeProductRecommendation = {
          getLookALike: function (_a) {
            var viewedProductId = _a.viewedProductId,
              storeID = _a.storeID,
              uuid = _a.uuid;
            return API_1.API.get({
              url: (exports.debugVersion || BASE_URL) + "/lookalike",
              params: {
                UUID: uuid,
                store_id: storeID,
                product_id: parseInt(viewedProductId),
              },
            });
          },
        };
        //# sourceMappingURL=lookAlikeProductRecommendation.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/services/related.js":
      /*!*************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/services/related.js ***!
  \*************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", { value: true });
        exports.Related = exports.debugVersion = void 0;
        var API_1 = __webpack_require__(
          /*! ../utils/API */ "./node_modules/fast-simon-sdk/lib/utils/API.js"
        );
        var config_1 = __webpack_require__(
          /*! ../config */ "./node_modules/fast-simon-sdk/lib/config.js"
        );
        var debug_1 = __webpack_require__(
          /*! ../utils/debug */ "./node_modules/fast-simon-sdk/lib/utils/debug.js"
        );
        var options_1 = __webpack_require__(
          /*! ../utils/options */ "./node_modules/fast-simon-sdk/lib/utils/options.js"
        );
        var BASE_URL = "https://api.fastsimon.com";
        exports.debugVersion = debug_1.getDebugEndpoint();
        exports.Related = {
          getProducts: function (_a) {
            var storeID = _a.storeID,
              uuid = _a.uuid,
              productID = _a.productID,
              _b = _a.recent,
              recent = _b === void 0 ? [] : _b,
              _c = _a.specs,
              specs = _c === void 0 ? [] : _c,
              cartToken = _a.cartToken,
              withAttributes = _a.withAttributes;
            return API_1.API.get({
              url:
                (exports.debugVersion || BASE_URL) +
                "/related_products_suggest",
              params: {
                product_id: productID,
                UUID: uuid,
                store_id: storeID,
                products: JSON.stringify(recent),
                specs: JSON.stringify(serializeSpecs(specs)),
                cart_token: cartToken,
                // ab_testing
                disable_personalization: options_1.getSDKABTestingOptionExist(
                  "ab_test_disable_recommendations_personalization"
                ),
                with_product_attributes: withAttributes,
              },
            });
          },
          getRecentlyViewed: function (_a) {
            var _b = _a.recent,
              recent = _b === void 0 ? [] : _b,
              uuid = _a.uuid,
              storeID = _a.storeID,
              categoryID = _a.categoryID,
              cartToken = _a.cartToken;
            return API_1.API.get({
              url:
                (exports.debugVersion || BASE_URL) +
                "/related_products_suggest",
              params: {
                UUID: uuid,
                store_id: storeID,
                products: JSON.stringify(recent),
                specs: JSON.stringify([
                  {
                    sources: "related_recently_viewed",
                    max_suggest: config_1.MAX_RECENT_COLLECTION_PRODUCTS,
                    widget_id: "isp-recently-viewed",
                    categories: categoryID,
                    personalization: true,
                  },
                ]),
                cart_token: cartToken,
              },
            });
          },
        };
        var serializeSpecs = function (specs) {
          return specs.map(function (spec) {
            var _a, _b;
            return {
              sources: spec.sources.join(","),
              max_suggest: String(spec.maxSuggestions),
              categories: ((_b =
                (_a = spec.collectionIDs) !== null && _a !== void 0
                  ? _a
                  : spec.categoriesIDs) !== null && _b !== void 0
                ? _b
                : []
              ).join(","),
              widget_id: spec.widgetID,
              title: "",
            };
          });
        };
        //# sourceMappingURL=related.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/services/reporting.js":
      /*!***************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/services/reporting.js ***!
  \***************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", { value: true });
        exports.Reporting = void 0;
        var debug_1 = __webpack_require__(
          /*! ../utils/debug */ "./node_modules/fast-simon-sdk/lib/utils/debug.js"
        );
        var API_1 = __webpack_require__(
          /*! ../utils/API */ "./node_modules/fast-simon-sdk/lib/utils/API.js"
        );
        var utils_1 = __webpack_require__(
          /*! ./utils */ "./node_modules/fast-simon-sdk/lib/services/utils.js"
        );
        var klaviyo_1 = __webpack_require__(
          /*! ../utils/klaviyo */ "./node_modules/fast-simon-sdk/lib/utils/klaviyo.js"
        );
        var REPORT_BASE = "https://ping-dot-acp-magento.appspot.com";
        var clientVersion = debug_1.getDebugEndpoint() || REPORT_BASE;
        var ReportingUpType;
        (function (ReportingUpType) {
          ReportingUpType[(ReportingUpType["popularSearchSeen"] = 1)] =
            "popularSearchSeen";
          ReportingUpType[(ReportingUpType["autocompleteProductSeen"] = 3)] =
            "autocompleteProductSeen";
          ReportingUpType[(ReportingUpType["searchPreformed"] = 4)] =
            "searchPreformed";
          ReportingUpType[(ReportingUpType["categorySearchSeen"] = 5)] =
            "categorySearchSeen";
          ReportingUpType[(ReportingUpType["relatedProductSeen"] = 12)] =
            "relatedProductSeen";
          ReportingUpType[(ReportingUpType["popUpUsedQuickView"] = 13)] =
            "popUpUsedQuickView";
          ReportingUpType[(ReportingUpType["popUpUsedLookALike"] = 17)] =
            "popUpUsedLookALike";
          ReportingUpType[(ReportingUpType["lookAlikeProductSeen"] = 18)] =
            "lookAlikeProductSeen";
          ReportingUpType[(ReportingUpType["collectionPreformed"] = 20)] =
            "collectionPreformed";
        })(ReportingUpType || (ReportingUpType = {}));
        exports.Reporting = {
          productSeen: function (_a) {
            var type = _a.type,
              categoryID = _a.categoryID,
              categoryName = _a.categoryName,
              cartToken = _a.cartToken,
              originId = _a.originId,
              originProduct = _a.originProduct,
              productId = _a.productId,
              reference = _a.reference,
              term = _a.term,
              sessionStart = _a.sessionStart,
              storeID = _a.storeID,
              userToken = _a.userToken,
              uuid = _a.uuid,
              position = _a.position,
              recommended = _a.recommended,
              imageID = _a.imageID,
              sourceProduct = _a.sourceProduct;
            return API_1.API.get({
              url: getEndpointByType(type),
              params: {
                source: "fast simon sdk",
                l: window.location.host,
                store_id: storeID,
                UUID: uuid,
                st: userToken,
                session: sessionStart,
                id: productId,
                original_search_query: originId,
                prev_up_type: getVisitedUpTypeByType(type),
                q: term,
                cart_token: cartToken,
                pos: position,
                rec: recommended ? 1 : undefined,
                ref: reference,
                isp_orig_product: originProduct,
                original_smart_navigation: categoryName,
                original_category_id: categoryID,
                image_id: imageID,
                kl_id: klaviyo_1.getKlaviyoCustomerID(),
                from_product: sourceProduct,
              },
            });
          },
          popularSearchSeen: function (_a) {
            var originId = _a.originId,
              userToken = _a.userToken,
              storeID = _a.storeID,
              sessionStart = _a.sessionStart,
              cartToken = _a.cartToken,
              uuid = _a.uuid,
              term = _a.term;
            return API_1.API.get({
              url: getEndpointByType("autocomplete"),
              params: {
                source: "fast simon sdk",
                l: window.location.host,
                store_id: storeID,
                UUID: uuid,
                st: userToken,
                session: sessionStart,
                original_search_query: originId,
                prev_up_type: ReportingUpType.popularSearchSeen,
                q: term,
                cart_token: cartToken,
              },
            });
          },
          categorySearchSeen: function (_a) {
            var uuid = _a.uuid,
              storeID = _a.storeID,
              term = _a.term,
              categoryID = _a.categoryID,
              sessionStart = _a.sessionStart,
              userToken = _a.userToken,
              cartToken = _a.cartToken;
            return API_1.API.get({
              url: getEndpointByType("autocomplete"),
              params: {
                source: "fast simon sdk",
                l: window.location.host,
                store_id: storeID,
                UUID: uuid,
                st: userToken,
                session: sessionStart,
                original_search_query: term,
                prev_up_type: ReportingUpType.categorySearchSeen,
                id: categoryID,
                cart_token: cartToken,
                kl_id: klaviyo_1.getKlaviyoCustomerID(),
              },
            });
          },
          searchPerformed: function (_a) {
            var storeID = _a.storeID,
              uuid = _a.uuid,
              query = _a.query,
              sortBy = _a.sortBy,
              narrow = _a.narrow,
              sessionStart = _a.sessionStart,
              userToken = _a.userToken,
              cartToken = _a.cartToken;
            var narrowByFilter = utils_1.serializeNarrowByFilter(narrow);
            return API_1.API.get({
              url: getEndpointByType("search"),
              params: {
                source: "fast simon sdk",
                store_id: storeID,
                UUID: uuid,
                st: userToken,
                session: sessionStart,
                original_search_query: query,
                prev_up_type: ReportingUpType.searchPreformed,
                serp: query,
                cart_token: cartToken,
                narrow_by_filters:
                  narrowByFilter && JSON.stringify(narrowByFilter),
                narrow_by:
                  narrowByFilter && utils_1.serializeNarrowBy(narrowByFilter),
                sort_by: sortBy,
                kl_id: klaviyo_1.getKlaviyoCustomerID(),
              },
            });
          },
          collectionPerformed: function (_a) {
            var sortBy = _a.sortBy,
              query = _a.query,
              narrow = _a.narrow,
              sessionStart = _a.sessionStart,
              userToken = _a.userToken,
              uuid = _a.uuid,
              storeID = _a.storeID,
              collectionID = _a.collectionID,
              cartToken = _a.cartToken;
            var narrowByFilter = utils_1.serializeNarrowByFilter(narrow);
            return API_1.API.get({
              url: getEndpointByType("category"),
              params: {
                source: "fast simon sdk",
                store_id: storeID,
                UUID: uuid,
                st: userToken,
                session: sessionStart,
                original_search_query: query,
                original_category_id: collectionID,
                prev_up_type: ReportingUpType.collectionPreformed,
                cart_token: cartToken,
                narrow_by_filters:
                  narrowByFilter && JSON.stringify(narrowByFilter),
                narrow_by:
                  narrowByFilter && utils_1.serializeNarrowBy(narrowByFilter),
                sort_by: sortBy,
                kl_id: klaviyo_1.getKlaviyoCustomerID(),
              },
            });
          },
          popUpUsed: function (_a) {
            var cartToken = _a.cartToken,
              sessionStart = _a.sessionStart,
              userToken = _a.userToken,
              uuid = _a.uuid,
              storeID = _a.storeID,
              position = _a.position,
              productId = _a.productId,
              categoryID = _a.categoryID,
              categoryName = _a.categoryName,
              query = _a.query,
              type = _a.type;
            return API_1.API.get({
              url: getEndpointByType("search"),
              params: {
                source: "fast simon sdk",
                store_id: storeID,
                UUID: uuid,
                st: userToken,
                session: sessionStart,
                id: productId,
                pos: position,
                prev_up_type:
                  type === "Look A Like"
                    ? ReportingUpType.popUpUsedLookALike
                    : ReportingUpType.popUpUsedQuickView,
                cart_token: cartToken,
                original_search_query: query,
                original_smart_navigation: categoryName,
                original_category_id: categoryID,
              },
            });
          },
          addToCart: function (_a) {
            var storeID = _a.storeID,
              uuid = _a.uuid,
              cartToken = _a.cartToken,
              sessionStart = _a.sessionStart,
              userToken = _a.userToken,
              productID = _a.productID;
            return API_1.API.get({
              url: getEndpointByType("search"),
              params: {
                source: "fast simon sdk",
                l: window.location.host,
                store_id: storeID,
                UUID: uuid,
                st: userToken,
                session: sessionStart,
                cart_token: cartToken,
                cart: 1,
                cart_product: productID,
                kl_id: klaviyo_1.getKlaviyoCustomerID(),
              },
            });
          },
        };
        var getEndpointByType = function (s) {
          return (
            clientVersion +
            (s === "autocomplete" ? "/post_load_ac" : "/post_load")
          );
        };
        var getVisitedUpTypeByType = function (s) {
          switch (s) {
            case "autocomplete":
              return ReportingUpType.autocompleteProductSeen;
            case "related":
              return ReportingUpType.relatedProductSeen;
            case "look a like":
              return ReportingUpType.lookAlikeProductSeen;
            case "quick view":
            case "category":
            case "direct":
            case "search":
              return undefined;
          }
        };
        //# sourceMappingURL=reporting.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/services/smartCollections.js":
      /*!**********************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/services/smartCollections.js ***!
  \**********************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", { value: true });
        exports.SmartCollections = exports.debugVersion = void 0;
        var API_1 = __webpack_require__(
          /*! ../utils/API */ "./node_modules/fast-simon-sdk/lib/utils/API.js"
        );
        var debug_1 = __webpack_require__(
          /*! ../utils/debug */ "./node_modules/fast-simon-sdk/lib/utils/debug.js"
        );
        var options_1 = __webpack_require__(
          /*! ../utils/options */ "./node_modules/fast-simon-sdk/lib/utils/options.js"
        );
        var segments_1 = __webpack_require__(
          /*! ../utils/segments */ "./node_modules/fast-simon-sdk/lib/utils/segments.js"
        );
        var BASE_URL = "https://api.fastsimon.com";
        exports.debugVersion = debug_1.getDebugEndpoint();
        exports.SmartCollections = {
          getSmartCollections: function (_a) {
            var uuid = _a.uuid,
              storeID = _a.storeID,
              cdn = _a.cdn,
              facetRequired = _a.facetRequired,
              narrowBy = _a.narrowBy,
              page = _a.page,
              productsPerPage = _a.productsPerPage,
              sortBy = _a.sortBy,
              withAttributes = _a.withAttributes,
              categoryID = _a.categoryID,
              recent = _a.recent,
              rec = _a.rec,
              searchWithinSearch = _a.searchWithinSearch;
            var params = {
              UUID: uuid,
              store_id: storeID,
              cdn_cache_key: cdn,
              facets_required: facetRequired,
              category_id: categoryID,
              page_num: page !== null && page !== void 0 ? page : 1,
              with_product_attributes: withAttributes,
              narrow: JSON.stringify(narrowBy),
              products_per_page: productsPerPage,
              sort_by: sortBy,
              sp: recent,
              m: debug_1.isDebugCaching() ? 1 : undefined,
              search_within_search: searchWithinSearch,
              // ab_testing
              disable_personalization: options_1.getSDKABTestingOptionExist(
                "ab_test_disable_search_personalization"
              ),
              disable_merchandising:
                options_1.getSDKABTestingOptionExist(
                  "ab_test_disable_merchandising"
                ) || options_1.getSDKABTestingOption("disable_merchandising"),
              disable_merchandising_rules:
                options_1.getSDKABTestingOptionExist(
                  "ab_test_disable_merchandising_rules"
                ) ||
                options_1.getSDKABTestingOption("disable_merchandising_rules"),
              disable_strategies:
                options_1.getSDKABTestingOptionExist(
                  "ab_test_disable_merchandising_strategies"
                ) || options_1.getSDKABTestingOption("disable_strategies"),
              disable_semantics: options_1.getSDKABTestingOptionExist(
                "ab_test_disable_semantics"
              ),
              //preview stuff
              merchandising_rules: options_1.getSDKABTestingOption(
                "merchandising_rules"
              ),
              request_serial_number: options_1.getSDKABTestingOption(
                "request_serial_number"
              ),
              related_search: options_1.getSDKABTestingOption("related_search"),
              st: segments_1.getSegments(),
            };
            if (options_1.getSDKABTestingOption("reasoning")) {
              return API_1.API.get({
                url:
                  (exports.debugVersion || BASE_URL) +
                  "/categories_navigation_reasoning",
                params: params,
                config: {
                  headers: {
                    sid: options_1
                      .getSDKABTestingOption("reasoning")
                      .split(":")[0],
                    site_key: options_1
                      .getSDKABTestingOption("reasoning")
                      .split(":")[1],
                  },
                },
              });
            }
            return API_1.API.get({
              url:
                (exports.debugVersion || BASE_URL) + "/categories_navigation",
              params: params,
            });
          },
        };
        //# sourceMappingURL=smartCollections.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/services/utils.js":
      /*!***********************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/services/utils.js ***!
  \***********************************************************/
      /***/ (__unused_webpack_module, exports) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", { value: true });
        exports.serializeNarrowBy = exports.serializeNarrowByFilter = void 0;
        var serializeNarrowByFilter = function (narrow) {
          if (!narrow) {
            return undefined;
          }
          var narrowKeys = {};
          for (var _i = 0, narrow_1 = narrow; _i < narrow_1.length; _i++) {
            var term = narrow_1[_i];
            var id = term[0],
              value = term[1];
            if (id in narrowKeys) {
              narrowKeys[id].push(value);
            } else {
              narrowKeys[id] = [value];
            }
          }
          return Object.entries(narrowKeys);
        };
        exports.serializeNarrowByFilter = serializeNarrowByFilter;
        var serializeNarrowBy = function (narrow) {
          return String(narrow);
        };
        exports.serializeNarrowBy = serializeNarrowBy;
        //# sourceMappingURL=utils.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/utils/API.js":
      /*!******************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/utils/API.js ***!
  \******************************************************/
      /***/ function (__unused_webpack_module, exports, __webpack_require__) {
        "use strict";

        var __assign =
          (this && this.__assign) ||
          function () {
            __assign =
              Object.assign ||
              function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                  s = arguments[i];
                  for (var p in s)
                    if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
              };
            return __assign.apply(this, arguments);
          };
        var __awaiter =
          (this && this.__awaiter) ||
          function (thisArg, _arguments, P, generator) {
            function adopt(value) {
              return value instanceof P
                ? value
                : new P(function (resolve) {
                    resolve(value);
                  });
            }
            return new (P || (P = Promise))(function (resolve, reject) {
              function fulfilled(value) {
                try {
                  step(generator.next(value));
                } catch (e) {
                  reject(e);
                }
              }
              function rejected(value) {
                try {
                  step(generator["throw"](value));
                } catch (e) {
                  reject(e);
                }
              }
              function step(result) {
                result.done
                  ? resolve(result.value)
                  : adopt(result.value).then(fulfilled, rejected);
              }
              step(
                (generator = generator.apply(thisArg, _arguments || [])).next()
              );
            });
          };
        var __generator =
          (this && this.__generator) ||
          function (thisArg, body) {
            var _ = {
                label: 0,
                sent: function () {
                  if (t[0] & 1) throw t[1];
                  return t[1];
                },
                trys: [],
                ops: [],
              },
              f,
              y,
              t,
              g;
            return (
              (g = { next: verb(0), throw: verb(1), return: verb(2) }),
              typeof Symbol === "function" &&
                (g[Symbol.iterator] = function () {
                  return this;
                }),
              g
            );
            function verb(n) {
              return function (v) {
                return step([n, v]);
              };
            }
            function step(op) {
              if (f) throw new TypeError("Generator is already executing.");
              while (_)
                try {
                  if (
                    ((f = 1),
                    y &&
                      (t =
                        op[0] & 2
                          ? y["return"]
                          : op[0]
                          ? y["throw"] || ((t = y["return"]) && t.call(y), 0)
                          : y.next) &&
                      !(t = t.call(y, op[1])).done)
                  )
                    return t;
                  if (((y = 0), t)) op = [op[0] & 2, t.value];
                  switch (op[0]) {
                    case 0:
                    case 1:
                      t = op;
                      break;
                    case 4:
                      _.label++;
                      return { value: op[1], done: false };
                    case 5:
                      _.label++;
                      y = op[1];
                      op = [0];
                      continue;
                    case 7:
                      op = _.ops.pop();
                      _.trys.pop();
                      continue;
                    default:
                      if (
                        !((t = _.trys),
                        (t = t.length > 0 && t[t.length - 1])) &&
                        (op[0] === 6 || op[0] === 2)
                      ) {
                        _ = 0;
                        continue;
                      }
                      if (
                        op[0] === 3 &&
                        (!t || (op[1] > t[0] && op[1] < t[3]))
                      ) {
                        _.label = op[1];
                        break;
                      }
                      if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                      }
                      if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                      }
                      if (t[2]) _.ops.pop();
                      _.trys.pop();
                      continue;
                  }
                  op = body.call(thisArg, _);
                } catch (e) {
                  op = [6, e];
                  y = 0;
                } finally {
                  f = t = 0;
                }
              if (op[0] & 5) throw op[1];
              return { value: op[0] ? op[1] : void 0, done: true };
            }
          };
        Object.defineProperty(exports, "__esModule", { value: true });
        exports.API = void 0;
        var axios_1 = __webpack_require__(
          /*! axios */ "./node_modules/axios/index.js"
        );
        exports.API = {
          get: function (_a) {
            var url = _a.url,
              params = _a.params,
              config = _a.config;
            return __awaiter(this, void 0, void 0, function () {
              var response;
              return __generator(this, function (_b) {
                switch (_b.label) {
                  case 0:
                    return [
                      4 /*yield*/,
                      axios_1.default.get(
                        url,
                        __assign({ params: params }, config)
                      ),
                    ];
                  case 1:
                    response = _b.sent();
                    return [2 /*return*/, response.data];
                }
              });
            });
          },
          post: function (_a) {
            var url = _a.url,
              config = _a.config,
              data = _a.data;
            return __awaiter(this, void 0, void 0, function () {
              var response;
              return __generator(this, function (_b) {
                switch (_b.label) {
                  case 0:
                    return [
                      4 /*yield*/,
                      axios_1.default.post(url, data, config),
                    ];
                  case 1:
                    response = _b.sent();
                    return [2 /*return*/, response.data];
                }
              });
            });
          },
        };
        //# sourceMappingURL=API.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/utils/ArrayUtils.js":
      /*!*************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/utils/ArrayUtils.js ***!
  \*************************************************************/
      /***/ (__unused_webpack_module, exports) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", { value: true });
        exports.insert = exports.arrayMove = void 0;
        function arrayMove(arr, oldIndex, newIndex) {
          if (newIndex >= arr.length) {
            var k = newIndex - arr.length + 1;
            while (k--) {
              arr.push(undefined);
            }
          }
          arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
        }
        exports.arrayMove = arrayMove;
        function insert(arr, index, item) {
          arr.splice(index, 0, item);
        }
        exports.insert = insert;
        //# sourceMappingURL=ArrayUtils.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/utils/cookies.js":
      /*!**********************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/utils/cookies.js ***!
  \**********************************************************/
      /***/ function (__unused_webpack_module, exports) {
        "use strict";

        var __assign =
          (this && this.__assign) ||
          function () {
            __assign =
              Object.assign ||
              function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                  s = arguments[i];
                  for (var p in s)
                    if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
              };
            return __assign.apply(this, arguments);
          };
        Object.defineProperty(exports, "__esModule", { value: true });
        var Cookies = /** @class */ (function () {
          function Cookies() {
            this.cookies = this.getCookies();
          }
          Cookies.prototype.getCookies = function () {
            return document.cookie.split("; ").reduce(function (a, c) {
              var _a;
              var _b = c.split("="),
                n = _b[0],
                v = _b[1];
              return __assign(
                __assign({}, a),
                ((_a = {}), (_a[n] = decodeURIComponent(v)), _a)
              );
            }, {});
          };
          Cookies.prototype.has = function (key) {
            return Boolean(this.cookies[key]);
          };
          Cookies.getActualKey = function (key) {
            return encodeURIComponent(key)
              .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
              .replace(/[()]/g, escape);
          };
          Cookies.getActualValue = function (value) {
            return encodeURIComponent(value).replace(
              /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
              decodeURIComponent
            );
          };
          Cookies.prototype.get = function (key) {
            var _a, _b;
            var actualKey = Cookies.getActualKey(key);
            return (_b =
              (_a = this.cookies[key]) !== null && _a !== void 0
                ? _a
                : this.cookies[actualKey]) !== null && _b !== void 0
              ? _b
              : "";
          };
          Cookies.prototype.set = function (key, value) {
            var actualKey = Cookies.getActualKey(key);
            var actualValue = Cookies.getActualValue(value);
            this.cookies[actualKey] = actualValue;
            document.cookie += actualKey + "=" + actualValue + "; ";
            return { actualKey: actualKey, actualValue: actualValue };
          };
          return Cookies;
        })();
        exports["default"] = Cookies;
        //# sourceMappingURL=cookies.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/utils/debug.js":
      /*!********************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/utils/debug.js ***!
  \********************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", { value: true });
        exports.clearDebugSDK =
          exports.debugSDK =
          exports.isDebugCaching =
          exports.getDebugEndpoint =
            void 0;
        var config_1 = __webpack_require__(
          /*! ../config */ "./node_modules/fast-simon-sdk/lib/config.js"
        );
        var getDebugEndpoint = function () {
          return localStorage.getItem(config_1.SDK_DEBUG_LS_LEY) || "";
        };
        exports.getDebugEndpoint = getDebugEndpoint;
        var isDebugCaching = function () {
          return Boolean(localStorage.getItem(config_1.SDK_NO_CACHING_LS_KEY));
        };
        exports.isDebugCaching = isDebugCaching;
        var debugSDK = function (endpoint, disableCaching) {
          if (endpoint) {
            localStorage.setItem(config_1.SDK_DEBUG_LS_LEY, endpoint);
          } else {
            localStorage.removeItem(config_1.SDK_DEBUG_LS_LEY);
          }
          if (disableCaching) {
            localStorage.setItem(config_1.SDK_NO_CACHING_LS_KEY, "true");
          } else {
            localStorage.removeItem(config_1.SDK_NO_CACHING_LS_KEY);
          }
        };
        exports.debugSDK = debugSDK;
        var clearDebugSDK = function () {
          exports.debugSDK("", false);
        };
        exports.clearDebugSDK = clearDebugSDK;
        //# sourceMappingURL=debug.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/utils/klaviyo.js":
      /*!**********************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/utils/klaviyo.js ***!
  \**********************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", { value: true });
        exports.getKlaviyoCustomerID = void 0;
        var config_1 = __webpack_require__(
          /*! ../config */ "./node_modules/fast-simon-sdk/lib/config.js"
        );
        var getKlaviyoCustomerID = function () {
          var _a;
          var anyWindow = window;
          if (config_1.KLAVIYO_ID_SS_KEY in sessionStorage) {
            return sessionStorage.getItem(config_1.KLAVIYO_ID_SS_KEY);
          }
          if ("_learnq" in anyWindow && "push" in anyWindow._learnq) {
            var customerID =
              (_a = anyWindow._learnq.push([
                "_getIdentifiers",
              ]).$exchange_id) !== null && _a !== void 0
                ? _a
                : "";
            if (customerID) {
              sessionStorage.setItem(config_1.KLAVIYO_ID_SS_KEY, customerID);
              return customerID;
            }
          }
          return undefined;
        };
        exports.getKlaviyoCustomerID = getKlaviyoCustomerID;
        //# sourceMappingURL=klaviyo.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/utils/options.js":
      /*!**********************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/utils/options.js ***!
  \**********************************************************/
      /***/ (__unused_webpack_module, exports) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", { value: true });
        exports.getSDKABTestingOption = exports.getSDKABTestingOptionExist =
          void 0;
        // old backend expects 1 / undefined instead of a plane boolean
        var getSDKABTestingOptionExist = function (flag) {
          return "fastSDKOptions" in window && window.fastSDKOptions[flag]
            ? 1
            : undefined;
        };
        exports.getSDKABTestingOptionExist = getSDKABTestingOptionExist;
        var getSDKABTestingOption = function (flag) {
          return "fastSDKOptions" in window &&
            typeof window.fastSDKOptions[flag] !== "undefined"
            ? window.fastSDKOptions[flag]
            : undefined;
        };
        exports.getSDKABTestingOption = getSDKABTestingOption;
        //# sourceMappingURL=options.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/utils/segments.js":
      /*!***********************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/utils/segments.js ***!
  \***********************************************************/
      /***/ (__unused_webpack_module, exports) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", { value: true });
        exports.getSegments = exports.setServingSegments = void 0;
        var ISP_SEGMENTS_SERVING_KEY = "ISP_SEGMENTS_SERVING_KEY";
        var LS_KEY = "isp_token_1";
        function setServingSegments(segmentRes) {
          if (segmentRes) {
            localStorage.setItem(ISP_SEGMENTS_SERVING_KEY, String(segmentRes));
          } else {
            localStorage.removeItem(ISP_SEGMENTS_SERVING_KEY);
          }
        }
        exports.setServingSegments = setServingSegments;
        function getSegments() {
          var _a, _b;
          var segments =
            (_a =
              window === null || window === void 0
                ? void 0
                : window.localStorage) === null || _a === void 0
              ? void 0
              : _a.getItem(ISP_SEGMENTS_SERVING_KEY);
          return segments
            ? (_b =
                window === null || window === void 0
                  ? void 0
                  : window.localStorage) === null || _b === void 0
              ? void 0
              : _b.getItem(LS_KEY)
            : undefined;
        }
        exports.getSegments = getSegments;
        //# sourceMappingURL=segments.js.map

        /***/
      },

    /***/ "./node_modules/fast-simon-sdk/lib/utils/validation.js":
      /*!*************************************************************!*\
  !*** ./node_modules/fast-simon-sdk/lib/utils/validation.js ***!
  \*************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", { value: true });
        exports.isValidAPIUser =
          exports.validateParams =
          exports.validateUUID =
            void 0;
        var config_1 = __webpack_require__(
          /*! ../config */ "./node_modules/fast-simon-sdk/lib/config.js"
        );
        var validateUUID = function (uuid) {
          if (uuid.split("-").length === 5) {
            return true;
          }
          console.log(
            "%c\u274C IS+ SDK Error | invalid UUID",
            "font-weight: bold; font-size: 12px; color: red"
          );
          return false;
        };
        exports.validateUUID = validateUUID;
        var validateParams = function (validators, props) {
          for (
            var _i = 0, validators_1 = validators;
            _i < validators_1.length;
            _i++
          ) {
            var v = validators_1[_i];
            if (!(v in props)) {
              console.log(
                "%c\u274C IS+ SDK Error | param: " + v + " missing",
                "font-weight: bold; font-size: 12px; color: red"
              );
              return false;
            }
          }
          return true;
        };
        exports.validateParams = validateParams;
        var isValidAPIUser = function (sdkUtils) {
          if (!sdkUtils.data.dashboard.using_isp_api) {
            console.log(
              "%c" + config_1.API_ERROR_MSG,
              "font-weight: bold; font-size: 12px; color: red"
            );
            return false;
          }
          return true;
        };
        exports.isValidAPIUser = isValidAPIUser;
        //# sourceMappingURL=validation.js.map

        /***/
      },

    /***/ "./node_modules/fizzy-ui-utils/utils.js":
      /*!**********************************************!*\
  !*** ./node_modules/fizzy-ui-utils/utils.js ***!
  \**********************************************/
      /***/ function (module) {
        /**
         * Fizzy UI utils v3.0.0
         * MIT license
         */

        (function (global, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS
            module.exports = factory(global);
          } else {
            // browser global
            global.fizzyUIUtils = factory(global);
          }
        })(this, function factory(global) {
          let utils = {};

          // ----- extend ----- //

          // extends objects
          utils.extend = function (a, b) {
            return Object.assign(a, b);
          };

          // ----- modulo ----- //

          utils.modulo = function (num, div) {
            return ((num % div) + div) % div;
          };

          // ----- makeArray ----- //

          // turn element or nodeList into an array
          utils.makeArray = function (obj) {
            // use object if already an array
            if (Array.isArray(obj)) return obj;

            // return empty array if undefined or null. #6
            if (obj === null || obj === undefined) return [];

            let isArrayLike =
              typeof obj == "object" && typeof obj.length == "number";
            // convert nodeList to array
            if (isArrayLike) return [...obj];

            // array of single index
            return [obj];
          };

          // ----- removeFrom ----- //

          utils.removeFrom = function (ary, obj) {
            let index = ary.indexOf(obj);
            if (index != -1) {
              ary.splice(index, 1);
            }
          };

          // ----- getParent ----- //

          utils.getParent = function (elem, selector) {
            while (elem.parentNode && elem != document.body) {
              elem = elem.parentNode;
              if (elem.matches(selector)) return elem;
            }
          };

          // ----- getQueryElement ----- //

          // use element as selector string
          utils.getQueryElement = function (elem) {
            if (typeof elem == "string") {
              return document.querySelector(elem);
            }
            return elem;
          };

          // ----- handleEvent ----- //

          // enable .ontype to trigger from .addEventListener( elem, 'type' )
          utils.handleEvent = function (event) {
            let method = "on" + event.type;
            if (this[method]) {
              this[method](event);
            }
          };

          // ----- filterFindElements ----- //

          utils.filterFindElements = function (elems, selector) {
            // make array of elems
            elems = utils.makeArray(elems);

            return (
              elems
                // check that elem is an actual element
                .filter((elem) => elem instanceof HTMLElement)
                .reduce((ffElems, elem) => {
                  // add elem if no selector
                  if (!selector) {
                    ffElems.push(elem);
                    return ffElems;
                  }
                  // filter & find items if we have a selector
                  // filter
                  if (elem.matches(selector)) {
                    ffElems.push(elem);
                  }
                  // find children
                  let childElems = elem.querySelectorAll(selector);
                  // concat childElems to filterFound array
                  ffElems = ffElems.concat(...childElems);
                  return ffElems;
                }, [])
            );
          };

          // ----- debounceMethod ----- //

          utils.debounceMethod = function (_class, methodName, threshold) {
            threshold = threshold || 100;
            // original method
            let method = _class.prototype[methodName];
            let timeoutName = methodName + "Timeout";

            _class.prototype[methodName] = function () {
              clearTimeout(this[timeoutName]);

              let args = arguments;
              this[timeoutName] = setTimeout(() => {
                method.apply(this, args);
                delete this[timeoutName];
              }, threshold);
            };
          };

          // ----- docReady ----- //

          utils.docReady = function (onDocReady) {
            let readyState = document.readyState;
            if (readyState == "complete" || readyState == "interactive") {
              // do async to allow for other scripts to run. metafizzy/flickity#441
              setTimeout(onDocReady);
            } else {
              document.addEventListener("DOMContentLoaded", onDocReady);
            }
          };

          // ----- htmlInit ----- //

          // http://bit.ly/3oYLusc
          utils.toDashed = function (str) {
            return str
              .replace(/(.)([A-Z])/g, function (match, $1, $2) {
                return $1 + "-" + $2;
              })
              .toLowerCase();
          };

          let console = global.console;

          // allow user to initialize classes via [data-namespace] or .js-namespace class
          // htmlInit( Widget, 'widgetName' )
          // options are parsed from data-namespace-options
          utils.htmlInit = function (WidgetClass, namespace) {
            utils.docReady(function () {
              let dashedNamespace = utils.toDashed(namespace);
              let dataAttr = "data-" + dashedNamespace;
              let dataAttrElems = document.querySelectorAll(`[${dataAttr}]`);
              let jQuery = global.jQuery;

              [...dataAttrElems].forEach((elem) => {
                let attr = elem.getAttribute(dataAttr);
                let options;
                try {
                  options = attr && JSON.parse(attr);
                } catch (error) {
                  // log error, do not initialize
                  if (console) {
                    console.error(
                      `Error parsing ${dataAttr} on ${elem.className}: ${error}`
                    );
                  }
                  return;
                }
                // initialize
                let instance = new WidgetClass(elem, options);
                // make available via $().data('namespace')
                if (jQuery) {
                  jQuery.data(elem, namespace, instance);
                }
              });
            });
          };

          // -----  ----- //

          return utils;
        });

        /***/
      },

    /***/ "./node_modules/flickity/js/add-remove-cell.js":
      /*!*****************************************************!*\
  !*** ./node_modules/flickity/js/add-remove-cell.js ***!
  \*****************************************************/
      /***/ function (module, __unused_webpack_exports, __webpack_require__) {
        // add, remove cell
        (function (window, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS
            module.exports = factory(
              __webpack_require__(
                /*! ./core */ "./node_modules/flickity/js/core.js"
              ),
              __webpack_require__(
                /*! fizzy-ui-utils */ "./node_modules/fizzy-ui-utils/utils.js"
              )
            );
          } else {
            // browser global
            factory(window.Flickity, window.fizzyUIUtils);
          }
        })(
          typeof window != "undefined" ? window : this,
          function factory(Flickity, utils) {
            // append cells to a document fragment
            function getCellsFragment(cells) {
              let fragment = document.createDocumentFragment();
              cells.forEach((cell) => fragment.appendChild(cell.element));
              return fragment;
            }

            // -------------------------- add/remove cell prototype -------------------------- //

            let proto = Flickity.prototype;

            /**
             * Insert, prepend, or append cells
             * @param {[Element, Array, NodeList]} elems - Elements to insert
             * @param {Integer} index - Zero-based number to insert
             */
            proto.insert = function (elems, index) {
              let cells = this._makeCells(elems);
              if (!cells || !cells.length) return;

              let len = this.cells.length;
              // default to append
              index = index === undefined ? len : index;
              // add cells with document fragment
              let fragment = getCellsFragment(cells);
              // append to slider
              let isAppend = index === len;
              if (isAppend) {
                this.slider.appendChild(fragment);
              } else {
                let insertCellElement = this.cells[index].element;
                this.slider.insertBefore(fragment, insertCellElement);
              }
              // add to this.cells
              if (index === 0) {
                // prepend, add to start
                this.cells = cells.concat(this.cells);
              } else if (isAppend) {
                // append, add to end
                this.cells = this.cells.concat(cells);
              } else {
                // insert in this.cells
                let endCells = this.cells.splice(index, len - index);
                this.cells = this.cells.concat(cells).concat(endCells);
              }

              this._sizeCells(cells);
              this.cellChange(index);
              this.positionSliderAtSelected();
            };

            proto.append = function (elems) {
              this.insert(elems, this.cells.length);
            };

            proto.prepend = function (elems) {
              this.insert(elems, 0);
            };

            /**
             * Remove cells
             * @param {[Element, Array, NodeList]} elems - ELements to remove
             */
            proto.remove = function (elems) {
              let cells = this.getCells(elems);
              if (!cells || !cells.length) return;

              let minCellIndex = this.cells.length - 1;
              // remove cells from collection & DOM
              cells.forEach((cell) => {
                cell.remove();
                let index = this.cells.indexOf(cell);
                minCellIndex = Math.min(index, minCellIndex);
                utils.removeFrom(this.cells, cell);
              });

              this.cellChange(minCellIndex);
              this.positionSliderAtSelected();
            };

            /**
             * logic to be run after a cell's size changes
             * @param {Element} elem - cell's element
             */
            proto.cellSizeChange = function (elem) {
              let cell = this.getCell(elem);
              if (!cell) return;

              cell.getSize();

              let index = this.cells.indexOf(cell);
              this.cellChange(index);
              // do not position slider after lazy load
            };

            /**
             * logic any time a cell is changed: added, removed, or size changed
             * @param {Integer} changedCellIndex - index of the changed cell, optional
             */
            proto.cellChange = function (changedCellIndex) {
              let prevSelectedElem = this.selectedElement;
              this._positionCells(changedCellIndex);
              this._updateWrapShiftCells();
              this.setGallerySize();
              // update selectedIndex, try to maintain position & select previous selected element
              let cell = this.getCell(prevSelectedElem);
              if (cell) this.selectedIndex = this.getCellSlideIndex(cell);
              this.selectedIndex = Math.min(
                this.slides.length - 1,
                this.selectedIndex
              );

              this.emitEvent("cellChange", [changedCellIndex]);
              // position slider
              this.select(this.selectedIndex);
            };

            // -----  ----- //

            return Flickity;
          }
        );

        /***/
      },

    /***/ "./node_modules/flickity/js/animate.js":
      /*!*********************************************!*\
  !*** ./node_modules/flickity/js/animate.js ***!
  \*********************************************/
      /***/ function (module, __unused_webpack_exports, __webpack_require__) {
        // animate
        (function (window, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS
            module.exports = factory(
              __webpack_require__(
                /*! fizzy-ui-utils */ "./node_modules/fizzy-ui-utils/utils.js"
              )
            );
          } else {
            // browser global
            window.Flickity = window.Flickity || {};
            window.Flickity.animatePrototype = factory(window.fizzyUIUtils);
          }
        })(
          typeof window != "undefined" ? window : this,
          function factory(utils) {
            // -------------------------- animate -------------------------- //

            let proto = {};

            proto.startAnimation = function () {
              if (this.isAnimating) return;

              this.isAnimating = true;
              this.restingFrames = 0;
              this.animate();
            };

            proto.animate = function () {
              this.applyDragForce();
              this.applySelectedAttraction();

              let previousX = this.x;

              this.integratePhysics();
              this.positionSlider();
              this.settle(previousX);
              // animate next frame
              if (this.isAnimating) requestAnimationFrame(() => this.animate());
            };

            proto.positionSlider = function () {
              let x = this.x;
              // wrap position around
              if (this.isWrapping) {
                x = utils.modulo(x, this.slideableWidth) - this.slideableWidth;
                this.shiftWrapCells(x);
              }

              this.setTranslateX(x, this.isAnimating);
              this.dispatchScrollEvent();
            };

            proto.setTranslateX = function (x, is3d) {
              x += this.cursorPosition;
              // reverse if right-to-left and using transform
              if (this.options.rightToLeft) x = -x;
              let translateX = this.getPositionValue(x);
              // use 3D transforms for hardware acceleration on iOS
              // but use 2D when settled, for better font-rendering
              this.slider.style.transform = is3d
                ? `translate3d(${translateX},0,0)`
                : `translateX(${translateX})`;
            };

            proto.dispatchScrollEvent = function () {
              let firstSlide = this.slides[0];
              if (!firstSlide) return;

              let positionX = -this.x - firstSlide.target;
              let progress = positionX / this.slidesWidth;
              this.dispatchEvent("scroll", null, [progress, positionX]);
            };

            proto.positionSliderAtSelected = function () {
              if (!this.cells.length) return;

              this.x = -this.selectedSlide.target;
              this.velocity = 0; // stop wobble
              this.positionSlider();
            };

            proto.getPositionValue = function (position) {
              if (this.options.percentPosition) {
                // percent position, round to 2 digits, like 12.34%
                return (
                  Math.round((position / this.size.innerWidth) * 10000) * 0.01 +
                  "%"
                );
              } else {
                // pixel positioning
                return Math.round(position) + "px";
              }
            };

            proto.settle = function (previousX) {
              // keep track of frames where x hasn't moved
              let isResting =
                !this.isPointerDown &&
                Math.round(this.x * 100) === Math.round(previousX * 100);
              if (isResting) this.restingFrames++;
              // stop animating if resting for 3 or more frames
              if (this.restingFrames > 2) {
                this.isAnimating = false;
                delete this.isFreeScrolling;
                // render position with translateX when settled
                this.positionSlider();
                this.dispatchEvent("settle", null, [this.selectedIndex]);
              }
            };

            proto.shiftWrapCells = function (x) {
              // shift before cells
              let beforeGap = this.cursorPosition + x;
              this._shiftCells(this.beforeShiftCells, beforeGap, -1);
              // shift after cells
              let afterGap =
                this.size.innerWidth -
                (x + this.slideableWidth + this.cursorPosition);
              this._shiftCells(this.afterShiftCells, afterGap, 1);
            };

            proto._shiftCells = function (cells, gap, shift) {
              cells.forEach((cell) => {
                let cellShift = gap > 0 ? shift : 0;
                this._wrapShiftCell(cell, cellShift);
                gap -= cell.size.outerWidth;
              });
            };

            proto._unshiftCells = function (cells) {
              if (!cells || !cells.length) return;

              cells.forEach((cell) => this._wrapShiftCell(cell, 0));
            };

            // @param {Integer} shift - 0, 1, or -1
            proto._wrapShiftCell = function (cell, shift) {
              this._renderCellPosition(
                cell,
                cell.x + this.slideableWidth * shift
              );
            };

            // -------------------------- physics -------------------------- //

            proto.integratePhysics = function () {
              this.x += this.velocity;
              this.velocity *= this.getFrictionFactor();
            };

            proto.applyForce = function (force) {
              this.velocity += force;
            };

            proto.getFrictionFactor = function () {
              return (
                1 -
                this.options[
                  this.isFreeScrolling ? "freeScrollFriction" : "friction"
                ]
              );
            };

            proto.getRestingPosition = function () {
              // my thanks to Steven Wittens, who simplified this math greatly
              return this.x + this.velocity / (1 - this.getFrictionFactor());
            };

            proto.applyDragForce = function () {
              if (!this.isDraggable || !this.isPointerDown) return;

              // change the position to drag position by applying force
              let dragVelocity = this.dragX - this.x;
              let dragForce = dragVelocity - this.velocity;
              this.applyForce(dragForce);
            };

            proto.applySelectedAttraction = function () {
              // do not attract if pointer down or no slides
              let dragDown = this.isDraggable && this.isPointerDown;
              if (dragDown || this.isFreeScrolling || !this.slides.length)
                return;

              let distance = this.selectedSlide.target * -1 - this.x;
              let force = distance * this.options.selectedAttraction;
              this.applyForce(force);
            };

            return proto;
          }
        );

        /***/
      },

    /***/ "./node_modules/flickity/js/cell.js":
      /*!******************************************!*\
  !*** ./node_modules/flickity/js/cell.js ***!
  \******************************************/
      /***/ function (module, __unused_webpack_exports, __webpack_require__) {
        // Flickity.Cell
        (function (window, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS
            module.exports = factory(
              __webpack_require__(
                /*! get-size */ "./node_modules/get-size/get-size.js"
              )
            );
          } else {
            // browser global
            window.Flickity = window.Flickity || {};
            window.Flickity.Cell = factory(window.getSize);
          }
        })(
          typeof window != "undefined" ? window : this,
          function factory(getSize) {
            const cellClassName = "flickity-cell";

            function Cell(elem) {
              this.element = elem;
              this.element.classList.add(cellClassName);

              this.x = 0;
              this.unselect();
            }

            let proto = Cell.prototype;

            proto.destroy = function () {
              // reset style
              this.unselect();
              this.element.classList.remove(cellClassName);
              this.element.style.transform = "";
              this.element.removeAttribute("aria-hidden");
            };

            proto.getSize = function () {
              this.size = getSize(this.element);
            };

            proto.select = function () {
              this.element.classList.add("is-selected");
              this.element.removeAttribute("aria-hidden");
            };

            proto.unselect = function () {
              this.element.classList.remove("is-selected");
              this.element.setAttribute("aria-hidden", "true");
            };

            proto.remove = function () {
              this.element.remove();
            };

            return Cell;
          }
        );

        /***/
      },

    /***/ "./node_modules/flickity/js/core.js":
      /*!******************************************!*\
  !*** ./node_modules/flickity/js/core.js ***!
  \******************************************/
      /***/ function (module, __unused_webpack_exports, __webpack_require__) {
        // Flickity main
        /* eslint-disable max-params */
        (function (window, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS
            module.exports = factory(
              window,
              __webpack_require__(
                /*! ev-emitter */ "./node_modules/ev-emitter/ev-emitter.js"
              ),
              __webpack_require__(
                /*! get-size */ "./node_modules/get-size/get-size.js"
              ),
              __webpack_require__(
                /*! fizzy-ui-utils */ "./node_modules/fizzy-ui-utils/utils.js"
              ),
              __webpack_require__(
                /*! ./cell */ "./node_modules/flickity/js/cell.js"
              ),
              __webpack_require__(
                /*! ./slide */ "./node_modules/flickity/js/slide.js"
              ),
              __webpack_require__(
                /*! ./animate */ "./node_modules/flickity/js/animate.js"
              )
            );
          } else {
            // browser global
            let _Flickity = window.Flickity;

            window.Flickity = factory(
              window,
              window.EvEmitter,
              window.getSize,
              window.fizzyUIUtils,
              _Flickity.Cell,
              _Flickity.Slide,
              _Flickity.animatePrototype
            );
          }
        })(
          typeof window != "undefined" ? window : this,
          function factory(
            window,
            EvEmitter,
            getSize,
            utils,
            Cell,
            Slide,
            animatePrototype
          ) {
            /* eslint-enable max-params */

            // vars
            const { getComputedStyle, console } = window;
            let { jQuery } = window;

            // -------------------------- Flickity -------------------------- //

            // globally unique identifiers
            let GUID = 0;
            // internal store of all Flickity intances
            let instances = {};

            function Flickity(element, options) {
              let queryElement = utils.getQueryElement(element);
              if (!queryElement) {
                if (console)
                  console.error(
                    `Bad element for Flickity: ${queryElement || element}`
                  );
                return;
              }
              this.element = queryElement;
              // do not initialize twice on same element
              if (this.element.flickityGUID) {
                let instance = instances[this.element.flickityGUID];
                if (instance) instance.option(options);
                return instance;
              }

              // add jQuery
              if (jQuery) {
                this.$element = jQuery(this.element);
              }
              // options
              this.options = { ...this.constructor.defaults };
              this.option(options);

              // kick things off
              this._create();
            }

            Flickity.defaults = {
              accessibility: true,
              // adaptiveHeight: false,
              cellAlign: "center",
              // cellSelector: undefined,
              // contain: false,
              freeScrollFriction: 0.075, // friction when free-scrolling
              friction: 0.28, // friction when selecting
              namespaceJQueryEvents: true,
              // initialIndex: 0,
              percentPosition: true,
              resize: true,
              selectedAttraction: 0.025,
              setGallerySize: true,
              // watchCSS: false,
              // wrapAround: false
            };

            // hash of methods triggered on _create()
            Flickity.create = {};

            let proto = Flickity.prototype;
            // inherit EventEmitter
            Object.assign(proto, EvEmitter.prototype);

            proto._create = function () {
              let { resize, watchCSS, rightToLeft } = this.options;
              // add id for Flickity.data
              let id = (this.guid = ++GUID);
              this.element.flickityGUID = id; // expando
              instances[id] = this; // associate via id
              // initial properties
              this.selectedIndex = 0;
              // how many frames slider has been in same position
              this.restingFrames = 0;
              // initial physics properties
              this.x = 0;
              this.velocity = 0;
              this.beginMargin = rightToLeft ? "marginRight" : "marginLeft";
              this.endMargin = rightToLeft ? "marginLeft" : "marginRight";
              // create viewport & slider
              this.viewport = document.createElement("div");
              this.viewport.className = "flickity-viewport";
              this._createSlider();
              // used for keyboard navigation
              this.focusableElems = [this.element];

              if (resize || watchCSS) {
                window.addEventListener("resize", this);
              }

              // add listeners from on option
              for (let eventName in this.options.on) {
                let listener = this.options.on[eventName];
                this.on(eventName, listener);
              }

              for (let method in Flickity.create) {
                Flickity.create[method].call(this);
              }

              if (watchCSS) {
                this.watchCSS();
              } else {
                this.activate();
              }
            };

            /**
             * set options
             * @param {Object} opts - options to extend
             */
            proto.option = function (opts) {
              Object.assign(this.options, opts);
            };

            proto.activate = function () {
              if (this.isActive) return;

              this.isActive = true;
              this.element.classList.add("flickity-enabled");
              if (this.options.rightToLeft) {
                this.element.classList.add("flickity-rtl");
              }

              this.getSize();
              // move initial cell elements so they can be loaded as cells
              let cellElems = this._filterFindCellElements(
                this.element.children
              );
              this.slider.append(...cellElems);
              this.viewport.append(this.slider);
              this.element.append(this.viewport);
              // get cells from children
              this.reloadCells();

              if (this.options.accessibility) {
                // allow element to focusable
                this.element.tabIndex = 0;
                // listen for key presses
                this.element.addEventListener("keydown", this);
              }

              this.emitEvent("activate");
              this.selectInitialIndex();
              // flag for initial activation, for using initialIndex
              this.isInitActivated = true;
              // ready event. #493
              this.dispatchEvent("ready");
            };

            // slider positions the cells
            proto._createSlider = function () {
              // slider element does all the positioning
              let slider = document.createElement("div");
              slider.className = "flickity-slider";
              this.slider = slider;
            };

            proto._filterFindCellElements = function (elems) {
              return utils.filterFindElements(elems, this.options.cellSelector);
            };

            // goes through all children
            proto.reloadCells = function () {
              // collection of item elements
              this.cells = this._makeCells(this.slider.children);
              this.positionCells();
              this._updateWrapShiftCells();
              this.setGallerySize();
            };

            /**
             * turn elements into Flickity.Cells
             * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
             * @returns {Array} items - collection of new Flickity Cells
             */
            proto._makeCells = function (elems) {
              let cellElems = this._filterFindCellElements(elems);

              // create new Cells for collection
              return cellElems.map((cellElem) => new Cell(cellElem));
            };

            proto.getLastCell = function () {
              return this.cells[this.cells.length - 1];
            };

            proto.getLastSlide = function () {
              return this.slides[this.slides.length - 1];
            };

            // positions all cells
            proto.positionCells = function () {
              // size all cells
              this._sizeCells(this.cells);
              // position all cells
              this._positionCells(0);
            };

            /**
             * position certain cells
             * @param {Integer} index - which cell to start with
             */
            proto._positionCells = function (index) {
              index = index || 0;
              // also measure maxCellHeight
              // start 0 if positioning all cells
              this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
              let cellX = 0;
              // get cellX
              if (index > 0) {
                let startCell = this.cells[index - 1];
                cellX = startCell.x + startCell.size.outerWidth;
              }

              this.cells.slice(index).forEach((cell) => {
                cell.x = cellX;
                this._renderCellPosition(cell, cellX);
                cellX += cell.size.outerWidth;
                this.maxCellHeight = Math.max(
                  cell.size.outerHeight,
                  this.maxCellHeight
                );
              });
              // keep track of cellX for wrap-around
              this.slideableWidth = cellX;
              // slides
              this.updateSlides();
              // contain slides target
              this._containSlides();
              // update slidesWidth
              this.slidesWidth = this.cells.length
                ? this.getLastSlide().target - this.slides[0].target
                : 0;
            };

            proto._renderCellPosition = function (cell, x) {
              // render position of cell with in slider
              let sideOffset = this.options.rightToLeft ? -1 : 1;
              let renderX = x * sideOffset;
              if (this.options.percentPosition)
                renderX *= this.size.innerWidth / cell.size.width;
              let positionValue = this.getPositionValue(renderX);
              cell.element.style.transform = `translateX( ${positionValue} )`;
            };

            /**
             * cell.getSize() on multiple cells
             * @param {Array} cells - cells to size
             */
            proto._sizeCells = function (cells) {
              cells.forEach((cell) => cell.getSize());
            };

            // --------------------------  -------------------------- //

            proto.updateSlides = function () {
              this.slides = [];
              if (!this.cells.length) return;

              let { beginMargin, endMargin } = this;
              let slide = new Slide(beginMargin, endMargin, this.cellAlign);
              this.slides.push(slide);

              let canCellFit = this._getCanCellFit();

              this.cells.forEach((cell, i) => {
                // just add cell if first cell in slide
                if (!slide.cells.length) {
                  slide.addCell(cell);
                  return;
                }

                let slideWidth =
                  slide.outerWidth -
                  slide.firstMargin +
                  (cell.size.outerWidth - cell.size[endMargin]);

                if (canCellFit(i, slideWidth)) {
                  slide.addCell(cell);
                } else {
                  // doesn't fit, new slide
                  slide.updateTarget();

                  slide = new Slide(beginMargin, endMargin, this.cellAlign);
                  this.slides.push(slide);
                  slide.addCell(cell);
                }
              });
              // last slide
              slide.updateTarget();
              // update .selectedSlide
              this.updateSelectedSlide();
            };

            proto._getCanCellFit = function () {
              let { groupCells } = this.options;
              if (!groupCells) return () => false;

              if (typeof groupCells == "number") {
                // group by number. 3 -> [0,1,2], [3,4,5], ...
                let number = parseInt(groupCells, 10);
                return (i) => i % number !== 0;
              }
              // default, group by width of slide
              let percent = 1;
              // parse '75%
              let percentMatch =
                typeof groupCells == "string" && groupCells.match(/^(\d+)%$/);
              if (percentMatch) percent = parseInt(percentMatch[1], 10) / 100;
              let groupWidth = (this.size.innerWidth + 1) * percent;
              return (i, slideWidth) => slideWidth <= groupWidth;
            };

            // alias _init for jQuery plugin .flickity()
            proto._init = proto.reposition = function () {
              this.positionCells();
              this.positionSliderAtSelected();
            };

            proto.getSize = function () {
              this.size = getSize(this.element);
              this.setCellAlign();
              this.cursorPosition = this.size.innerWidth * this.cellAlign;
            };

            let cellAlignShorthands = {
              left: 0,
              center: 0.5,
              right: 1,
            };

            proto.setCellAlign = function () {
              let { cellAlign, rightToLeft } = this.options;
              let shorthand = cellAlignShorthands[cellAlign];
              this.cellAlign = shorthand !== undefined ? shorthand : cellAlign;
              if (rightToLeft) this.cellAlign = 1 - this.cellAlign;
            };

            proto.setGallerySize = function () {
              if (!this.options.setGallerySize) return;

              let height =
                this.options.adaptiveHeight && this.selectedSlide
                  ? this.selectedSlide.height
                  : this.maxCellHeight;
              this.viewport.style.height = `${height}px`;
            };

            proto._updateWrapShiftCells = function () {
              // update isWrapping
              this.isWrapping = this.getIsWrapping();
              // only for wrap-around
              if (!this.isWrapping) return;

              // unshift previous cells
              this._unshiftCells(this.beforeShiftCells);
              this._unshiftCells(this.afterShiftCells);
              // get before cells
              // initial gap
              let beforeGapX = this.cursorPosition;
              let lastIndex = this.cells.length - 1;
              this.beforeShiftCells = this._getGapCells(
                beforeGapX,
                lastIndex,
                -1
              );
              // get after cells
              // ending gap between last cell and end of gallery viewport
              let afterGapX = this.size.innerWidth - this.cursorPosition;
              // start cloning at first cell, working forwards
              this.afterShiftCells = this._getGapCells(afterGapX, 0, 1);
            };

            proto.getIsWrapping = function () {
              let { wrapAround } = this.options;
              if (!wrapAround || this.slides.length < 2) return false;

              if (wrapAround !== "fill") return true;
              // check that slides can fit

              let gapWidth = this.slideableWidth - this.size.innerWidth;
              if (gapWidth > this.size.innerWidth) return true; // gap * 2x big, all good
              // check that content width - shifting cell is bigger than viewport width
              for (let cell of this.cells) {
                if (cell.size.outerWidth > gapWidth) return false;
              }
              return true;
            };

            proto._getGapCells = function (gapX, cellIndex, increment) {
              // keep adding cells until the cover the initial gap
              let cells = [];
              while (gapX > 0) {
                let cell = this.cells[cellIndex];
                if (!cell) break;

                cells.push(cell);
                cellIndex += increment;
                gapX -= cell.size.outerWidth;
              }
              return cells;
            };

            // ----- contain & wrap ----- //

            // contain cell targets so no excess sliding
            proto._containSlides = function () {
              let isContaining =
                this.options.contain && !this.isWrapping && this.cells.length;
              if (!isContaining) return;

              let contentWidth =
                this.slideableWidth - this.getLastCell().size[this.endMargin];
              // content is less than gallery size
              let isContentSmaller = contentWidth < this.size.innerWidth;
              if (isContentSmaller) {
                // all cells fit inside gallery
                this.slides.forEach((slide) => {
                  slide.target = contentWidth * this.cellAlign;
                });
              } else {
                // contain to bounds
                let beginBound =
                  this.cursorPosition + this.cells[0].size[this.beginMargin];
                let endBound =
                  contentWidth - this.size.innerWidth * (1 - this.cellAlign);
                this.slides.forEach((slide) => {
                  slide.target = Math.max(slide.target, beginBound);
                  slide.target = Math.min(slide.target, endBound);
                });
              }
            };

            // ----- events ----- //

            /**
             * emits events via eventEmitter and jQuery events
             * @param {String} type - name of event
             * @param {Event} event - original event
             * @param {Array} args - extra arguments
             */
            proto.dispatchEvent = function (type, event, args) {
              let emitArgs = event ? [event].concat(args) : args;
              this.emitEvent(type, emitArgs);

              if (jQuery && this.$element) {
                // default trigger with type if no event
                type += this.options.namespaceJQueryEvents ? ".flickity" : "";
                let $event = type;
                if (event) {
                  // create jQuery event
                  let jQEvent = new jQuery.Event(event);
                  jQEvent.type = type;
                  $event = jQEvent;
                }
                this.$element.trigger($event, args);
              }
            };

            const unidraggerEvents = [
              "dragStart",
              "dragMove",
              "dragEnd",
              "pointerDown",
              "pointerMove",
              "pointerEnd",
              "staticClick",
            ];

            let _emitEvent = proto.emitEvent;
            proto.emitEvent = function (eventName, args) {
              if (eventName === "staticClick") {
                // add cellElem and cellIndex args to staticClick
                let clickedCell = this.getParentCell(args[0].target);
                let cellElem = clickedCell && clickedCell.element;
                let cellIndex = clickedCell && this.cells.indexOf(clickedCell);
                args = args.concat(cellElem, cellIndex);
              }
              // do regular thing
              _emitEvent.call(this, eventName, args);
              // duck-punch in jQuery events for Unidragger events
              let isUnidraggerEvent = unidraggerEvents.includes(eventName);
              if (!isUnidraggerEvent || !jQuery || !this.$element) return;

              eventName += this.options.namespaceJQueryEvents
                ? ".flickity"
                : "";
              let event = args.shift(0);
              let jQEvent = new jQuery.Event(event);
              jQEvent.type = eventName;
              this.$element.trigger(jQEvent, args);
            };

            // -------------------------- select -------------------------- //

            /**
             * @param {Integer} index - index of the slide
             * @param {Boolean} isWrap - will wrap-around to last/first if at the end
             * @param {Boolean} isInstant - will immediately set position at selected cell
             */
            proto.select = function (index, isWrap, isInstant) {
              if (!this.isActive) return;

              index = parseInt(index, 10);
              this._wrapSelect(index);

              if (this.isWrapping || isWrap) {
                index = utils.modulo(index, this.slides.length);
              }
              // bail if invalid index
              if (!this.slides[index]) return;

              let prevIndex = this.selectedIndex;
              this.selectedIndex = index;
              this.updateSelectedSlide();
              if (isInstant) {
                this.positionSliderAtSelected();
              } else {
                this.startAnimation();
              }
              if (this.options.adaptiveHeight) {
                this.setGallerySize();
              }
              // events
              this.dispatchEvent("select", null, [index]);
              // change event if new index
              if (index !== prevIndex) {
                this.dispatchEvent("change", null, [index]);
              }
            };

            // wraps position for wrapAround, to move to closest slide. #113
            proto._wrapSelect = function (index) {
              if (!this.isWrapping) return;

              const {
                selectedIndex,
                slideableWidth,
                slides: { length },
              } = this;
              // shift index for wrap, do not wrap dragSelect
              if (!this.isDragSelect) {
                let wrapIndex = utils.modulo(index, length);
                // go to shortest
                let delta = Math.abs(wrapIndex - selectedIndex);
                let backWrapDelta = Math.abs(
                  wrapIndex + length - selectedIndex
                );
                let forewardWrapDelta = Math.abs(
                  wrapIndex - length - selectedIndex
                );
                if (backWrapDelta < delta) {
                  index += length;
                } else if (forewardWrapDelta < delta) {
                  index -= length;
                }
              }

              // wrap position so slider is within normal area
              if (index < 0) {
                this.x -= slideableWidth;
              } else if (index >= length) {
                this.x += slideableWidth;
              }
            };

            proto.previous = function (isWrap, isInstant) {
              this.select(this.selectedIndex - 1, isWrap, isInstant);
            };

            proto.next = function (isWrap, isInstant) {
              this.select(this.selectedIndex + 1, isWrap, isInstant);
            };

            proto.updateSelectedSlide = function () {
              let slide = this.slides[this.selectedIndex];
              // selectedIndex could be outside of slides, if triggered before resize()
              if (!slide) return;

              // unselect previous selected slide
              this.unselectSelectedSlide();
              // update new selected slide
              this.selectedSlide = slide;
              slide.select();
              this.selectedCells = slide.cells;
              this.selectedElements = slide.getCellElements();
              // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
              this.selectedCell = slide.cells[0];
              this.selectedElement = this.selectedElements[0];
            };

            proto.unselectSelectedSlide = function () {
              if (this.selectedSlide) this.selectedSlide.unselect();
            };

            proto.selectInitialIndex = function () {
              let initialIndex = this.options.initialIndex;
              // already activated, select previous selectedIndex
              if (this.isInitActivated) {
                this.select(this.selectedIndex, false, true);
                return;
              }
              // select with selector string
              if (initialIndex && typeof initialIndex == "string") {
                let cell = this.queryCell(initialIndex);
                if (cell) {
                  this.selectCell(initialIndex, false, true);
                  return;
                }
              }

              let index = 0;
              // select with number
              if (initialIndex && this.slides[initialIndex]) {
                index = initialIndex;
              }
              // select instantly
              this.select(index, false, true);
            };

            /**
             * select slide from number or cell element
             * @param {[Element, Number]} value - zero-based index or element to select
             * @param {Boolean} isWrap - enables wrapping around for extra index
             * @param {Boolean} isInstant - disables slide animation
             */
            proto.selectCell = function (value, isWrap, isInstant) {
              // get cell
              let cell = this.queryCell(value);
              if (!cell) return;

              let index = this.getCellSlideIndex(cell);
              this.select(index, isWrap, isInstant);
            };

            proto.getCellSlideIndex = function (cell) {
              // get index of slide that has cell
              let cellSlide = this.slides.find((slide) =>
                slide.cells.includes(cell)
              );
              return this.slides.indexOf(cellSlide);
            };

            // -------------------------- get cells -------------------------- //

            /**
             * get Flickity.Cell, given an Element
             * @param {Element} elem - matching cell element
             * @returns {Flickity.Cell} cell - matching cell
             */
            proto.getCell = function (elem) {
              // loop through cells to get the one that matches
              for (let cell of this.cells) {
                if (cell.element === elem) return cell;
              }
            };

            /**
             * get collection of Flickity.Cells, given Elements
             * @param {[Element, Array, NodeList]} elems - multiple elements
             * @returns {Array} cells - Flickity.Cells
             */
            proto.getCells = function (elems) {
              elems = utils.makeArray(elems);
              return elems.map((elem) => this.getCell(elem)).filter(Boolean);
            };

            /**
             * get cell elements
             * @returns {Array} cellElems
             */
            proto.getCellElements = function () {
              return this.cells.map((cell) => cell.element);
            };

            /**
             * get parent cell from an element
             * @param {Element} elem - child element
             * @returns {Flickit.Cell} cell - parent cell
             */
            proto.getParentCell = function (elem) {
              // first check if elem is cell
              let cell = this.getCell(elem);
              if (cell) return cell;

              // try to get parent cell elem
              let closest = elem.closest(".flickity-slider > *");
              return this.getCell(closest);
            };

            /**
             * get cells adjacent to a slide
             * @param {Integer} adjCount - number of adjacent slides
             * @param {Integer} index - index of slide to start
             * @returns {Array} cells - array of Flickity.Cells
             */
            proto.getAdjacentCellElements = function (adjCount, index) {
              if (!adjCount) return this.selectedSlide.getCellElements();

              index = index === undefined ? this.selectedIndex : index;

              let len = this.slides.length;
              if (1 + adjCount * 2 >= len) {
                return this.getCellElements(); // get all
              }

              let cellElems = [];
              for (let i = index - adjCount; i <= index + adjCount; i++) {
                let slideIndex = this.isWrapping ? utils.modulo(i, len) : i;
                let slide = this.slides[slideIndex];
                if (slide) {
                  cellElems = cellElems.concat(slide.getCellElements());
                }
              }
              return cellElems;
            };

            /**
             * select slide from number or cell element
             * @param {[Element, String, Number]} selector - element, selector string, or index
             * @returns {Flickity.Cell} - matching cell
             */
            proto.queryCell = function (selector) {
              if (typeof selector == "number") {
                // use number as index
                return this.cells[selector];
              }
              // do not select invalid selectors from hash: #123, #/. #791
              let isSelectorString =
                typeof selector == "string" && !selector.match(/^[#.]?[\d/]/);
              if (isSelectorString) {
                // use string as selector, get element
                selector = this.element.querySelector(selector);
              }
              // get cell from element
              return this.getCell(selector);
            };

            // -------------------------- events -------------------------- //

            proto.uiChange = function () {
              this.emitEvent("uiChange");
            };

            // ----- resize ----- //

            proto.onresize = function () {
              this.watchCSS();
              this.resize();
            };

            utils.debounceMethod(Flickity, "onresize", 150);

            proto.resize = function () {
              // #1177 disable resize behavior when animating or dragging for iOS 15
              if (!this.isActive || this.isAnimating || this.isDragging) return;
              this.getSize();
              // wrap values
              if (this.isWrapping) {
                this.x = utils.modulo(this.x, this.slideableWidth);
              }
              this.positionCells();
              this._updateWrapShiftCells();
              this.setGallerySize();
              this.emitEvent("resize");
              // update selected index for group slides, instant
              // TODO: position can be lost between groups of various numbers
              let selectedElement =
                this.selectedElements && this.selectedElements[0];
              this.selectCell(selectedElement, false, true);
            };

            // watches the :after property, activates/deactivates
            proto.watchCSS = function () {
              if (!this.options.watchCSS) return;

              let afterContent = getComputedStyle(
                this.element,
                ":after"
              ).content;
              // activate if :after { content: 'flickity' }
              if (afterContent.includes("flickity")) {
                this.activate();
              } else {
                this.deactivate();
              }
            };

            // ----- keydown ----- //

            // go previous/next if left/right keys pressed
            proto.onkeydown = function (event) {
              let { activeElement } = document;
              let handler = Flickity.keyboardHandlers[event.key];
              // only work if element is in focus
              if (!this.options.accessibility || !activeElement || !handler)
                return;

              let isFocused = this.focusableElems.some(
                (elem) => activeElement === elem
              );
              if (isFocused) handler.call(this);
            };

            Flickity.keyboardHandlers = {
              ArrowLeft: function () {
                this.uiChange();
                let leftMethod = this.options.rightToLeft ? "next" : "previous";
                this[leftMethod]();
              },
              ArrowRight: function () {
                this.uiChange();
                let rightMethod = this.options.rightToLeft
                  ? "previous"
                  : "next";
                this[rightMethod]();
              },
            };

            // ----- focus ----- //

            proto.focus = function () {
              this.element.focus({ preventScroll: true });
            };

            // -------------------------- destroy -------------------------- //

            // deactivate all Flickity functionality, but keep stuff available
            proto.deactivate = function () {
              if (!this.isActive) return;

              this.element.classList.remove("flickity-enabled");
              this.element.classList.remove("flickity-rtl");
              this.unselectSelectedSlide();
              // destroy cells
              this.cells.forEach((cell) => cell.destroy());
              this.viewport.remove();
              // move child elements back into element
              this.element.append(...this.slider.children);
              if (this.options.accessibility) {
                this.element.removeAttribute("tabIndex");
                this.element.removeEventListener("keydown", this);
              }
              // set flags
              this.isActive = false;
              this.emitEvent("deactivate");
            };

            proto.destroy = function () {
              this.deactivate();
              window.removeEventListener("resize", this);
              this.allOff();
              this.emitEvent("destroy");
              if (jQuery && this.$element) {
                jQuery.removeData(this.element, "flickity");
              }
              delete this.element.flickityGUID;
              delete instances[this.guid];
            };

            // -------------------------- prototype -------------------------- //

            Object.assign(proto, animatePrototype);

            // -------------------------- extras -------------------------- //

            /**
             * get Flickity instance from element
             * @param {[Element, String]} elem - element or selector string
             * @returns {Flickity} - Flickity instance
             */
            Flickity.data = function (elem) {
              elem = utils.getQueryElement(elem);
              if (elem) return instances[elem.flickityGUID];
            };

            utils.htmlInit(Flickity, "flickity");

            let { jQueryBridget } = window;
            if (jQuery && jQueryBridget) {
              jQueryBridget("flickity", Flickity, jQuery);
            }

            // set internal jQuery, for Webpack + jQuery v3, #478
            Flickity.setJQuery = function (jq) {
              jQuery = jq;
            };

            Flickity.Cell = Cell;
            Flickity.Slide = Slide;

            return Flickity;
          }
        );

        /***/
      },

    /***/ "./node_modules/flickity/js/drag.js":
      /*!******************************************!*\
  !*** ./node_modules/flickity/js/drag.js ***!
  \******************************************/
      /***/ function (module, __unused_webpack_exports, __webpack_require__) {
        // drag
        (function (window, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS
            module.exports = factory(
              window,
              __webpack_require__(
                /*! ./core */ "./node_modules/flickity/js/core.js"
              ),
              __webpack_require__(
                /*! unidragger */ "./node_modules/unidragger/unidragger.js"
              ),
              __webpack_require__(
                /*! fizzy-ui-utils */ "./node_modules/fizzy-ui-utils/utils.js"
              )
            );
          } else {
            // browser global
            window.Flickity = factory(
              window,
              window.Flickity,
              window.Unidragger,
              window.fizzyUIUtils
            );
          }
        })(
          typeof window != "undefined" ? window : this,
          function factory(window, Flickity, Unidragger, utils) {
            // ----- defaults ----- //

            Object.assign(Flickity.defaults, {
              draggable: ">1",
              dragThreshold: 3,
            });

            // -------------------------- drag prototype -------------------------- //

            let proto = Flickity.prototype;
            Object.assign(proto, Unidragger.prototype); // inherit Unidragger
            proto.touchActionValue = "";

            // --------------------------  -------------------------- //

            Flickity.create.drag = function () {
              this.on("activate", this.onActivateDrag);
              this.on("uiChange", this._uiChangeDrag);
              this.on("deactivate", this.onDeactivateDrag);
              this.on("cellChange", this.updateDraggable);
              this.on("pointerDown", this.handlePointerDown);
              this.on("pointerUp", this.handlePointerUp);
              this.on("pointerDown", this.handlePointerDone);
              this.on("dragStart", this.handleDragStart);
              this.on("dragMove", this.handleDragMove);
              this.on("dragEnd", this.handleDragEnd);
              this.on("staticClick", this.handleStaticClick);
              // TODO updateDraggable on resize? if groupCells & slides change
            };

            proto.onActivateDrag = function () {
              this.handles = [this.viewport];
              this.bindHandles();
              this.updateDraggable();
            };

            proto.onDeactivateDrag = function () {
              this.unbindHandles();
              this.element.classList.remove("is-draggable");
            };

            proto.updateDraggable = function () {
              // disable dragging if less than 2 slides. #278
              if (this.options.draggable === ">1") {
                this.isDraggable = this.slides.length > 1;
              } else {
                this.isDraggable = this.options.draggable;
              }
              this.element.classList.toggle("is-draggable", this.isDraggable);
            };

            proto._uiChangeDrag = function () {
              delete this.isFreeScrolling;
            };

            // -------------------------- pointer events -------------------------- //

            proto.handlePointerDown = function (event) {
              if (!this.isDraggable) {
                // proceed for staticClick
                this.bindActivePointerEvents(event);
                return;
              }

              let isTouchStart = event.type === "touchstart";
              let isTouchPointer = event.pointerType === "touch";
              let isFocusNode = event.target.matches("input, textarea, select");
              if (!isTouchStart && !isTouchPointer && !isFocusNode)
                event.preventDefault();
              if (!isFocusNode) this.focus();
              // blur
              if (document.activeElement !== this.element)
                document.activeElement.blur();
              // stop if it was moving
              this.dragX = this.x;
              this.viewport.classList.add("is-pointer-down");
              // track scrolling
              this.pointerDownScroll = getScrollPosition();
              window.addEventListener("scroll", this);
              this.bindActivePointerEvents(event);
            };

            // ----- move ----- //

            proto.hasDragStarted = function (moveVector) {
              return Math.abs(moveVector.x) > this.options.dragThreshold;
            };

            // ----- up ----- //

            proto.handlePointerUp = function () {
              delete this.isTouchScrolling;
              this.viewport.classList.remove("is-pointer-down");
            };

            proto.handlePointerDone = function () {
              window.removeEventListener("scroll", this);
              delete this.pointerDownScroll;
            };

            // -------------------------- dragging -------------------------- //

            proto.handleDragStart = function () {
              if (!this.isDraggable) return;

              this.dragStartPosition = this.x;
              this.startAnimation();
              window.removeEventListener("scroll", this);
            };

            proto.handleDragMove = function (event, pointer, moveVector) {
              if (!this.isDraggable) return;

              event.preventDefault();

              this.previousDragX = this.dragX;
              // reverse if right-to-left
              let direction = this.options.rightToLeft ? -1 : 1;
              // wrap around move. #589
              if (this.isWrapping) moveVector.x %= this.slideableWidth;
              let dragX = this.dragStartPosition + moveVector.x * direction;

              if (!this.isWrapping) {
                // slow drag
                let originBound = Math.max(
                  -this.slides[0].target,
                  this.dragStartPosition
                );
                dragX =
                  dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
                let endBound = Math.min(
                  -this.getLastSlide().target,
                  this.dragStartPosition
                );
                dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
              }

              this.dragX = dragX;
              this.dragMoveTime = new Date();
            };

            proto.handleDragEnd = function () {
              if (!this.isDraggable) return;

              let { freeScroll } = this.options;
              if (freeScroll) this.isFreeScrolling = true;
              // set selectedIndex based on where flick will end up
              let index = this.dragEndRestingSelect();

              if (freeScroll && !this.isWrapping) {
                // if free-scroll & not wrap around
                // do not free-scroll if going outside of bounding slides
                // so bounding slides can attract slider, and keep it in bounds
                let restingX = this.getRestingPosition();
                this.isFreeScrolling =
                  -restingX > this.slides[0].target &&
                  -restingX < this.getLastSlide().target;
              } else if (!freeScroll && index === this.selectedIndex) {
                // boost selection if selected index has not changed
                index += this.dragEndBoostSelect();
              }
              delete this.previousDragX;
              // apply selection
              // HACK, set flag so dragging stays in correct direction
              this.isDragSelect = this.isWrapping;
              this.select(index);
              delete this.isDragSelect;
            };

            proto.dragEndRestingSelect = function () {
              let restingX = this.getRestingPosition();
              // how far away from selected slide
              let distance = Math.abs(
                this.getSlideDistance(-restingX, this.selectedIndex)
              );
              // get closet resting going up and going down
              let positiveResting = this._getClosestResting(
                restingX,
                distance,
                1
              );
              let negativeResting = this._getClosestResting(
                restingX,
                distance,
                -1
              );
              // use closer resting for wrap-around
              return positiveResting.distance < negativeResting.distance
                ? positiveResting.index
                : negativeResting.index;
            };

            /**
             * given resting X and distance to selected cell
             * get the distance and index of the closest cell
             * @param {Number} restingX - estimated post-flick resting position
             * @param {Number} distance - distance to selected cell
             * @param {Integer} increment - +1 or -1, going up or down
             * @returns {Object} - { distance: {Number}, index: {Integer} }
             */
            proto._getClosestResting = function (
              restingX,
              distance,
              increment
            ) {
              let index = this.selectedIndex;
              let minDistance = Infinity;
              let condition =
                this.options.contain && !this.isWrapping
                  ? // if containing, keep going if distance is equal to minDistance
                    (dist, minDist) => dist <= minDist
                  : (dist, minDist) => dist < minDist;

              while (condition(distance, minDistance)) {
                // measure distance to next cell
                index += increment;
                minDistance = distance;
                distance = this.getSlideDistance(-restingX, index);
                if (distance === null) break;

                distance = Math.abs(distance);
              }
              return {
                distance: minDistance,
                // selected was previous index
                index: index - increment,
              };
            };

            /**
             * measure distance between x and a slide target
             * @param {Number} x - horizontal position
             * @param {Integer} index - slide index
             * @returns {Number} - slide distance
             */
            proto.getSlideDistance = function (x, index) {
              let len = this.slides.length;
              // wrap around if at least 2 slides
              let isWrapAround = this.options.wrapAround && len > 1;
              let slideIndex = isWrapAround ? utils.modulo(index, len) : index;
              let slide = this.slides[slideIndex];
              if (!slide) return null;

              // add distance for wrap-around slides
              let wrap = isWrapAround
                ? this.slideableWidth * Math.floor(index / len)
                : 0;
              return x - (slide.target + wrap);
            };

            proto.dragEndBoostSelect = function () {
              // do not boost if no previousDragX or dragMoveTime
              if (
                this.previousDragX === undefined ||
                !this.dragMoveTime ||
                // or if drag was held for 100 ms
                new Date() - this.dragMoveTime > 100
              ) {
                return 0;
              }

              let distance = this.getSlideDistance(
                -this.dragX,
                this.selectedIndex
              );
              let delta = this.previousDragX - this.dragX;
              if (distance > 0 && delta > 0) {
                // boost to next if moving towards the right, and positive velocity
                return 1;
              } else if (distance < 0 && delta < 0) {
                // boost to previous if moving towards the left, and negative velocity
                return -1;
              }
              return 0;
            };

            // ----- scroll ----- //

            proto.onscroll = function () {
              let scroll = getScrollPosition();
              let scrollMoveX = this.pointerDownScroll.x - scroll.x;
              let scrollMoveY = this.pointerDownScroll.y - scroll.y;
              // cancel click/tap if scroll is too much
              if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) {
                this.pointerDone();
              }
            };

            // ----- utils ----- //

            function getScrollPosition() {
              return {
                x: window.pageXOffset,
                y: window.pageYOffset,
              };
            }

            // -----  ----- //

            return Flickity;
          }
        );

        /***/
      },

    /***/ "./node_modules/flickity/js/imagesloaded.js":
      /*!**************************************************!*\
  !*** ./node_modules/flickity/js/imagesloaded.js ***!
  \**************************************************/
      /***/ function (module, __unused_webpack_exports, __webpack_require__) {
        // imagesloaded
        (function (window, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS
            module.exports = factory(
              __webpack_require__(
                /*! ./core */ "./node_modules/flickity/js/core.js"
              ),
              __webpack_require__(
                /*! imagesloaded */ "./node_modules/imagesloaded/imagesloaded.js"
              )
            );
          } else {
            // browser global
            factory(window.Flickity, window.imagesLoaded);
          }
        })(
          typeof window != "undefined" ? window : this,
          function factory(Flickity, imagesLoaded) {
            Flickity.create.imagesLoaded = function () {
              this.on("activate", this.imagesLoaded);
            };

            Flickity.prototype.imagesLoaded = function () {
              if (!this.options.imagesLoaded) return;

              let onImagesLoadedProgress = (instance, image) => {
                let cell = this.getParentCell(image.img);
                this.cellSizeChange(cell && cell.element);
                if (!this.options.freeScroll) this.positionSliderAtSelected();
              };
              imagesLoaded(this.slider).on("progress", onImagesLoadedProgress);
            };

            return Flickity;
          }
        );

        /***/
      },

    /***/ "./node_modules/flickity/js/index.js":
      /*!*******************************************!*\
  !*** ./node_modules/flickity/js/index.js ***!
  \*******************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        /*!
         * Flickity v3.0.0
         * Touch, responsive, flickable carousels
         *
         * Licensed GPLv3 for open source use
         * or Flickity Commercial License for commercial use
         *
         * https://flickity.metafizzy.co
         * Copyright 2015-2022 Metafizzy
         */

        if (true && module.exports) {
          const Flickity = __webpack_require__(
            /*! ./core */ "./node_modules/flickity/js/core.js"
          );
          __webpack_require__(
            /*! ./drag */ "./node_modules/flickity/js/drag.js"
          );
          __webpack_require__(
            /*! ./prev-next-button */ "./node_modules/flickity/js/prev-next-button.js"
          );
          __webpack_require__(
            /*! ./page-dots */ "./node_modules/flickity/js/page-dots.js"
          );
          __webpack_require__(
            /*! ./player */ "./node_modules/flickity/js/player.js"
          );
          __webpack_require__(
            /*! ./add-remove-cell */ "./node_modules/flickity/js/add-remove-cell.js"
          );
          __webpack_require__(
            /*! ./lazyload */ "./node_modules/flickity/js/lazyload.js"
          );
          __webpack_require__(
            /*! ./imagesloaded */ "./node_modules/flickity/js/imagesloaded.js"
          );

          module.exports = Flickity;
        }

        /***/
      },

    /***/ "./node_modules/flickity/js/lazyload.js":
      /*!**********************************************!*\
  !*** ./node_modules/flickity/js/lazyload.js ***!
  \**********************************************/
      /***/ function (module, __unused_webpack_exports, __webpack_require__) {
        // lazyload
        (function (window, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS
            module.exports = factory(
              __webpack_require__(
                /*! ./core */ "./node_modules/flickity/js/core.js"
              ),
              __webpack_require__(
                /*! fizzy-ui-utils */ "./node_modules/fizzy-ui-utils/utils.js"
              )
            );
          } else {
            // browser global
            factory(window.Flickity, window.fizzyUIUtils);
          }
        })(
          typeof window != "undefined" ? window : this,
          function factory(Flickity, utils) {
            const lazyAttr = "data-flickity-lazyload";
            const lazySrcAttr = `${lazyAttr}-src`;
            const lazySrcsetAttr = `${lazyAttr}-srcset`;
            const imgSelector =
              `img[${lazyAttr}], img[${lazySrcAttr}], ` +
              `img[${lazySrcsetAttr}], source[${lazySrcsetAttr}]`;

            Flickity.create.lazyLoad = function () {
              this.on("select", this.lazyLoad);

              this.handleLazyLoadComplete = this.onLazyLoadComplete.bind(this);
            };

            let proto = Flickity.prototype;

            proto.lazyLoad = function () {
              let { lazyLoad } = this.options;
              if (!lazyLoad) return;

              // get adjacent cells, use lazyLoad option for adjacent count
              let adjCount = typeof lazyLoad == "number" ? lazyLoad : 0;
              // lazy load images
              this.getAdjacentCellElements(adjCount)
                .map(getCellLazyImages)
                .flat()
                .forEach(
                  (img) => new LazyLoader(img, this.handleLazyLoadComplete)
                );
            };

            function getCellLazyImages(cellElem) {
              // check if cell element is lazy image
              if (cellElem.matches("img")) {
                let cellAttr = cellElem.getAttribute(lazyAttr);
                let cellSrcAttr = cellElem.getAttribute(lazySrcAttr);
                let cellSrcsetAttr = cellElem.getAttribute(lazySrcsetAttr);
                if (cellAttr || cellSrcAttr || cellSrcsetAttr) {
                  return cellElem;
                }
              }
              // select lazy images in cell
              return [...cellElem.querySelectorAll(imgSelector)];
            }

            proto.onLazyLoadComplete = function (img, event) {
              let cell = this.getParentCell(img);
              let cellElem = cell && cell.element;
              this.cellSizeChange(cellElem);

              this.dispatchEvent("lazyLoad", event, cellElem);
            };

            // -------------------------- LazyLoader -------------------------- //

            /**
             * class to handle loading images
             * @param {Image} img - Image element
             * @param {Function} onComplete - callback function
             */
            function LazyLoader(img, onComplete) {
              this.img = img;
              this.onComplete = onComplete;
              this.load();
            }

            LazyLoader.prototype.handleEvent = utils.handleEvent;

            LazyLoader.prototype.load = function () {
              this.img.addEventListener("load", this);
              this.img.addEventListener("error", this);
              // get src & srcset
              let src =
                this.img.getAttribute(lazyAttr) ||
                this.img.getAttribute(lazySrcAttr);
              let srcset = this.img.getAttribute(lazySrcsetAttr);
              // set src & serset
              this.img.src = src;
              if (srcset) this.img.setAttribute("srcset", srcset);
              // remove attr
              this.img.removeAttribute(lazyAttr);
              this.img.removeAttribute(lazySrcAttr);
              this.img.removeAttribute(lazySrcsetAttr);
            };

            LazyLoader.prototype.onload = function (event) {
              this.complete(event, "flickity-lazyloaded");
            };

            LazyLoader.prototype.onerror = function (event) {
              this.complete(event, "flickity-lazyerror");
            };

            LazyLoader.prototype.complete = function (event, className) {
              // unbind events
              this.img.removeEventListener("load", this);
              this.img.removeEventListener("error", this);
              let mediaElem = this.img.parentNode.matches("picture")
                ? this.img.parentNode
                : this.img;
              mediaElem.classList.add(className);

              this.onComplete(this.img, event);
            };

            // -----  ----- //

            Flickity.LazyLoader = LazyLoader;

            return Flickity;
          }
        );

        /***/
      },

    /***/ "./node_modules/flickity/js/page-dots.js":
      /*!***********************************************!*\
  !*** ./node_modules/flickity/js/page-dots.js ***!
  \***********************************************/
      /***/ function (module, __unused_webpack_exports, __webpack_require__) {
        // page dots
        (function (window, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS
            module.exports = factory(
              __webpack_require__(
                /*! ./core */ "./node_modules/flickity/js/core.js"
              ),
              __webpack_require__(
                /*! fizzy-ui-utils */ "./node_modules/fizzy-ui-utils/utils.js"
              )
            );
          } else {
            // browser global
            factory(window.Flickity, window.fizzyUIUtils);
          }
        })(
          typeof window != "undefined" ? window : this,
          function factory(Flickity, utils) {
            // -------------------------- PageDots -------------------------- //

            function PageDots() {
              // create holder element
              this.holder = document.createElement("div");
              this.holder.className = "flickity-page-dots";
              // create dots, array of elements
              this.dots = [];
            }

            PageDots.prototype.setDots = function (slidesLength) {
              // get difference between number of slides and number of dots
              let delta = slidesLength - this.dots.length;
              if (delta > 0) {
                this.addDots(delta);
              } else if (delta < 0) {
                this.removeDots(-delta);
              }
            };

            PageDots.prototype.addDots = function (count) {
              let newDots = new Array(count).fill().map((item, i) => {
                let dot = document.createElement("button");
                dot.setAttribute("type", "button");
                let num = i + 1 + this.dots.length;
                dot.className = "flickity-page-dot";
                dot.textContent = `View slide ${num}`;
                return dot;
              });

              this.holder.append(...newDots);
              this.dots = this.dots.concat(newDots);
            };

            PageDots.prototype.removeDots = function (count) {
              // remove from this.dots collection
              let removeDots = this.dots.splice(
                this.dots.length - count,
                count
              );
              // remove from DOM
              removeDots.forEach((dot) => dot.remove());
            };

            PageDots.prototype.updateSelected = function (index) {
              // remove selected class on previous
              if (this.selectedDot) {
                this.selectedDot.classList.remove("is-selected");
                this.selectedDot.removeAttribute("aria-current");
              }
              // don't proceed if no dots
              if (!this.dots.length) return;

              this.selectedDot = this.dots[index];
              this.selectedDot.classList.add("is-selected");
              this.selectedDot.setAttribute("aria-current", "step");
            };

            Flickity.PageDots = PageDots;

            // -------------------------- Flickity -------------------------- //

            Object.assign(Flickity.defaults, {
              pageDots: true,
            });

            Flickity.create.pageDots = function () {
              if (!this.options.pageDots) return;

              this.pageDots = new PageDots();
              this.handlePageDotsClick = this.onPageDotsClick.bind(this);
              // events
              this.on("activate", this.activatePageDots);
              this.on("select", this.updateSelectedPageDots);
              this.on("cellChange", this.updatePageDots);
              this.on("resize", this.updatePageDots);
              this.on("deactivate", this.deactivatePageDots);
            };

            let proto = Flickity.prototype;

            proto.activatePageDots = function () {
              this.pageDots.setDots(this.slides.length);
              this.focusableElems.push(...this.pageDots.dots);
              this.pageDots.holder.addEventListener(
                "click",
                this.handlePageDotsClick
              );
              this.element.append(this.pageDots.holder);
            };

            proto.onPageDotsClick = function (event) {
              let index = this.pageDots.dots.indexOf(event.target);
              if (index === -1) return; // only dot clicks

              this.uiChange();
              this.select(index);
            };

            proto.updateSelectedPageDots = function () {
              this.pageDots.updateSelected(this.selectedIndex);
            };

            proto.updatePageDots = function () {
              this.pageDots.dots.forEach((dot) => {
                utils.removeFrom(this.focusableElems, dot);
              });
              this.pageDots.setDots(this.slides.length);
              this.focusableElems.push(...this.pageDots.dots);
            };

            proto.deactivatePageDots = function () {
              this.pageDots.holder.remove();
              this.pageDots.holder.removeEventListener(
                "click",
                this.handlePageDotsClick
              );
            };

            // -----  ----- //

            Flickity.PageDots = PageDots;

            return Flickity;
          }
        );

        /***/
      },

    /***/ "./node_modules/flickity/js/player.js":
      /*!********************************************!*\
  !*** ./node_modules/flickity/js/player.js ***!
  \********************************************/
      /***/ function (module, __unused_webpack_exports, __webpack_require__) {
        // player & autoPlay
        (function (window, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS
            module.exports = factory(
              __webpack_require__(
                /*! ./core */ "./node_modules/flickity/js/core.js"
              )
            );
          } else {
            // browser global
            factory(window.Flickity);
          }
        })(
          typeof window != "undefined" ? window : this,
          function factory(Flickity) {
            // -------------------------- Player -------------------------- //

            function Player(autoPlay, onTick) {
              this.autoPlay = autoPlay;
              this.onTick = onTick;
              this.state = "stopped";
              // visibility change event handler
              this.onVisibilityChange = this.visibilityChange.bind(this);
              this.onVisibilityPlay = this.visibilityPlay.bind(this);
            }

            // start play
            Player.prototype.play = function () {
              if (this.state === "playing") return;

              // do not play if page is hidden, start playing when page is visible
              let isPageHidden = document.hidden;
              if (isPageHidden) {
                document.addEventListener(
                  "visibilitychange",
                  this.onVisibilityPlay
                );
                return;
              }

              this.state = "playing";
              // listen to visibility change
              document.addEventListener(
                "visibilitychange",
                this.onVisibilityChange
              );
              // start ticking
              this.tick();
            };

            Player.prototype.tick = function () {
              // do not tick if not playing
              if (this.state !== "playing") return;

              // default to 3 seconds
              let time =
                typeof this.autoPlay == "number" ? this.autoPlay : 3000;
              // HACK: reset ticks if stopped and started within interval
              this.clear();
              this.timeout = setTimeout(() => {
                this.onTick();
                this.tick();
              }, time);
            };

            Player.prototype.stop = function () {
              this.state = "stopped";
              this.clear();
              // remove visibility change event
              document.removeEventListener(
                "visibilitychange",
                this.onVisibilityChange
              );
            };

            Player.prototype.clear = function () {
              clearTimeout(this.timeout);
            };

            Player.prototype.pause = function () {
              if (this.state === "playing") {
                this.state = "paused";
                this.clear();
              }
            };

            Player.prototype.unpause = function () {
              // re-start play if paused
              if (this.state === "paused") this.play();
            };

            // pause if page visibility is hidden, unpause if visible
            Player.prototype.visibilityChange = function () {
              let isPageHidden = document.hidden;
              this[isPageHidden ? "pause" : "unpause"]();
            };

            Player.prototype.visibilityPlay = function () {
              this.play();
              document.removeEventListener(
                "visibilitychange",
                this.onVisibilityPlay
              );
            };

            // -------------------------- Flickity -------------------------- //

            Object.assign(Flickity.defaults, {
              pauseAutoPlayOnHover: true,
            });

            Flickity.create.player = function () {
              this.player = new Player(this.options.autoPlay, () => {
                this.next(true);
              });

              this.on("activate", this.activatePlayer);
              this.on("uiChange", this.stopPlayer);
              this.on("pointerDown", this.stopPlayer);
              this.on("deactivate", this.deactivatePlayer);
            };

            let proto = Flickity.prototype;

            proto.activatePlayer = function () {
              if (!this.options.autoPlay) return;

              this.player.play();
              this.element.addEventListener("mouseenter", this);
            };

            // Player API, don't hate the ... thanks I know where the door is

            proto.playPlayer = function () {
              this.player.play();
            };

            proto.stopPlayer = function () {
              this.player.stop();
            };

            proto.pausePlayer = function () {
              this.player.pause();
            };

            proto.unpausePlayer = function () {
              this.player.unpause();
            };

            proto.deactivatePlayer = function () {
              this.player.stop();
              this.element.removeEventListener("mouseenter", this);
            };

            // ----- mouseenter/leave ----- //

            // pause auto-play on hover
            proto.onmouseenter = function () {
              if (!this.options.pauseAutoPlayOnHover) return;

              this.player.pause();
              this.element.addEventListener("mouseleave", this);
            };

            // resume auto-play on hover off
            proto.onmouseleave = function () {
              this.player.unpause();
              this.element.removeEventListener("mouseleave", this);
            };

            // -----  ----- //

            Flickity.Player = Player;

            return Flickity;
          }
        );

        /***/
      },

    /***/ "./node_modules/flickity/js/prev-next-button.js":
      /*!******************************************************!*\
  !*** ./node_modules/flickity/js/prev-next-button.js ***!
  \******************************************************/
      /***/ function (module, __unused_webpack_exports, __webpack_require__) {
        // prev/next buttons
        (function (window, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS
            module.exports = factory(
              __webpack_require__(
                /*! ./core */ "./node_modules/flickity/js/core.js"
              )
            );
          } else {
            // browser global
            factory(window.Flickity);
          }
        })(
          typeof window != "undefined" ? window : this,
          function factory(Flickity) {
            const svgURI = "http://www.w3.org/2000/svg";

            // -------------------------- PrevNextButton -------------------------- //

            function PrevNextButton(increment, direction, arrowShape) {
              this.increment = increment;
              this.direction = direction;
              this.isPrevious = increment === "previous";
              this.isLeft = direction === "left";
              this._create(arrowShape);
            }

            PrevNextButton.prototype._create = function (arrowShape) {
              // properties
              let element = (this.element = document.createElement("button"));
              element.className = `flickity-button flickity-prev-next-button ${this.increment}`;
              let label = this.isPrevious ? "Previous" : "Next";
              // prevent button from submitting form https://stackoverflow.com/a/10836076/182183
              element.setAttribute("type", "button");
              element.setAttribute("aria-label", label);
              // init as disabled
              this.disable();
              // create arrow
              let svg = this.createSVG(label, arrowShape);
              element.append(svg);
            };

            PrevNextButton.prototype.createSVG = function (label, arrowShape) {
              let svg = document.createElementNS(svgURI, "svg");
              svg.setAttribute("class", "flickity-button-icon");
              svg.setAttribute("viewBox", "0 0 100 100");
              // add title #1189
              let title = document.createElementNS(svgURI, "title");
              title.append(label);
              // add path
              let path = document.createElementNS(svgURI, "path");
              let pathMovements = getArrowMovements(arrowShape);
              path.setAttribute("d", pathMovements);
              path.setAttribute("class", "arrow");
              // rotate arrow
              if (!this.isLeft) {
                path.setAttribute(
                  "transform",
                  "translate(100, 100) rotate(180)"
                );
              }
              svg.append(title, path);
              return svg;
            };

            // get SVG path movmement
            function getArrowMovements(shape) {
              // use shape as movement if string
              if (typeof shape == "string") return shape;

              let { x0, x1, x2, x3, y1, y2 } = shape;

              // create movement string
              return `M ${x0}, 50
    L ${x1}, ${y1 + 50}
    L ${x2}, ${y2 + 50}
    L ${x3}, 50
    L ${x2}, ${50 - y2}
    L ${x1}, ${50 - y1}
    Z`;
            }

            // -----  ----- //

            PrevNextButton.prototype.enable = function () {
              this.element.removeAttribute("disabled");
            };

            PrevNextButton.prototype.disable = function () {
              this.element.setAttribute("disabled", true);
            };

            // -------------------------- Flickity prototype -------------------------- //

            Object.assign(Flickity.defaults, {
              prevNextButtons: true,
              arrowShape: {
                x0: 10,
                x1: 60,
                y1: 50,
                x2: 70,
                y2: 40,
                x3: 30,
              },
            });

            Flickity.create.prevNextButtons = function () {
              if (!this.options.prevNextButtons) return;

              let { rightToLeft, arrowShape } = this.options;
              let prevDirection = rightToLeft ? "right" : "left";
              let nextDirection = rightToLeft ? "left" : "right";
              this.prevButton = new PrevNextButton(
                "previous",
                prevDirection,
                arrowShape
              );
              this.nextButton = new PrevNextButton(
                "next",
                nextDirection,
                arrowShape
              );
              this.focusableElems.push(this.prevButton.element);
              this.focusableElems.push(this.nextButton.element);

              this.handlePrevButtonClick = () => {
                this.uiChange();
                this.previous();
              };

              this.handleNextButtonClick = () => {
                this.uiChange();
                this.next();
              };

              this.on("activate", this.activatePrevNextButtons);
              this.on("select", this.updatePrevNextButtons);
            };

            let proto = Flickity.prototype;

            proto.updatePrevNextButtons = function () {
              let lastIndex = this.slides.length ? this.slides.length - 1 : 0;
              this.updatePrevNextButton(this.prevButton, 0);
              this.updatePrevNextButton(this.nextButton, lastIndex);
            };

            proto.updatePrevNextButton = function (button, disabledIndex) {
              // enable is wrapAround and at least 2 slides
              if (this.isWrapping && this.slides.length > 1) {
                button.enable();
                return;
              }

              let isEnabled = this.selectedIndex !== disabledIndex;
              button[isEnabled ? "enable" : "disable"]();
              // if disabling button that is focused,
              // shift focus to element to maintain keyboard accessibility
              let isDisabledFocused =
                !isEnabled && document.activeElement === button.element;
              if (isDisabledFocused) this.focus();
            };

            proto.activatePrevNextButtons = function () {
              this.prevButton.element.addEventListener(
                "click",
                this.handlePrevButtonClick
              );
              this.nextButton.element.addEventListener(
                "click",
                this.handleNextButtonClick
              );
              this.element.append(
                this.prevButton.element,
                this.nextButton.element
              );
              this.on("deactivate", this.deactivatePrevNextButtons);
            };

            proto.deactivatePrevNextButtons = function () {
              this.prevButton.element.remove();
              this.nextButton.element.remove();
              this.prevButton.element.removeEventListener(
                "click",
                this.handlePrevButtonClick
              );
              this.nextButton.element.removeEventListener(
                "click",
                this.handleNextButtonClick
              );
              this.off("deactivate", this.deactivatePrevNextButtons);
            };

            // --------------------------  -------------------------- //

            Flickity.PrevNextButton = PrevNextButton;

            return Flickity;
          }
        );

        /***/
      },

    /***/ "./node_modules/flickity/js/slide.js":
      /*!*******************************************!*\
  !*** ./node_modules/flickity/js/slide.js ***!
  \*******************************************/
      /***/ function (module) {
        // slide
        (function (window, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS
            module.exports = factory();
          } else {
            // browser global
            window.Flickity = window.Flickity || {};
            window.Flickity.Slide = factory();
          }
        })(typeof window != "undefined" ? window : this, function factory() {
          function Slide(beginMargin, endMargin, cellAlign) {
            this.beginMargin = beginMargin;
            this.endMargin = endMargin;
            this.cellAlign = cellAlign;
            this.cells = [];
            this.outerWidth = 0;
            this.height = 0;
          }

          let proto = Slide.prototype;

          proto.addCell = function (cell) {
            this.cells.push(cell);
            this.outerWidth += cell.size.outerWidth;
            this.height = Math.max(cell.size.outerHeight, this.height);
            // first cell stuff
            if (this.cells.length === 1) {
              this.x = cell.x; // x comes from first cell
              this.firstMargin = cell.size[this.beginMargin];
            }
          };

          proto.updateTarget = function () {
            let lastCell = this.getLastCell();
            let lastMargin = lastCell ? lastCell.size[this.endMargin] : 0;
            let slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
            this.target =
              this.x + this.firstMargin + slideWidth * this.cellAlign;
          };

          proto.getLastCell = function () {
            return this.cells[this.cells.length - 1];
          };

          proto.select = function () {
            this.cells.forEach((cell) => cell.select());
          };

          proto.unselect = function () {
            this.cells.forEach((cell) => cell.unselect());
          };

          proto.getCellElements = function () {
            return this.cells.map((cell) => cell.element);
          };

          return Slide;
        });

        /***/
      },

    /***/ "./node_modules/get-size/get-size.js":
      /*!*******************************************!*\
  !*** ./node_modules/get-size/get-size.js ***!
  \*******************************************/
      /***/ (module) => {
        /*!
         * Infinite Scroll v2.0.4
         * measure size of elements
         * MIT license
         */

        (function (window, factory) {
          if (true && module.exports) {
            // CommonJS
            module.exports = factory();
          } else {
            // browser global
            window.getSize = factory();
          }
        })(window, function factory() {
          // -------------------------- helpers -------------------------- //

          // get a number from a string, not a percentage
          function getStyleSize(value) {
            let num = parseFloat(value);
            // not a percent like '100%', and a number
            let isValid = value.indexOf("%") == -1 && !isNaN(num);
            return isValid && num;
          }

          // -------------------------- measurements -------------------------- //

          let measurements = [
            "paddingLeft",
            "paddingRight",
            "paddingTop",
            "paddingBottom",
            "marginLeft",
            "marginRight",
            "marginTop",
            "marginBottom",
            "borderLeftWidth",
            "borderRightWidth",
            "borderTopWidth",
            "borderBottomWidth",
          ];

          let measurementsLength = measurements.length;

          function getZeroSize() {
            let size = {
              width: 0,
              height: 0,
              innerWidth: 0,
              innerHeight: 0,
              outerWidth: 0,
              outerHeight: 0,
            };
            measurements.forEach((measurement) => {
              size[measurement] = 0;
            });
            return size;
          }

          // -------------------------- getSize -------------------------- //

          function getSize(elem) {
            // use querySeletor if elem is string
            if (typeof elem == "string") elem = document.querySelector(elem);

            // do not proceed on non-objects
            let isElement = elem && typeof elem == "object" && elem.nodeType;
            if (!isElement) return;

            let style = getComputedStyle(elem);

            // if hidden, everything is 0
            if (style.display == "none") return getZeroSize();

            let size = {};
            size.width = elem.offsetWidth;
            size.height = elem.offsetHeight;

            let isBorderBox = (size.isBorderBox =
              style.boxSizing == "border-box");

            // get all measurements
            measurements.forEach((measurement) => {
              let value = style[measurement];
              let num = parseFloat(value);
              // any 'auto', 'medium' value will be 0
              size[measurement] = !isNaN(num) ? num : 0;
            });

            let paddingWidth = size.paddingLeft + size.paddingRight;
            let paddingHeight = size.paddingTop + size.paddingBottom;
            let marginWidth = size.marginLeft + size.marginRight;
            let marginHeight = size.marginTop + size.marginBottom;
            let borderWidth = size.borderLeftWidth + size.borderRightWidth;
            let borderHeight = size.borderTopWidth + size.borderBottomWidth;

            // overwrite width and height if we can get it from style
            let styleWidth = getStyleSize(style.width);
            if (styleWidth !== false) {
              size.width =
                styleWidth +
                // add padding and border unless it's already including it
                (isBorderBox ? 0 : paddingWidth + borderWidth);
            }

            let styleHeight = getStyleSize(style.height);
            if (styleHeight !== false) {
              size.height =
                styleHeight +
                // add padding and border unless it's already including it
                (isBorderBox ? 0 : paddingHeight + borderHeight);
            }

            size.innerWidth = size.width - (paddingWidth + borderWidth);
            size.innerHeight = size.height - (paddingHeight + borderHeight);

            size.outerWidth = size.width + marginWidth;
            size.outerHeight = size.height + marginHeight;

            return size;
          }

          return getSize;
        });

        /***/
      },

    /***/ "./node_modules/imagesloaded/imagesloaded.js":
      /*!***************************************************!*\
  !*** ./node_modules/imagesloaded/imagesloaded.js ***!
  \***************************************************/
      /***/ function (module, __unused_webpack_exports, __webpack_require__) {
        /*!
         * imagesLoaded v5.0.0
         * JavaScript is all like "You images are done yet or what?"
         * MIT License
         */

        (function (window, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS
            module.exports = factory(
              window,
              __webpack_require__(
                /*! ev-emitter */ "./node_modules/ev-emitter/ev-emitter.js"
              )
            );
          } else {
            // browser global
            window.imagesLoaded = factory(window, window.EvEmitter);
          }
        })(
          typeof window !== "undefined" ? window : this,
          function factory(window, EvEmitter) {
            let $ = window.jQuery;
            let console = window.console;

            // -------------------------- helpers -------------------------- //

            // turn element or nodeList into an array
            function makeArray(obj) {
              // use object if already an array
              if (Array.isArray(obj)) return obj;

              let isArrayLike =
                typeof obj == "object" && typeof obj.length == "number";
              // convert nodeList to array
              if (isArrayLike) return [...obj];

              // array of single index
              return [obj];
            }

            // -------------------------- imagesLoaded -------------------------- //

            /**
             * @param {[Array, Element, NodeList, String]} elem
             * @param {[Object, Function]} options - if function, use as callback
             * @param {Function} onAlways - callback function
             * @returns {ImagesLoaded}
             */
            function ImagesLoaded(elem, options, onAlways) {
              // coerce ImagesLoaded() without new, to be new ImagesLoaded()
              if (!(this instanceof ImagesLoaded)) {
                return new ImagesLoaded(elem, options, onAlways);
              }
              // use elem as selector string
              let queryElem = elem;
              if (typeof elem == "string") {
                queryElem = document.querySelectorAll(elem);
              }
              // bail if bad element
              if (!queryElem) {
                console.error(
                  `Bad element for imagesLoaded ${queryElem || elem}`
                );
                return;
              }

              this.elements = makeArray(queryElem);
              this.options = {};
              // shift arguments if no options set
              if (typeof options == "function") {
                onAlways = options;
              } else {
                Object.assign(this.options, options);
              }

              if (onAlways) this.on("always", onAlways);

              this.getImages();
              // add jQuery Deferred object
              if ($) this.jqDeferred = new $.Deferred();

              // HACK check async to allow time to bind listeners
              setTimeout(this.check.bind(this));
            }

            ImagesLoaded.prototype = Object.create(EvEmitter.prototype);

            ImagesLoaded.prototype.getImages = function () {
              this.images = [];

              // filter & find items if we have an item selector
              this.elements.forEach(this.addElementImages, this);
            };

            const elementNodeTypes = [1, 9, 11];

            /**
             * @param {Node} elem
             */
            ImagesLoaded.prototype.addElementImages = function (elem) {
              // filter siblings
              if (elem.nodeName === "IMG") {
                this.addImage(elem);
              }
              // get background image on element
              if (this.options.background === true) {
                this.addElementBackgroundImages(elem);
              }

              // find children
              // no non-element nodes, #143
              let { nodeType } = elem;
              if (!nodeType || !elementNodeTypes.includes(nodeType)) return;

              let childImgs = elem.querySelectorAll("img");
              // concat childElems to filterFound array
              for (let img of childImgs) {
                this.addImage(img);
              }

              // get child background images
              if (typeof this.options.background == "string") {
                let children = elem.querySelectorAll(this.options.background);
                for (let child of children) {
                  this.addElementBackgroundImages(child);
                }
              }
            };

            const reURL = /url\((['"])?(.*?)\1\)/gi;

            ImagesLoaded.prototype.addElementBackgroundImages = function (
              elem
            ) {
              let style = getComputedStyle(elem);
              // Firefox returns null if in a hidden iframe https://bugzil.la/548397
              if (!style) return;

              // get url inside url("...")
              let matches = reURL.exec(style.backgroundImage);
              while (matches !== null) {
                let url = matches && matches[2];
                if (url) {
                  this.addBackground(url, elem);
                }
                matches = reURL.exec(style.backgroundImage);
              }
            };

            /**
             * @param {Image} img
             */
            ImagesLoaded.prototype.addImage = function (img) {
              let loadingImage = new LoadingImage(img);
              this.images.push(loadingImage);
            };

            ImagesLoaded.prototype.addBackground = function (url, elem) {
              let background = new Background(url, elem);
              this.images.push(background);
            };

            ImagesLoaded.prototype.check = function () {
              this.progressedCount = 0;
              this.hasAnyBroken = false;
              // complete if no images
              if (!this.images.length) {
                this.complete();
                return;
              }

              /* eslint-disable-next-line func-style */
              let onProgress = (image, elem, message) => {
                // HACK - Chrome triggers event before object properties have changed. #83
                setTimeout(() => {
                  this.progress(image, elem, message);
                });
              };

              this.images.forEach(function (loadingImage) {
                loadingImage.once("progress", onProgress);
                loadingImage.check();
              });
            };

            ImagesLoaded.prototype.progress = function (image, elem, message) {
              this.progressedCount++;
              this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
              // progress event
              this.emitEvent("progress", [this, image, elem]);
              if (this.jqDeferred && this.jqDeferred.notify) {
                this.jqDeferred.notify(this, image);
              }
              // check if completed
              if (this.progressedCount === this.images.length) {
                this.complete();
              }

              if (this.options.debug && console) {
                console.log(`progress: ${message}`, image, elem);
              }
            };

            ImagesLoaded.prototype.complete = function () {
              let eventName = this.hasAnyBroken ? "fail" : "done";
              this.isComplete = true;
              this.emitEvent(eventName, [this]);
              this.emitEvent("always", [this]);
              if (this.jqDeferred) {
                let jqMethod = this.hasAnyBroken ? "reject" : "resolve";
                this.jqDeferred[jqMethod](this);
              }
            };

            // --------------------------  -------------------------- //

            function LoadingImage(img) {
              this.img = img;
            }

            LoadingImage.prototype = Object.create(EvEmitter.prototype);

            LoadingImage.prototype.check = function () {
              // If complete is true and browser supports natural sizes,
              // try to check for image status manually.
              let isComplete = this.getIsImageComplete();
              if (isComplete) {
                // report based on naturalWidth
                this.confirm(this.img.naturalWidth !== 0, "naturalWidth");
                return;
              }

              // If none of the checks above matched, simulate loading on detached element.
              this.proxyImage = new Image();
              // add crossOrigin attribute. #204
              if (this.img.crossOrigin) {
                this.proxyImage.crossOrigin = this.img.crossOrigin;
              }
              this.proxyImage.addEventListener("load", this);
              this.proxyImage.addEventListener("error", this);
              // bind to image as well for Firefox. #191
              this.img.addEventListener("load", this);
              this.img.addEventListener("error", this);
              this.proxyImage.src = this.img.currentSrc || this.img.src;
            };

            LoadingImage.prototype.getIsImageComplete = function () {
              // check for non-zero, non-undefined naturalWidth
              // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
              return this.img.complete && this.img.naturalWidth;
            };

            LoadingImage.prototype.confirm = function (isLoaded, message) {
              this.isLoaded = isLoaded;
              let { parentNode } = this.img;
              // emit progress with parent <picture> or self <img>
              let elem =
                parentNode.nodeName === "PICTURE" ? parentNode : this.img;
              this.emitEvent("progress", [this, elem, message]);
            };

            // ----- events ----- //

            // trigger specified handler for event type
            LoadingImage.prototype.handleEvent = function (event) {
              let method = "on" + event.type;
              if (this[method]) {
                this[method](event);
              }
            };

            LoadingImage.prototype.onload = function () {
              this.confirm(true, "onload");
              this.unbindEvents();
            };

            LoadingImage.prototype.onerror = function () {
              this.confirm(false, "onerror");
              this.unbindEvents();
            };

            LoadingImage.prototype.unbindEvents = function () {
              this.proxyImage.removeEventListener("load", this);
              this.proxyImage.removeEventListener("error", this);
              this.img.removeEventListener("load", this);
              this.img.removeEventListener("error", this);
            };

            // -------------------------- Background -------------------------- //

            function Background(url, element) {
              this.url = url;
              this.element = element;
              this.img = new Image();
            }

            // inherit LoadingImage prototype
            Background.prototype = Object.create(LoadingImage.prototype);

            Background.prototype.check = function () {
              this.img.addEventListener("load", this);
              this.img.addEventListener("error", this);
              this.img.src = this.url;
              // check if image is already complete
              let isComplete = this.getIsImageComplete();
              if (isComplete) {
                this.confirm(this.img.naturalWidth !== 0, "naturalWidth");
                this.unbindEvents();
              }
            };

            Background.prototype.unbindEvents = function () {
              this.img.removeEventListener("load", this);
              this.img.removeEventListener("error", this);
            };

            Background.prototype.confirm = function (isLoaded, message) {
              this.isLoaded = isLoaded;
              this.emitEvent("progress", [this, this.element, message]);
            };

            // -------------------------- jQuery -------------------------- //

            ImagesLoaded.makeJQueryPlugin = function (jQuery) {
              jQuery = jQuery || window.jQuery;
              if (!jQuery) return;

              // set local variable
              $ = jQuery;
              // $().imagesLoaded()
              $.fn.imagesLoaded = function (options, onAlways) {
                let instance = new ImagesLoaded(this, options, onAlways);
                return instance.jqDeferred.promise($(this));
              };
            };
            // try making plugin
            ImagesLoaded.makeJQueryPlugin();

            // --------------------------  -------------------------- //

            return ImagesLoaded;
          }
        );

        /***/
      },

    /***/ "./node_modules/js-image-zoom/js-image-zoom.js":
      /*!*****************************************************!*\
  !*** ./node_modules/js-image-zoom/js-image-zoom.js ***!
  \*****************************************************/
      /***/ function (module) {
        (function (root, factory) {
          if (true && module.exports) {
            module.exports = factory();
          } else {
            root.ImageZoom = factory();
          }
        })(this, function () {
          /**
           * @param {Object} container DOM element, which contains an image to be zoomed (required)
           * @param {Object} options js-image-zoom options (required)
           * **width** (number) - width of the source image (optional)
           * **height** (number) - height of the source image (optional).
           * **zoomWidth** (number) - width of the zoomed image. Zoomed image height equals source image height (optional)
           * **img** (string) - url of the source image. Provided if container does not contain img element as a tag (optional)
           * **scale** (number) - zoom scale. if not provided, scale is calculated as natural image size / image size, provided in params (optional if zoomWidth param is provided)
           * **offset** (object) - {vertical: number, horizontal: number}. Zoomed image offset (optional)
           * **zoomContainer** (node) - DOM node reference where zoomedImage will be appended to (default to the container element of image)
           * **zoomStyle** (string) - custom style applied to the zoomed image (i.e. 'opacity: 0.1;background-color: white;')
           * **zoomPosition** (string) - position of zoomed image. It can be:  `top`, `left`, `bottom`, `original` or the default `right`.
           * **zoomLensStyle** (string) custom style applied to to zoom lents (i.e. 'opacity: 0.1;background-color: white;')
           */
          return function ImageZoom(container, opts) {
            "use strict";
            var options = opts;
            if (!container) {
              return;
            }
            var data = {
              sourceImg: {
                element: null,
                width: 0,
                height: 0,
                naturalWidth: 0,
                naturalHeight: 0,
              },
              zoomedImgOffset: {
                vertical: 0,
                horizontal: 0,
              },
              zoomedImg: {
                element: null,
                width: 0,
                height: 0,
              },
              zoomLens: {
                element: null,
                width: 0,
                height: 0,
              },
            };

            var div = document.createElement("div");
            var lensDiv = document.createElement("div");
            var scaleX;
            var scaleY;
            var offset;
            data.zoomedImgOffset = {
              vertical:
                options.offset && options.offset.vertical
                  ? options.offset.vertical
                  : 0,
              horizontal:
                options.offset && options.offset.horizontal
                  ? options.offset.horizontal
                  : 0,
            };
            data.zoomPosition = options.zoomPosition || "right";
            data.zoomContainer = options.zoomContainer
              ? options.zoomContainer
              : container;
            function getOffset(el) {
              if (el) {
                var elRect = el.getBoundingClientRect();
                return { left: elRect.left, top: elRect.top };
              }
              return { left: 0, top: 0 };
            }

            function leftLimit(min) {
              return options.width - min;
            }

            function topLimit(min) {
              return options.height - min;
            }

            function getValue(val, min, max) {
              if (val < min) {
                return min;
              }
              if (val > max) {
                return max;
              }
              return val;
            }

            function getPosition(v, min, max) {
              var value = getValue(v, min, max);
              return value - min;
            }

            function zoomLensLeft(left) {
              var leftMin = data.zoomLens.width / 2;
              return getPosition(left, leftMin, leftLimit(leftMin));
            }

            function zoomLensTop(top) {
              var topMin = data.zoomLens.height / 2;
              return getPosition(top, topMin, topLimit(topMin));
            }

            function setZoomedImgSize(options, data) {
              if (options.scale) {
                data.zoomedImg.element.style.width =
                  options.width * options.scale + "px";
                data.zoomedImg.element.style.height =
                  options.height * options.scale + "px";
              } else if (options.zoomWidth) {
                data.zoomedImg.element.style.width = options.zoomWidth + "px";
                data.zoomedImg.element.style.height =
                  data.sourceImg.element.style.height;
              } else {
                data.zoomedImg.element.style.width = "100%";
                data.zoomedImg.element.style.height = "100%";
              }
            }

            function onSourceImgLoad() {
              // use height determined by browser if height is not set in options
              options.height = options.height || data.sourceImg.element.height;
              data.sourceImg.element.style.height = options.height + "px";

              // use width determined by browser if width is not set in options
              options.width = options.width || data.sourceImg.element.width;
              data.sourceImg.element.style.width = options.width + "px";

              setZoomedImgSize(options, data);

              data.sourceImg.naturalWidth = data.sourceImg.element.naturalWidth;
              data.sourceImg.naturalHeight =
                data.sourceImg.element.naturalHeight;
              data.zoomedImg.element.style.backgroundSize =
                data.sourceImg.naturalWidth +
                "px " +
                data.sourceImg.naturalHeight +
                "px";

              if (options.zoomStyle) {
                data.zoomedImg.element.style.cssText += options.zoomStyle;
              }
              if (options.zoomLensStyle) {
                data.zoomLens.element.style.cssText += options.zoomLensStyle;
              } else {
                data.zoomLens.element.style.background = "white";
                data.zoomLens.element.style.opacity = "0.4";
              }

              scaleX = data.sourceImg.naturalWidth / options.width;
              scaleY = data.sourceImg.naturalHeight / options.height;
              offset = getOffset(data.sourceImg.element);

              // set zoomLens dimensions
              // if custom scale is set
              if (options.scale) {
                data.zoomLens.width =
                  options.width /
                  (data.sourceImg.naturalWidth /
                    (options.width * options.scale));
                data.zoomLens.height =
                  options.height /
                  (data.sourceImg.naturalHeight /
                    (options.height * options.scale));
              }

              // else if zoomWidth is set
              else if (options.zoomWidth) {
                data.zoomLens.width = options.zoomWidth / scaleX;
                data.zoomLens.height = options.height / scaleY;
              }

              // else read from the zoomedImg
              else {
                data.zoomedImg.element.style.display = "block";
                data.zoomLens.width =
                  data.zoomedImg.element.clientWidth / scaleX;
                data.zoomLens.height =
                  data.zoomedImg.element.clientHeight / scaleY;
                data.zoomedImg.element.style.display = "none";
              }

              data.zoomLens.element.style.position = "absolute";
              data.zoomLens.element.style.width = data.zoomLens.width + "px";
              data.zoomLens.element.style.height = data.zoomLens.height + "px";
              data.zoomLens.element.pointerEvents = "none";
            }

            function setup() {
              // create sourceImg element
              if (options.img) {
                var img = document.createElement("img");
                img.src = options.img;
                data.sourceImg.element = container.appendChild(img);
              }

              // or get sourceImg element from specified container
              else {
                data.sourceImg.element = container.children[0];

                // if sourceImg is not an img (might be a picture element), try to find one
                if (data.sourceImg.element.nodeName !== "IMG") {
                  data.sourceImg.element =
                    data.sourceImg.element.querySelector("img");
                }
              }

              options = options || {};
              container.style.position = "relative";
              data.sourceImg.element.style.width = options.width
                ? options.width + "px"
                : "auto";
              data.sourceImg.element.style.height = options.height
                ? options.height + "px"
                : "auto";

              data.zoomLens.element = container.appendChild(lensDiv);
              data.zoomLens.element.style.display = "none";
              data.zoomLens.element.classList.add("js-image-zoom__zoomed-area");

              data.zoomedImg.element = data.zoomContainer.appendChild(div);
              data.zoomedImg.element.classList.add(
                "js-image-zoom__zoomed-image"
              );
              data.zoomedImg.element.style.backgroundImage =
                "url('" + data.sourceImg.element.src + "')";
              data.zoomedImg.element.style.backgroundRepeat = "no-repeat";
              data.zoomedImg.element.style.display = "none";

              switch (data.zoomPosition) {
                case "left":
                  data.zoomedImg.element.style.position = "absolute";
                  data.zoomedImg.element.style.top =
                    data.zoomedImgOffset.vertical + "px";
                  data.zoomedImg.element.style.left =
                    data.zoomedImgOffset.horizontal -
                    data.zoomedImgOffset.horizontal * 2 +
                    "px";
                  data.zoomedImg.element.style.transform = "translateX(-100%)";
                  break;

                case "top":
                  data.zoomedImg.element.style.position = "absolute";
                  data.zoomedImg.element.style.top =
                    data.zoomedImgOffset.vertical -
                    data.zoomedImgOffset.vertical * 2 +
                    "px";
                  data.zoomedImg.element.style.left =
                    "calc(50% + " + data.zoomedImgOffset.horizontal + "px)";
                  data.zoomedImg.element.style.transform =
                    "translate3d(-50%, -100%, 0)";
                  break;

                case "bottom":
                  data.zoomedImg.element.style.position = "absolute";
                  data.zoomedImg.element.style.bottom =
                    data.zoomedImgOffset.vertical -
                    data.zoomedImgOffset.vertical * 2 +
                    "px";
                  data.zoomedImg.element.style.left =
                    "calc(50% + " + data.zoomedImgOffset.horizontal + "px)";
                  data.zoomedImg.element.style.transform =
                    "translate3d(-50%, 100%, 0)";
                  break;

                case "original":
                  data.zoomedImg.element.style.position = "absolute";
                  data.zoomedImg.element.style.top = "0px";
                  data.zoomedImg.element.style.left = "0px";
                  break;

                // Right Position
                default:
                  data.zoomedImg.element.style.position = "absolute";
                  data.zoomedImg.element.style.top =
                    data.zoomedImgOffset.vertical + "px";
                  data.zoomedImg.element.style.right =
                    data.zoomedImgOffset.horizontal -
                    data.zoomedImgOffset.horizontal * 2 +
                    "px";
                  data.zoomedImg.element.style.transform = "translateX(100%)";
                  break;
              }

              // setup event listeners
              container.addEventListener("mousemove", events, false);
              container.addEventListener("mouseenter", events, false);
              container.addEventListener("mouseleave", events, false);
              data.zoomLens.element.addEventListener(
                "mouseenter",
                events,
                false
              );
              data.zoomLens.element.addEventListener(
                "mouseleave",
                events,
                false
              );
              window.addEventListener("scroll", events, false);

              return data;
            }

            function kill() {
              // remove event listeners
              container.removeEventListener("mousemove", events, false);
              container.removeEventListener("mouseenter", events, false);
              container.removeEventListener("mouseleave", events, false);
              data.zoomLens.element.removeEventListener(
                "mouseenter",
                events,
                false
              );
              data.zoomLens.element.removeEventListener(
                "mouseleave",
                events,
                false
              );
              window.removeEventListener("scroll", events, false);

              // remove dom nodes
              if (data.zoomLens && data.zoomedImg) {
                container.removeChild(data.zoomLens.element);
                data.zoomContainer.removeChild(data.zoomedImg.element);
              }

              if (options.img) {
                container.removeChild(data.sourceImg.element);
              } else {
                data.sourceImg.element.style.width = "";
                data.sourceImg.element.style.height = "";
              }

              return data;
            }

            var events = {
              handleEvent: function (event) {
                switch (event.type) {
                  case "mousemove":
                    return this.handleMouseMove(event);
                  case "mouseenter":
                    return this.handleMouseEnter(event);
                  case "mouseleave":
                    return this.handleMouseLeave(event);
                  case "scroll":
                    return this.handleScroll(event);
                }
              },
              handleMouseMove: function (event) {
                var offsetX;
                var offsetY;
                var backgroundTop;
                var backgroundRight;
                var backgroundPosition;
                if (offset) {
                  offsetX = zoomLensLeft(event.clientX - offset.left);
                  offsetY = zoomLensTop(event.clientY - offset.top);
                  backgroundTop = offsetX * scaleX;
                  backgroundRight = offsetY * scaleY;
                  backgroundPosition =
                    "-" + backgroundTop + "px " + "-" + backgroundRight + "px";
                  data.zoomedImg.element.style.backgroundPosition =
                    backgroundPosition;
                  data.zoomLens.element.style.cssText +=
                    "top:" +
                    offsetY +
                    "px;" +
                    "left:" +
                    offsetX +
                    "px;display: block;";
                }
              },
              handleMouseEnter: function () {
                data.zoomedImg.element.style.display = "block";
                data.zoomLens.element.style.display = "block";
              },
              handleMouseLeave: function () {
                data.zoomedImg.element.style.display = "none";
                data.zoomLens.element.style.display = "none";
              },
              handleScroll: function () {
                offset = getOffset(data.sourceImg.element);
              },
            };

            // Setup/Initialize library
            setup();

            if (data.sourceImg.element.complete) {
              onSourceImgLoad();
            } else {
              data.sourceImg.element.onload = onSourceImgLoad;
            }

            return {
              setup: function () {
                setup();
              },
              kill: function () {
                kill();
              },
              _getInstanceInfo: function () {
                return {
                  setup: setup,
                  kill: kill,
                  onSourceImgLoad: onSourceImgLoad,
                  data: data,
                  options: options,
                };
              },
            };
          };
        });

        /***/
      },

    /***/ "./node_modules/process/browser.js":
      /*!*****************************************!*\
  !*** ./node_modules/process/browser.js ***!
  \*****************************************/
      /***/ (module) => {
        // shim for using process in browser
        var process = (module.exports = {});

        // cached from whatever global is present so that test runners that stub it
        // don't break things.  But we need to wrap it in a try catch in case it is
        // wrapped in strict mode code which doesn't define any globals.  It's inside a
        // function because try/catches deoptimize in certain engines.

        var cachedSetTimeout;
        var cachedClearTimeout;

        function defaultSetTimout() {
          throw new Error("setTimeout has not been defined");
        }
        function defaultClearTimeout() {
          throw new Error("clearTimeout has not been defined");
        }
        (function () {
          try {
            if (typeof setTimeout === "function") {
              cachedSetTimeout = setTimeout;
            } else {
              cachedSetTimeout = defaultSetTimout;
            }
          } catch (e) {
            cachedSetTimeout = defaultSetTimout;
          }
          try {
            if (typeof clearTimeout === "function") {
              cachedClearTimeout = clearTimeout;
            } else {
              cachedClearTimeout = defaultClearTimeout;
            }
          } catch (e) {
            cachedClearTimeout = defaultClearTimeout;
          }
        })();
        function runTimeout(fun) {
          if (cachedSetTimeout === setTimeout) {
            //normal enviroments in sane situations
            return setTimeout(fun, 0);
          }
          // if setTimeout wasn't available but was latter defined
          if (
            (cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) &&
            setTimeout
          ) {
            cachedSetTimeout = setTimeout;
            return setTimeout(fun, 0);
          }
          try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedSetTimeout(fun, 0);
          } catch (e) {
            try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
              return cachedSetTimeout.call(null, fun, 0);
            } catch (e) {
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
              return cachedSetTimeout.call(this, fun, 0);
            }
          }
        }
        function runClearTimeout(marker) {
          if (cachedClearTimeout === clearTimeout) {
            //normal enviroments in sane situations
            return clearTimeout(marker);
          }
          // if clearTimeout wasn't available but was latter defined
          if (
            (cachedClearTimeout === defaultClearTimeout ||
              !cachedClearTimeout) &&
            clearTimeout
          ) {
            cachedClearTimeout = clearTimeout;
            return clearTimeout(marker);
          }
          try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedClearTimeout(marker);
          } catch (e) {
            try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
              return cachedClearTimeout.call(null, marker);
            } catch (e) {
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
              // Some versions of I.E. have different rules for clearTimeout vs setTimeout
              return cachedClearTimeout.call(this, marker);
            }
          }
        }
        var queue = [];
        var draining = false;
        var currentQueue;
        var queueIndex = -1;

        function cleanUpNextTick() {
          if (!draining || !currentQueue) {
            return;
          }
          draining = false;
          if (currentQueue.length) {
            queue = currentQueue.concat(queue);
          } else {
            queueIndex = -1;
          }
          if (queue.length) {
            drainQueue();
          }
        }

        function drainQueue() {
          if (draining) {
            return;
          }
          var timeout = runTimeout(cleanUpNextTick);
          draining = true;

          var len = queue.length;
          while (len) {
            currentQueue = queue;
            queue = [];
            while (++queueIndex < len) {
              if (currentQueue) {
                currentQueue[queueIndex].run();
              }
            }
            queueIndex = -1;
            len = queue.length;
          }
          currentQueue = null;
          draining = false;
          runClearTimeout(timeout);
        }

        process.nextTick = function (fun) {
          var args = new Array(arguments.length - 1);
          if (arguments.length > 1) {
            for (var i = 1; i < arguments.length; i++) {
              args[i - 1] = arguments[i];
            }
          }
          queue.push(new Item(fun, args));
          if (queue.length === 1 && !draining) {
            runTimeout(drainQueue);
          }
        };

        // v8 likes predictible objects
        function Item(fun, array) {
          this.fun = fun;
          this.array = array;
        }
        Item.prototype.run = function () {
          this.fun.apply(null, this.array);
        };
        process.title = "browser";
        process.browser = true;
        process.env = {};
        process.argv = [];
        process.version = ""; // empty string to avoid regexp issues
        process.versions = {};

        function noop() {}

        process.on = noop;
        process.addListener = noop;
        process.once = noop;
        process.off = noop;
        process.removeListener = noop;
        process.removeAllListeners = noop;
        process.emit = noop;
        process.prependListener = noop;
        process.prependOnceListener = noop;

        process.listeners = function (name) {
          return [];
        };

        process.binding = function (name) {
          throw new Error("process.binding is not supported");
        };

        process.cwd = function () {
          return "/";
        };
        process.chdir = function (dir) {
          throw new Error("process.chdir is not supported");
        };
        process.umask = function () {
          return 0;
        };

        /***/
      },

    /***/ "./node_modules/unidragger/unidragger.js":
      /*!***********************************************!*\
  !*** ./node_modules/unidragger/unidragger.js ***!
  \***********************************************/
      /***/ function (module, __unused_webpack_exports, __webpack_require__) {
        /*!
         * Unidragger v3.0.1
         * Draggable base class
         * MIT license
         */

        (function (window, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS
            module.exports = factory(
              window,
              __webpack_require__(
                /*! ev-emitter */ "./node_modules/ev-emitter/ev-emitter.js"
              )
            );
          } else {
            // browser global
            window.Unidragger = factory(window, window.EvEmitter);
          }
        })(
          typeof window != "undefined" ? window : this,
          function factory(window, EvEmitter) {
            function Unidragger() {}

            // inherit EvEmitter
            let proto = (Unidragger.prototype = Object.create(
              EvEmitter.prototype
            ));

            // ----- bind start ----- //

            // trigger handler methods for events
            proto.handleEvent = function (event) {
              let method = "on" + event.type;
              if (this[method]) {
                this[method](event);
              }
            };

            let startEvent, activeEvents;
            if ("ontouchstart" in window) {
              // HACK prefer Touch Events as you can preventDefault on touchstart to
              // disable scroll in iOS & mobile Chrome metafizzy/flickity#1177
              startEvent = "touchstart";
              activeEvents = ["touchmove", "touchend", "touchcancel"];
            } else if (window.PointerEvent) {
              // Pointer Events
              startEvent = "pointerdown";
              activeEvents = ["pointermove", "pointerup", "pointercancel"];
            } else {
              // mouse events
              startEvent = "mousedown";
              activeEvents = ["mousemove", "mouseup"];
            }

            // prototype so it can be overwriteable by Flickity
            proto.touchActionValue = "none";

            proto.bindHandles = function () {
              this._bindHandles("addEventListener", this.touchActionValue);
            };

            proto.unbindHandles = function () {
              this._bindHandles("removeEventListener", "");
            };

            /**
             * Add or remove start event
             * @param {String} bindMethod - addEventListener or removeEventListener
             * @param {String} touchAction - value for touch-action CSS property
             */
            proto._bindHandles = function (bindMethod, touchAction) {
              this.handles.forEach((handle) => {
                handle[bindMethod](startEvent, this);
                handle[bindMethod]("click", this);
                // touch-action: none to override browser touch gestures. metafizzy/flickity#540
                if (window.PointerEvent) handle.style.touchAction = touchAction;
              });
            };

            proto.bindActivePointerEvents = function () {
              activeEvents.forEach((eventName) => {
                window.addEventListener(eventName, this);
              });
            };

            proto.unbindActivePointerEvents = function () {
              activeEvents.forEach((eventName) => {
                window.removeEventListener(eventName, this);
              });
            };

            // ----- event handler helpers ----- //

            // trigger method with matching pointer
            proto.withPointer = function (methodName, event) {
              if (event.pointerId === this.pointerIdentifier) {
                this[methodName](event, event);
              }
            };

            // trigger method with matching touch
            proto.withTouch = function (methodName, event) {
              let touch;
              for (let changedTouch of event.changedTouches) {
                if (changedTouch.identifier === this.pointerIdentifier) {
                  touch = changedTouch;
                }
              }
              if (touch) this[methodName](event, touch);
            };

            // ----- start event ----- //

            proto.onmousedown = function (event) {
              this.pointerDown(event, event);
            };

            proto.ontouchstart = function (event) {
              this.pointerDown(event, event.changedTouches[0]);
            };

            proto.onpointerdown = function (event) {
              this.pointerDown(event, event);
            };

            // nodes that have text fields
            const cursorNodes = ["TEXTAREA", "INPUT", "SELECT", "OPTION"];
            // input types that do not have text fields
            const clickTypes = [
              "radio",
              "checkbox",
              "button",
              "submit",
              "image",
              "file",
            ];

            /**
             * any time you set `event, pointer` it refers to:
             * @param {Event} event
             * @param {Event | Touch} pointer
             */
            proto.pointerDown = function (event, pointer) {
              // dismiss multi-touch taps, right clicks, and clicks on text fields
              let isCursorNode = cursorNodes.includes(event.target.nodeName);
              let isClickType = clickTypes.includes(event.target.type);
              let isOkayElement = !isCursorNode || isClickType;
              let isOkay =
                !this.isPointerDown && !event.button && isOkayElement;
              if (!isOkay) return;

              this.isPointerDown = true;
              // save pointer identifier to match up touch events
              this.pointerIdentifier =
                pointer.pointerId !== undefined
                  ? // pointerId for pointer events, touch.indentifier for touch events
                    pointer.pointerId
                  : pointer.identifier;
              // track position for move
              this.pointerDownPointer = {
                pageX: pointer.pageX,
                pageY: pointer.pageY,
              };

              this.bindActivePointerEvents();
              this.emitEvent("pointerDown", [event, pointer]);
            };

            // ----- move ----- //

            proto.onmousemove = function (event) {
              this.pointerMove(event, event);
            };

            proto.onpointermove = function (event) {
              this.withPointer("pointerMove", event);
            };

            proto.ontouchmove = function (event) {
              this.withTouch("pointerMove", event);
            };

            proto.pointerMove = function (event, pointer) {
              let moveVector = {
                x: pointer.pageX - this.pointerDownPointer.pageX,
                y: pointer.pageY - this.pointerDownPointer.pageY,
              };
              this.emitEvent("pointerMove", [event, pointer, moveVector]);
              // start drag if pointer has moved far enough to start drag
              let isDragStarting =
                !this.isDragging && this.hasDragStarted(moveVector);
              if (isDragStarting) this.dragStart(event, pointer);
              if (this.isDragging) this.dragMove(event, pointer, moveVector);
            };

            // condition if pointer has moved far enough to start drag
            proto.hasDragStarted = function (moveVector) {
              return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
            };

            // ----- drag ----- //

            proto.dragStart = function (event, pointer) {
              this.isDragging = true;
              this.isPreventingClicks = true; // set flag to prevent clicks
              this.emitEvent("dragStart", [event, pointer]);
            };

            proto.dragMove = function (event, pointer, moveVector) {
              this.emitEvent("dragMove", [event, pointer, moveVector]);
            };

            // ----- end ----- //

            proto.onmouseup = function (event) {
              this.pointerUp(event, event);
            };

            proto.onpointerup = function (event) {
              this.withPointer("pointerUp", event);
            };

            proto.ontouchend = function (event) {
              this.withTouch("pointerUp", event);
            };

            proto.pointerUp = function (event, pointer) {
              this.pointerDone();
              this.emitEvent("pointerUp", [event, pointer]);

              if (this.isDragging) {
                this.dragEnd(event, pointer);
              } else {
                // pointer didn't move enough for drag to start
                this.staticClick(event, pointer);
              }
            };

            proto.dragEnd = function (event, pointer) {
              this.isDragging = false; // reset flag
              // re-enable clicking async
              setTimeout(() => delete this.isPreventingClicks);

              this.emitEvent("dragEnd", [event, pointer]);
            };

            // triggered on pointer up & pointer cancel
            proto.pointerDone = function () {
              this.isPointerDown = false;
              delete this.pointerIdentifier;
              this.unbindActivePointerEvents();
              this.emitEvent("pointerDone");
            };

            // ----- cancel ----- //

            proto.onpointercancel = function (event) {
              this.withPointer("pointerCancel", event);
            };

            proto.ontouchcancel = function (event) {
              this.withTouch("pointerCancel", event);
            };

            proto.pointerCancel = function (event, pointer) {
              this.pointerDone();
              this.emitEvent("pointerCancel", [event, pointer]);
            };

            // ----- click ----- //

            // handle all clicks and prevent clicks when dragging
            proto.onclick = function (event) {
              if (this.isPreventingClicks) event.preventDefault();
            };

            // triggered after pointer down & up with no/tiny movement
            proto.staticClick = function (event, pointer) {
              // ignore emulated mouse up clicks
              let isMouseup = event.type === "mouseup";
              if (isMouseup && this.isIgnoringMouseUp) return;

              this.emitEvent("staticClick", [event, pointer]);

              // set flag for emulated clicks 300ms after touchend
              if (isMouseup) {
                this.isIgnoringMouseUp = true;
                // reset flag after 400ms
                setTimeout(() => {
                  delete this.isIgnoringMouseUp;
                }, 400);
              }
            };

            // -----  ----- //

            return Unidragger;
          }
        );

        /***/
      },

    /***/ "./node_modules/axios/package.json":
      /*!*****************************************!*\
  !*** ./node_modules/axios/package.json ***!
  \*****************************************/
      /***/ (module) => {
        "use strict";
        module.exports = JSON.parse(
          '{"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}'
        );

        /***/
      },

    /******/
  };
  /************************************************************************/
  /******/ // The module cache
  /******/ var __webpack_module_cache__ = {};
  /******/
  /******/ // The require function
  /******/ function __webpack_require__(moduleId) {
    /******/ // Check if module is in cache
    /******/ var cachedModule = __webpack_module_cache__[moduleId];
    /******/ if (cachedModule !== undefined) {
      /******/ return cachedModule.exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/ var module = (__webpack_module_cache__[moduleId] = {
      /******/ // no module.id needed
      /******/ // no module.loaded needed
      /******/ exports: {},
      /******/
    });
    /******/
    /******/ // Execute the module function
    /******/ __webpack_modules__[moduleId].call(
      module.exports,
      module,
      module.exports,
      __webpack_require__
    );
    /******/
    /******/ // Return the exports of the module
    /******/ return module.exports;
    /******/
  }
  /******/
  /************************************************************************/
  /******/ /* webpack/runtime/compat get default export */
  /******/ (() => {
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/ __webpack_require__.n = (module) => {
      /******/ var getter =
        module && module.__esModule
          ? /******/ () => module["default"]
          : /******/ () => module;
      /******/ __webpack_require__.d(getter, { a: getter });
      /******/ return getter;
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/define property getters */
  /******/ (() => {
    /******/ // define getter functions for harmony exports
    /******/ __webpack_require__.d = (exports, definition) => {
      /******/ for (var key in definition) {
        /******/ if (
          __webpack_require__.o(definition, key) &&
          !__webpack_require__.o(exports, key)
        ) {
          /******/ Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key],
          });
          /******/
        }
        /******/
      }
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/hasOwnProperty shorthand */
  /******/ (() => {
    /******/ __webpack_require__.o = (obj, prop) =>
      Object.prototype.hasOwnProperty.call(obj, prop);
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/make namespace object */
  /******/ (() => {
    /******/ // define __esModule on exports
    /******/ __webpack_require__.r = (exports) => {
      /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
        /******/ Object.defineProperty(exports, Symbol.toStringTag, {
          value: "Module",
        });
        /******/
      }
      /******/ Object.defineProperty(exports, "__esModule", { value: true });
      /******/
    };
    /******/
  })();
  /******/
  /************************************************************************/
  var __webpack_exports__ = {};
  // This entry need to be wrapped in an IIFE because it need to be in strict mode.
  (() => {
    "use strict";
    /*!***********************!*\
  !*** ./src/js/app.js ***!
  \***********************/
    __webpack_require__.r(__webpack_exports__);
    /* harmony import */ var alpinejs__WEBPACK_IMPORTED_MODULE_0__ =
      __webpack_require__(
        /*! alpinejs */ "./node_modules/alpinejs/dist/module.esm.js"
      );
    /* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_1__ =
      __webpack_require__(
        /*! flickity */ "./node_modules/flickity/js/index.js"
      );
    /* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_1___default =
      /*#__PURE__*/ __webpack_require__.n(
        flickity__WEBPACK_IMPORTED_MODULE_1__
      );
    /* harmony import */ var js_image_zoom__WEBPACK_IMPORTED_MODULE_2__ =
      __webpack_require__(
        /*! js-image-zoom */ "./node_modules/js-image-zoom/js-image-zoom.js"
      );
    /* harmony import */ var js_image_zoom__WEBPACK_IMPORTED_MODULE_2___default =
      /*#__PURE__*/ __webpack_require__.n(
        js_image_zoom__WEBPACK_IMPORTED_MODULE_2__
      );
    /* harmony import */ var fast_simon_sdk__WEBPACK_IMPORTED_MODULE_3__ =
      __webpack_require__(
        /*! fast-simon-sdk */ "./node_modules/fast-simon-sdk/lib/index.js"
      );
    /* harmony import */ var fast_simon_sdk__WEBPACK_IMPORTED_MODULE_3___default =
      /*#__PURE__*/ __webpack_require__.n(
        fast_simon_sdk__WEBPACK_IMPORTED_MODULE_3__
      );
    function _typeof(obj) {
      "@babel/helpers - typeof";
      return (
        (_typeof =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (obj) {
                return typeof obj;
              }
            : function (obj) {
                return obj &&
                  "function" == typeof Symbol &&
                  obj.constructor === Symbol &&
                  obj !== Symbol.prototype
                  ? "symbol"
                  : typeof obj;
              }),
        _typeof(obj)
      );
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    function _defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    function _createClass(Constructor, protoProps, staticProps) {
      if (protoProps) _defineProperties(Constructor.prototype, protoProps);
      if (staticProps) _defineProperties(Constructor, staticProps);
      Object.defineProperty(Constructor, "prototype", { writable: false });
      return Constructor;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError(
          "Super expression must either be null or a function"
        );
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: { value: subClass, writable: true, configurable: true },
      });
      Object.defineProperty(subClass, "prototype", { writable: false });
      if (superClass) _setPrototypeOf(subClass, superClass);
    }

    function _createSuper(Derived) {
      var hasNativeReflectConstruct = _isNativeReflectConstruct();
      return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived),
          result;
        if (hasNativeReflectConstruct) {
          var NewTarget = _getPrototypeOf(this).constructor;
          result = Reflect.construct(Super, arguments, NewTarget);
        } else {
          result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
      };
    }

    function _possibleConstructorReturn(self, call) {
      if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
      } else if (call !== void 0) {
        throw new TypeError(
          "Derived constructors may only return object or undefined"
        );
      }
      return _assertThisInitialized(self);
    }

    function _assertThisInitialized(self) {
      if (self === void 0) {
        throw new ReferenceError(
          "this hasn't been initialised - super() hasn't been called"
        );
      }
      return self;
    }

    function _wrapNativeSuper(Class) {
      var _cache = typeof Map === "function" ? new Map() : undefined;
      _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") {
          throw new TypeError(
            "Super expression must either be null or a function"
          );
        }
        if (typeof _cache !== "undefined") {
          if (_cache.has(Class)) return _cache.get(Class);
          _cache.set(Class, Wrapper);
        }
        function Wrapper() {
          return _construct(
            Class,
            arguments,
            _getPrototypeOf(this).constructor
          );
        }
        Wrapper.prototype = Object.create(Class.prototype, {
          constructor: {
            value: Wrapper,
            enumerable: false,
            writable: true,
            configurable: true,
          },
        });
        return _setPrototypeOf(Wrapper, Class);
      };
      return _wrapNativeSuper(Class);
    }

    function _construct(Parent, args, Class) {
      if (_isNativeReflectConstruct()) {
        _construct = Reflect.construct.bind();
      } else {
        _construct = function _construct(Parent, args, Class) {
          var a = [null];
          a.push.apply(a, args);
          var Constructor = Function.bind.apply(Parent, a);
          var instance = new Constructor();
          if (Class) _setPrototypeOf(instance, Class.prototype);
          return instance;
        };
      }
      return _construct.apply(null, arguments);
    }

    function _isNativeReflectConstruct() {
      if (typeof Reflect === "undefined" || !Reflect.construct) return false;
      if (Reflect.construct.sham) return false;
      if (typeof Proxy === "function") return true;
      try {
        Boolean.prototype.valueOf.call(
          Reflect.construct(Boolean, [], function () {})
        );
        return true;
      } catch (e) {
        return false;
      }
    }

    function _isNativeFunction(fn) {
      return Function.toString.call(fn).indexOf("[native code]") !== -1;
    }

    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf
        ? Object.setPrototypeOf.bind()
        : function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
          };
      return _setPrototypeOf(o, p);
    }

    function _getPrototypeOf(o) {
      _getPrototypeOf = Object.setPrototypeOf
        ? Object.getPrototypeOf.bind()
        : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
          };
      return _getPrototypeOf(o);
    }

    window.FastSimonSDK =
      fast_simon_sdk__WEBPACK_IMPORTED_MODULE_3__.FastSimonSDK;
    window.Alpine = alpinejs__WEBPACK_IMPORTED_MODULE_0__["default"];
    window.Flickity = flickity__WEBPACK_IMPORTED_MODULE_1___default();
    window.ImageZoom = js_image_zoom__WEBPACK_IMPORTED_MODULE_2___default();
    alpinejs__WEBPACK_IMPORTED_MODULE_0__["default"].store("header", {
      searchResults: {},
      isMobileSearchBarOpen: false,
      isMenuOpen: false,
      isScrolling: false,
      toggleMobileSearchBar: function toggleMobileSearchBar() {
        this.isMobileSearchBarOpen = !this.isMobileSearchBarOpen;
        document.getElementById("searchAll").value = "";
      },
      toggleMenuDrawer: function toggleMenuDrawer() {
        this.isMenuOpen = !this.isMenuOpen;
      },
    });
    alpinejs__WEBPACK_IMPORTED_MODULE_0__["default"].store("drawer", {
      isDrawerOpen: false,
      toggleDrawer: function toggleDrawer() {
        this.isDrawerOpen = !this.isDrawerOpen;
      },
    });
    alpinejs__WEBPACK_IMPORTED_MODULE_0__["default"].start();
    var Sunrise = {
      updateQuantity: function updateQuantity(line, qty) {
        fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            quantity: qty,
            line: line,
          }),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            // fire javascript event on window
            window.dispatchEvent(new Event("cart-updated"));
          })
          ["catch"](function (error) {
            console.error("Error:", error);
          });
      },
    };
    window.Sunrise = Sunrise; // var Shopify = Shopify || {};
    // ---------------------------------------------------------------------------
    // Money format handler
    // ---------------------------------------------------------------------------

    window.Shopify.money_format = "${{amount}}";

    window.Shopify.formatCollectionMoney = function (price) {
      return "$" + parseInt(price).toFixed(0);
    };

    window.Shopify.formatMoney = function (cents, format) {
      if (typeof cents == "string") {
        cents = cents.replace(".", "");
      }

      var value = "";
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || this.money_format;

      function defaultOption(opt, def) {
        return typeof opt == "undefined" ? def : opt;
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ",");
        decimal = defaultOption(decimal, ".");

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);
        var parts = number.split("."),
          dollars = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            "$1" + thousands
          ),
          cents = parts[1] ? decimal + parts[1] : "";
        return dollars + cents;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;

        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;

        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;

        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    };

    var VariantSelects = /*#__PURE__*/ (function (_HTMLElement) {
      _inherits(VariantSelects, _HTMLElement);

      var _super = _createSuper(VariantSelects);

      function VariantSelects() {
        var _this;

        _classCallCheck(this, VariantSelects);

        _this = _super.call(this);

        _this.addEventListener("change", _this.onVariantChange);

        return _this;
      }

      _createClass(VariantSelects, [
        {
          key: "onVariantChange",
          value: function onVariantChange() {
            this.updateOptions();
            this.updateMasterId();
            this.toggleAddButton(true, "", false);
            this.updatePickupAvailability();
            this.removeErrorMessage();

            if (!this.currentVariant) {
              this.toggleAddButton(true, "", true);
              this.setUnavailable();
            } else {
              this.updateMedia();
              this.updateURL();
              this.updateVariantInput();
              this.renderProductInfo();
              this.updateShareUrl();
            }
          },
        },
        {
          key: "updateOptions",
          value: function updateOptions() {
            this.options = Array.from(
              this.querySelectorAll("select"),
              function (select) {
                return select.value;
              }
            );
          },
        },
        {
          key: "updateMasterId",
          value: function updateMasterId() {
            var _this2 = this;

            this.currentVariant = this.getVariantData().find(function (
              variant
            ) {
              return !variant.options
                .map(function (option, index) {
                  return _this2.options[index] === option;
                })
                .includes(false);
            });
          },
        },
        {
          key: "updateMedia",
          value: function updateMedia() {
            if (!this.currentVariant) return;
            if (!this.currentVariant.featured_media) return;
            var mediaGallery = document.getElementById(
              "MediaGallery-".concat(this.dataset.section)
            );
            mediaGallery.setActiveMedia(
              ""
                .concat(this.dataset.section, "-")
                .concat(this.currentVariant.featured_media.id),
              true
            );
            var modalContent = document.querySelector(
              "#ProductModal-".concat(
                this.dataset.section,
                " .product-media-modal__content"
              )
            );
            if (!modalContent) return;
            var newMediaModal = modalContent.querySelector(
              '[data-media-id="'.concat(
                this.currentVariant.featured_media.id,
                '"]'
              )
            );
            modalContent.prepend(newMediaModal);
          },
        },
        {
          key: "updateURL",
          value: function updateURL() {
            if (!this.currentVariant || this.dataset.updateUrl === "false")
              return;
            window.history.replaceState(
              {},
              "",
              ""
                .concat(this.dataset.url, "?variant=")
                .concat(this.currentVariant.id)
            );
          },
        },
        {
          key: "updateShareUrl",
          value: function updateShareUrl() {
            var shareButton = document.getElementById(
              "Share-".concat(this.dataset.section)
            );
            if (!shareButton || !shareButton.updateUrl) return;
            shareButton.updateUrl(
              ""
                .concat(window.shopUrl)
                .concat(this.dataset.url, "?variant=")
                .concat(this.currentVariant.id)
            );
          },
        },
        {
          key: "updateVariantInput",
          value: function updateVariantInput() {
            var _this3 = this;

            var productForms = document.querySelectorAll(
              "#product-form-"
                .concat(this.dataset.section, ", #product-form-installment-")
                .concat(this.dataset.section)
            );
            productForms.forEach(function (productForm) {
              var input = productForm.querySelector('input[name="id"]');
              input.value = _this3.currentVariant.id;
              input.dispatchEvent(
                new Event("change", {
                  bubbles: true,
                })
              );
            });
          },
        },
        {
          key: "updatePickupAvailability",
          value: function updatePickupAvailability() {
            var pickUpAvailability = document.querySelector(
              "pickup-availability"
            );
            if (!pickUpAvailability) return;

            if (this.currentVariant && this.currentVariant.available) {
              pickUpAvailability.fetchAvailability(this.currentVariant.id);
            } else {
              pickUpAvailability.removeAttribute("available");
              pickUpAvailability.innerHTML = "";
            }
          },
        },
        {
          key: "removeErrorMessage",
          value: function removeErrorMessage() {
            var section = this.closest("section");
            if (!section) return;
            var productForm = section.querySelector("product-form");
            if (productForm) productForm.handleErrorMessage();
          },
        },
        {
          key: "renderProductInfo",
          value: function renderProductInfo() {
            var _this4 = this;

            fetch(
              ""
                .concat(this.dataset.url, "?variant=")
                .concat(this.currentVariant.id, "&section_id=")
                .concat(
                  this.dataset.originalSection
                    ? this.dataset.originalSection
                    : this.dataset.section
                )
            )
              .then(function (response) {
                return response.text();
              })
              .then(function (responseText) {
                var html = new DOMParser().parseFromString(
                  responseText,
                  "text/html"
                );
                var destination = document.getElementById(
                  "price-".concat(_this4.dataset.section)
                );
                var source = html.getElementById(
                  "price-".concat(
                    _this4.dataset.originalSection
                      ? _this4.dataset.originalSection
                      : _this4.dataset.section
                  )
                );
                if (source && destination)
                  destination.innerHTML = source.innerHTML;
                var price = document.getElementById(
                  "price-".concat(_this4.dataset.section)
                );
                if (price) price.classList.remove("visibility-hidden");

                _this4.toggleAddButton(
                  !_this4.currentVariant.available,
                  window.variantStrings.soldOut
                );
              });
          },
        },
        {
          key: "toggleAddButton",
          value: function toggleAddButton() {
            var disable =
              arguments.length > 0 && arguments[0] !== undefined
                ? arguments[0]
                : true;
            var text = arguments.length > 1 ? arguments[1] : undefined;
            var modifyClass =
              arguments.length > 2 && arguments[2] !== undefined
                ? arguments[2]
                : true;
            var productForm = document.getElementById(
              "product-form-".concat(this.dataset.section)
            );
            if (!productForm) return;
            var addButton = productForm.querySelector('[name="add"]');
            var addButtonText = productForm.querySelector(
              '[name="add"] > span'
            );
            if (!addButton) return;

            if (disable) {
              addButton.setAttribute("disabled", "disabled");
              if (text) addButtonText.textContent = text;
            } else {
              addButton.removeAttribute("disabled");
              addButtonText.textContent = window.variantStrings.addToCart;
            }

            if (!modifyClass) return;
          },
        },
        {
          key: "setUnavailable",
          value: function setUnavailable() {
            var button = document.getElementById(
              "product-form-".concat(this.dataset.section)
            );
            var addButton = button.querySelector('[name="add"]');
            var addButtonText = button.querySelector('[name="add"] > span');
            var price = document.getElementById(
              "price-".concat(this.dataset.section)
            );
            if (!addButton) return;
            addButtonText.textContent = window.variantStrings.unavailable;
            if (price) price.classList.add("visibility-hidden");
          },
        },
        {
          key: "getVariantData",
          value: function getVariantData() {
            this.variantData =
              this.variantData ||
              JSON.parse(
                this.querySelector('[type="application/json"]').textContent
              );
            return this.variantData;
          },
        },
      ]);

      return VariantSelects;
    })(/*#__PURE__*/ _wrapNativeSuper(HTMLElement));

    customElements.define("variant-selects", VariantSelects);

    var VariantRadios = /*#__PURE__*/ (function (_VariantSelects) {
      _inherits(VariantRadios, _VariantSelects);

      var _super2 = _createSuper(VariantRadios);

      function VariantRadios() {
        _classCallCheck(this, VariantRadios);

        return _super2.call(this);
      }

      _createClass(VariantRadios, [
        {
          key: "updateOptions",
          value: function updateOptions() {
            var fieldsets = Array.from(this.querySelectorAll("fieldset"));
            this.options = fieldsets.map(function (fieldset) {
              return Array.from(fieldset.querySelectorAll("input")).find(
                function (radio) {
                  return radio.checked;
                }
              ).value;
            });
          },
        },
      ]);

      return VariantRadios;
    })(VariantSelects);

    customElements.define("variant-radios", VariantRadios);
  })();

  /******/
})();
